if (!sessionStorage.getItem('is_history')) {
  sessionStorage.setItem('is_history', 'true');
}

document.addEventListener("DOMContentLoaded", function () {


const chatProductSwipers = new Map();
let sidebarCountdownInterval = null;
let currentViewedProduct = null;
const productEndTimes = {};

window.gdWidgetSkipInitialChatLoad = false;
window.gdWidgetSkipInitialChatLoadSize = false;


let gdWidgetRegisteredInFlight = null;
gdWidgetSendRegisteredEvent();

const EXPANDED_CLASS = "goddiva-assistant-expanded";

function applyPriceLayoutAroundDiscounts(container) {
  if (!container) return;

  const slides = Array.from(container.querySelectorAll('.swiper-slide'));
  if (!slides.length) return;

  // Detect if we are still in the initial swiper mode
  const wrapper = container.querySelector('.chat-product-item-wrapper');
  const isSwiperMode = container.classList.contains('swiper') && 
                       wrapper?.classList.contains('swiper-wrapper');

  // --- SPECIAL RULE FOR INITIAL SWIPER (first 5 slides) ---
  if (isSwiperMode && slides.length <= 5) {
    // Remove any existing class
    slides.forEach(slide => {
      slide.querySelectorAll('.gd-chat-widget-product-meta-row')
        .forEach(row => row.classList.remove('price-column-layouts'));
    });

    const firstFive = slides.slice(0, 5);
    const hasDiscount = firstFive.some(slide => {
      const card = slide.querySelector('.gd-chat-widget-product-card');
      return card?.dataset.hasDiscount === 'true';
    });

    if (hasDiscount) {
      firstFive.forEach(slide => {
        slide.querySelectorAll('.gd-chat-widget-product-meta-row')
          .forEach(row => row.classList.add('price-column-layouts'));
      });
    }
    return; // done for swiper mode
  }

  // --- ROW‑BASED RULE FOR GRID MODE (original logic) ---
  const isExpanded = document.body.classList.contains(EXPANDED_CLASS);
  const perRow = isExpanded ? 5 : 2;   // adjust if your grid uses different numbers

  // Remove class from all slides first
  slides.forEach(slide => {
    slide.querySelectorAll('.gd-chat-widget-product-meta-row')
      .forEach(row => row.classList.remove('price-column-layouts'));
  });

  // Group slides into rows and apply class if any slide in the row has discount
  for (let i = 0; i < slides.length; i += perRow) {
    const rowSlides = slides.slice(i, i + perRow);
    const rowHasDiscount = rowSlides.some(slide => {
      const card = slide.querySelector('.gd-chat-widget-product-card');
      return card?.dataset.hasDiscount === 'true';
    });
    if (rowHasDiscount) {
      rowSlides.forEach(slide => {
        slide.querySelectorAll('.gd-chat-widget-product-meta-row')
          .forEach(row => row.classList.add('price-column-layouts'));
      });
    }
  }
}



function getSlidesPerView() {
  return document.body.classList.contains(EXPANDED_CLASS) ? 5 : 2.18;
}

async function gdWidgetToggle(isOpen = true) {
    const openBtn = document.getElementById("gd-chat-widget-openAssistantBtn");
    const panel = document.getElementById("gd-chat-widget-assistantPanel");
    const mainLoader = document.getElementById("gd-chat-widget-loader");

    window.addEventListener("resize", () => {
      console.log("Window resized!");
    });


    if (isOpen) {
      
       panel.style.display = "";

        document.body.classList.add("gd-chatsidebar-open");
        if(openBtn){
          openBtn.style.display = "none";
         }
       
        document.querySelectorAll('.slick-slider').forEach(el => {
          $(el).slick('setPosition');
          $(el).slick('refresh');
        });
        const items = document.querySelectorAll('.scrolling-text-item');
        if (items.length) {
          const firstHeight = items[0].offsetHeight;
          items.forEach(item => {
            item.style.height = firstHeight + 'px';
          });
        }

        document
        .querySelectorAll("#gd-chat-widget-btnExpand, #gd-chat-widget-btnRegisterExpand")
        .forEach(btn => btn.hidden = false);

      document
        .querySelectorAll("#gd-chat-widget-btnCollapse, #gd-chat-widget-btnRegisterCollapse")
        .forEach(btn => btn.hidden = true);

         chatProductSwipers.forEach(swiper => {
          swiper.params.slidesPerView = getSlidesPerView();
          swiper.update();
        });


        initTipSwiper();

        clearAllSwiperInstances();

        await gdWidgetSendRegisteredEvent();

        initGDChatWidget();

        document.body.classList.add('goddiva-assistant-open');

        //if (mainLoader) mainLoader.style.display = "flex";
        const userEmailss = localStorage.getItem('user_email')?.toLowerCase();
        const allowedss = 'sai@citygoddess.co.uk';
        if (userEmailss === allowedss) {
         
        }
  
        setTimeout(function() {
           gdWidgetScrollToBottom();
         }, 10);

       const elAiSearchDropdownModern = document.getElementById("ai-search-dropdown-modern");

        if (elAiSearchDropdownModern) {
          elAiSearchDropdownModern.style.display = "none";
        }

    } else {
       // clearAllSwiperInstances();
        panel.style.display = "none";

        document.body.classList.remove("gd-chatsidebar-open");
        document.body.classList.remove("goddiva-assistant-expanded");
        if(openBtn){
          openBtn.style.display = "flex";
        }
        
        document.querySelectorAll('.slick-slider').forEach(el => {
          $(el).slick('setPosition');
          $(el).slick('refresh');
        });
        const items = document.querySelectorAll('.scrolling-text-item');
        if (items.length) {
          const firstHeight = items[0].offsetHeight;
          items.forEach(item => {
            item.style.height = firstHeight + 'px';
          });
        }

        document
        .querySelectorAll("#gd-chat-widget-btnExpand, #gd-chat-widget-btnRegisterExpand")
        .forEach(btn => btn.hidden = false);

      document
        .querySelectorAll("#gd-chat-widget-btnCollapse, #gd-chat-widget-btnRegisterCollapse")
        .forEach(btn => btn.hidden = true);

         chatProductSwipers.forEach(swiper => {
          swiper.params.slidesPerView = getSlidesPerView();
          swiper.update();
        });

        initTipSwiper();

        document.body.classList.remove('goddiva-assistant-open');
    }
}

window.gdWidgetToggle = gdWidgetToggle;

const openBtnChatWidget = document.getElementById("gd-chat-widget-openAssistantBtn");
const closeBtnChatWidget = document.getElementById("gd-chat-widget-btnClose");
const registerCloseBtnChatWidget = document.getElementById("gd-chat-widget-registerClose");

const underMaintainanceClose = document.getElementById("gd-chat-widget-underMaintainanceClose");

if(openBtnChatWidget){
  openBtnChatWidget.addEventListener("click", () => gdWidgetToggle(true));
}

if(closeBtnChatWidget){
  closeBtnChatWidget.addEventListener("click", () => gdWidgetToggle(false));
}

if(registerCloseBtnChatWidget){
  registerCloseBtnChatWidget.addEventListener("click", () => gdWidgetToggle(false));
}

if (underMaintainanceClose) {
  underMaintainanceClose.addEventListener("click", () => {
    gdWidgetToggle(false);

    const modal = document.getElementById("gd-chat-widget-underMaintainance");
    if (modal) {
      modal.style.display = "none";
    }
  });
}

/* -----------------------------
   Expand / Collapse Buttons
------------------------------ */

const expandBtns = [
  "gd-chat-widget-btnExpand",
  "gd-chat-widget-btnRegisterExpand"
].map(id => document.getElementById(id)).filter(Boolean);

const collapseBtns = [
  "gd-chat-widget-btnCollapse",
  "gd-chat-widget-btnRegisterCollapse"
].map(id => document.getElementById(id)).filter(Boolean);

function updateButtons(isExpanded) {
  expandBtns.forEach(btn => (btn.hidden = isExpanded));
  collapseBtns.forEach(btn => (btn.hidden = !isExpanded));
}

/* -----------------------------
   Sliding Discount Layout Logic
------------------------------ */
function applyDiscountLayoutByChunk(container, chunkSize) {
  if (!container) return;

  const slides = Array.from(container.querySelectorAll('.swiper-slide'));
  if (!slides.length) return;

  console.log("[CHUNK] total slides:", slides.length, "chunkSize:", chunkSize);

  // Hard reset
  slides.forEach(slide => {
    slide
      .querySelector('.gd-chat-widget-product-meta-row')
      ?.classList.remove('price-column-layout');
  });

  // Process in chunks
  for (let i = 0; i < slides.length; i += chunkSize) {
    const chunk = slides.slice(i, i + chunkSize);

    const hasDiscount = chunk.some(slide =>
      slide.querySelector('.gd-chat-widget-product-card')?.dataset.hasDiscount === 'true'
    );

    console.log(
      `[CHUNK] ${i} → ${i + chunk.length - 1} hasDiscount:`,
      hasDiscount
    );

    if (hasDiscount) {
      chunk.forEach(slide => {
        slide
          .querySelector('.gd-chat-widget-product-meta-row')
          ?.classList.add('price-column-layout');
      });
    }
  }
}



function applyDiscountLayoutEverywhere(isExpanded) {
  const radius = isExpanded ? 2 : 1;

  document
    .querySelectorAll('.gd-widget-drag-scroll')
    .forEach((container, idx) => {
      applyDiscountLayoutByChunk(container, document.body.classList.contains(EXPANDED_CLASS) ? 5 : 2);
    });
}


/* -----------------------------
   Expand / Collapse Handler
------------------------------ */

function setGdWidgetExpanded(isExpanded) {

  document.body.classList.toggle(EXPANDED_CLASS, isExpanded);
  updateButtons(isExpanded);

  // Refresh slick sliders
  document.querySelectorAll('.slick-slider').forEach(el => {
    $(el).slick('setPosition');
    $(el).slick('refresh');
  });

  // Equal heights
  const items = document.querySelectorAll('.scrolling-text-item');
  if (items.length) {
    const h = items[0].offsetHeight;
    items.forEach(i => (i.style.height = h + 'px'));
  }

  // Update Swipers (if any)
  chatProductSwipers.forEach((swiper, idx) => {
    swiper.params.slidesPerView = getSlidesPerView();
    swiper.update();
  });

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      applyDiscountLayoutEverywhere(isExpanded);
    });
  });

  initTipSwiper();
}


/* -----------------------------
   Button Events
------------------------------ */

expandBtns.forEach(btn =>
  btn.addEventListener("click", () => {
    setGdWidgetExpanded(true);
  })
);

collapseBtns.forEach(btn =>
  btn.addEventListener("click", () => {
    setGdWidgetExpanded(false);
  })
);


function gdChatWidgetGetInitials(name) {
  if (!name) return 'You'; // fallback
  let parts = name.trim().split(' ').filter(Boolean);
  let initials = parts[0]?.charAt(0).toUpperCase() || '';
  
  if (parts.length > 1) {
    initials += parts[parts.length - 1].charAt(0).toUpperCase();
  }
  return initials || 'You';
}

function gdChatWidgetGetUserInitials() {
  let userName = localStorage.getItem('user_name');
  return gdChatWidgetGetInitials(userName);
}


function gdChatWidgetUpdateUserInitials() {
  let userName = localStorage.getItem('user_name');
  let userInitials = gdChatWidgetGetInitials(userName);

  // Update profile button or avatar in header
  const profileBtn = document.querySelector('#gd-chat-widget-btnProfile');

  if (profileBtn) profileBtn.textContent = userInitials;
}

window.gdChatWidgetGetInitials = gdChatWidgetGetInitials;
window.gdChatWidgetGetUserInitials = gdChatWidgetGetUserInitials;
window.gdChatWidgetUpdateUserInitials = gdChatWidgetUpdateUserInitials;

gdChatWidgetUpdateUserInitials();



function gdWidgetFreezeActions() {
  console.log("🧊 Widget Actions frozen");
  
  // Disable main chat elements
  const chatInput = document.getElementById('gd-chat-widget-chatInput');
  const chatSend = document.getElementById('gd-chat-widget-chatSend');
  if (chatInput) chatInput.disabled = true;
  if (chatSend) chatSend.disabled = true;
  
  // Disable register form elements (if in register mode)
  const regName = document.getElementById('gd-chat-widget-regName');
  const regEmail = document.getElementById('gd-chat-widget-regEmail');
  const regMessage = document.getElementById('gd-chat-widget-regMessage');
  const regSend = document.querySelector('.gd-chat-widget-register-send');
  
  if (regName) regName.disabled = true;
  if (regEmail) regEmail.disabled = true;
  if (regMessage) regMessage.disabled = true;
  if (regSend) regSend.disabled = true;
  
  // Disable all prompt buttons (if they exist)
  const promptButtons = document.querySelectorAll('#gd-chat-widget-prompt_suggestion button, .prompt-btn, .get-session-btn');
  if (promptButtons.length > 0) {
    promptButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable chat alternative section buttons (if they exist)
  const altButtons = document.querySelectorAll('.chat-alternative-section button');
  if (altButtons.length > 0) {
    altButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable filter buttons (if they exist)
  const deleteFilters = document.querySelectorAll('.delete-filter');
  const changeFilters = document.querySelectorAll('.change-filter');
  const filterBtns = document.querySelectorAll('.filter-btn');
  
  if (deleteFilters.length > 0) {
    deleteFilters.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (changeFilters.length > 0) {
    changeFilters.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (filterBtns.length > 0) {
    filterBtns.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable product action buttons (if they exist)
  const findSimilarButtons = document.querySelectorAll('.chat-find-similar-item');
  const addButtons = document.querySelectorAll('.chataiaddbuttn');
  const productIconButtons = document.querySelectorAll('.gd-chat-widget-product-icon-btn');
  const sizePills = document.querySelectorAll('.gd-chat-widget-size-pill');
  const registerSizeOptions = document.querySelectorAll('.gd-chat-widget-register-size-btnOption');
  
  if (findSimilarButtons.length > 0) {
    findSimilarButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (addButtons.length > 0) {
    addButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (productIconButtons.length > 0) {
    productIconButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (sizePills.length > 0) {
    sizePills.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (registerSizeOptions.length > 0) {
    registerSizeOptions.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable quick view and overlay buttons (if they exist)
  const qvAddBtn = document.getElementById('gd-chat-widget-qvAddBtn');
  const qvWishlistBtn = document.getElementById('gd-chat-widget-qvWishlistBtn');
  const videoToggles = document.querySelectorAll('.gd-chat-widget-qv-video-toggle');
  const colourTags = document.querySelectorAll('.colour-tag');
  const sizeTags = document.querySelectorAll('.size-pill, .size-tag');
  
  if (qvAddBtn) qvAddBtn.disabled = true;
  if (qvWishlistBtn) qvWishlistBtn.disabled = true;
  
  if (videoToggles.length > 0) {
    videoToggles.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (colourTags.length > 0) {
    colourTags.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (sizeTags.length > 0) {
    sizeTags.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable size dropdown and buttons (if they exist)
  const sizeDropdown = document.getElementById('gd-chat-widget-sizeDropdown');
  const sizeSaveBtn = document.getElementById('gd-chat-widget-btnSizeSave');
  const sizeCancelBtn = document.getElementById('gd-chat-widget-btnSizeCancel');
  
  if (sizeDropdown) {
    sizeDropdown.style.pointerEvents = 'none';
    sizeDropdown.style.opacity = '0.5';
  }
  if (sizeSaveBtn) sizeSaveBtn.disabled = true;
  if (sizeCancelBtn) sizeCancelBtn.disabled = true;
  
  // Disable reset buttons (if they exist)
  const resetBtn = document.getElementById('gd-chat-widget-btnReset');
  const resetYes = document.getElementById('gd-chat-widget-btnResetYes');
  const resetNo = document.getElementById('gd-chat-widget-btnResetNo');

  
  if (resetBtn) resetBtn.disabled = true;
  if (resetYes) resetYes.disabled = true;
  if (resetNo) resetNo.disabled = true;

  const sizeMentioned = document.getElementById('gdChatWidgetSizeMentioned');
  if (sizeMentioned) sizeMentioned.disabled = true;
  
  // Disable profile buttons (if they exist)
  const profileBtn = document.getElementById('gd-chat-widget-btnProfile');
  const profileSave = document.getElementById('gd-chat-widget-btnProfileSave');
  const profileCancel = document.getElementById('gd-chat-widget-btnProfileCancel');
  
  if (profileBtn) profileBtn.disabled = true;
  if (profileSave) profileSave.disabled = true;
  if (profileCancel) profileCancel.disabled = true;
  
  // Disable microphone button (if it exists)
  const micBtn = document.getElementById('gd-chat-widget-chat-input-micIcon');
  if (micBtn){
    micBtn.style.pointerEvents = 'none';
    micBtn.style.opacity = '0.5';
  }
  
  // Disable toggle buttons (if they exist)
  const toggleMakeYours = document.querySelectorAll('.toggle-makeyours');
  const toggleRefilter = document.querySelectorAll('.toggle-refilter');
  
  if (toggleMakeYours.length > 0) {
    toggleMakeYours.forEach(toggle => {
      if (toggle) {
        toggle.style.pointerEvents = 'none';
        toggle.style.opacity = '0.5';
      }
    });
  }
  
  if (toggleRefilter.length > 0) {
    toggleRefilter.forEach(toggle => {
      if (toggle) {
        toggle.style.pointerEvents = 'none';
        toggle.style.opacity = '0.5';
      }
    });
  }
  
  // Disable dropdown items (if they exist)
  const dropdownItems = document.querySelectorAll('#chat-widget-global-chat-dropdown li');
  if (dropdownItems.length > 0) {
    dropdownItems.forEach(item => {
      if (item) {
        item.style.pointerEvents = 'none';
        item.style.opacity = '0.5';
        item.style.cursor = 'not-allowed';
      }
    });
  }
  
  // Disable load more buttons (if they exist)
  const loadMoreButtons = document.querySelectorAll('.chat-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable suggestion buttons (if they exist)
  const chatSuggestions = document.querySelectorAll('.gd-chat-widget-suggestion');
  const registerSuggestions = document.querySelectorAll('.gd-chat-widget-register-suggestion-btn');
  
  if (chatSuggestions.length > 0) {
    chatSuggestions.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  if (registerSuggestions.length > 0) {
    registerSuggestions.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable size guide buttons (if they exist)
  const sizeGuideBtns = document.querySelectorAll('.gd-chat-widget-qv-size-guide');
  if (sizeGuideBtns.length > 0) {
    sizeGuideBtns.forEach(btn => {
      if (btn) btn.disabled = true;
    });
  }
  
  // Disable start button (if it exists)
  const startBtn = document.getElementById('gdChatWidgetStartBtn');
  if (startBtn) startBtn.disabled = true;
  
  // Disable slide update size button (if it exists)
  const slideUpdateBtn = document.getElementById('gd-chat-widget-btnSlideUpdateSize');
  if (slideUpdateBtn) slideUpdateBtn.disabled = true;


  const allChips = document.querySelectorAll(".refinement-chip");
  allChips.forEach(chip => {
    chip.disabled = true;
    chip.style.opacity = '0.6';
    chip.style.cursor = 'not-allowed';
    chip.style.pointerEvents = 'none';
  });

  // Disable return/exchange/alteration panel interactive elements
  const returnPanelSelectors = [
    '.gd-chat-widget-li-checkbox',
    '.gd-chat-widget-li-reason',
    '.gd-chat-widget-li-process-btn',
    '.gd-chat-widget-li-view-details-btn',
    '.gd-chat-widget-li-outlet-radio',
    '.gd-chat-widget-li-addtoprev-radio',
    '.gd-chat-widget-li-terms-chk',
    '.gd-chat-widget-li-outlet-acc-header',
    '.gd-chat-widget-li-specific-reason',
    '.gd-chat-widget-li-upload-btn',
    '.gd-chat-widget-li-faulty-remove',
    '.gd-chat-widget-li-opt-card',
    '.gd-chat-widget-li-file-input',
    '.gd-chat-widget-ex-chk',
    '.gd-chat-widget-ex-available-option',
    '.gd-chat-widget-ex-reason',
    '.gd-chat-widget-ex-specific-reason',
    '.gd-chat-widget-ex-terms-chk',
    '.gd-chat-widget-alt-chk',
    '.gd-chat-widget-alt-length',
    '.gd-chat-widget-alt-note',
    '.gd-chat-widget-alt-terms-chk',
    '.gd-chat-widget-pay-now-btn',
    '.gd-chat-widget-pay-acc-header',
    '.gd-chat-widget-pay-close',
    '.gd-chat-widget-li-req-acc-header',
    '.gd-chat-widget-req-dl-btn',
    '.gd-chat-widget-li-req-show-more-btn',
    '.gd-chat-widget-req-show-more-btn',
    '.gd-chat-widget-req-faulty-thumb',
    '.gd-chat-widget-img-popup-nav',
    '.gd-chat-widget-img-popup-close',
  ];
  returnPanelSelectors.forEach(selector => {
    const els = document.querySelectorAll(selector);
    if (els.length > 0) {
      els.forEach(el => {
        el.disabled = true;
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      });
    }
  });

  const stepperBtns = document.querySelectorAll(
    '.gd-chat-widget-li-panel button, .gd-chat-widget-ex-panel button, .gd-chat-widget-alt-panel button'
  );
  if (stepperBtns.length > 0) {
    stepperBtns.forEach(btn => {
      btn.disabled = true;
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    });
  }

  const requestedBtns = document.querySelectorAll(
    '.gd-chat-widget-li-requested-separator button, ' +
    '.gd-chat-widget-li-req-accordion .gd-chat-widget-li-req-acc-header, ' +
    '.gd-chat-widget-li-requested-only button'
  );
  if (requestedBtns.length > 0) {
    requestedBtns.forEach(btn => {
      btn.disabled = true;
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    });
  }
  
}

function gdWidgetReleaseActions() {
  console.log("🔥 Widget Actions released");
  
  // Enable main chat elements
  const chatInput = document.getElementById('gd-chat-widget-chatInput');
  const chatSend = document.getElementById('gd-chat-widget-chatSend');
  if (chatInput) chatInput.disabled = false;
  if (chatSend) chatSend.disabled = false;
  
  // Enable register form elements (if in register mode)
  const regName = document.getElementById('gd-chat-widget-regName');
  const regEmail = document.getElementById('gd-chat-widget-regEmail');
  const regMessage = document.getElementById('gd-chat-widget-regMessage');
  const regSend = document.querySelector('.gd-chat-widget-register-send');
  
  if (regName) regName.disabled = false;
  if (regEmail) regEmail.disabled = false;
  if (regMessage) regMessage.disabled = false;
  if (regSend) regSend.disabled = false;
  
  // Enable all prompt buttons (if they exist)
  const promptButtons = document.querySelectorAll('#gd-chat-widget-prompt_suggestion button, .prompt-btn, .get-session-btn');
  if (promptButtons.length > 0) {
    promptButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable chat alternative section buttons (if they exist)
  const altButtons = document.querySelectorAll('.chat-alternative-section button');
  if (altButtons.length > 0) {
    altButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable filter buttons (if they exist)
  const deleteFilters = document.querySelectorAll('.delete-filter');
  const changeFilters = document.querySelectorAll('.change-filter');
  const filterBtns = document.querySelectorAll('.filter-btn');
  
  if (deleteFilters.length > 0) {
    deleteFilters.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (changeFilters.length > 0) {
    changeFilters.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (filterBtns.length > 0) {
    filterBtns.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable product action buttons (if they exist)
  const findSimilarButtons = document.querySelectorAll('.chat-find-similar-item');
  const addButtons = document.querySelectorAll('.chataiaddbuttn');
  const productIconButtons = document.querySelectorAll('.gd-chat-widget-product-icon-btn');
  const sizePills = document.querySelectorAll('.gd-chat-widget-size-pill');
  const registerSizeOptions = document.querySelectorAll('.gd-chat-widget-register-size-btnOption');
  
  if (findSimilarButtons.length > 0) {
    findSimilarButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (addButtons.length > 0) {
    addButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (productIconButtons.length > 0) {
    productIconButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (sizePills.length > 0) {
    sizePills.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (registerSizeOptions.length > 0) {
    registerSizeOptions.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable quick view and overlay buttons (if they exist)
  const qvAddBtn = document.getElementById('gd-chat-widget-qvAddBtn');
  const qvWishlistBtn = document.getElementById('gd-chat-widget-qvWishlistBtn');
  const videoToggles = document.querySelectorAll('.gd-chat-widget-qv-video-toggle');
  const colourTags = document.querySelectorAll('.colour-tag');
  const sizeTags = document.querySelectorAll('.size-pill, .size-tag');
  
  if (qvAddBtn) qvAddBtn.disabled = false;
  if (qvWishlistBtn) qvWishlistBtn.disabled = false;
  
  if (videoToggles.length > 0) {
    videoToggles.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (colourTags.length > 0) {
    colourTags.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (sizeTags.length > 0) {
    sizeTags.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable size dropdown and buttons (if they exist)
  const sizeDropdown = document.getElementById('gd-chat-widget-sizeDropdown');
  const sizeSaveBtn = document.getElementById('gd-chat-widget-btnSizeSave');
  const sizeCancelBtn = document.getElementById('gd-chat-widget-btnSizeCancel');
  
  if (sizeDropdown) {
    sizeDropdown.style.pointerEvents = '';
    sizeDropdown.style.opacity = '';
  }
  if (sizeSaveBtn) sizeSaveBtn.disabled = false;
  if (sizeCancelBtn) sizeCancelBtn.disabled = false;
  
  // Enable reset buttons (if they exist)
  const resetBtn = document.getElementById('gd-chat-widget-btnReset');
  const resetYes = document.getElementById('gd-chat-widget-btnResetYes');
  const resetNo = document.getElementById('gd-chat-widget-btnResetNo');
  
  
  if (resetBtn) resetBtn.disabled = false;
  if (resetYes) resetYes.disabled = false;
  if (resetNo) resetNo.disabled = false;

  const sizeMentioned = document.getElementById('gdChatWidgetSizeMentioned');
  if (sizeMentioned) sizeMentioned.disabled = false;
  
  // Enable profile buttons (if they exist)
  const profileBtn = document.getElementById('gd-chat-widget-btnProfile');
  const profileSave = document.getElementById('gd-chat-widget-btnProfileSave');
  const profileCancel = document.getElementById('gd-chat-widget-btnProfileCancel');
  
  if (profileBtn) profileBtn.disabled = false;
  if (profileSave) profileSave.disabled = false;
  if (profileCancel) profileCancel.disabled = false;
  
  // Enable microphone button (if it exists)
  const micBtn = document.getElementById('gd-chat-widget-chat-input-micIcon');
  if (micBtn){
    micBtn.style.pointerEvents = '';
    micBtn.style.opacity = '';
  } 
  
  // Enable toggle buttons (if they exist)
  const toggleMakeYours = document.querySelectorAll('.toggle-makeyours');
  const toggleRefilter = document.querySelectorAll('.toggle-refilter');
  
  if (toggleMakeYours.length > 0) {
    toggleMakeYours.forEach(toggle => {
      if (toggle) {
        toggle.style.pointerEvents = '';
        toggle.style.opacity = '';
      }
    });
  }
  
  if (toggleRefilter.length > 0) {
    toggleRefilter.forEach(toggle => {
      if (toggle) {
        toggle.style.pointerEvents = '';
        toggle.style.opacity = '';
      }
    });
  }
  
  // Enable dropdown items (if they exist)
  const dropdownItems = document.querySelectorAll('#chat-widget-global-chat-dropdown li');
  if (dropdownItems.length > 0) {
    dropdownItems.forEach(item => {
      if (item) {
        item.style.pointerEvents = '';
        item.style.opacity = '';
        item.style.cursor = '';
      }
    });
  }
  
  // Enable load more buttons (if they exist)
  const loadMoreButtons = document.querySelectorAll('.chat-load-more');
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable suggestion buttons (if they exist)
  const chatSuggestions = document.querySelectorAll('.gd-chat-widget-suggestion');
  const registerSuggestions = document.querySelectorAll('.gd-chat-widget-register-suggestion-btn');
  
  if (chatSuggestions.length > 0) {
    chatSuggestions.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  if (registerSuggestions.length > 0) {
    registerSuggestions.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable size guide buttons (if they exist)
  const sizeGuideBtns = document.querySelectorAll('.gd-chat-widget-qv-size-guide');
  if (sizeGuideBtns.length > 0) {
    sizeGuideBtns.forEach(btn => {
      if (btn) btn.disabled = false;
    });
  }
  
  // Enable start button (if it exists)
  const startBtn = document.getElementById('gdChatWidgetStartBtn');
  if (startBtn) startBtn.disabled = false;
  
  // Enable slide update size button (if it exists)
  const slideUpdateBtn = document.getElementById('gd-chat-widget-btnSlideUpdateSize');
  if (slideUpdateBtn) slideUpdateBtn.disabled = false;
  
  // Clear suggestion wrappers (if they exist)
  const chatSuggestionsWrapper = document.querySelector('.gd-chat-widget-chat-suggestions');
  const registerSuggestionsWrapper = document.querySelector('.gd-chat-widget-register-suggestions');
  
  if (chatSuggestionsWrapper) chatSuggestionsWrapper.innerHTML = '';
  if (registerSuggestionsWrapper) registerSuggestionsWrapper.innerHTML = '';


  const allChips = document.querySelectorAll(".refinement-chip");
  allChips.forEach(chip => {
    chip.disabled = false;
    chip.style.opacity = '';
    chip.style.cursor = '';
    chip.style.pointerEvents = '';
  });

  // Re-enable return/exchange/alteration panel interactive elements
//   const returnPanelSelectors = [
//     '.gd-chat-widget-li-checkbox',
//     '.gd-chat-widget-li-reason',
//     '.gd-chat-widget-li-process-btn',
//     '.gd-chat-widget-li-view-details-btn',
//     '.gd-chat-widget-li-outlet-radio',
//     '.gd-chat-widget-li-addtoprev-radio',
//     '.gd-chat-widget-li-terms-chk',
//     '.gd-chat-widget-li-outlet-acc-header',
//     '.gd-chat-widget-li-specific-reason',
//     '.gd-chat-widget-li-upload-btn',
//     '.gd-chat-widget-li-faulty-remove',
//     '.gd-chat-widget-li-opt-card',
//     '.gd-chat-widget-li-file-input',
//     '.gd-chat-widget-ex-chk',
//     '.gd-chat-widget-ex-available-option',
//     '.gd-chat-widget-ex-reason',
//     '.gd-chat-widget-ex-specific-reason',
//     '.gd-chat-widget-ex-terms-chk',
//     '.gd-chat-widget-alt-chk',
//     '.gd-chat-widget-alt-length',
//     '.gd-chat-widget-alt-note',
//     '.gd-chat-widget-alt-terms-chk',
//     '.gd-chat-widget-pay-now-btn',
//     '.gd-chat-widget-pay-acc-header',
//     '.gd-chat-widget-pay-close',
//     '.gd-chat-widget-li-req-acc-header',
//     '.gd-chat-widget-req-dl-btn',
//     '.gd-chat-widget-li-req-show-more-btn',
//     '.gd-chat-widget-req-show-more-btn',
//     '.gd-chat-widget-req-faulty-thumb',
//     '.gd-chat-widget-img-popup-nav',
//     '.gd-chat-widget-img-popup-close',
//   ];
//   returnPanelSelectors.forEach(selector => {
//     const els = document.querySelectorAll(selector);
//     if (els.length > 0) {
//       els.forEach(el => {
//         el.style.pointerEvents = '';
//         el.style.opacity = '';
//         const frozenPanel = el.closest(
//           '.gd-chat-widget-li-panel-frozen, .gd-chat-widget-panel-stale'
//         );
//         if (!frozenPanel) {
//           el.disabled = false;
//         }
//       });
//     }
//   });

//   const stepperBtns = document.querySelectorAll(
//     '.gd-chat-widget-li-panel button, .gd-chat-widget-ex-panel button, .gd-chat-widget-alt-panel button'
//   );
//   if (stepperBtns.length > 0) {
//     stepperBtns.forEach(btn => {
//       const frozenPanel = btn.closest(
//         '.gd-chat-widget-li-panel-frozen, .gd-chat-widget-panel-stale'
//       );
//       btn.style.pointerEvents = frozenPanel ? 'none' : '';
//       btn.style.opacity = frozenPanel ? '0.5' : '';
//       if (!frozenPanel) {
//         btn.disabled = false;
//       }
//     });
//   }

//   const requestedBtns = document.querySelectorAll(
//     '.gd-chat-widget-li-requested-separator button, ' +
//     '.gd-chat-widget-li-req-accordion .gd-chat-widget-li-req-acc-header, ' +
//     '.gd-chat-widget-li-requested-only button'
//   );
//   if (requestedBtns.length > 0) {
//     requestedBtns.forEach(btn => {
//       const frozenPanel = btn.closest(
//         '.gd-chat-widget-li-panel-frozen, .gd-chat-widget-panel-stale'
//       );
//       btn.style.pointerEvents = frozenPanel ? 'none' : '';
//       btn.style.opacity = frozenPanel ? '0.5' : '';
//       if (!frozenPanel) {
//         btn.disabled = false;
//       }
//     });
//   }

}


function getGDChatWidgetAiToken() {
    const access = localStorage.getItem("ai_access_token");
    const refresh = localStorage.getItem("ai_refresh_token");

    return access || refresh || null;
}



function initGDChatWidget() {

    clearAllSwiperInstances();
    const userId = localStorage.getItem('user_id');
    const userName = localStorage.getItem('user_name');

    const registerWrapper = document.getElementById('gd-chat-widget-registerWrapper');
    const mainWrapper = document.getElementById('gd-chat-widget-main-wrapper');
    const userNameEl = document.getElementById('gd-chat-widget-user-name');
    const mainLoader = document.getElementById("gd-chat-widget-loader");

    if (window.gdWidgetSkipInitialChatLoad) {
        console.log('Skipping initGDChatWidget');
        window.gdWidgetSkipInitialChatLoad = false; // Reset flag
        return;
    }
    

    if (userId) {
        // Hide register, show main
        if (registerWrapper) registerWrapper.style.display = 'none';
        if (mainWrapper) mainWrapper.style.display = 'flex';

        // Set username
        if (userNameEl) userNameEl.textContent = userName;
        const sessionId = localStorage.getItem('session_id');
        if (sessionId) gdWidgetchatAssistant(sessionId);
         console.log('initGDChatWidget user id found');
         
    } else {
        // Show register, hide main
        if (registerWrapper) registerWrapper.style.display = 'block';
        if (mainWrapper) mainWrapper.style.display = 'none';
        
        if (mainLoader) mainLoader.style.display = "none";
         console.log('initGDChatWidget user id not found');
        
    }
    
}

//initGDChatWidget();


function initGDChatWidgetRegister() {

    // -------------------------------
    // DOM ELEMENTS
    // -------------------------------
    const registerWrapper = document.getElementById('gd-chat-widget-registerWrapper');
    const mainWrapper = document.getElementById('gd-chat-widget-main-wrapper');

    const nameInput = document.getElementById('gd-chat-widget-regName');
    const emailInput = document.getElementById('gd-chat-widget-regEmail');
    const messageInput = document.getElementById('gd-chat-widget-regMessage');
    const sendBtn = document.querySelector('.gd-chat-widget-register-send');

    const termsCheckbox = document.getElementById('gd-chat-widget-regTerms');

    const orderField = document.getElementById('register-chat-widget-order-id-field'); // guest visible field
    const hiddenOrderField = document.getElementById('hidden-register-chat-widget-order-id'); // logged-in auto order no.

    const conversationArea = document.querySelector('.gd-chat-widget-conversation-area');
    const userNameEl = document.getElementById('gd-chat-widget-user-name');

    const sizeCheckboxes = document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox');
    const profileBtn = document.querySelector('#gd-chat-widget-btnProfile');



    gdChatWidgetShowDiscountIfEligible("chat-register");



    // ------------------------------------------
    // AUTO SHOW / HIDE ORDER NUMBER FIELD
    // ------------------------------------------
    messageInput.addEventListener("input", () => {
        const text = messageInput.value.trim();

        // show when suggestion requires order number
        // if (gdChatWidgetSelectedSuggestion?.required_fields?.includes("order_number")) {
        //     orderField.style.display = "block";
        //     orderField.required = true;
        // }

        if (messageInput.value.trim().length <= 0) {
            orderField.classList.remove("error-border"); 
            orderField.style.display = "none"; 
            orderField.value = "";
        }

    });


    // ------------------------------------------
    // VALIDATION
    // ------------------------------------------
    function validate() {
        let valid = true;

        document.querySelectorAll(".error-border, .error-text")
            .forEach(el => el.classList.remove("error-border", "error-text"));

        // Name
        if (!nameInput.value.trim()) {
            nameInput.classList.add("error-border");
            valid = false;
        }

        // Email
        const emailVal = emailInput.value.trim();
        if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
            emailInput.classList.add("error-border");
            valid = false;
        }

        // Message
        if (!messageInput.value.trim()) {
            messageInput.classList.add("error-border");
            valid = false;
        }

        // Terms checkbox
        if (!termsCheckbox.checked) {
            termsCheckbox.parentElement.classList.add("error-text");
            valid = false;
        }

        // At least one size must be selected
        const sizeChecked = [...sizeCheckboxes].some(cb => cb.checked);
        if (!sizeChecked) {
            document.getElementById('gd-chat-widget-register-sizeTrigger')
                .classList.add("error-border");
            valid = false;
        }

        // ORDER NUMBER VALIDATION
        if (gdChatWidgetSelectedSuggestion?.required_fields?.includes("order_number")) {

            let orderValue = "";

            if (hiddenOrderField) orderValue = hiddenOrderField.value.trim();
            if (orderField && orderField.style.display !== "none") orderValue = orderField.value.trim();

            if (!orderValue) {
                orderField?.classList.add("error-border");
                valid = false;
            }
        }

        return valid;
    }


    // ------------------------------------------
    // COLLECT SIZES (UK + INTL + ONESIZE)
    // ------------------------------------------
    function collectSizes() {
        const sizes = [];

        document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox:checked')
            .forEach(cb => {
                const ukId = Number(cb.dataset.id);
                const ukName = cb.dataset.value;

                const intlId = Number(cb.dataset.internationalId);
                const intlName = cb.dataset.international;

                sizes.push({ id: ukId, name: ukName });

                if (intlId && intlName && intlName.toLowerCase() !== "null") {
                    sizes.push({ id: intlId, name: intlName });
                }
            });

        // Add ONESIZE automatically (ID: 2)
        const oneSize = document.querySelector('.gd-chat-widget-register-sizeCheckbox[data-id="2"]');
        if (oneSize && !sizes.some(s => s.id === 2)) {
            sizes.push({ id: 2, name: oneSize.dataset.value });
        }

        return sizes;
    }


    // ------------------------------------------
    // SUBMIT REGISTER
    // ------------------------------------------
    async function registerUser() {

      const modal = document.getElementById("gd-chat-widget-underMaintainance");
      modal.style.display = "none";

        if (!validate()) return;

        const name = nameInput.value.trim();
        const email = emailInput.value.trim();
        const message = messageInput.value.trim();

        // order number selection
        let orderNumber = null;
        if (hiddenOrderField) orderNumber = hiddenOrderField.value.trim();
        if (orderField && orderField.style.display !== "none") orderNumber = orderField.value.trim();

        const sizes = collectSizes();

        const trafficInfo = JSON.parse(sessionStorage.getItem("trafficInfo") || "{}");

        const payload = {
            name,
            email,
            size: sizes,
            ppc_source: trafficInfo,
            perefernce: {}
        };

        sendBtn.disabled = true;

        try {
            const res = await fetch("https://ai.mygoddiva.com/user-register", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const data = await res.json();

            // Save session
            sessionStorage.setItem("is_history", "true");
            localStorage.setItem("session_id", data.session_id);
            localStorage.setItem("user_id", data.user_id);
            localStorage.setItem("user_email", email);
            localStorage.setItem("user_name", name);

            if (data.token) {
                localStorage.setItem("ai_access_token", data.token.access);
                localStorage.setItem("ai_refresh_token", data.token.refresh);
            }

            // Switch UI to chat
            registerWrapper.style.display = "none";
            mainWrapper.style.display = "flex";

            if (userNameEl) userNameEl.textContent = name;


            // ------------------------------------------
            // BUILD combinedMessage (like old system)
            // ------------------------------------------
            let combinedMessage = message;

            if (gdChatWidgetSelectedSuggestion?.required_fields?.includes("order_number") && orderNumber) {
                combinedMessage += ` Order number is ${orderNumber}`;
                combinedMessage += ` and email address is ${email}`;
            }

            const initials = gdChatWidgetGetUserInitials();

            if (profileBtn) profileBtn.textContent = initials;

            // Append first chat message
            conversationArea.insertAdjacentHTML(
                "beforeend",
                `
                <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
                    <div class="gd-chat-widget-user-bubble">${combinedMessage}</div>
                    <div class="gd-chat-widget-user-avatar">${initials}</div>
                </div>
                `
            );
            conversationArea.scrollTop = conversationArea.scrollHeight;

            // Send message to AI
            if (typeof gdWidgetChatQuery === "function") {
                gdWidgetChatQuery(combinedMessage);
            }

            // ---------------------------------------------
            // UPDATE SIZE LABEL UI (NEW WIDGET VERSION)
            // ---------------------------------------------
            const sizeLabel = document.getElementById("gd-chat-widget-sizeLabel");

            if (payload.size && payload.size.length && sizeLabel) {

                // Only UK sizes (exclude ONESIZE and international duplicates)
                const ukIds = [...document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox')]
                    .map(cb => Number(cb.dataset.id));

                const uniqueUkSizes = payload.size.filter(
                    item => ukIds.includes(item.id) && item.name.toLowerCase() !== 'onesize'
                );

                if (uniqueUkSizes.length === 1) {
                    // Only 1 size selected
                    sizeLabel.textContent = `Size: ${uniqueUkSizes[0].name.trim()}`;
                } 
                else if (uniqueUkSizes.length > 1) {
                    // Multiple sizes selected
                    const firstSize = uniqueUkSizes[0].name.trim();
                    const moreCount = uniqueUkSizes.length - 1;
                    sizeLabel.textContent = `Size: ${firstSize} +${moreCount} more`;
                }
            }


            //CRAZY EGG Start here

            try {
                window.CE_API = window.CE_API || [];
                window.CE_API.push(function () {
                  if (typeof CE2 !== 'undefined' && email) {
                    CE2.identify(email);
                    console.log("Crazy Egg identified as:", email);
                  } else {
                    const fallbackId = "DudeAIVisitor #" + Math.random().toString(36).substring(2, 12);
                    CE2.identify(fallbackId);
                    console.log("Crazy Egg identified with fallback:", fallbackId);
                  }
                });
              } catch (err) {
                console.error("Crazy Egg identify failed:", err);
              }

            //CRAZY EGG Ends here


        } catch (err) {
            console.error("Register error:", err);
            const modal = document.getElementById("gd-chat-widget-underMaintainance");
            modal.style.display = "flex";
        }

        sendBtn.disabled = false;
        
    }


    // ------------------------------------------
    // EVENTS
    // ------------------------------------------
    sendBtn.addEventListener("click", registerUser);

    messageInput.addEventListener("keydown", e => {
        if (e.key === "Enter") {
            e.preventDefault();
            registerUser();
        }
    });
}

initGDChatWidgetRegister();


let gdChatWidgetSelectedSuggestion = null;

function gdChatWidgetInitSuggestions(
  inputSelector,
  suggestionWrapperSelector,
  jsonUrl,
  minLength = 3
) {
  let allSuggestions = [];

  /* ----------------------------
     Load suggestion JSON once
  ----------------------------- */
  fetch(jsonUrl)
    .then(res => res.json())
    .then(data => {
      allSuggestions = data || [];
    })
    .catch(() => {
      allSuggestions = [];
    });

  const input   = document.querySelector(inputSelector);
  const wrapper = document.querySelector(suggestionWrapperSelector);

  const mainOrderField = document.querySelector(".main-chat-widget-order-id-field");
  const regOrderField  = document.querySelector(".register-chat-widget-order-id-field");

  if (!input || !wrapper) return;

  /* ----------------------------
     Stopwords & helpers
  ----------------------------- */
  const stopwords = [
    "i","me","my","mine","you","your","yours",
    "am","is","are","was","were","be","been","being",
    "do","does","did","done",
    "have","has","had","having",
    "will","would","shall","should","can","could","may","might","must",
    "a","an","the",
    "for","to","in","on","at","with","of","by","about",
    "and","or","but","if","than","then",
    "this","that","these","those",
    "here","there",
    "looking","searching","want","need","find","show","give","get",
    "yahoo","gmail","hotmail","outlook","aol","icloud","protonmail",
    "com","co","uk","net","org","gov","edu","info","biz",
    "@"
  ];

  const synonyms = {
    rad: "red",
    retorn: "return",
    retrn: "return",
    reurn: "return",
    adress: "address",
    ordr: "order"
  };

  function matchesInput(item, value) {
    const tokens = value
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(Boolean);

    const meaningfulTokens = tokens.filter(t => !stopwords.includes(t));
    if (meaningfulTokens.length === 0) return false;

    const textWords = item.text
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(Boolean);

    const keywords = (item.keywords || []).map(k => k.toLowerCase());

    return meaningfulTokens.every(token =>
      textWords.some(w => w === token || w.startsWith(token)) ||
      keywords.some(k => k === token || k.startsWith(token))
    );
  }

  /* ----------------------------
     Input event
  ----------------------------- */
  input.addEventListener("input", function () {
    const value = input.value.trim().toLowerCase();

    const tokens = value.split(/[^a-z0-9]+/).filter(Boolean);
    let meaningfulTokens = tokens.filter(t => !stopwords.includes(t));

    const corrected = meaningfulTokens.map(t => synonyms[t] || t);

    if (!corrected.some(t => t.length >= minLength)) {
      wrapper.innerHTML = "";
      return;
    }

    const correctedValue = corrected.join(" ");

    /* ---- Exact matches ---- */
    let exact = allSuggestions.filter(item =>
      item.text.toLowerCase() === correctedValue ||
      (item.keywords || [])
        .map(k => k.toLowerCase())
        .includes(correctedValue)
    );

    /* ---- Partial matches ---- */
    let partial = allSuggestions.filter(item =>
      matchesInput(item, correctedValue) &&
      item.text.toLowerCase() !== correctedValue
    );

    /* ---- Remove duplicates ---- */
    const seen = new Set(exact.map(i => i.id));
    partial = partial.filter(i => !seen.has(i.id));

    exact.sort((a, b) => a.priority - b.priority);
    partial.sort((a, b) => a.priority - b.priority);

    let results = [...exact, ...partial];

    /* ---- Priority filter ---- */
    let filtered = results.filter(r => r.priority <= 2);
    if (filtered.length === 0) {
      filtered = results.filter(r => r.priority === 3);
    }
    results = filtered;

    /* ---- Ignore words ---- */
    results = results.filter(item => {
      if (!item.ignore_words || !Array.isArray(item.ignore_words)) return true;

      return !item.ignore_words.some(
        ig => correctedValue === ig.toLowerCase()
      );
    });

    /* ---- Build HTML ---- */
    let html = "";
    results.forEach(item => {
      html += `<li class="gd-chat-widget-suggestion" data-id="${item.id}">${item.text}</li>`;
    });

    wrapper.innerHTML = html;
  });

  /* ----------------------------
     Click suggestion
  ----------------------------- */
  wrapper.addEventListener("click", function (e) {
    const li = e.target.closest(".gd-chat-widget-suggestion");
    if (!li) return;

    const text = li.textContent;
    const id   = li.dataset.id;

    const match = allSuggestions.find(s => String(s.id) === String(id));
    gdChatWidgetSelectedSuggestion = match || null;

    input.value = text;
    input.focus();
    wrapper.innerHTML = "";

    if (
      gdChatWidgetSelectedSuggestion?.required_fields?.includes("order_number")
    ) {
      mainOrderField?.style.setProperty("display", "block");
      regOrderField?.style.setProperty("display", "block");
    }
  });

  /* ----------------------------
     Enter key
  ----------------------------- */
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      if (input.value.trim()) {
        wrapper.innerHTML = "";
      }
    }
  });
}

/* ============================
   INIT CALLS (same as before)
============================= */

gdChatWidgetInitSuggestions(
  "#gd-chat-widget-chatInput",
  ".gd-chat-widget-chat-suggestions",
  "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-suugestion-ignore_new_1_1_1.json?v=1760464442",
  3
);

gdChatWidgetInitSuggestions(
  "#gd-chat-widget-regMessage",
  ".gd-chat-widget-register-suggestions",
  "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-suugestion-ignore_new_1_1_1.json?v=1760464442",
  3
);

  const sizeTrigger = document.getElementById('gd-chat-widget-register-sizeTrigger');
  const sizeLabel   = document.getElementById('gd-chat-widget-register-sizeLabel');
  const overlay     = document.getElementById('gd-chat-widget-register-sizeOverlay');
  const sheetGrid   = document.getElementById('gd-chat-widget-register-sizeGrid');
  const btnSave     = document.getElementById('gd-chat-widget-register-sizeSave');
  const btnCancel   = document.getElementById('gd-chat-widget-register-sizeCancel');

  let sourceChecks = document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox');

  /* -------------------------------------------------------
      1) PRESELECT CUSTOMER SIZES
  ---------------------------------------------------------*/
  function preselectCustomerSizes() {
    if (!window.customerSizeTags || !Array.isArray(window.customerSizeTags)) return;

    const tags = window.customerSizeTags.map(t => t.toLowerCase().trim());

    sourceChecks.forEach(cb => {
      const sizeTag = cb.dataset.customerSize?.toLowerCase().trim();
      if (sizeTag && tags.includes(sizeTag)) {
        cb.checked = true;
      }
    });
  }

  /* -------------------------------------------------------
      2) UPDATE SIZE LABEL (EXCLUDE ONESIZE)
  ---------------------------------------------------------*/
  function updateLabel() {
    const selected = Array.from(sourceChecks)
      .filter(cb => cb.checked && cb.dataset.value.toLowerCase() !== "onesize")
      .map(cb => cb.dataset.value);

    if (selected.length === 0) {
      sizeLabel.textContent = "Select your sizes";
    } else if (selected.length === 1) {
      sizeLabel.textContent = selected[0];
    } else {
      sizeLabel.textContent = `${selected[0]} +${selected.length - 1} more`;
    }
  }

  /* -------------------------------------------------------
      3) BUILD BOTTOM SHEET GRID
  ---------------------------------------------------------*/
  function buildSizeGrid() {
    sheetGrid.innerHTML = "";

    sourceChecks.forEach(cb => {
      if (cb.type !== "checkbox") return;

      // ❌ Skip onesize in UI
      if (cb.dataset.value.toLowerCase() === "onesize") return;

      const full = cb.dataset.value;
      const [ukLabel, rest] = full.split("(");

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gd-chat-widget-register-size-btnOption";
      btn.dataset.value = full;

      btn.innerHTML = `
        <strong>${ukLabel.trim()}</strong>
        <small>(${rest}</small>
      `;

      // Pre-select if checkbox is checked
      if (cb.checked) btn.classList.add("is-active");

      btn.addEventListener("click", () => btn.classList.toggle("is-active"));

      sheetGrid.appendChild(btn);
    });
  }

  /* -------------------------------------------------------
      4) SAVE GRID SELECTION → CHECKBOXES
  ---------------------------------------------------------*/
  function syncGridToCheckboxes() {
    const activeBtns = sheetGrid.querySelectorAll('.gd-chat-widget-register-size-btnOption.is-active');

    // reset all
    sourceChecks.forEach(cb => cb.checked = false);

    // sync
    activeBtns.forEach(btn => {
      const val = btn.dataset.value;
      sourceChecks.forEach(cb => {
        if (cb.dataset.value === val) cb.checked = true;
      });
    });

    // 🔥 ONESIZE ALWAYS ACTIVE
    const onesizeCb = document.querySelector('.gd-chat-widget-register-sizeCheckbox[data-id="2"]');
    if (onesizeCb) onesizeCb.checked = true;
  }

  /* -------------------------------------------------------
      5) OPEN / CLOSE SHEET
  ---------------------------------------------------------*/
  function openSheet() {
    buildSizeGrid();
    overlay.classList.add("is-open");
  }

  function closeSheet() {
    overlay.classList.remove("is-open");
  }

  sizeTrigger.addEventListener("click", openSheet);
  btnCancel.addEventListener("click", closeSheet);
  overlay.addEventListener("click", e => {
    if (e.target === overlay) closeSheet();
  });

  btnSave.addEventListener("click", () => {
    syncGridToCheckboxes();
    updateLabel();
    closeSheet();
  });

  /* -------------------------------------------------------
      6) RUN LOGIC AFTER DOM READY
  ---------------------------------------------------------*/
  preselectCustomerSizes();
  updateLabel();


function gdWidgetChatQuery(message, name = null, action = null, label = null, promptId = null) {


  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;

 window.gdWidgetAutoScrollToUserReply();


  gdWidgetFreezeActions();

  // Show loader bubble
  const loader = document.getElementById("gd-chat-widget-loader-bubble");
  if (loader) loader.style.display = "inline-flex";
  
 

  const payload = {
    query: message,
    assistant_id: localStorage.getItem('session_id'),
    is_history: isHistory
  };

  if (window.isProductPage && window.productId) {
    payload.product_id = window.productId;
  }

  if (window.isProductPage && window.productId && name) {
    if (name === 'specific_product_inquiry' || name === 'similar_product_request') {
      payload.type = { name };
    } else if (action) {
      payload.type = { name, action };
    }
  } else if (name && action) {
     payload.type = { name, action };
  }

  if (payload.type) {
    if (label) payload.type.label = label;
    if (promptId) payload.type.prompt_id = promptId;
  }

  console.log("📤 Sending payload:", payload);
  const token = getGDChatWidgetAiToken();

  fetch("https://ai.mygoddiva.com/user-query", {
    method: "POST",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      token ? { "Authorization": "Bearer " + token } : {}
    ),
    body: JSON.stringify(payload)
  })
  .then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  })
  .then(response => {

    const prompt_id = response.prompt_id ? response.prompt_id : null;

    response._originalQuery = message;

    // Render chat response
    if (typeof gdChatWidgetChatResponse === "function") {
      gdChatWidgetChatResponse(response, null, null, prompt_id);
    }

    // for return portal implementation
    document.querySelectorAll('.gd-chat-widget-panel-stale').forEach(el => {
      el.classList.remove('gd-chat-widget-panel-stale');
      const loader = el.querySelector('.gd-chat-widget-panel-loader');
      if (loader) loader.remove();
    });

    // Clear input field
    const input = document.getElementById("gd-chat-widget-chatInput");
    if (input) input.value = "";

    // Hide loader
    if (loader) loader.style.display = "none";
    gdWidgetReleaseActions();

    setTimeout(() => {
          window.gdWidgetAutoScroll();
        //  window.gdWidgetCheckPromptSuggestion();
      }, 500);

      const promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");
      if (promptSuggestion) {
        const suggestions = response.suggestions;
        if (!suggestions || suggestions.length === 0) {
            promptSuggestion.style.display = "none";
        }
      }
      

  })
  .catch(err => {
    console.error("gdWidgetChatQuery error:", err);

    gdWidgetShowRetryButtonInMessage(message, gdWidgetChatQuery, [message, name, action, label, promptId]);
    // Hide loader on error
    if (loader) loader.style.display = "none";
    gdWidgetReleaseActions();

    
  });
}

window.gdWidgetChatQuery = gdWidgetChatQuery;


// top bar, prompt suggestion , suggestions etc

function gdWidgetmoreLike(id, image, name) {

  const conversationArea = document.querySelector('.gd-chat-widget-conversation-area');
  if (conversationArea) {
    conversationArea.insertAdjacentHTML(
      'beforeend',
      gdWidgetmoreLikeHtml({ title: name, image: image })
    );
  }

  const changeFilter = document.querySelector('#chat-widget-change_Filter_suggestion');
  if (changeFilter) {
    changeFilter.innerHTML = '';
  }
  gdWidgetAjaxChat(null, null, id);
}

function gdWidgetmoreLikeHtml(value) {
  const userInitials = gdChatWidgetGetUserInitials();

  return `
    <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg gdWidgetmoreLikeHtml">
      <div class="gd-chat-widget-user-bubble more_like">
        <div class="more_like-top-row">
          <div class="more_like-title-text">${value.title}</div>
          <img src="${value.image}" alt="Product" class="more_like-product-image">
        </div>
        <div class="more_like-cta-text">Show me more like this</div>
      </div>
      <div class="gd-chat-widget-user-avatar">${userInitials}</div>
    </div>
  `;
}

window.gdWidgetmoreLike = gdWidgetmoreLike;
window.gdWidgetmoreLikeHtml = gdWidgetmoreLikeHtml;


function gdWidgetbotResponseHandel(botResponse, filter, promptId) {
    let filterHtml = "";

    // Safe check: filter must exist AND filter.value must be a real array
    if (filter && Array.isArray(filter.value)) {
        filterHtml += `
            <div class="filter-label filter-panel filter-panel-${promptId}">
                ${filter.label || ""}
            </div>
            <div class="filter-panel filter-panel-${promptId}">
        `;

        filter.value.forEach(value => {
            filterHtml += `
                <button class="filter-btn"
                    onclick="gdWidgetfilterOnclick(${value.id}, '${value.name}', '${promptId}')"
                    data-id="${value.id}">
                    ${value.name}
                </button>
            `;
        });

        filterHtml += `</div>`;
    }

    return `
        <div class="gd-chat-widget-msg-row gd-chat-widget-bot-msg gdWidgetbotResponseHandel">
            <div class="gd-chat-widget-bot-avatar-small">G</div>
            <div class="gd-chat-widget-bot-reply">
                ${botResponse}
                ${filterHtml}
            </div>
        </div>
    `;
}


function gdWidgetfilterOnclick(id, name, promptId) {
    const el = document.getElementById("chat-widget-change_Filter_suggestion");
    if (el) el.style.display = "none";

    const filter = {
        prompt_id: promptId,
        value: [{ id: id, name: name }]
    };

    gdWidgetAjaxChat(null, filter);
}

function gdWidgetAjaxChat(prompt, filter, productId = null) {

    gdWidgetFreezeActions();

    // Show / hide elements
    const changeFilter = document.getElementById("chat-widget-change_Filter_suggestion");
    if (changeFilter) changeFilter.style.display = "block";

    const promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");
    if (promptSuggestion) promptSuggestion.style.display = "none";

    document.querySelectorAll(".chat-alternative-section").forEach(el => el.remove());
    const loader = document.getElementById("gd-chat-widget-loader-bubble");
    if (loader) loader.style.display = "inline-flex";

    // Set promptId
    promptId = prompt ? prompt.id : "";

    const token = getGDChatWidgetAiToken();

    // Create payload
    const payload = {
        assistant_id: localStorage.getItem('session_id'),
        prompt: prompt,
        filter: filter,
        product_id: productId
    };

    // if (window.isProductPage && window.productId) {
    //   payload.product_id = window.productId;
    // }

    // Fetch API version of jQuery $.ajax
    fetch("https://ai.mygoddiva.com/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { "Authorization": "Bearer " + token } : {})
        },
        body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(response => {
        gdChatWidgetChatResponse(response, filter, productId, promptId);
        gdWidgetReleaseActions();

    })
    .catch(error => {
        console.error("AJAX Error:", error);
        gdWidgetShowRetryButtonInMessage(prompt?.message, gdWidgetAjaxChat, [prompt, filter, productId]);
        gdWidgetReleaseActions();
    });
}


function gdWidgetSelectedFilter(filters) {
    let filterHtml = "";

    filters.forEach(value => {
        filterHtml += `<span class="tag filter-tag">${value.label ? value.label + " : " : ""}${value.value}</span>`;
    });

    // ✅ Keep existing search-query tags
    // const existingSearchTags = document.querySelector(".chat-widget-tag-container .search-query")?.cloneNode(true);

    // ✅ Replace tag container content with filters
    const tagContainer = document.querySelector(".chat-widget-tag-container");
    if (tagContainer) {
        tagContainer.innerHTML = filterHtml;
        tagContainer.style.display = "block";
    }

    // ✅ Add back the preserved search-query tags at the top
    // if (existingSearchTags) {
    //     tagContainer.prepend(existingSearchTags);
    // }

    // document.getElementById("chat-widget-top-bar").style.display = "block";

    // ✅ Show/hide logic commented for below useremail
    // if (filters.length >= 3) {
    //     document.querySelector(".chat-widget-looking-for").style.display = "block";
    //     document.getElementById("chat-widget-top-bar").style.display = "block";
    // } else {
    //     document.querySelector(".chat-widget-looking-for").style.display = "none";
    //     document.getElementById("chat-widget-top-bar").style.display = "none";
    // }


    // removed from allowed email 20 feb "yathu@citygoddess.co.uk",
    const userEmail = localStorage.getItem("user_email")?.toLowerCase();
    const allowed = [
        "methan@akhitsolutions.com",
        "sai@citygoddess.co.uk"
    ];

    if (filters.length >= 3) {
        document.querySelectorAll(".chat-widget-looking-for, #chat-widget-top-bar").forEach(el => {
            el.style.display = "none";
        });
    } else {
        document.querySelectorAll(".chat-widget-looking-for, #chat-widget-top-bar").forEach(el => {
            el.style.display = "none";
        });
    }

    if (allowed.includes(userEmail)) {
        if (filters.length >= 3) {
            document.querySelectorAll(".chat-widget-looking-for, #chat-widget-top-bar").forEach(el => {
                el.style.display = "none";
            });
        }
    } else {
        const topBar = document.getElementById("chat-widget-top-bar");
        if (topBar) topBar.setAttribute("style", "display:none !important;");
    }
}


let lastFilterButton = null;
let originalHiddenButtonsHTML = ''; // store hidden non-id prompt buttons

// ----------------------------------------------
// 🔹 SVG for chevron
// ----------------------------------------------
function gdWidgetGetChevronSVG() {
  return `<svg class="svg-inline--fa fa-chevron-down" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
    <path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"></path>
  </svg>`;
}

// Global variable for active filter button
let activeFilterButton = null;

// ----------------------------------------------
// 🔹 GENERIC PROMPT BUTTON CLICK HANDLER (ALL IN ONE)
// ----------------------------------------------

document.addEventListener("click", function (e) {
    // const btn = e.target.closest("#gd-chat-widget-prompt_suggestion button, .chat-alternative-section button");
     const btn = e.target.closest(".prompt-btn");
    if (!btn) return;

    const btnId = btn.dataset.id;
    const btnFilter = btn.dataset.filter;
    const btnText = btn.textContent.trim();
    const btnType = btn.dataset.type;
    const btnAction = btn.dataset.action;
    const btnIsReset = btn.dataset.isReset;
    const btnCondition = btn.dataset.condition;

    const promptSuggestionReset = document.getElementById("gd-chat-widget-prompt_suggestion-reset");
    if(promptSuggestionReset){
      promptSuggestionReset.innerHTML = '';
    }

    // Skip toggles — handled separately
    if (
        btn.classList.contains("toggle-makeyours") ||
        btn.classList.contains("toggle-refilter") ||
        btn.classList.contains("filter-btn-user-getsession")
    ) return;

    // ===============================
    // 🔹 CHANGE FILTER BUTTON
    // ===============================
    if (btnId === "changed_1") {
        gdWidgetchangeFilterAjax();
        // removed from allowed 20 feb "yathu@citygoddess.co.uk",
        const userEmail = localStorage.getItem("user_email")?.toLowerCase();
        const allowed = ["methan@akhitsolutions.com", "sai@citygoddess.co.uk"];

        const topBar = document.getElementById("chat-widget-top-bar");
        const promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");

        if (allowed.includes(userEmail)) {
            if (topBar) topBar.removeAttribute("style");
            if (topBar) topBar.style.display = "block";
            if (promptSuggestion) promptSuggestion.style.display = "block";
        } else {
            if (topBar) topBar.setAttribute("style", "display:none !important;");
        }
        return;
    }

    // ===============================
    // 🔹 ASSISTANT FILTER BUTTON (data-filter="filter")
    // ===============================
    if (btnFilter === "filter") {
        const btnMessage = btn.dataset.message || btnText;

        // If clicked same filter expand → collapse
        const expandPanel = document.querySelector(".assistant-expand-panel");

        if (activeFilterButton === btn) {
            if (expandPanel && expandPanel.style.display !== "none") {
                document.querySelectorAll(".data-filter-chev").forEach(c => c.classList.remove("rotated"));
                slideUp(expandPanel);
                return;
            }
        }

        activeFilterButton = btn;

        // Update title
        const valueEl = document.getElementById("promt-btn-text-value");
        if (valueEl) valueEl.textContent = btnMessage;

        // Rotate chevron
        document.querySelectorAll(".data-filter-chev").forEach(c => c.classList.remove("rotated"));
        const chevron = btn.querySelector(".data-filter-chev");
        if (chevron) chevron.classList.add("rotated");

        // Hide + empty assistant expand panel
        const panel = document.querySelector(".assistant-expand-panel");
        if (panel) {
            slideUp(panel);
            panel.innerHTML = "";
        }

        // Restore last hidden button
        if (lastFilterButton) {
            lastFilterButton.dataset.hiddenByUser = "false";
            lastFilterButton.style.display = "inline-block";
        }

        // Hide current filter button
        btn.dataset.hiddenByUser = "true";
        btn.style.display = "inline-block";
        lastFilterButton = btn;

        // Fetch assistant filter values
        gdWidgetgetAssistantFilterValues({
            id: localStorage.getItem("session_id"),
            prompt_id: btnId,
            category: "",
            renderInPanel: true
        });
        return;
    }

    // ===============================
    // 🔹 NATURAL LANGUAGE BUTTONS (NO ID)
    // ===============================
    if (!btnId) {
        const loader = document.getElementById("gd-chat-widget-loader-bubble");
        const changeFilter = document.getElementById("chat-widget-change_Filter_suggestion");

        if (loader) loader.style.display = "inline-flex";
        if (changeFilter) changeFilter.style.display = "none";

        const initials = gdChatWidgetGetUserInitials();
          //original
           document.querySelector(".gd-chat-widget-conversation-area")?.insertAdjacentHTML(
            "beforeend",
            `
          <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
              <div class="gd-chat-widget-user-bubble">${btnText}</div>
              <div class="gd-chat-widget-user-avatar">${initials}</div>
          </div>
        `
        );

        

       

        document.getElementById("gd-chat-widget-prompt_suggestion")?.style.setProperty("display", "none");

        document.querySelectorAll(".chat-alternative-section").forEach(el => el.remove());
        document.querySelectorAll(".filter-panel").forEach(el => el.style.display = "none");

        const input = document.getElementById("gd-chat-widget-chatInput");
        if (input) input.value = "";

        const isHistory = btnIsReset === "1" ? false : true;
        sessionStorage.setItem("is_history", isHistory);

        gdWidgetChatQuery(btnText, btnType, btnAction, null, btnId);
        return;
    }

    // ===============================
    // 🔹 FILTER-ID CUSTOM FILTER BUTTONS
    // ===============================
    if (btn.dataset.filterId) {
        gdWidgetfilterOnclick(btn.dataset.filterId, btn.dataset.filterName, btnId);
        return;
    }

    // ===============================
    // 🔹 DEFAULT CHAT BUTTONS (with ID)
    // ===============================
    const initials = gdChatWidgetGetUserInitials();
    //original
     document.querySelector(".gd-chat-widget-conversation-area")?.insertAdjacentHTML(
        "beforeend",
        `
      <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
          <div class="gd-chat-widget-user-bubble">${btnText}</div>
          <div class="gd-chat-widget-user-avatar">${initials}</div>
      </div>
    `
    );
  

    gdWidgetAjaxChat({ id: btnId, text: btnText, is_delete: 0 }, null);

   
    
});

// ------------------------------------------------------------------------
// second handler (pure JS)
// ------------------------------------------------------------------------

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".chat-alternative-section button");
    if (!btn) return;

    const target = document.getElementById("gd-chat-widget-loader-bubble");
    if (!target) return;
});


function gdWidgetpromptHandel(prompts, filterKey = null) {
  if (!prompts || !Array.isArray(prompts) || prompts.length === 0) {
    console.log("No prompts → exiting");
    return;
  }

  let reFilterPrompts = [], nonIdPrompts = [], idPrompts = [],
      alternativePrompts = [], specificProductInquiryPrompts = [],
      similarProductRequestPrompts = [];

  // ------------------------------------------------
  // LOOP PROMPTS
  // ------------------------------------------------
  prompts.forEach(function (value) {
    const type = value.type || {};
    const isObj = typeof type === "object";
    const typeName = isObj ? (type.name || '') : type;
    const isReset = isObj && 'is_reset' in type ? type.is_reset : null;
    const action = isObj && 'action' in type ? type.action : null;
    const condition = isObj && 'condition' in type ? type.condition : null;

    let attrs = `data-id="${value.id || ''}" data-message="${(value.message || '').replace(/"/g, '&quot;')}"`;

    if (isObj) {
      if (typeName) attrs += ` data-type="${typeName}"`;
      if (isReset !== null) attrs += ` data-is-reset="${isReset}"`;
      if (action !== null) attrs += ` data-action="${action}"`;
      if (condition !== null) attrs += ` data-condition="${condition}"`;
    } else if (type) {
      attrs += ` data-filter="${type}"`;
    }

    const html =
      (type === "filter" || typeName === "filter" || attrs.includes('data-filter="filter"'))
        ? `<button class="prompt-btn get-session-btn ${value.message.toLowerCase().replace(/\s+/g, '-')}" ${attrs}>
             ${value.message}<span class="data-filter-chev">${gdWidgetGetChevronSVG()}</span>
           </button>`
        : `<button class="prompt-btn get-session-btn ${value.message.toLowerCase().replace(/\s+/g, '-')}" ${attrs}>
             ${value.message}
           </button>`;

    // Categorize buttons
    if (typeName === "specific_product_inquiry") {
      specificProductInquiryPrompts.push(html);
    } else if (typeName === "similar_product_request") {
      similarProductRequestPrompts.push(html);
    } else if (!value.id && condition === "alternative") {
      alternativePrompts.push(html);
    } else if (!value.id && condition === "re_filter") {
      reFilterPrompts.push(html);
    } else if (!value.id) {
      nonIdPrompts.push(html);
    } else {
      idPrompts.push(html);
    }
  });

  // ------------------------------------------------
  // FILTER KEY BUTTON
  // ------------------------------------------------
  let filterButtonHTML = "";
  if (filterKey && filterKey.id && filterKey.name) {
    const safeName = filterKey.name.replace(/"/g, "&quot;");
    filterButtonHTML = `
      <button class="prompt-btn get-session-btn ${safeName.toLowerCase().replace(/\s+/g, '-')}"
        data-id="${filterKey.id}"
        data-message="${safeName}"
        data-filter="filter">
        ${safeName}<span class="data-filter-chev">${gdWidgetGetChevronSVG()}</span>
      </button>`;
  }

  // ------------------------------------------------
  // REORDER ID BUTTONS
  // ------------------------------------------------
  let filterKeyButton = "", filterButtonsWithId = [], otherIdButtons = [], modifyResultButton = "";
  idPrompts.forEach(btn => {
    if (filterKey && btn.includes(`data-id="${filterKey.id}"`)) {
      filterKeyButton = btn;
    } else if (btn.includes('data-id="changed_1"')) {
      modifyResultButton = btn;
    } else if (btn.includes(`data-filter="filter"`)) {
      filterButtonsWithId.push(btn);
    } else {
      otherIdButtons.push(btn);
    }
  });

  const orderedIdButtons = [
    filterKeyButton,
    ...filterButtonsWithId,
    ...otherIdButtons,
    modifyResultButton
  ].join('');

  // ------------------------------------------------
  // NON-ID BUTTON VISIBILITY
  // ------------------------------------------------
  let visible = "", hidden = "";
  if (filterKey) {
    visible = "";
    hidden = nonIdPrompts.join("");
  } else {
    visible = nonIdPrompts.slice(0, 4).join("");
    hidden = nonIdPrompts.slice(4).join("");
  }
  originalHiddenButtonsHTML = hidden;

  // ---------- Headings with chevrons (product page only) ----------
  const chevronSVG = gdWidgetGetChevronSVG();
  const isProductPage = window.isProductPage === true;

  // Make it yours heading
  let makeYoursHeadingHTML = '';
  if (filterKey) {
    if (isProductPage) {
      makeYoursHeadingHTML = `
        <p class="make-your-text make-yours-filter">
          <span class="toggle-make-yours-heading">
            <strong>Make it yours - </strong>
            <span class="chevron">${chevronSVG}</span>
          </span>
          <span id="spantext" style="display: none;">
            Refine your results: tap a 
            <span id="promt-btn-text-value" data-id="${filterKey.id}">${filterKey.name}</span> 
            or adjust your filters below
          </span>
        </p>`;
    } else {
      makeYoursHeadingHTML = `
        <p class="make-your-text make-yours-filter">
          <strong>Make it yours - </strong>
          <span id="spantext">
            Refine your results: tap a 
            <span id="promt-btn-text-value" data-id="${filterKey.id}">${filterKey.name}</span> 
            or adjust your filters below
          </span>
        </p>`;
    }
  } else {
    makeYoursHeadingHTML = `<strong class="suggestedsuggested-searches-heading">Suggested Searches:</strong>`;
  }

  // Find the one heading
  let findTheOneHeadingHTML = '';
  if (reFilterPrompts.length) {
    const rawFirst = reFilterPrompts[0].replace(/<[^>]+>/g, "").trim();
    let firstWord = rawFirst.split(/\s+/)[0] || "this selection";
    const genericWords = ["show","view","see","find","all","these","the","this","check","explore","browse","discover","try"];
    if (genericWords.includes(firstWord.toLowerCase())) firstWord = "this selection";

    if (isProductPage) {
      findTheOneHeadingHTML = `
        <p class="find-heading-subheading">
          <span class="toggle-find-one-heading">
            <strong class="find-the-one-heading">Find the one - </strong>
            <span class="chevron">${chevronSVG}</span>
          </span>
          <span class="find-the-one-subtext" style="display: none;">Do you want to explore all variants related to "${firstWord}"?</span>
        </p>`;
    } else {
      findTheOneHeadingHTML = `
        <p class="find-heading-subheading">
          <strong class="find-the-one-heading">Find the one - </strong>
          <span class="find-the-one-subtext">Do you want to explore all variants related to "${firstWord}"?</span>
        </p>`;
    }
  }

  // ------------------------------------------------
  // SHOW MORE
  // ------------------------------------------------
  let showMoreHTML = "";
  if (!filterKey && nonIdPrompts.length > 4) {
    showMoreHTML = `<div class="toggle-makeyours" role="button" tabindex="0">Show More</div>`;
  }

  // ------------------------------------------------
  // FINAL MAKE-YOURS SECTION
  // ------------------------------------------------
  const hasMakeYoursButtons = Boolean(filterButtonHTML) || nonIdPrompts.length > 0 || idPrompts.length > 0 || modifyResultButton;
  let makeYoursHTML = '';
  if (hasMakeYoursButtons) {
    const btnWrapperHiddenStyle = (isProductPage && filterKey) ? ' style="display: none;"' : '';
    makeYoursHTML = `
      <div class="suggested-make-it-yours-wrapper">
        ${makeYoursHeadingHTML}
        <div class="prompt-btn-wrapper ${filterKey ? "make-yours-filter" : "suggested-search-wrapper"}"${btnWrapperHiddenStyle}>
          ${filterButtonHTML}
          ${!filterKey ? visible : ""}
          ${filterKey ? orderedIdButtons : orderedIdButtons.replace(modifyResultButton, "")}
          ${!filterKey ? modifyResultButton : ""}
          ${showMoreHTML}
        </div>
        ${hidden ? `<div class="make-yours-expand-panel" style="display:none;"><div class="make-yours-expand-button-wrapper">${hidden}</div></div>` : ""}
        <div class="assistant-expand-panel" style="display:none;"></div>
      </div>`;
  }

  // ------------------------------------------------
  // FIND THE ONE SECTION
  // ------------------------------------------------
  let findTheOneHTML = '';
  if (reFilterPrompts.length) {
    const reWrapperHiddenStyle = isProductPage ? ' style="display: none;"' : '';
    findTheOneHTML = `
      <div class="refilter-section">
        ${findTheOneHeadingHTML}
        <div class="prompt-btn-wrapper re-filter-wrapper"${reWrapperHiddenStyle}>
          ${reFilterPrompts.join('')}
          ${reFilterPrompts.length > 4 ? `<div class="toggle-refilter" role="button" tabindex="0">View all<span class="chev">${gdWidgetGetChevronSVG()}</span></div>` : ""}
        </div>
      </div>`;
  }

  // ------------------------------------------------
  // ALTERNATIVE SECTION
  // ------------------------------------------------
  if (alternativePrompts.length) {
    const alternativeHTML = `
      <div class="chat-alternative-section" data-injected="true">
        <div class="alternative-btn-wrapper">${alternativePrompts.join("")}</div>
      </div>`;
    const msgs = document.querySelectorAll(".gd-chat-widget-conversation-area .gd-chat-widget-bot-msg");
    const lastBotMsg = msgs[msgs.length - 1];
    if (lastBotMsg) {
      const nextAlt = lastBotMsg.nextElementSibling;
      if (nextAlt?.classList.contains("chat-alternative-section")) nextAlt.remove();
      lastBotMsg.insertAdjacentHTML("afterend", alternativeHTML);
    }
  }

  // ------------------------------------------------
  // SPECIFIC PRODUCT INQUIRY & SIMILAR PRODUCT REQUEST
  // ------------------------------------------------
  let specificProductInquiryHTML = '';
  if (specificProductInquiryPrompts.length) {
    specificProductInquiryHTML = `
      <div class="specific-product-inquiry-section">
        <p class="specific-product-heading"><strong>Product details you may want to know</strong></p>
        <div class="prompt-btn-wrapper specific-product-inquiry-wrapper">${specificProductInquiryPrompts.join("")}</div>
      </div>`;
  }
  let similarProductRequestHTML = '';
  if (similarProductRequestPrompts.length) {
    similarProductRequestHTML = `
      <div class="similar-product-request-section">
        <p class="similar-product-heading"><strong>Explore similar styles</strong></p>
        <div class="prompt-btn-wrapper similar-product-request-wrapper">${similarProductRequestPrompts.join("")}</div>
      </div>`;
  }

  // ------------------------------------------------
  // WRITE TO DOM
  // ------------------------------------------------
  const container = document.getElementById("gd-chat-widget-prompt_suggestion");
  if (container) {
    container.innerHTML = `
      <div class="prompt-sections-wrapper">
       <!-- ${specificProductInquiryHTML}-->
       <!-- ${similarProductRequestHTML}-->
        ${makeYoursHTML}
        ${findTheOneHTML}
      </div>`;

    // Inject CSS for chevron rotation if not already present
    if (!document.getElementById('chevron-rotate-style')) {
      const style = document.createElement('style');
      style.id = 'chevron-rotate-style';
      style.textContent = `
        .chevron, .chev {
          display: inline-block;
          transition: transform 0.3s ease;
        }
        .chevron.rotate, .chev.rotate {
          transform: rotate(180deg);
        }
      `;
      document.head.appendChild(style);
    }

    // ------------------------------------------------
    // TOGGLE HANDLERS (only on product page)
    // ------------------------------------------------
    if (isProductPage) {
      // Make it yours toggle
      const makeToggle = document.querySelector('.toggle-make-yours-heading');
      if (makeToggle) {
        makeToggle.addEventListener('click', function(e) {
          e.stopPropagation();
          const spantext = document.getElementById('spantext');
          const btnWrapper = document.querySelector('.suggested-make-it-yours-wrapper .prompt-btn-wrapper');
          const chevron = this.querySelector('.chevron');
          const makeYoursPanel = document.querySelector('.make-yours-expand-panel');
          const assistantPanel = document.querySelector('.assistant-expand-panel');
          if (spantext && btnWrapper) {
            const isCurrentlyHidden = spantext.style.display === 'none';


            makeToggle.classList.toggle('toggle-make-yours-heading-open', isCurrentlyHidden)
          
            // Toggle visibility
            spantext.style.display = isCurrentlyHidden ? 'inline' : 'none';
            btnWrapper.style.display = isCurrentlyHidden ? 'flex' : 'none';
            // Rotate chevron: add rotate class when expanding (becoming visible)
            if (chevron) {
              chevron.classList.toggle('rotate', isCurrentlyHidden);
            }
            if (!makeToggle.classList.contains('toggle-make-yours-heading-open')) {
              if (makeYoursPanel) makeYoursPanel.style.display = 'none';
              if (assistantPanel) assistantPanel.style.display = 'none';
            }
          }
        });
      }

      // Find the one toggle
      const findToggle = document.querySelector('.toggle-find-one-heading');
      if (findToggle) {
        findToggle.addEventListener('click', function(e) {
          e.stopPropagation();
          const subtext = document.querySelector('.find-the-one-subtext');
          const reWrapper = document.querySelector('.re-filter-wrapper');
          const chevron = this.querySelector('.chevron');
          if (subtext && reWrapper) {
            const isCurrentlyHidden = subtext.style.display === 'none';
            subtext.style.display = isCurrentlyHidden ? 'inline' : 'none';
            reWrapper.style.display = isCurrentlyHidden ? 'flex' : 'none';
            if (chevron) {
              chevron.classList.toggle('rotate', isCurrentlyHidden);
            }
          }
        });
      }
    }
  }


  const containerproduct = document.getElementById("gd-chat-widget-prompt_suggestion-for-product");
  if (containerproduct) {
    containerproduct.innerHTML = `
    <div class="prompt-sections-wrapper">
      ${specificProductInquiryHTML}
      ${similarProductRequestHTML}
    </div>`;
  }


  gdWidgetapplyInitialPromptVisibility();
}

window.gdWidgetpromptHandel = gdWidgetpromptHandel;


document.addEventListener("click", function (e) {
    const t = e.target.closest(".toggle-refilter");
    if (!t) return;

    e.preventDefault();

    const wrap = t.closest(".re-filter-wrapper");
    const expanded = wrap.classList.contains("expanded");

    wrap.classList.toggle("expanded", !expanded);

    // Replace first text node (same logic as jQuery .contents().filter(nodeType===3))
    const textNode = Array.from(t.childNodes).find(n => n.nodeType === 3);
    if (textNode) {
        textNode.textContent = expanded ? "View all " : "View less ";
    }
});

document.addEventListener("click", function (e) {
    const t = e.target.closest(".toggle-makeyours");
    if (!t) return;

    e.preventDefault();

    const panel = document.querySelector(".make-yours-expand-panel");
    if (!panel) return;

    const showMore = t.textContent.trim().toLowerCase() === "show more";

    if (showMore) {
        panel.style.display = "block";
        t.textContent = "Show Less";
    } else {
        panel.style.display = "none";
        t.textContent = "Show More";
    }
});

function gdWidgethandleAssistantFilterResponse(response, payload) {
    if (!payload || payload.dropdown === 'chat-widget-top-bar-filter') return;

    const renderInPanel = payload.renderInPanel || false;
    const filterKey = Object.keys(response)[0];
    const filterValues = response[filterKey] || [];

    const panel = document.querySelector(".assistant-expand-panel");
    if (!panel || !renderInPanel) return;

    // No values → hide + empty
    if (!filterValues.length) {
        panel.style.display = "none";
        panel.innerHTML = "";
        return;
    }

    const html = `
        <div class="assistant-buttons">
            ${filterValues.map(v => `
                <button class="prompt-btn assistant-btn ${v.name.toLowerCase().replace(/\s+/g, '-')}"
                    data-message="${v.name}">
                    ${v.name}
                </button>
            `).join('')}
        </div>
    `;

    panel.innerHTML = html;
    panel.style.display = "block";
}

function gdWidgetapplyInitialPromptVisibility() {
    const refilter = document.querySelector(".re-filter-wrapper");
    const makeYours = document.querySelector(".prompt-btn-wrapper.make-yours-filter");

    if (!refilter || !makeYours) return;

    const buttons = refilter.querySelectorAll('.prompt-btn[data-filter], .filter-btn-user-getsession');

    buttons.forEach(btn => {
        makeYours.appendChild(btn);
    });
}


function gdWidgetgetAssistantFilterValues(payload) {

    gdWidgetFreezeActions();

    const token = getGDChatWidgetAiToken();
    const headers = {
        "Content-Type": "application/json"
    };

    if (token) {
        headers["Authorization"] = "Bearer " + token;
    }

    fetch("https://ai.mygoddiva.com/get-assistant-filter-values", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(payload || {})
    })
    .then(res => res.json())
    .then(response => {
        console.log("Filter Values Response:", response);

        // Always update prompt buttons
        gdWidgethandleAssistantFilterResponse(response, payload);

        // Build dropdown if data exists
        const categoryKey = payload.category.toLowerCase().replace(/\s+/g, "_");

        if (response[categoryKey] && response[categoryKey].length > 0) {
            gdWidgetaddDropdownToggleToFilter(payload.category, payload.prompt_id);
            gdWidgetcreateFilterDropdown(
                response[categoryKey],
                payload.category,
                payload.prompt_id
            );
        }
        gdWidgetReleaseActions();
    })
    .catch(err => {
        const loader = document.getElementById("gd-chat-widget-loader-bubble");
        if (loader) loader.style.display = "none";
        gdWidgetReleaseActions();
        console.error("Error fetching filter values:", err);
    });
}

function gdWidgetaddDropdownToggleToFilter(category, promptId) {

    const button = document.querySelector(`button.change-filter[data-category="${category}"]`);
    const deleteBtn = document.querySelector(`button.delete-filter[data-category="${category}"]`);

    if (!button || !deleteBtn) return;

    // Remove existing dropdown toggle siblings
    const siblingToggles = button.parentElement.querySelectorAll('.chat-dropdown-toggle');
    siblingToggles.forEach(el => el.remove());

    // Create toggle element
    const toggle = document.createElement("span");
    toggle.className = "chat-dropdown-toggle";
    toggle.innerHTML = `
        <svg class="svg-inline--fa fa-chevron-down drop-icon-svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"></path></svg>
    `;

    // Clicking toggle → open dropdown
    toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        gdWidgettoggleFilterDropdown(category, promptId);
    });

    // Apply click handlers on button clickable parts
    button.querySelectorAll(".filter-category, .filter-value, .chat-dropdown-toggle")
        .forEach(el => {
            el.addEventListener("click", function (e) {
                e.stopPropagation();
                gdWidgettoggleFilterDropdown(category, promptId);
            });
        });

    // Insert toggle after button
    button.parentElement.insertBefore(toggle, button.nextSibling);
}

function gdWidgettoggleFilterDropdown(category, promptId) {
    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");
    const wrapper = document
        .querySelector(`button.change-filter[data-category="${category}"]`)
        ?.closest(".change-filter-btn-wrapper");

    if (!dropdown || !wrapper) return;

    // Remove active class from all wrappers
    document.querySelectorAll(".change-filter-btn-wrapper")
        .forEach(el => el.classList.remove("active"));

    const isVisible = dropdown.style.display === "block";
    const currentCategory = dropdown.dataset.category;

    // If already open for same category → close it
    if (isVisible && currentCategory === category) {
        dropdown.style.display = "none";
        delete dropdown.dataset.category;
        wrapper.classList.remove("active");
        return false;
    }

    // Open for the new category
    wrapper.classList.add("active");
    dropdown.dataset.category = category;
    dropdown.style.display = "block";

    // Fetch new assistant filter values
    gdWidgetgetAssistantFilterValues({
        id: localStorage.getItem("session_id"),
        prompt_id: promptId,
        category: category
    });
}


document.addEventListener("click", function (event) {

    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");
    if (!dropdown) return;

    const isVisible = dropdown.style.display === "block";

    const clickedInsideDropdown = event.target.closest("#chat-widget-global-chat-dropdown");
    const clickedInsideWrapper = event.target.closest(".change-filter-btn-wrapper");

    // If open + clicked outside → close
    if (isVisible && !clickedInsideDropdown && !clickedInsideWrapper) {

        const activeCategory = dropdown.dataset.category;

        if (activeCategory) {
            const wrapper = document
                .querySelector(`button.change-filter[data-category="${activeCategory}"]`)
                ?.closest(".change-filter-btn-wrapper");

            if (wrapper) wrapper.classList.remove("active");
        }

        dropdown.style.display = "none";
        delete dropdown.dataset.category;
    }
});


function gdWidgetcreateFilterDropdown(categoryData, category, promptId) {

    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");
    if (!dropdown) return;

    dropdown.innerHTML = ""; // $dropdown.empty()

    if (!Array.isArray(categoryData) || categoryData.length === 0) {
        dropdown.style.display = "none";
        return;
    }

    // -----------------------------------------------
    // SORT ALPHABETICALLY (same as your jQuery code)
    // -----------------------------------------------
    categoryData.sort((a, b) =>
        a.name.localeCompare(b.name, "en", { sensitivity: "base" })
    );

    // -----------------------------------------------
    // CLOSE ICON
    // -----------------------------------------------
    const closeBtn = document.createElement("div");
    closeBtn.className = "chat-dropdown-close";
    closeBtn.innerHTML = "&times;"; // × icon

    closeBtn.addEventListener("click", () => {
        dropdown.style.display = "none";
    });

    dropdown.appendChild(closeBtn);

    // -----------------------------------------------
    // BUILD <ul> WRAPPER FOR <li> ITEMS
    // -----------------------------------------------
    const ul = document.createElement("ul");
    ul.className = "chat-widget-dropdown-list";

    categoryData.forEach(item => {
        const li = document.createElement("li");
        li.className = "chat-widget-dropdown-item";

        li.textContent = item.name;
        li.dataset.id = item.id;
        li.dataset.value = item.name;
        li.dataset.category = category;
        li.dataset.name = "product_suggestion_request";
        li.dataset.action = "update";

        ul.appendChild(li);
    });

    dropdown.appendChild(ul);

    dropdown.dataset.category = category; // $dropdown.data('category')

    // Run your existing positioning function
    // gdWidgetpositionDropdownNearFilterButton(category);

    dropdown.style.display = "flex"; // $dropdown.show()
}



function gdWidgetpositionDropdownNearFilterButton(category) {
    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");
    const tag = document.querySelector(`button.change-filter[data-category="${category}"]`);

    if (!dropdown || !tag) return;

    const rect = tag.getBoundingClientRect();
    const dropdownHeight = 200;
    const spaceBelow = window.innerHeight - rect.bottom;
    const showAbove = spaceBelow < dropdownHeight && rect.top > dropdownHeight;

    // jQuery outerWidth() → approximate using offsetWidth
    const finalWidth = tag.offsetWidth + 60;

    dropdown.style.position = "fixed";
    dropdown.style.top = showAbove
        ? (rect.top - dropdownHeight - 5) + "px"
        : (rect.bottom + 5) + "px";

    dropdown.style.left = rect.left + "px";

    // jQuery minWidth → style.minWidth
    dropdown.style.minWidth = tag.offsetWidth + "px";

    dropdown.style.display = "block";
    dropdown.style.zIndex = "1001";
    dropdown.style.width = finalWidth + "px";
}

document.addEventListener("click", function (event) {
    const li = event.target.closest("#chat-widget-global-chat-dropdown li");
    if (!li) return;

    const value = li.textContent.trim();
    const id = li.dataset.id;
    const category = document.getElementById("chat-widget-global-chat-dropdown").dataset.category;

    if (!category || !value) return;

    const wrapper = document
        .querySelector(`button.change-filter[data-category="${category}"]`)
        ?.closest(".change-filter-btn-wrapper");

    if (!wrapper) return;

    const changeButton = wrapper.querySelector(".change-filter");
    const deleteButton = wrapper.querySelector(".delete-filter");

    const name = li.dataset.name;
    const action = li.dataset.action;
    const label = category ? category.toLowerCase() : null;

    // Update change button display + dataset
    const filterValueEl = changeButton.querySelector(".filter-value");
    if (filterValueEl) filterValueEl.textContent = value;

    changeButton.dataset.value = value;
    changeButton.dataset.id = id;

    // Update delete button dataset
    deleteButton.dataset.value = value;
    deleteButton.dataset.id = id;

    // Close dropdown
    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");
    dropdown.style.display = "none";
    delete dropdown.dataset.category;

    wrapper.classList.remove("active");

    // Show loader
    const loader = document.getElementById("gd-chat-widget-loader-bubble");
    if (loader) loader.style.display = "inline-flex";

    // Chat message output
    const message = `${value}`;
    const userInitials = gdChatWidgetGetUserInitials();

    document.querySelector(".gd-chat-widget-conversation-area")?.insertAdjacentHTML(
        "beforeend",
        `
        <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
            <div class="gd-chat-widget-user-bubble">${message}</div>
            <div class="gd-chat-widget-user-avatar">${userInitials}</div>
        </div>
        `
    );

    // Trigger assistant call
    gdWidgetChatQuery(message, name, action, label);
});

function gdWidgetchangeFilterAjax() {

    // Correct selector (# added exactly as you intended)
    const loader = document.getElementById("gd-chat-widget-loader-bubble");
    if (loader) loader.style.display = "inline-flex";

    // Hide prompt suggestion
    const promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");
    if (promptSuggestion) promptSuggestion.style.display = "none";

    // Remove alternative buttons
    document.querySelectorAll(".chat-alternative-section").forEach(el => el.remove());

    const token = getGDChatWidgetAiToken();

    const sessionId = localStorage.getItem("session_id");
    const url = "https://ai.mygoddiva.com/get-selected-filter?id=" + encodeURIComponent(sessionId);

    fetch(url, {
        method: "GET",
        headers: token ? { "Authorization": "Bearer " + token } : {}
    })
    .then(res => res.json())
    .then(response => {

        // Same as your original
        const tagContainer = document.querySelector(".chat-widget-tag-container");
        if (tagContainer) {
            tagContainer.innerHTML = "";
            tagContainer.style.display = "none";
        }

        if (loader) loader.style.display = "none";

        const topBar = document.getElementById("chat-widget-top-bar");
        if (topBar) topBar.style.display = "block";

        if (promptSuggestion) promptSuggestion.style.display = "block";

        const wrapper = document.getElementById("chat-widget-change_Filter_suggestion");
        if (wrapper) {
            wrapper.innerHTML = "";
            wrapper.insertAdjacentHTML(
                "beforeend",
                gdWidgetchangeFilterHtml(response.selected_filters)
            );
            wrapper.style.display = "block";
        }

        document.querySelectorAll(".filter-panel").forEach(el => {
            el.style.display = "none";
        });
    })
    .catch(error => {
        console.error("AJAX Error:", error);
    });
}

function gdWidgetchangeFilterHtml(filters) {
    console.log(filters, 'filters');

    let filterHtml = `<div class="filter-wrapper">`;

    filters.forEach(function (value) {
        const hasChanged = value.is_has_changed == 1;

        filterHtml += `
        <div class="change-filter-btn-wrapper">
            <button 
                class="change-filter" 
                data-category="${value.filter}" 
                data-ishaschanged="${value.is_has_changed}"
                ${hasChanged ? `onclick="gdWidgetchangeFilterhandel('${value.prompt_id}','${value.message}','${value.filter}')"` : ''}>
                
                ${value.filter ? `<span class="filter-category">${value.filter} :</span>` : ''}
                
                <span class="filter-value">${value.label}</span>

                ${hasChanged ? `
                <span class="chat-dropdown-toggle">
                    <svg class="svg-inline--fa fa-chevron-down drop-icon-svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"></path></svg>
                </span>` : ''}
            </button>

            <button 
                data-category="${value.filter}" 
                data-prompt-id="${value.prompt_id}" 
                data-value="${value.label}" 
                data-id="${value.prompt_id}" 
                data-ishaschanged="${value.is_has_changed}" 
                data-name="product_suggestion_request" 
                data-action="remove" 
                class="delete-filter">x</button>
        </div>`;
    });

    filterHtml += `</div>`;

    console.log("filters.length", filters.length);

    // 🔹 Show/Hide elements (converted from jQuery)
    const lookingFor = document.querySelector(".chat-widget-looking-for");
    const topBar = document.getElementById("chat-widget-top-bar");

    if (filters.length >= 3) {
        if (lookingFor) lookingFor.style.display = "block";
        if (topBar) topBar.style.display = "block";
    } else {
        if (lookingFor) lookingFor.style.display = "none";
        // Note: original jQuery hides ONLY .chat-widget-looking-for, not #chat-widget-top-bar
    }

    return filterHtml;
}

document.addEventListener("click", function (event) {
    const deleteButton = event.target.closest(".delete-filter");
    if (!deleteButton) return;

    const wrapper = deleteButton.closest(".change-filter-btn-wrapper");

    const category     = deleteButton.dataset.category;
    const id           = deleteButton.dataset.id;
    const value        = deleteButton.dataset.value;
    const promptId     = deleteButton.dataset.promptId;
    const ishaschanged = parseInt(deleteButton.dataset.ishaschanged);
    const name         = deleteButton.dataset.name;
    const action       = deleteButton.dataset.action;

    const dropdown = document.getElementById("chat-widget-global-chat-dropdown");

    // Remove the button wrapper
    if (wrapper) wrapper.remove();

    // Hide dropdown
    if (dropdown) dropdown.style.display = "none";

    // If no filter wrappers remain, hide container
    if (document.querySelectorAll(".change-filter-btn-wrapper").length === 0) {
        const changeSuggestion = document.getElementById("chat-widget-change_Filter_suggestion");
        if (changeSuggestion) changeSuggestion.style.display = "none";
    }

    // Build delete message
    const deleteLabel = `remove ${value}`;
    const userInitials = gdChatWidgetGetUserInitials();

    // Append message bubble
    document.querySelector(".gd-chat-widget-conversation-area")?.insertAdjacentHTML(
        "beforeend",
        `
        <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
            <div class="gd-chat-widget-user-bubble">${deleteLabel}</div>
            <div class="gd-chat-widget-user-avatar">${userInitials}</div>
        </div>
        `
    );

    // Show loader
    const loader = document.getElementById("gd-chat-widget-loader-bubble");
    if (loader) loader.style.display = "inline-flex";
    
    // Fire assistant query
    if (ishaschanged === 0) {
        gdWidgetChatQuery(deleteLabel, name, action, null, promptId);
    } else {
        gdWidgetChatQuery(deleteLabel, name, action, category.toLowerCase());
    }
});


function gdWidgetchangeFilterhandel(id, label, category) {
    const tagContainer = document.querySelector(".chat-widget-tag-container");
    if (tagContainer) {
        tagContainer.innerHTML = "";
        tagContainer.style.display = "none";
    }

    gdWidgetgetAssistantFilterValues({
        id: localStorage.getItem("session_id"),
        prompt_id: id,
        category: category,
        dropdown: "chat-widget-top-bar-filter"
    });
}

// 🔥 Make it globally accessible for inline onclick
window.gdWidgetchangeFilterhandel = gdWidgetchangeFilterhandel;


function slideDown(elem, duration = 300) {
    elem.style.removeProperty('display');
    let display = window.getComputedStyle(elem).display;
    if (display === 'none') display = 'block';
    elem.style.display = display;

    const height = elem.offsetHeight;
    elem.style.overflow = 'hidden';
    elem.style.height = '0px';
    elem.offsetHeight; // force reflow

    elem.style.transition = `height ${duration}ms ease`;
    elem.style.height = height + 'px';

    setTimeout(() => {
        elem.style.removeProperty('height');
        elem.style.removeProperty('overflow');
        elem.style.removeProperty('transition');
    }, duration);
}

function slideUp(elem, duration = 300) {
    elem.style.height = elem.offsetHeight + 'px';
    elem.style.overflow = 'hidden';
    elem.style.transition = `height ${duration}ms ease`;

    elem.offsetHeight; // reflow
    elem.style.height = '0px';

    setTimeout(() => {
        elem.style.display = 'none';
        elem.style.removeProperty('height');
        elem.style.removeProperty('overflow');
        elem.style.removeProperty('transition');
    }, duration);
}


function gdNormalizePrompts(arr) {
    if (!Array.isArray(arr)) return [];

    return arr.map(item => {
        if (typeof item === "string") {
            return { message: item };
        }
        if (typeof item === "object" && item && !item.message) {
            return { ...item, message: "" };
        }
        return item;
    });
}

window.gdNormalizePrompts = gdNormalizePrompts;

var currentFilterKey = null;

function gdChatWidgetChatResponse(response, filter = null, productId = null, promptId = null) {

    const conversationArea = document.querySelector(".gd-chat-widget-conversation-area");
    if (!conversationArea) return;

    // ---------------------------------------------------
    // Hide loader
    // ---------------------------------------------------
    const loader = document.getElementById("gd-chat-widget-loader-bubble");
    if (loader) loader.style.display = "none";

    const promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");
    if (promptSuggestion) promptSuggestion.style.display = "block";

    // ---------------------------------------------------
    // 1️⃣ Append USER MESSAGE (avoid duplicates)
    // ---------------------------------------------------
    if (response.message && !productId) {

        // 1️⃣ Find the LAST user message bubble (the text only)
            const lastUserBubble = conversationArea.querySelector(
                ".gd-chat-widget-user-msg .gd-chat-widget-user-bubble:last-child"
            );

            const newMsg = response.message.trim();
            const oldMsg = lastUserBubble ? lastUserBubble.textContent.trim() : "";

            // 2️⃣ Only append if it's NOT a duplicate
            if (newMsg !== oldMsg) {
                const userInitials = gdChatWidgetGetUserInitials();

                const userHtml = `
                    <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
                        <div class="gd-chat-widget-user-bubble">${newMsg}</div>
                        <div class="gd-chat-widget-user-avatar">${userInitials}</div>
                    </div>
                `;

                conversationArea.insertAdjacentHTML("beforeend", userHtml);
            }
    }

    // ---------------------------------------------------
    // Hide previous filter panel (old jQuery)
    // ---------------------------------------------------
    if (filter) {
        const panels = document.querySelectorAll(`.filter-panel-${filter.prompt_id}`);
        panels.forEach(panel => panel.style.display = "none");
    }

    // ---------------------------------------------------
    // Append BOT RESPONSE (with filters) 
    // ---------------------------------------------------
    const botResponseHTML = gdWidgetbotResponseHandel(
        response.response,
        response.filters,
        promptId
    );

    conversationArea.insertAdjacentHTML("beforeend", botResponseHTML);
    

  //   setTimeout(() => {
  //     window.gdWidgetAutoScroll();
  // }, 100);
   

    // ---------------------------------------------------
    // 3️⃣ PRODUCT RESULTS
    // ---------------------------------------------------
    if (response.products && response.products.total > 0) {

        const sliderHTML = `
            <div class="gd-widget-drag-scroll"
                data-id="${response.id}"
                data-total="${response.products.total}"
                data-page="1"
                data-has="true">
                
                <div class="swiper chat-swiper gd-chat-widget-product-swiper">
                    <div class="chat-product-item-wrapper swiper-wrapper"></div>
                </div>

                <div class="swiper-button-prev gd-chat-widget-product-prev chat-swiper-prev" aria-label="Previous product"></div>
                <div class="swiper-button-next gd-chat-widget-product-next chat-swiper-next" aria-label="Next product"></div>
            </div>
        `;

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = sliderHTML;
        const newSlider = tempDiv.firstElementChild;

        conversationArea.appendChild(newSlider);
        gdChatWidgetInitLazyLoad(newSlider, newSlider.dataset.id, response.products);
        if (document.querySelectorAll('.gd-widget-drag-scroll').length === 1) {
        // yathu asked to remove 3 oct
        // document.querySelector('.gd-chat-widget-conversation-area')?.insertAdjacentHTML('beforeend',gdWidgetProductRecommendationFeedback(newSlider.dataset.id));
        }

        // setTimeout(() => {
        //     window.gdWidgetAutoScroll();
        // }, 100);
    }

    // ---------------------------------------------------
    // 4️⃣ HANDLE FILTER TAGS
    // ---------------------------------------------------
    if (response.selected_filter) gdWidgetSelectedFilter(response.selected_filter);

    const changeFilter = document.getElementById('chat-widget-change_Filter_suggestion');
    const tagContainers = document.querySelectorAll('.chat-widget-tag-container');

    // Trim innerHTML like $.trim()
    if (changeFilter && changeFilter.innerHTML.trim() !== "") {
        tagContainers.forEach(function (el) {
            el.style.display = 'none';
        });
    } else {
        tagContainers.forEach(function (el) {
            el.style.display = '';
        });
    }

    if (response.filter_key) {
        currentFilterKey = response.filter_key;
        console.log("currentFilterKey user-query", currentFilterKey);
    }

    // if (response.suggestions) {
    //     gdWidgetpromptHandel(response.suggestions, response.filter_key);
    // }

    if (response.suggestions) {
          gdWidgetpromptHandel(
              gdNormalizePrompts(response.suggestions),
              response.filter_key
          );
      }


      if (response.trigger_prompt_id) {
          setTimeout(function() {
              var triggerBtn = document.querySelector('.prompt-btn[data-id="' + response.trigger_prompt_id + '"]');
              var toggleHeadingBtnProductPage = document.querySelector('.toggle-make-yours-heading');
              if (triggerBtn && triggerBtn.getAttribute('data-filter') === 'filter') {
                  if(toggleHeadingBtnProductPage){
                    toggleHeadingBtnProductPage.click();
                  }
                  triggerBtn.click();
              }
          }, 500);
      }


    // ---------------------------------------------------
    // 5️⃣ SIZE REMINDER
    // ---------------------------------------------------
    if (response.is_size_mentioned === 1) {

        const reminderHtml = `
            <div class="gd-chat-widget-msg-row gd-chat-widget-bot-msg size-reminder">
                <div class="gd-chat-widget-bot-avatar-small">G</div>
                <div class="gd-chat-widget-bot-reply">
                    Looking for different Size(s)? Tap below to update<br>
                    <button id="gdChatWidgetSizeMentioned">Change Your Size</button>
                </div>
            </div>
        `;

        setTimeout(() => {
            conversationArea.querySelectorAll(".size-reminder").forEach(el => el.remove());
            conversationArea.insertAdjacentHTML("beforeend", reminderHtml);
        }, 500);
    }

    //return portal start
     

    let requestType = '';
    if (response.type) {
      requestType = response.type;
    }

    if (response.line_items) {
      const lineItems = response.line_items;
      const originalQuery = response._originalQuery || response.message || '';

      // ── Build last_return_items from complete_label ──
      const completeLabels = lineItems?.requested?.return?.return_label?.complete_label || [];
      const rawLastReturn  = [];
      completeLabels.forEach(returnRequest => {
        returnRequest.items?.forEach(seller => {
          seller.items?.forEach(item => {
            if (item.is_return == 3 || item.alteration_request_status != null) return;
            rawLastReturn.push({
              brand_id      : item.brand_id,
              brand_name    : item.brand,
              requested_date: item.requested_date,
            });
          });
        });
      });
      const latestByBrand = new Map();
      rawLastReturn
        .sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date))
        .forEach(item => {
          if (!latestByBrand.has(item.brand_id)) latestByBrand.set(item.brand_id, item);
        });
      lineItems.last_return_items = Array.from(latestByBrand.values());

      // ── Build last_pending_fees_items from pending_label ──
      const pendingLabels = lineItems?.requested?.return?.return_label?.pending_label || [];
      const rawPendingFees = [];
      pendingLabels.forEach(label => {
        label.items?.forEach(seller => {
          seller.items?.forEach(item => {
            rawPendingFees.push({
              brand_id      : item.brand_id,
              brand_name    : item.brand,
              requested_date: item.requested_date,
            });
          });
        });
      });
      const latestPendingByBrand = new Map();
      rawPendingFees
        .sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date))
        .forEach(item => {
          if (!latestPendingByBrand.has(item.brand_id)) latestPendingByBrand.set(item.brand_id, item);
        });
      lineItems.last_pending_fees_items = Array.from(latestPendingByBrand.values());

      // ── Flatten items ──
      const notRequestedItems = (lineItems.not_requested || []).flatMap(s => s.items || []);
      const outletReturnItems = (lineItems.partner_id == 1)
        ? (lineItems.outlet || []).flatMap(s => s.items || [])
        : [];
      const allReturnItems = [...notRequestedItems, ...outletReturnItems];
      let newPanel = null;

      // ── Return panel ──
      if (requestType == 'return_request') {
        if (allReturnItems.length > 0) {
          // Freeze all existing return panels
          conversationArea.querySelectorAll('.gd-chat-widget-li-panel').forEach(p => {
            gdWidgetResetPanel(p);
            gdWidgetFreezePanel(p, 'Updated return panel available below');
          });

          const html = gdWidgetRenderLineItems(allReturnItems, lineItems);
          conversationArea.insertAdjacentHTML('beforeend', html);

          const allReturnPanels = conversationArea.querySelectorAll('.gd-chat-widget-li-panel');
          newPanel = allReturnPanels[allReturnPanels.length - 1];

          if (newPanel) {
            gdWidgetSetPanelReasons(newPanel, lineItems.reasons || []);
            gdWidgetUpdateGiftBag(newPanel);
            newPanel.dataset.originalQuery = originalQuery;
            newPanel.dataset.pendingLabels = JSON.stringify(pendingLabels);
            newPanel.dataset.shippingCode  = lineItems.shipping_country_code || '';
            newPanel.dataset.returnFee     = lineItems.return_fee || 0;
          }
        }

        // ── Requested items (read-only history) ──
       const requestedHtml = gdWidgetRenderRequestedItems(lineItems, newPanel?.id || null);
        if (requestedHtml) {
          if (newPanel) {
            newPanel.insertAdjacentHTML('beforeend', requestedHtml);
          } else {
            const wrapperId = `gd-chat-widget-req-wrapper_${Date.now()}`;
            conversationArea.insertAdjacentHTML('beforeend', `
              <div class="gd-chat-widget-li-requested-only"
                  id="${wrapperId}"
                  data-order-id="${lineItems.order || ''}"
                  data-customer-id="${lineItems.customer || ''}"
                  data-pending-labels='${gdWidgetEscHtml(JSON.stringify(pendingLabels))}'
                  data-shipping-code="${lineItems.shipping_country_code || ''}"
                  data-return-fee="${lineItems.return_fee || 0}"
                  data-original-query="${gdWidgetEscHtml(originalQuery)}">
                ${requestedHtml}
                ${gdWidgetRenderRequestedPopups(wrapperId)}
              </div>
            `);
          }
        }

        // ── Auto-show payment popup if pending labels exist ──
        if (pendingLabels.length > 0) {
          const targetPanel = newPanel
            || conversationArea.querySelector('.gd-chat-widget-li-requested-only:last-child');

          if (targetPanel) {
            // Small delay to ensure DOM is ready
            setTimeout(() => {
              const payBtn = targetPanel.querySelector(
                '[data-invoice-url][onclick*="gdWidgetOpenPaymentFromPending"]'
              );
              if (payBtn) payBtn.click();
            }, 500);
          }
        }

      }

      if (requestType == 'exchange_request') {
        const hasExchangeData = notRequestedItems.length > 0
          || lineItems?.requested?.exchange?.length > 0
          || lineItems?.requested?.return?.return_label?.complete_label?.length > 0
          || lineItems?.requested?.return?.return_label?.pending_label?.length > 0
          || lineItems?.requested?.alteration?.length > 0
          || (lineItems.outlet || []).length > 0
          || (lineItems.nonReturnableItems || []).length > 0;

        if (hasExchangeData) {
          conversationArea.querySelectorAll('.gd-chat-widget-ex-panel').forEach(p => {
            gdWidgetResetPanel(p);
            gdWidgetFreezePanel(p, 'Updated exchange panel available below');
          });
          const exHtml = gdWidgetRenderExchangePanel(notRequestedItems, lineItems);
          if (exHtml) {
            conversationArea.insertAdjacentHTML('beforeend', exHtml);
            // Store original query on exchange panel
            const allExPanels = conversationArea.querySelectorAll('.gd-chat-widget-ex-panel');
            const exPanel = allExPanels[allExPanels.length - 1];
            if (exPanel) exPanel.dataset.originalQuery = originalQuery;
          }
        }
      }

      if (requestType == 'alteration_request') {
        const hasAlterationData = notRequestedItems.length > 0
        || (lineItems.outlet || []).length > 0
        || lineItems?.requested?.alteration?.length > 0
        || lineItems?.requested?.return?.return_label?.complete_label?.length > 0
        || lineItems?.requested?.return?.return_label?.pending_label?.length > 0
        || lineItems?.requested?.exchange?.length > 0;

        if (hasAlterationData) {
          conversationArea.querySelectorAll('.gd-chat-widget-alt-panel').forEach(p => {
            gdWidgetResetPanel(p);
            gdWidgetFreezePanel(p, 'Updated alteration panel available below');
          });
          const altHtml = gdWidgetRenderAlterationPanel(notRequestedItems, lineItems);
          if (altHtml) {
            conversationArea.insertAdjacentHTML('beforeend', altHtml);
            // Store original query on alteration panel
            const allAltPanels = conversationArea.querySelectorAll('.gd-chat-widget-alt-panel');
            const altPanel = allAltPanels[allAltPanels.length - 1];
            if (altPanel) altPanel.dataset.originalQuery = originalQuery;
          }
        }
      }
    }


    //return portal ends


  //  setTimeout(() => {
  //     window.gdWidgetAutoScroll();
  // }, 200);
}


let exitIntentBound = false;
let submitCount = 0;

function initGDChatWidgetMainForm() {

    const chatInput        = document.getElementById("gd-chat-widget-chatInput");
    const sendBtn          = document.getElementById("gd-chat-widget-chatSend");
    const conversationArea = document.querySelector(".gd-chat-widget-conversation-area");

    const orderField       = document.getElementById("main-chat-widget-order-id-field");
    const hiddenOrder      = document.getElementById("hidden-main-chat-widget-order-id");
    const refineWrapper = document.querySelector(".gd-chat-widget-refine");


    const resetBtn = document.getElementById("gd-chat-widget-btnReset");
    const resetBar = document.getElementById("gd-chat-widget-resetBar");
    const chatInputWrap = document.getElementById("gd-chat-widget-chatInputWrap");
    const resetYes = document.getElementById("gd-chat-widget-btnResetYes");
    const resetNo = document.getElementById("gd-chat-widget-btnResetNo");

    const resetStartBtn = document.getElementById("gdChatWidgetStartBtn");

    resetBtn.addEventListener("click", () => {
      resetBar.style.display = "flex";
      resetBar.classList.add("blink");
      chatInputWrap.style.display = "none";
      refineWrapper.style.display = "none"; 

      setTimeout(() => {
        resetBar.classList.remove("blink");
      }, 1500);
    });


    resetNo.addEventListener("click", () => {
      resetBar.style.display = "none";
      chatInputWrap.style.display = "block";
      refineWrapper.style.display = "none"; 
      // document.querySelectorAll('.gd-chat-widget-chat-suggestions')
      //   .forEach(el => {
      //     el.innerHTML = '';
      //   });
    });

    // resetYes.addEventListener("click", () => {
    //   resetBar.style.display = "none";
    //   chatInputWrap.style.display = "block";
    //   refineWrapper.style.display = "none"; 
    // });

    resetStartBtn.addEventListener("click", () => {
      resetBar.style.display = "flex";
      chatInputWrap.style.display = "none";
      refineWrapper.style.display = "none"; 
    });


    if (!chatInput || !sendBtn) return;

    /* -----------------------------------------------
      REMOVE ERROR WHEN TYPING
    -------------------------------------------------- */
    chatInput.addEventListener("input", function () {
        chatInput.classList.remove("error-border");

        if (chatInput.value.trim().length > 0) {
            refineWrapper.style.display = "flex";
        } else {
            refineWrapper.style.display = "none"; 
            if(orderField){
              orderField.classList.remove("error-border"); 
              orderField.style.display = "none"; 
              orderField.value = "";
            }
        }
    });


    if (orderField) {
        orderField.addEventListener("input", function () {
            orderField.classList.remove("error-border");
            hideFieldError(orderField);
        });
    }

    /* -----------------------------------------------
       HANDLE SUBMISSION
    -------------------------------------------------- */
    async function sendChatMessage() {
        const message = chatInput.value.trim();
        const email   = localStorage.getItem("user_email") || "";
        // const orderId = hiddenOrder?.value?.trim() || (orderField?.style.display !== "none" ? orderField.value.trim() : "");

        let orderId = "";

        if (hiddenOrder?.value) {
          orderId = hiddenOrder.value.trim();
        } else if (orderField && orderField.style.display !== "none" && orderField.value) {
          orderId = orderField.value.trim();
        }


        resetBar.style.display = "none";
        refineWrapper.style.display = "none"; 

        submitCount++;

        /* --------------------
          EMPTY INPUT VALIDATION
        ---------------------- */
        if (!message) {
            chatInput.classList.add("error-border");
            return;
        }

        /* -------------------------------
           ORDER-ID REQUIRED VALIDATION
        -------------------------------- */
      
        if (orderField && orderField.style.display !== "none" && gdChatWidgetSelectedSuggestion?.required_fields?.includes('order_number')) {
            if (!orderId) {
                orderField.classList.add("error-border");
                // showFieldError(orderField, "Order number is required");
                orderField.focus();
                return;
            }
        }

        /* -------------------------------
            BUILD FINAL USER MESSAGE
        -------------------------------- */
        let finalMessage = message;

        if (gdChatWidgetSelectedSuggestion?.required_fields?.includes('order_number') && orderId){
        
            finalMessage += ` Order number is ${orderId}`;
            finalMessage += ` and email address is ${email}`;
        }

        /* -------------------------------
            RESET ORDER FIELD
        -------------------------------- */
        resetOrderField();

        /* -------------------------------
            APPEND USER MESSAGE → UI
        -------------------------------- */
        const initials = gdChatWidgetGetUserInitials();
        const userHtml = `
            <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
                <div class="gd-chat-widget-user-bubble">${finalMessage}</div>
                <div class="gd-chat-widget-user-avatar">${initials}</div>
            </div>
        `;
        conversationArea.insertAdjacentHTML("beforeend", userHtml);

        /* -------------------------------
            SCROLL TO BOTTOM
        -------------------------------- */
        conversationArea.scrollTop = conversationArea.scrollHeight;

        // Hide #gd-chat-widget-prompt_suggestion (only if exists)
          const promptSuggestion = document.getElementById('gd-chat-widget-prompt_suggestion');
          if (promptSuggestion) {
            promptSuggestion.style.display = 'none';
          }

          // Remove all .chat-alternative-section elements (only if found)
          const altSections = document.querySelectorAll('.chat-alternative-section');
          if (altSections.length > 0) {
            altSections.forEach(el => el.remove());
          }

          // Hide all .filter-panel elements (only if found)
          const filterPanels = document.querySelectorAll('.filter-panel');
          if (filterPanels.length > 0) {
            filterPanels.forEach(el => {
              el.style.display = 'none';
            });
          }


        /* -------------------------------
            SEND TO API
        -------------------------------- */
        gdWidgetChatQuery(finalMessage);

        /* -------------------------------
            CLEAR INPUT
        -------------------------------- */
        const el = document.querySelector('.gd-chat-widget-chat-suggestions');
        if (el) el.innerHTML = '';

        chatInput.value = "";

        /* -------------------------------
            EXIT INTENT DISCOUNT LOGIC
        -------------------------------- */
        if (submitCount === 1 && !exitIntentBound) {
            exitIntentBound = true;
            document.addEventListener("mouseleave", function (e) {
                if (e.clientY <= 0) {
                    gdChatWidgetShowDiscountIfEligible("exit intent");
                }
            }, { once: true });
        }

        /* -------------------------------
            SWIPE CARDS LOGIC
        -------------------------------- */
        if (submitCount === 1) {
            let swipeData = sessionStorage.getItem("swipeData");
            if (swipeData) swipeData = JSON.parse(swipeData);

            if (!swipeData || (Object.keys(swipeData.likes).length === 0 && Object.keys(swipeData.dislikes).length === 0)) {
                if (!document.querySelector(".chat_show_swipecards_container")) {
                    //yathu asked to remove 3 oct
                    // gdWidgetShowSwipeCardsInChat(); 
                }
            }
        }
        
    }

    /* -----------------------------------------------
       RESET ORDER FIELD
    -------------------------------------------------- */
    function resetOrderField() {
        if (!orderField) return;
        orderField.style.display = "none";
        orderField.value = "";
        orderField.classList.remove("error-border");
        orderField.placeholder = "Order number";
        hideFieldError(orderField);
    }

    /* -----------------------------------------------
        FIELD ERROR HELPERS
    -------------------------------------------------- */
    function showFieldError(field, message) {
        hideFieldError(field);
        const div = document.createElement("div");
        div.className = "field-error-message";
        div.textContent = message;
        field.insertAdjacentElement("afterend", div);
    }

    function hideFieldError(field) {
        const err = field.parentElement.querySelector(".field-error-message");
        if (err) err.remove();
    }

    /* -----------------------------------------------
        TRIGGER SEND ON BUTTON CLICK
    -------------------------------------------------- */
    sendBtn.addEventListener("click", function () {
        sendChatMessage();
    });

    /* -----------------------------------------------
        TRIGGER SEND ON ENTER KEY
    -------------------------------------------------- */
    chatInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            sendChatMessage();
        }
    });
}

initGDChatWidgetMainForm();



function gdChatWidgetVoiceAssistant() {
  const micBtn = document.getElementById('gd-chat-widget-chat-input-micIcon');
  const chatInput = document.getElementById('gd-chat-widget-chatInput');
  
  //chatInput.focus();
  
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  let recognition = null;
  
  if (SpeechRecognition) {
      recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';
      
      recognition.onresult = function(event) {
          const transcript = event.results[0][0].transcript;
          chatInput.value = transcript;
          chatInput.focus();
          
          const inputEvent = new Event('input', {
              bubbles: true,
              cancelable: true,
          });
          chatInput.dispatchEvent(inputEvent);
      };
      
      recognition.onerror = function(event) {
          console.error('Speech recognition error', event.error);
          micBtn.classList.remove('pulse');
          // Focus back on input after error
          chatInput.focus();
      };
      
      recognition.onend = function() {
          micBtn.classList.remove('pulse');
          chatInput.placeholder = 'Ask me anything about fashion, styling, or products…';
          // Focus back on input after recognition ends
          chatInput.focus();
      };
  } else {
      micBtn.style.opacity = '0.5';
      micBtn.title = 'Speech recognition not supported in this browser';
  }
  
  // Toggle speech recognition
   micBtn.addEventListener('click', function() {
          if (!recognition) return;
          
          if (!micBtn.classList.contains('pulse')) {
              // Start recognition
              try {
                  recognition.start();
                  micBtn.classList.add('pulse');
                  chatInput.placeholder = 'Listening...';
                  chatInput.focus();
              } catch (error) {
                  console.error('Recognition start failed:', error);
              }
          } else {
              // Stop recognition
              recognition.stop();
              micBtn.classList.remove('pulse');
              chatInput.placeholder = 'Ask me anything about fashion, styling, or products…';
              chatInput.focus();
          }
    });

}

gdChatWidgetVoiceAssistant();


function gdWidgetProductContextHtml(product) {
  const productImage = window.ProductImage || '';
  const productTitle = window.productTitle || '';
  const productHandle = window.productURL || '';
  const productColor = window.productColor || ''

  return `
    <div class="gd-widget-product-context">
      <div class="gd-widget-product-context-header">
        <span class="gd-widget-product-context-label">YOU'RE VIEWING</span>
        <!--<button class="gd-widget-product-context-change" data-handle="${productHandle}">Change</button>-->
      </div>
      <div class="gd-widget-product-context-details">
        <img src="${productImage}" alt="${productTitle}" class="gd-widget-product-context-image" onerror="this.style.display='none'">
        <div class="gd-widget-product-context-info">
          <div class="gd-widget-product-context-title">${productTitle}</div>
          <div class="gd-widget-product-context-color">${productColor}</div>
        </div>
      </div>
      <div class="gd-widget-product-context-prompt">
        Ask me anything about THIS dress
      </div>
    </div>
  `;
}


function gdInsertProductContext(product) {
  const onLoadProductContextElement = document.querySelector(".on-load-product-context");
  if (!onLoadProductContextElement) return;
  
  const old = onLoadProductContextElement.querySelector('.gd-widget-product-context');
  if (old) old.remove();

  const html = gdWidgetProductContextHtml(product);
  onLoadProductContextElement.insertAdjacentHTML('beforeend', html);
}

//for session
function gdWidgetProductInfoHtml(product) {
  return `
    <div class="gd-widget-product-info">
      <div class="gd-widget-product-info-message">
        <a href="/products/${product.handle}" target="_blank">
          ${product.title}
        </a>
      </div>
    </div>
  `;
}

async function gdWidgetchatAssistant(userId) {

   //const userEmailwws = localStorage.getItem('user_email');
  // if (userEmailwws && (userEmailwws != 'sai@citygoddess.co.uk')) {
  //     return;
  // }

   if (window.gdWidgetSkipInitialChatLoad) {
        console.log('Skipping chat assistant initialization due to registered user');
        window.gdWidgetSkipInitialChatLoad = false; // Reset flag
        return;
    }

    const token = getGDChatWidgetAiToken();
    const refreshToken = localStorage.getItem("ai_refresh_token");
    const conversationArea = document.querySelector(".gd-chat-widget-conversation-area");
    const mainLoader = document.getElementById("gd-chat-widget-loader");

    if (!conversationArea) return;
    
    if (mainLoader) mainLoader.style.display = "flex";

    // Clear UI
    //conversationArea.innerHTML = "";

    if (window.isProductPage) {
      const keepElements = [
        document.getElementById("gd-chat-widget-prompt_suggestion"),
        document.getElementById("onloadproductcontext"),
        document.getElementById("gd-chat-widget-prompt_suggestion-for-product"),
        document.getElementById("gd-chat-widget-prompt_suggestion-reset")
      ].filter(Boolean);

      conversationArea.replaceChildren(...keepElements);
    } else {
      conversationArea.replaceChildren(); // clears everything
    }  


    if (window.isProductPage) {

      const idsToKeep = [
        "gd-chat-widget-prompt_suggestion",
        "onloadproductcontext",
        "gd-chat-widget-prompt_suggestion-for-product",
        "gd-chat-widget-prompt_suggestion-reset"
      ];

      const idsToClear = [
        "gd-chat-widget-prompt_suggestion-reset"
      ];

      // 1️⃣ Get elements to keep
      const keepElements = idsToKeep
        .map(id => document.getElementById(id))
        .filter(Boolean);

      // 2️⃣ Clear specific elements (but keep them in DOM)
      idsToClear.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.innerHTML = "";
      });

      // 3️⃣ Replace conversationArea content with only keep elements
      conversationArea.replaceChildren(...keepElements);

    } else {
      conversationArea.replaceChildren(); // clears everything
    }

    
    clearAllSwiperInstances();

    try {

       const payload = {
          id: userId,
          refresh_token: refreshToken
        };

        if (window.isProductPage && window.productId) {
          payload.product_id = window.productId;
        }

        if (window.isCollectionPage && window.collectionHandle) {
          payload.collection = window.collectionHandle;
        }


        const response = await fetch("https://ai.mygoddiva.com/get-session", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        // ---------------------------------------------------
        // 1️⃣ Save refreshed tokens + session
        // ---------------------------------------------------
        if (data.token) {
            localStorage.setItem("ai_access_token", data.token.access);
            localStorage.setItem("ai_refresh_token", data.token.refresh);
        }

        if (data.session_id) {
            localStorage.setItem("session_id", data.session_id);
        }
        // ---------------------------------------------------
        // 2️⃣ Restore message history
        // ---------------------------------------------------
        if (data.messages && data.messages.length > 0) {
          data.messages.forEach((msg, index) => {

                // USER MESSAGE or MORE-LIKE block
                if (msg.more_like && msg.more_like.length) {

                 if (conversationArea) {
                    conversationArea.insertAdjacentHTML(
                      'beforeend',
                      gdWidgetmoreLikeHtml(msg.more_like)
                    );
                  }

                } else {

                 if (msg.product_info && msg.product_info.title && window.isProductPage) {
                      conversationArea.insertAdjacentHTML(
                          'beforeend',
                          gdWidgetProductInfoHtml(msg.product_info)
                      );
                  }
                  
                    // USER bubble
                    const initials = gdChatWidgetGetUserInitials();
                    const userHtml = `
                        <div class="gd-chat-widget-msg-row gd-chat-widget-user-msg">
                            <div class="gd-chat-widget-user-bubble">${msg.user_message}</div>
                            <div class="gd-chat-widget-user-avatar">${initials}</div>
                        </div>
                    `;
                    conversationArea.insertAdjacentHTML("beforeend", userHtml);
                }

               conversationArea.insertAdjacentHTML(
                    "beforeend",
                    gdWidgetbotResponseHandel(msg.bot_response, msg.filters, msg.prompt_id)
                );

                // ---------------------------------------------------
                // 3️⃣ Restore product section
                // ---------------------------------------------------
                 if (msg.products && msg.products.total > 0) {
                    const sliderHTML = `
                        <div class="gd-widget-drag-scroll"
                            data-id="${msg.id}"
                            data-total="${msg.products.total}"
                            data-page="1"
                            data-has="true">
                            
                            <div class="swiper chat-swiper gd-chat-widget-product-swiper">
                                <div class="chat-product-item-wrapper swiper-wrapper"></div>
                            </div>

                            <div class="swiper-button-prev gd-chat-widget-product-prev chat-swiper-prev" aria-label="Previous product"></div>
                            <div class="swiper-button-next gd-chat-widget-product-next chat-swiper-next" aria-label="Next product"></div>
                        </div>
                    `;
                    
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = sliderHTML;
                    const newSlider = tempDiv.firstElementChild;
                    conversationArea.appendChild(newSlider);
                    
                    const messageId = newSlider.dataset.id;
                    
                    // Initialize slider with staggered timing
                    setTimeout(() => {
                        gdChatWidgetInitLazyLoad(newSlider, messageId, msg.products);
                    }, index * 20); // Stagger by 50ms for each slider
                }
            });
        }

        // ---------------------------------------------------
        // 🆕 Wrap previous messages in accordion on product pages
        // ---------------------------------------------------
        if (window.isProductPage && data.messages && data.messages.length > 0) {
            // Only wrap if there are messages and they are direct children of conversationArea
            if (conversationArea.children.length > 0) {
                // Create accordion elements
                const accordion = document.createElement('div');
                accordion.className = 'gd-chat-widget-previous-accordion';
                
                const header = document.createElement('div');
                header.className = 'gd-chat-widget-accordion-header';
                const messageCount = data.messages.length;
                header.innerHTML = `
                    <span>
                    <?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.88" style="enable-background:new 0 0 122.88 122.88" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44C27.51,122.88,0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z M52.92,30.52h7.51c1.37,0,2.5,1.13,2.5,2.5v28.94h26.41c1.38,0,2.5,1.13,2.5,2.5v7.51 c0,1.38-1.13,2.5-2.5,2.5H50.41V33.02C50.41,31.64,51.54,30.52,52.92,30.52L52.92,30.52z M61.44,13.95 c26.23,0,47.49,21.26,47.49,47.49c0,26.23-21.26,47.49-47.49,47.49c-26.23,0-47.49-21.26-47.49-47.49 C13.95,35.22,35.21,13.95,61.44,13.95L61.44,13.95z"/></g></svg>
                    Previous Conversations (${messageCount})
                    </span>
                    <span class="gd-chat-widget-chevron">${gdWidgetGetChevronSVG()}</span>
                `;
                
                const content = document.createElement('div');
                content.className = 'gd-chat-widget-accordion-content';
                content.style.display = 'none'; // initially collapsed
                
                // Move all current message nodes into the content
                // while (conversationArea.firstChild) {
                //     content.appendChild(conversationArea.firstChild);
                // }

                const excludeIds = [
                  "gd-chat-widget-prompt_suggestion",
                  "onloadproductcontext",
                  "gd-chat-widget-prompt_suggestion-for-product",
                  "gd-chat-widget-prompt_suggestion-reset"
                ];

                // Move only message nodes into accordion content
                Array.from(conversationArea.children).forEach(child => {
                  if (!excludeIds.includes(child.id)) {
                    content.appendChild(child);
                  }
                });

                
                
                // Assemble accordion
                accordion.appendChild(header);
                accordion.appendChild(content);
                //conversationArea.appendChild(accordion);

                // Insert accordion ABOVE prompt suggestions
                const suggestionEl = document.getElementById("gd-chat-widget-prompt_suggestion");

                if (suggestionEl) {
                  conversationArea.insertBefore(accordion, suggestionEl);
                } else {
                  conversationArea.appendChild(accordion);
                }

                
                // Toggle functionality
                header.addEventListener('click', function() {
                    const isHidden = content.style.display === 'none';
                    content.style.display = isHidden ? 'block' : 'none';
                    header.classList.toggle('open', isHidden);
                    const chevron = header.querySelector('.gd-chat-widget-chevron');
                    if (chevron) {
                        chevron.style.transform = isHidden ? 'rotate(180deg)' : 'rotate(0deg)';
                    }
                });
            }
        }

        if (data.selected_filter) {
            gdWidgetSelectedFilter(data.selected_filter);
        }

        const changeFilter = document.getElementById('chat-widget-change_Filter_suggestion');
        const tagContainers = document.querySelectorAll('.chat-widget-tag-container');

        // Trim innerHTML like $.trim()
        if (changeFilter && changeFilter.innerHTML.trim() !== "") {
            tagContainers.forEach(function (el) {
                el.style.display = 'none';
            });
        } else {
            tagContainers.forEach(function (el) {
                el.style.display = '';
            });
        }

        if (data.filter_key) {
            currentFilterKey = data.filter_key;
            console.log("currentFilterKey get-session", currentFilterKey);
        }

        // if (data.prompts) {
        //     gdWidgetpromptHandel(data.prompts, data.filter_key);
        // }

        if (data.prompts) {
            gdWidgetpromptHandel(
                gdNormalizePrompts(data.prompts),
                data.filter_key
            );
        }
        if (data.size && data.size.length) {
            gdChatWidgetSetCurrentSizesFromSession(data.size);
        }
        
        const modal = document.getElementById("gd-chat-widget-underMaintainance");
        modal.style.display = "none";

    } catch (err) {
        console.error("Session restore failed:", err);
         const modal = document.getElementById("gd-chat-widget-underMaintainance");
          modal.style.display = "flex";
    }

    if (mainLoader) mainLoader.style.display = "none";

    // append current product context
     if (window.isProductPage && window.productTitle && window.productURL) {
      gdInsertProductContext({
        title: window.productTitle,
        handle: window.productURL
      });
    }

    window.gdWidgetScrollToBottom();
    window.dispatchEvent(new Event("gd-chat-restore-complete"));
}


let gdChatWidgetCurrentSizes = [];

function gdChatWidgetSetCurrentSizesFromSession(sizeArray) {
    // store them globally
    gdChatWidgetCurrentSizes = sizeArray.slice(); // shallow copy

    // update the "Size: ..." label once
    gdChatWidgetUpdateSizeLabel(gdChatWidgetCurrentSizes);
}

function gdChatWidgetInitSizeDropdown() {
    const dropdown = document.getElementById("gd-chat-widget-sizeDropdown");
    const modal = document.getElementById("gd-chat-widget-sizeModal");

    if (!dropdown || !modal) return;

    dropdown.addEventListener("click", () => {

      if (dropdown.dataset.programmatic === "true") {
            dropdown.dataset.programmatic = "false";
        } else if (sessionStorage.getItem("sizeMentioned") === "true") {
            sessionStorage.removeItem("sizeMentioned");
        }

         if (window.gdWidgetSkipInitialChatLoadSize) {
            window.gdWidgetSkipInitialChatLoadSize = false; // Reset flag
           
        }else{

           // 1️⃣ Clear all active states
        document.querySelectorAll(".gd-chat-widget-size-pill").forEach(btn => {
            btn.classList.remove("active");
        });

        // 2️⃣ Read selected sizes from the global session variable
        //     (NOT from a DOM element that does not exist)
        const selectedIds = gdChatWidgetCurrentSizes.map(s => Number(s.id));

        // 3️⃣ Activate pills that match selected sizes
        document.querySelectorAll(".gd-chat-widget-size-pill").forEach(btn => {
            const id = Number(btn.dataset.id);
            if (selectedIds.includes(id)) {
                btn.classList.add("active");
            }
        });

        // 4️⃣ Always activate hidden onesize
        const oneSize = document.querySelector('#size_onesize');
        if (oneSize) oneSize.classList.add("active");

        }
  
        // 5️⃣ Open modal
        modal.style.display = "flex";
    });
}


function gdChatWidgetApplySizeButtonLogic() {
    document.addEventListener("click", (e) => {
        const btn = e.target.closest(".gd-chat-widget-size-pill");
        if (!btn) return;

        // Prevent clicking onesize
        if (btn.dataset.id === "2") return;

        // Toggle only if user clicked
        if (btn.classList.contains("active")) {
            btn.classList.remove("active");
        } else {
            btn.classList.add("active");
        }

        document.querySelector(".gd-chat-widget-update-size-error").style.display = "none";
    });
}

function gdChatWidgetCancelSizeModal() {
    const btn = document.getElementById("gd-chat-widget-btnSizeCancel");
    const modal = document.getElementById("gd-chat-widget-sizeModal");

    btn.addEventListener("click", () => {

        const bubbles = document.querySelectorAll(".gd-chat-widget-user-bubble");
        const lastMsgEl = bubbles[bubbles.length - 1] || null;
        const lastUserMessage = lastMsgEl ? lastMsgEl.textContent.trim() : "";

        const sizeMentioned = sessionStorage.getItem("sizeMentioned") === "true";

        if (sizeMentioned && lastUserMessage) {
            gdWidgetChatQuery(
                lastUserMessage,
                "product_suggestion_request",
                "add"
            );
        } else {
            console.log("Size mentioned when cancel, not re-sending message");
        }

        sessionStorage.removeItem("sizeMentioned");
        modal.style.display = "none";
    });
}

function gdChatWidgetSaveSizes() {
    const btn = document.getElementById("gd-chat-widget-btnSizeSave");

    btn.addEventListener("click", async () => {
        const pills = [...document.querySelectorAll(".gd-chat-widget-size-pill.active")];
        const errorEl = document.querySelector(".gd-chat-widget-update-size-error");

        // Validation (exclude onesize)
        const visibleSelected = pills.filter(p => p.dataset.id !== "2");
        if (visibleSelected.length === 0) {
            errorEl.style.display = "block";
            return;
        }

        // Build payload
        let selectedSizes = pills.map(p => ({
            id: Number(p.dataset.id),
            name: p.textContent.trim()
        }));

        // Add onesize always
        const oneSizeBtn = document.querySelector('#size_onesize');
        if (oneSizeBtn && !selectedSizes.some(s => s.id === 2)) {
            selectedSizes.push({ id: 2, name: "onesize" });
        }

        // API CALL
        const userId = localStorage.getItem("user_id");
        const token = getGDChatWidgetAiToken();

        const response = await fetch("https://ai.mygoddiva.com/user/size-update", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { "Authorization": "Bearer " + token } : {})
            },
            body: JSON.stringify({ id: userId, size: selectedSizes })
        });

        const data = await response.json();

        
        // -----------------------------------------------------
        // 🟢 Build arrays for message output (like old system)
        // -----------------------------------------------------

        const prevSizes = gdChatWidgetCurrentSizes
            .filter(s => s.name.toLowerCase() !== "onesize")
            .map(s => s.name.trim())
            .join(", ") || "None";

        const newSizesArray = selectedSizes
            .filter(s => s.name.toLowerCase() !== "onesize")
            .map(s => s.name.trim());

        // Save new sizes into global state
        gdChatWidgetCurrentSizes = selectedSizes.slice();

        // Update label
        gdChatWidgetUpdateSizeLabel(selectedSizes);

        // Append message to chat
        gdChatWidgetAppendSizeUpdatedMessage(prevSizes, newSizesArray);

        // Close modal
        document.getElementById("gd-chat-widget-sizeModal").style.display = "none";
        
        // // using this event in ai-collection-personalization.js start
        

        // if (response.ok && (window.pageType === 'collection' || window.pageType === 'page')) {
        //     const activePills = [
        //         ...document.querySelectorAll(".gd-chat-widget-size-pill.active")
        //     ];

        //     const dataValues = activePills.map(pill => pill.dataset.value);

        //     console.log("size saved event dataValues:", dataValues);
        //     console.log("size saved event sizes:", newSizesArray);
        //     console.log("size saved event previousSizes:", prevSizes);

        //     const eventName =
        //         window.pageType === 'collection'
        //             ? 'gd-chat-widget-sizes-saved'
        //             : 'gd-chat-widget-sizes-saved-for-page';

        //     const event = new CustomEvent(eventName, {
        //         detail: {
        //             dataValues,              // existing dataset values
        //             sizes: newSizesArray,   // ✅ new sizes added
        //             previousSizes: prevSizes // optional but useful
        //         }
        //     });

        //     window.dispatchEvent(event);

        // }

        // if (response.ok && window.pageType === 'collection') {
        //     const activePills = [
        //         ...document.querySelectorAll(".gd-chat-widget-size-pill.active")
        //     ];

        //     const dataValues = activePills.map(pill => pill.dataset.value);

        //     console.log("size saved event dataValues:", dataValues);
        //     console.log("size saved event sizes:", newSizesArray);
        //     console.log("size saved event previousSizes:", prevSizes);

        //     const event = new CustomEvent('gd-chat-widget-sizes-saved', {
        //         detail: {
        //             dataValues,
        //             sizes: newSizesArray,
        //             previousSizes: prevSizes
        //         }
        //     });

        //     window.dispatchEvent(event);
        // }


        // Add paths that should NOT fire this event
          const excludedPaths = [
              '/pages/ai-search-result',
              // '/pages/another-page',
          ];

          const isExcludedPath = excludedPaths.includes(window.location.pathname);

          if (response.ok && !isExcludedPath) {
              const activePills = [
                  ...document.querySelectorAll(".gd-chat-widget-size-pill.active")
              ];

              const dataValues = activePills.map(pill => pill.dataset.value);

              console.log("size saved event dataValues:", dataValues);
              console.log("size saved event sizes:", newSizesArray);
              console.log("size saved event previousSizes:", prevSizes);
               console.log('event received for other pages');

              const event = new CustomEvent('gd-chat-widget-sizes-saved', {
                  detail: {
                      dataValues,
                      sizes: newSizesArray,
                      previousSizes: prevSizes
                  }
              });

              window.dispatchEvent(event);
          }

        // Add more pageTypes or paths here as needed
        const forPageTypes = ['page'];
        const forPagePaths = [
            '/pages/ai-search-result',
            // '/pages/another-page',
        ];

        const isForPageType = forPageTypes.includes(window.pageType);
        const isForPagePath = forPagePaths.includes(window.location.pathname);

        if (response.ok && (isForPageType || isForPagePath)) {
            const activePills = [
                ...document.querySelectorAll(".gd-chat-widget-size-pill.active")
            ];

            const dataValues = activePills.map(pill => pill.dataset.value);

            console.log("size saved event dataValues:", dataValues);
            console.log("size saved event sizes:", newSizesArray);
            console.log("size saved event previousSizes:", prevSizes);
             console.log('event received for ai-search-result page');

            const event = new CustomEvent('gd-chat-widget-sizes-saved-for-page', {
                detail: {
                    dataValues,
                    sizes: newSizesArray,
                    previousSizes: prevSizes
                }
            });

            window.dispatchEvent(event);
        }

        
        const bubbles = document.querySelectorAll(".gd-chat-widget-user-bubble");
        const lastMsgEl = bubbles[bubbles.length - 1] || null;
        const lastUserMessage = lastMsgEl ? lastMsgEl.textContent.trim() : "";

        const sizeMentioned = sessionStorage.getItem("sizeMentioned") === "true";

        if (sizeMentioned && lastUserMessage) {
            gdWidgetChatQuery(
                lastUserMessage,
                "product_suggestion_request",
                "add"
            );
        }

        sessionStorage.removeItem("sizeMentioned");

    });
}


function gdChatWidgetUpdateSizeLabel(sizes) {
    const label = document.getElementById("gd-chat-widget-sizeLabel");
    if (!label) return;

    // 1️⃣ Collect all UK size IDs (same as old code but pure JS)
    const ukIds = [...document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox')]
        .map(cb => Number(cb.dataset.id));

    // 2️⃣ Keep ONLY UK sizes (remove international + onesize)
    const ukSizes = sizes.filter(s =>
        ukIds.includes(s.id) &&
        s.name.toLowerCase() !== "onesize"
    );

    // If nothing selected
    if (ukSizes.length === 0) {
        label.textContent = "Size: Select";
        return;
    }

    // First size
    const firstSize = ukSizes[0].name.trim();
    const remaining = ukSizes.length - 1;

    if (remaining > 0) {
        label.textContent = `Sizes: ${firstSize} +${remaining} more`;
    } else {
        label.textContent = `Size: ${firstSize}`;
    }
}



function gdChatWidgetFetchSizesFromSession(sizeArray) {
    const container = document.getElementById("gd-chat-widget-selectedSizes");
    if (!container) return;

    // 1️⃣ Collect UK IDs
    const ukIds = [...document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox')]
        .map(cb => Number(cb.dataset.id));

    container.innerHTML = "";

    sizeArray.forEach(item => {
        if (!ukIds.includes(item.id)) return;      // skip international
        if (item.name.toLowerCase() === "onesize") return;

        container.insertAdjacentHTML(
            "beforeend",
            `<span class="size-item" data-id="${item.id}">${item.name}</span>`
        );
    });

    gdChatWidgetUpdateSizeLabel(sizeArray);
}



function gdChatWidgetAppendSizeUpdatedMessage(prevSizes, newSizesArray) {
    let area;
    if(window.isProductPage){
       area = document.querySelector(".gd-chat-widget-conversation-area");
    }else{
       area = document.querySelector("#gd-chat-widget-prompt_suggestion");
    }  
    
    if (!area) return;

    // Remove older size-update messages
    area.querySelectorAll(".gd-message-update-size").forEach(el => el.remove());

    let newSizesDisplay = "";
    let toggleButton = "";

    if (newSizesArray.length > 1) {
        const visible = newSizesArray.slice(0, 1).join(", ");
        const hidden = newSizesArray.slice(1).join(", ");
        const hiddenCount = newSizesArray.length - 1;

        newSizesDisplay = `
            <span class="sizes-visible">${visible}</span>
            <span class="more-indicator"> +${hiddenCount} more</span>
            <span class="sizes-hidden" style="display:none;">, ${hidden}</span>
        `;

        toggleButton = `
            <button type="button" class="gd-toggle-sizes-btn">Show more</button>
        `;
    } else {
        newSizesDisplay = newSizesArray.join(", ");
    }

    let message = `
        <div class="gd-message-update-size">
            Size has been changed from <strong>${prevSizes}</strong> to 
            <strong class="sizes-container">${newSizesDisplay}</strong>
            ${toggleButton}. Please start again.
        </div>
    `;

    message = message.replace(/\s+\.(Please)/g, '.$1');

    area.insertAdjacentHTML("beforeend", message);

    // Scroll to bottom
    const newMessage = area.querySelector(".gd-message-update-size:last-child");
    if (newMessage) {
      setTimeout(() => {

        newMessage.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        const scrollParent = newMessage.closest(".gd-chat-widget-conversation-area");

        if (scrollParent) {
          scrollParent.scrollBy({
            top: -80,
            behavior: "smooth"
          });
        }

      }, 50);
    }

}

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".gd-toggle-sizes-btn");
    if (!btn) return;

    const container = btn.parentElement.querySelector(".sizes-container");
    const hidden = container.querySelector(".sizes-hidden");
    const indicator = container.querySelector(".more-indicator");

    if (hidden.style.display === "none") {
        hidden.style.display = "inline";
        indicator.style.display = "none";
        btn.textContent = "Show less";
    } else {
        hidden.style.display = "none";
        indicator.style.display = "inline";
        btn.textContent = "Show more";
    }
});

gdChatWidgetInitSizeDropdown();
gdChatWidgetApplySizeButtonLogic();
gdChatWidgetSaveSizes();
gdChatWidgetCancelSizeModal();


document.addEventListener("click", function (event) {
    const btn = event.target.closest("#gdChatWidgetSizeMentioned");
    if (!btn) return;

    const dropdown = document.getElementById("gd-chat-widget-sizeDropdown");

    dropdown.dataset.programmatic = "true"; // ✅ correct element
    sessionStorage.setItem("sizeMentioned", "true");

    dropdown.click();
});




async function gdWidgetdisplayGDChatWidgetSuggestions() {
    const wrapper = document.querySelector(".gd-chat-widget-register-suggestion-wrapper");
    if (!wrapper) return;

    wrapper.innerHTML = ""; // reset

    // Read traffic info
    let trafficInfo = sessionStorage.getItem("trafficInfo");
    let parsedTrafficInfo = trafficInfo ? JSON.parse(trafficInfo) : {};

    const messageInput = document.getElementById("gd-chat-widget-regMessage");

    // Fetch suggestions
    let suggestions = [];
    try {
        suggestions = await generateGDChatWidgetSuggestions(parsedTrafficInfo.landingPath);
    } catch (e) {
        suggestions = [];
    }

    if (!Array.isArray(suggestions)) suggestions = [];

    // Fallback suggestions
    if (suggestions.length === 0) {
        const fallback = [
            "Show me Maxi Dresses for Party",
            "Show me Evening Maxi Dresses",
            "Show me Red Bridesmaid Dresses",
            "Show me Maxi dresses for Black Tie Event",
            "Show Me Maxi Dresses Under £100",
            "Show me Red Prom Dresses",
            "Show me your best Sequin Dresses",
            "Show me Affordable Cocktail Dresses",
            "Show me elegant Maxi Dresses for a Gala Evening"
        ];

        fallback.sort(() => 0.5 - Math.random());
        suggestions = fallback.slice(0, 4);
    }

    // Build HTML
    let html = `<div class="gd-chat-widget-register-suggestion-inner">`;

    // Product image + code
    if (parsedTrafficInfo.traficProductCode && parsedTrafficInfo.traficProductImage) {
        html += `
            <div class="gd-chat-widget-register-product-block">
                <div class="gd-chat-widget-register-product-img">
                    <img src="${parsedTrafficInfo.traficProductImage}" 
                         alt="${parsedTrafficInfo.traficProductCode}">
                    <div class="gd-chat-widget-register-product-overlay"></div>
                </div>
                <p class="gd-chat-widget-register-product-find">
                    Find Similar - <span class="gd-chat-widget-register-product-code">
                        ${parsedTrafficInfo.traficProductCode}
                    </span>
                </p>
            </div>
        `;
    }

    // Suggestion buttons
    html += `
        <div class="gd-chat-widget-register-suggestion-block">
            <h3 class="gd-chat-widget-register-suggestion-title">Suggested Searches:</h3>
            <div class="gd-chat-widget-register-suggestion-grid">
    `;

    suggestions.forEach(text => {
        html += `
            <button class="gd-chat-widget-register-suggestion-btn">
                <span>${text}</span>
            </button>
        `;
    });

    html += `
            </div>
        </div>
    </div>
    `;

    wrapper.innerHTML = html;
 
    // Add click events

    // Product block
    const productBlock = wrapper.querySelector(".gd-chat-widget-register-product-block");
    if (productBlock) {
        productBlock.addEventListener("click", () => {
            messageInput.value = `Similar: ${parsedTrafficInfo.traficProductCode}`;
            messageInput.focus();
        });
    }

    // Suggestion buttons
    wrapper.querySelectorAll(".gd-chat-widget-register-suggestion-btn")
    .forEach(btn => {
        btn.addEventListener("click", () => {
            messageInput.value = btn.textContent
                .replace(/\u00A0/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            messageInput.focus();
        });
    });

}



async function generateGDChatWidgetSuggestions(path) {
    let trafficInfo = sessionStorage.getItem("trafficInfo");
    let parsedTrafficInfo = trafficInfo ? JSON.parse(trafficInfo) : {};

    let suggestions = [];

    if (!path) return suggestions;

    // -------------------------------
    // 📌 COLLECTION PAGE SUGGESTIONS
    // -------------------------------
    if (path.includes("/collections/")) {
        let slug = path.split("/collections/")[1] || "";
        slug = slug.split("/")[0]; // Remove after slash
        slug = slug.replace(/-/g, " ");

        let words = slug
            .split(" ")
            .map(w => w.charAt(0).toUpperCase() + w.slice(1));

        if (words.length > 0) {
            suggestions.push(words.join(" "));
        }

        return suggestions;
    }

    // -------------------------------
    // 📌 PRODUCT PAGE → CALL API
    // -------------------------------
    if (path.includes("/products/")) {
        const code = parsedTrafficInfo.traficProductCode;

        if (!code) return suggestions;

        try {
            const res = await fetch(
                `https://ai.mygoddiva.com/get-product-by-code?code=${code}`
            );
            const data = await res.json();

            if (!data) return suggestions;

            let temp = [];

            // Category
            if (data.category) {
                temp.push(`Show me ${data.category}`);
            }

            // Length
            if (data.length) {
                temp.push(`Show me ${data.length} Dresses`);
            }

            // Fabric(s)
            if (Array.isArray(data.fabric) && data.fabric.length > 0) {
                data.fabric.forEach(f => {
                    temp.push(`Show me ${f} Dresses`);
                });
            }

            // Remove duplicates
            return [...new Set(temp)];

        } catch (error) {
            console.error("GD Widget Suggestion API Error:", error);
            return suggestions;
        }
    }

    // -------------------------------
    // 📌 DELIVERY & RETURNS PAGE
    // -------------------------------
    if (path.includes("delivery-returns")) {
        return [
            "Delivery Details",
            "Returns and Refunds",
            "Returns Portal"
        ];
    }

    return suggestions;
}


gdWidgetdisplayGDChatWidgetSuggestions();


/* -----------------------------------------------------------
 * DISCOUNT DEFINITIONS
 * ----------------------------------------------------------- */
const gdChatWidgetDiscounts = {
  google: {
    code: "GGP10",
    text: "£10 off",
    remaining_time: 3600,
    footerText: "Min. £20"
  },
  awin: {
    code: "GAW20",
    text: "20% off",
    remaining_time: 3600,
    footerText: "No minimum requirements"
  },
  direct: {
    code: "GDR5",
    text: "£5 off",
    remaining_time: 3600,
    footerText: "Min. £20"
  }
};


/* -----------------------------------------------------------
 * HELPER FUNCTIONS
 * ----------------------------------------------------------- */

function gdChatWidgetElementIsVisible(selector) {
  const el = document.querySelector(selector);
  if (!el) return false;
  const style = getComputedStyle(el);
  if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") return false;
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function gdChatWidgetCreateFragment(html) {
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  return template.content;
}


function gdChatWidgetShowConfettiGIF(discountContainer) {
  const panel = document.getElementById("gd-chat-widget-assistantPanel");
  const loader = document.getElementById("gd-chat-widget-loader");

  if (!panel || !loader || !discountContainer) return;

  let seenVisible = false;

  const interval = setInterval(() => {
    // stop if discount got removed
    if (!document.body.contains(discountContainer)) {
      clearInterval(interval);
      return;
    }

    const hidden = getComputedStyle(loader).display === "none";

    if (!seenVisible && !hidden) {
      seenVisible = true;
      return;
    }

    if (seenVisible && hidden) {
      clearInterval(interval);

      setTimeout(() => {
        if (!document.body.contains(discountContainer)) return;

        const parentWrapper = discountContainer.closest(
          "#gd-chat-widget-registerWrapper, #gd-chat-widget-main-wrapper"
        );

        if (!parentWrapper) return;

        if (getComputedStyle(parentWrapper).display === "none") return;


        const old = document.getElementById("gd-chat-widget-confetti-gif");
        if (old) old.remove();

        const img = document.createElement("img");
        img.id = "gd-chat-widget-confetti-gif";
        img.src = "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Confetti-gif.gif?v=1760093253";
        img.style.position = "absolute";
        img.style.top = "50%";
        img.style.left = "50%";
        img.style.transform = "translate(-50%, -50%)";
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.pointerEvents = "none";
        img.style.zIndex = "99999";

        if (getComputedStyle(panel).position === "static") {
          panel.style.position = "relative";
        }

        panel.appendChild(img);
        setTimeout(() => img.remove(), 3000);
      }, 1000);

    }

  }, 100);
}



/* -----------------------------------------------------------
 * BUILD DISCOUNT BLOCK HTML
 * ----------------------------------------------------------- */
function gdChatWidgetBuildDiscountHTML(discount) {
  return `
    <div class="gd_widget_show_discount-container gd_widget_show_discount-container-${discount.code}"
         data-discount-timer="${discount.remaining_time}">
      
      <div class="gd_widget_show_discount-header">
        <span class="gd_widget_show_discount-title">Exclusive Session Offer</span>
      </div>

      <p class="gd_widget_show_discount-subtitle">
        🎉 Congratulations! You've unlocked a special discount for this styling session.
      </p>

      <div class="gd_widget_show_discount-card">
       <div class="gd_widget_show_discount_content_wrapper">
            <div class="gd_widget_show_discount_content">
               <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/BIZcoin_lottie_AI.gif?v=1759772275">
                <div>
                    <p class="gd_widget_show_discount_wrapper">Expires in: <span class="discount-timer"></span></p>
                    <p class="gd_widget_show_discount_off_text">${discount.text}</p>
                    <p class="gd_widget_show_discount_footer_text">${discount.footerText}</p>
                </div>
            </div>
            <div class="gd_widget_show_discount_code">
                CODE: <span class="gd_widget_show_discount_code-span">${discount.code}</span>
            </div>
        </div>
      </div>
       <button type="button" class="gd_widget_show_discount-btn-primary">Apply Now</button>
      <div class="discount-claim"></div>
    </div>
  `;
}


/* -----------------------------------------------------------
 * COUNTDOWN TIMER
 * ----------------------------------------------------------- */
function gdChatWidgetStartCountdown(duration, el) {
  let time = duration;

  const timer = setInterval(() => {
    const h = String(Math.floor(time / 3600)).padStart(2, "0");
    const m = String(Math.floor((time % 3600) / 60)).padStart(2, "0");
    const s = String(time % 60).padStart(2, "0");
    el.textContent = `${h}:${m}:${s}`;

    if (time-- <= 0) {
      clearInterval(timer);
      el.textContent = "Expired";
    }
  }, 1000);
}


/* -----------------------------------------------------------
 * INSERT DISCOUNT BLOCK
 * - if target is conversation area → insert BEFORE loader bubble
 * ----------------------------------------------------------- */
function gdChatWidgetInsertDiscount(targetSelector, html) {
  const target = document.querySelector(targetSelector);
  if (!target) return null;

  const fragment = gdChatWidgetCreateFragment(html);
  let inserted = null;

  const loader = document.getElementById("gd-chat-widget-loader-bubble");

  if (targetSelector === ".gd-chat-widget-conversation-area" && loader && loader.parentNode === target) {
    // Insert just like chat messages → before loader bubble
    loader.insertAdjacentElement("beforebegin", fragment.firstElementChild);
    inserted = loader.previousElementSibling;
  } else {
    target.appendChild(fragment);
    const all = target.querySelectorAll(".gd_widget_show_discount-container");
    inserted = all[all.length - 1];
  }

  return inserted;
}


/* -----------------------------------------------------------
 * APPLY DISCOUNT CODE — EVENT DELEGATION
 * ----------------------------------------------------------- */
document.addEventListener("click", e => {
  const btn = e.target.closest(".gd_widget_show_discount-btn-primary");
  if (!btn) return;

  const container = btn.closest(".gd_widget_show_discount-container");
  const codeEl = container.querySelector(".gd_widget_show_discount_code-span");
  if (!codeEl) return;

  const code = codeEl.textContent.trim();
  sessionStorage.setItem("claimedDiscountCode", code);

  btn.textContent = "Code Applied";
  btn.disabled = true;
  btn.style.backgroundColor = "#16a34a";
  btn.style.color = "#fff";

  container.querySelector(".discount-claim").innerHTML =
    `<div class="discount-claim-notice" style="color:#16a34a;text-align:center;margin-top:8px;font-size:12px;">
        Discount applied — it will auto-apply at checkout.
     </div>`;
});


/* -----------------------------------------------------------
 * CHECKOUT REDIRECT
 * ----------------------------------------------------------- */
document.addEventListener("click", e => {
  const btn = e.target.closest(".button-checkout");
  if (!btn) return;

  const code = sessionStorage.getItem("claimedDiscountCode");
  if (!code) return;

  e.preventDefault();
  sessionStorage.removeItem("claimedDiscountCode");
  window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
});


/* -----------------------------------------------------------
 * SHOW DISCOUNT CODE (MAIN FUNCTION)
 * ----------------------------------------------------------- */
function gdChatWidgetShowDiscountCode(delay, targetSelector, source) {
  const discount = gdChatWidgetDiscounts[source];
  if (!discount) return;

  const target = document.querySelector(targetSelector);
  if (!target) return;

  // Avoid duplicates
  if (target.querySelector(`.gd_widget_show_discount-container-${discount.code}`)) return;

  setTimeout(() => {
    const html = gdChatWidgetBuildDiscountHTML(discount);
    const inserted = gdChatWidgetInsertDiscount(targetSelector, html);
    if (!inserted) return;

    gdChatWidgetShowConfettiGIF(inserted);

    const timerEl = inserted.querySelector(".discount-timer");
    gdChatWidgetStartCountdown(discount.remaining_time, timerEl);
  }, delay * 1000);
}


/* -----------------------------------------------------------
 * SHOW IF ELIGIBLE (old logic but with your new selectors)
 * ----------------------------------------------------------- */
function gdChatWidgetShowDiscountIfEligible(trigger) {
  const traffic = JSON.parse(sessionStorage.getItem("trafficInfo") || "{}");
  const source = traffic.source;

  if (!["google", "awin", "direct"].includes(source)) return;


  /* ---------------- REGISTER ---------------- */
  if (trigger === "chat-register") {
    const interval = setInterval(() => {
      const regVisible = gdChatWidgetElementIsVisible("#gd-chat-widget-registerWrapper");
      const registerDiscountExists = !!document.querySelector(".gd-chat-widget-register-discount");

      if (regVisible && registerDiscountExists) {
        clearInterval(interval);
        gdChatWidgetShowDiscountCode(0, ".gd-chat-widget-register-discount", source);
      }
    }, 250);
    return;
  }


  /* ---------------- EXIT INTENT ---------------- */
  if (trigger === "exit intent") {
    const interval = setInterval(() => {
      const chatVisible = gdChatWidgetElementIsVisible("#gd-chat-widget-main-wrapper");

      if (chatVisible) {
        clearInterval(interval);
        gdChatWidgetShowDiscountCode(0, ".gd-chat-widget-conversation-area", source);
      }
    }, 250);
    return;
  }


  /* ---------------- REVISITS ---------------- */
  if (trigger.includes("revisit")) {
    const interval = setInterval(() => {
      const chatVisible = gdChatWidgetElementIsVisible("#gd-chat-widget-main-wrapper");

      if (chatVisible) {
        clearInterval(interval);
        gdChatWidgetShowDiscountCode(0, ".gd-chat-widget-conversation-area", source);
      }
    }, 250);
    return;
  }
}



/* -----------------------------------------------------------
 * TAB CLOSE / REVISIT LOGIC
 * ----------------------------------------------------------- */
function gdChatWidgetSetupTabCloseDetection() {
  const save = () => {
    document.cookie = "gdTabClosedTime=" + Date.now() + "; path=/; max-age=30";
  };
  window.addEventListener("beforeunload", save);
  window.addEventListener("pagehide", save);
}

function gdChatWidgetCheckRevisitDiscount() {
  const now = Date.now();
  const oneDay = 86400000;

  const firstVisit = localStorage.getItem("gdFirstVisitTime");
  if (!firstVisit) {
    localStorage.setItem("gdFirstVisitTime", now);
    return;
  }

  const tabClosed = document.cookie
    .split("; ")
    .find(x => x.startsWith("gdTabClosedTime="));

  if (!tabClosed) return;

  const closedTime = Number(tabClosed.split("=")[1]);
  const days = Math.floor((now - Number(firstVisit)) / oneDay);

  if (now - closedTime > 1000) {
    if (days === 1) gdChatWidgetShowDiscountIfEligible("1-day revisit");
    if (days === 7) gdChatWidgetShowDiscountIfEligible("7-day revisit");
  }

  document.cookie = "gdTabClosedTime=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
}


/* -----------------------------------------------------------
 * INIT DISCOUNT SYSTEM
 * ----------------------------------------------------------- */
gdChatWidgetSetupTabCloseDetection();
gdChatWidgetCheckRevisitDiscount();


function gdChatWidgetInitProfileUpdater() {
  const modal = document.getElementById("gd-chat-widget-profileModal");
  const btnOpen = document.getElementById("gd-chat-widget-btnProfile");
  const btnCancel = document.getElementById("gd-chat-widget-btnProfileCancel");
  const btnSave = document.getElementById("gd-chat-widget-btnProfileSave");

  // Updated selectors
  const nameInput = modal.querySelector(".gd-chat-widget-update-name");
  const emailInput = modal.querySelector(".gd-chat-widget-update-email");
  const errorBox = modal.querySelector(".gd-chat-widget-update-user-data-error");

  // 📌 Use ONLY user_name + user_email
  let oldName = localStorage.getItem("user_name") || "";
  let oldEmail = localStorage.getItem("user_email") || "";
  let userId = localStorage.getItem("user_id");

  // -----------------------------
  // OPEN MODAL (prefill from storage)
  // -----------------------------
  btnOpen.addEventListener("click", () => {
   
    const namePrefill = localStorage.getItem("user_name") || "";
    const emailPrefill = localStorage.getItem("user_email") || "";

    nameInput.value = namePrefill;
    emailInput.value = emailPrefill;

    oldName = namePrefill;
    oldEmail = emailPrefill;

    btnSave.disabled = true;
    btnSave.classList.add("disabled");

    if (errorBox) {
      errorBox.style.display = "none";
      errorBox.textContent = "";
    }

    modal.style.display = "flex";
  });

  // -----------------------------
  // CLOSE MODAL
  // -----------------------------
  btnCancel.addEventListener("click", () => {
    nameInput.value = "";
    emailInput.value = "";
    modal.style.display = "none";
    if (errorBox) errorBox.style.display = "none";
  });

  // -----------------------------
  // CHECK FOR CHANGES
  // -----------------------------
  function checkChanges() {
    if (
      nameInput.value.trim() !== oldName ||
      emailInput.value.trim() !== oldEmail
    ) {
      btnSave.disabled = false;
      btnSave.classList.remove("disabled");
    } else {
      btnSave.disabled = true;
      btnSave.classList.add("disabled");
    }
  }

  nameInput.addEventListener("input", checkChanges);
  emailInput.addEventListener("input", checkChanges);

  // -----------------------------
  // SAVE DATA
  // -----------------------------
  btnSave.addEventListener("click", function () {
    const userId = localStorage.getItem("user_id");
    if (errorBox) {
      errorBox.style.display = "none";
      errorBox.textContent = "";
    }

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();

    // Validation
    if (!name || !email) {
      errorBox.textContent = "Please enter both name and email.";
      errorBox.style.display = "block";
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      errorBox.textContent = "Please enter a valid email address.";
      errorBox.style.display = "block";
      return;
    }

    if (!userId) {
      errorBox.textContent = "User ID missing.";
      errorBox.style.display = "block";
      return;
    }

    const prevName = oldName;
    const prevEmail = oldEmail;

    const payload = {
      id: userId,
      name,
      email
    };

    const token = getGDChatWidgetAiToken();

    btnSave.disabled = true;
    btnSave.textContent = "Saving...";

    // -----------------------------
    // FETCH API
    // -----------------------------
    fetch("https://ai.mygoddiva.com/user-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { "Authorization": "Bearer " + token } : {})
      },
      body: JSON.stringify(payload)
    })
      .then(async (res) => {
        if (!res.ok) throw await res.json();
        return res.json();
      })
      .then(() => {
        modal.style.display = "none";

        // Save updated values
        localStorage.setItem("user_name", name);
        localStorage.setItem("user_email", email);

        // Update old values AFTER use
        oldName = name;
        oldEmail = email;

        // ░░ UPDATE INITIALS USING YOUR FUNCTION ░░
        const initials = gdChatWidgetGetUserInitials();
        btnOpen.textContent = initials;

        // Update profile avatars (old system)
        document.querySelectorAll(".gd-chat-widget-btn-profile").forEach(el => {
          el.textContent = initials;
        });

        // Update all chat avatars
        document.querySelectorAll(".gd-chat-widget-user-avatar").forEach(el => {
          el.textContent = initials;
        });

        // Update span name like OLD CODE
        const spanUser = document.getElementById("gd-chat-widget-user-name");
        if (spanUser) spanUser.textContent = name;

        // Build message
        const changes = [];
        if (prevName !== name) changes.push(`<b>Name:</b> ${prevName || "N/A"} → ${name}`);
        if (prevEmail !== email) changes.push(`<b>Email:</b> ${prevEmail || "N/A"} → ${email}`);

        if (changes.length > 0) {
          const html = `
            <div class="message-update-user-name-email">
              User details updated successfully.<br>
              ${changes.join("<br>")}
            </div>
          `;

          let chatbox;
          if(window.isProductPage){
             chatBox = document.querySelector(".gd-chat-widget-conversation-area");
          }else{
             chatBox = document.querySelector("#gd-chat-widget-prompt_suggestion");
          }  

         
          chatBox.insertAdjacentHTML("beforeend", html);

          setTimeout(() => {
            chatBox.scrollTop = chatBox.scrollHeight;
          }, 50);

            const newMessage = area.querySelector(".message-update-user-name-email:last-child");

            if (newMessage) {
              setTimeout(() => {

                newMessage.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });

                const scrollParent = newMessage.closest(".gd-chat-widget-conversation-area");

                if (scrollParent) {
                  scrollParent.scrollBy({
                    top: -80,
                    behavior: "smooth"
                  });
                }

              }, 50);
            }
        }

        btnSave.textContent = "Save";
      })
      .catch((err) => {
        btnSave.disabled = false;
        btnSave.textContent = "Save";

        if (err?.email) {
          errorBox.textContent = err.email[0];
        } else {
          errorBox.textContent = "An unexpected error occurred. Please try again.";
        }

        errorBox.style.display = "block";
      });
  });
}

gdChatWidgetInitProfileUpdater();


let tipSwiper = null;

function getTipSlidesPerView() {
  return document.body.classList.contains(EXPANDED_CLASS) ? 2 : 1;
}
function getTipSpaceBetween() {
  return document.body.classList.contains(EXPANDED_CLASS) ? 10 : 0;
}


function initTipSwiper() {

    const btn = document.getElementById("gd-chat-widget-btnSlideUpdateSize");
    const dropdown = document.getElementById("gd-chat-widget-sizeDropdown");

    if (btn && dropdown) {
        btn.addEventListener("click", () => dropdown.click());
    }

  // destroy if already exists
  if (tipSwiper) {
    tipSwiper.destroy(true, true);
    tipSwiper = null;
  }

  tipSwiper = new Swiper(".gd-chat-widget-tip-swiper", {
    slidesPerView: getTipSlidesPerView(),
    spaceBetween: getTipSpaceBetween(),
    autoHeight: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: ".gd-chat-widget-tip-swiper .swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".gd-chat-widget-tip-swiper .swiper-button-next",
      prevEl: ".gd-chat-widget-tip-swiper .swiper-button-prev"
    }
  });
}

initTipSwiper();


function clearAllSwiperInstances() {
    if (chatProductSwipers && chatProductSwipers.size > 0) {
        chatProductSwipers.forEach((swiper, messageId) => {
            if (swiper && typeof swiper.destroy === 'function') {
                try {
                    swiper.destroy(true, true);
                } catch (error) {
                    console.error('Error destroying swiper:', error);
                }
            }
        });
        chatProductSwipers.clear();
    }
   
}

function initChatProductSwiper(container, messageId) {
    if (!container) return;
    
    const swiperEl = container.querySelector('.chat-swiper');
    if (!swiperEl) return;
    
    // Check if swiper is already initialized on this element
    if (swiperEl.swiper) {
        return; // Already initialized
    }
    
    // Don't reinitialize if already exists in our Map
    if (chatProductSwipers.has(messageId)) {
        return;
    }

    // Wait a tick for DOM to be fully ready
    setTimeout(() => {
        try {
            const swiper = new Swiper(swiperEl, {
                //slidesPerView: 2.18,
                slidesPerView: getSlidesPerView(),
                spaceBetween: 5,
                grabCursor: true,
                navigation: {
                    nextEl: container.querySelector('.chat-swiper-next'),
                    prevEl: container.querySelector('.chat-swiper-prev')
                },
                init: false // Don't auto-initialize
            });
            
            // Initialize it
            swiper.init();
            
            // Store swiper instance with message ID as key
            chatProductSwipers.set(messageId, swiper);

            applyPriceLayoutAroundDiscounts(container);   
        } catch (error) {
            console.error('Failed to initialize swiper:', error);
        }
    }, 100);

}

function destroyChatProductSwiper(messageId) {
    if (chatProductSwipers.has(messageId)) {
        const swiper = chatProductSwipers.get(messageId);
        try {
            if (swiper && typeof swiper.destroy === 'function') {
                swiper.destroy(true, true);
            }
        } catch (error) {
            console.error('Error destroying swiper:', error);
        }
        chatProductSwipers.delete(messageId);
    }
}


// ============================
// PRODUCT HANDLING
// ============================
function gdChatWidgetProductHandel(product, id, isDirect = 1) {
    let productHtml = '';

    if (isDirect === 1) {
        productHtml = `
            <div class="products gd-widget-drag-scroll-wrapper">
                <div class="gd-widget-drag-scroll"
                    data-page="${product.page}"
                    data-has="${product.has_next}"
                    data-id="${id}"
                    data-total="${product.total}">
                    <div class="chat-product-item-wrapper">`;
    }

    let items = product.items || [];

    // Split into multiple colour-based products only if 1 item and more than 1 colour
    if (items.length === 1 && items[0].colour && items[0].colour.length > 1) {
        const singleItem = items[0];
        const expandedItems = singleItem.colour.map(col => {
            const colourVariants = (singleItem.variants || []).filter(v => v.colour === col.name);
            const variantHandle = colourVariants[0]?.handel || singleItem.handle;

            return {
                ...singleItem,
                handle: variantHandle,
                image: col.image,
                name: `${singleItem.name.split('-')[0].trim()} - ${col.name}`,
                colour: [col],
                price: col.price,  // Use colour price
                sale_price: col.sale_price,  // Use colour sale price
                variants: colourVariants
            };
        });

        items = expandedItems;
    }

    // Loop through final items
    items.forEach((value, index) => {
        const countdownId = `countdown-${index}-${id}-${value.shopify_ids}`;

        // 🔥 FINAL COLOUR PRICE SYSTEM - Use colour prices directly
        let selectedColourPrice = value.price;  // This now comes from colour after split
        let selectedColourSalePrice = value.sale_price;  // This now comes from colour after split

        // For non-split items with multiple colours, find the cheapest colour price
        if (value.colour && value.colour.length > 1 && !value.colour[0].price) {
            // Item not split, find cheapest colour
            const sortedColours = [...value.colour].sort((a, b) => {
                const aPrice = a.price ?? Infinity;
                const bPrice = b.price ?? Infinity;
                return aPrice - bPrice;
            });
            
            selectedColourPrice = sortedColours[0].price ?? value.price;
            selectedColourSalePrice = sortedColours[0].sale_price ?? null;
        }

        let discountValid = false;
        let discountPercentage = 0;
        let amountSaved = 0;

        if (value.discount && value.discount.expire_at) {
          const expireTimestamp = Date.parse(value.discount.expire_at);
          if (window.dateNowTs < expireTimestamp) {
            if (value.discount.type === 1 && value.discount.amount > 0) {
              discountValid = true;
            } else if (value.discount.type === 2 && value.discount.percentage > 0) {
              discountValid = true;
              discountPercentage = Math.round(value.discount.percentage * 100);
            }
          }
        }

        let basePrice = selectedColourSalePrice ?? selectedColourPrice;
        basePrice = Number(basePrice) || 0;

        let vipPrice = basePrice;
        if (discountValid) {
          if (value.discount.type === 1) {
            vipPrice = basePrice - value.discount.amount; 
            amountSaved = value.discount.amount;
            discountPercentage = Math.round((amountSaved / basePrice) * 100);
          } else {
            vipPrice = basePrice * (1 - (discountPercentage / 100));
            amountSaved = basePrice - vipPrice;
          }
        }
        vipPrice = Number(vipPrice.toFixed(2));
        amountSaved = Number(amountSaved.toFixed(2));

        
        // ✅ Unique colors with their pricing
        const uniqueColors = [...new Set((value.variants || []).map(v => v.colour))];
        const colorVariants = uniqueColors.map(color => {
            const variant = (value.variants || []).find(v => v.colour === color);
            const colourObj = (value.colour || []).find(c => c.name === color) || {};
            return {
                id: colourObj.id || '',
                name: color,
                handle: variant ? variant.handel || variant.handle || '' : '',
                image: colourObj.image || '',
                price: typeof colourObj.price !== 'undefined' ? Number(colourObj.price) : null,
                sale_price: typeof colourObj.sale_price !== 'undefined' ? 
                    (colourObj.sale_price === null ? null : Number(colourObj.sale_price)) : null
            };
        });

        // ✅ Unique sizes
        const uniqueSizes = [...new Set((value.variants || []).map(v => v.size))];
        const sizeVariants = uniqueSizes.map(size => {
            const variant = (value.variants || []).find(v => v.size === size);
            return {
                id: (value.size || []).find(s => s.name === size)?.id || '',
                name: size,
                handle: variant ? variant.handle : ''
            };
        });

        // Determine effective price for cart buttons - use colour pricing
        let effectivePrice = discountValid ? vipPrice : 
                            (selectedColourSalePrice ?? selectedColourPrice);

        // ✅ Build thumbnail list from colour images (NEW)
        const colourThumbs = (value.colour || [])
            .filter(c => c.image)
            .map((c, i) => ({
                src: c.image,
                active: i === 0
            }));

        // Fallback: if no colour image, still have at least one thumb using main image
        const thumbSources = colourThumbs.length
            ? colourThumbs
            : [{ src: value.image, active: true }];

        // Show deal badge only if discount is valid
        const hasDealBadge = discountValid;

        // Calculate remaining time for data attributes
        let remainingMinutes = 0;
        let remainingSeconds = 0;
        if (discountValid && value.discount?.expire_at) {
            const expireTimestamp = Date.parse(value.discount.expire_at);
            remainingSeconds = Math.max(0, Math.floor((expireTimestamp - window.dateNowTs) / 1000));
            remainingMinutes = Math.floor(remainingSeconds / 60);
        }

        // 🧩 Build Product HTML - Show colour-specific pricing
        productHtml += `
            <div class="swiper-slide">
                <div class="gd-chat-widget-product-card" data-has-discount="${discountValid || !!selectedColourSalePrice}">
                    <div class="gd-chat-widget-product-img-wrap">
                        <img src="${value.image}" alt="${value.name}" class="gd-chat-widget-product-main-img">
                        ${
                            hasDealBadge ? `
                            <div class="deal-timer gd-chat-widget-product-deal-badge">
                                Deal
                                <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chatclockicon-4.png?v=1760010677">
                                <span class="countdown-inline" id="${countdownId}" data-timer> </span>
                            </div>` : ''
                        }

                      ${thumbSources.length > 1 ? `
                        <div class="gd-chat-widget-product-thumb-column" aria-hidden="false">
                            <button class="gd-chat-widget-thumb-arrow gd-chat-widget-thumb-up" title="Scroll thumbnails up">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                    <path d="M6 15L12 9L18 15"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <div class="gd-chat-widget-product-thumbs">
                                ${
                                    thumbSources.map(t => `
                                        <div class="gd-chat-widget-product-thumb ${t.active ? "active" : ""}" data-src="${t.src}">
                                            <img src="${t.src}" alt="">
                                        </div>
                                    `).join('')
                                }
                            </div>
                            <button class="gd-chat-widget-thumb-arrow gd-chat-widget-thumb-down" title="Scroll thumbnails down">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                      <path d="M6 9L12 15L18 9"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                  </svg>
                            </button>
                        </div>
                        ` : ''}

                        <div class="chat-widget-render-in-sidebar" style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;"
                            data-id="${value.id}"
                            data-code="${value.code}"
                            data-name="${value.name}"
                            data-price="${selectedColourPrice}"
                            data-sale-price="${selectedColourSalePrice}"
                            data-discounted-price="${vipPrice}"
                            data-discount-percentage="${discountPercentage}"
                            data-discount-type="${value.discount?.type || 2}"
                            data-discount-amount="${value.discount?.type === 1 ? value.discount.amount : 0}"
                            data-img="${value.image}"
                            data-discount-remaining-time="${remainingMinutes}"
                            data-remaining-seconds="${remainingSeconds}"
                            data-shopify-ids="${value.shopify_ids}"
                            data-variants='${JSON.stringify(value.variants || [])}'
                            data-colours='${JSON.stringify(colorVariants)}'
                            data-sizes='${JSON.stringify(sizeVariants)}'>
                            
                        </div>
                    </div>

                    <div class="gd-chat-widget-product-meta-row">
                        <div class="gd-chat-widget-product-price-row${discountValid ? ' col-direct' : ''}">
                          ${
                            discountValid
                              ? `
                              <div class="price-main">
                                ${
                                  selectedColourSalePrice
                                    ? `
                                    <span class="old-price">£${selectedColourPrice.toFixed(2)}</span>
                                    <span class="new-price salestrike">£${selectedColourSalePrice.toFixed(2)}</span>
                                    `
                                    : `
                                    <span class="old-price salestrike">£${selectedColourPrice.toFixed(2)}</span>
                                    `
                                }
                              </div>

                              <div class="vip-prices">
                                <span class="personalized-offs">
                                    ${value.discount?.type === 1
                                      ? `£${amountSaved.toFixed(2)} OFF`
                                      : `${discountPercentage}% OFF`
                                    }
                                  </span>
                                  <span class="personalized-prices">
                                    VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span>
                                  </span>
                              </div>
                              `
                              : selectedColourSalePrice
                              ? `
                              <div class="price-main">
                                <span class="old-price">£${selectedColourPrice.toFixed(2)}</span>
                                <span class="new-price">£${selectedColourSalePrice.toFixed(2)}</span>
                              </div>
                              `
                              : `
                              <div class="price-main">
                                <span class="new-price">£${selectedColourPrice.toFixed(2)}</span>
                              </div>
                              `
                          }
                        </div>

                        <div class="gd-chat-widget-product-icons">
                            <button class="chat-find-similar-item gd-chat-widget-product-icon-btn"
                                title="Find similar item"
                                data-product-id="${value.id}"
                                data-product-name="${value.name}"
                                data-product-price="${effectivePrice.toFixed(2)}"
                                onclick="gdWidgetmoreLike(${value.id},'${value.image}','${value.name}')">
                                <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-find-similar-5.png?v=1760027753">
                            </button>
                            <button class="cart-btn add-btn chataiaddbuttn gd-chat-widget-product-icon-btn"
                                onclick="gdChatWidgetOpenOverlay(this,'${value.code}')"
                                title="Add to cart"
                                data-product-id="${value.code}"
                                data-product-name="${value.name}"
                                data-product-price="${effectivePrice.toFixed(2)}">
                                <img class="chataiaddbuttn"
                                    src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/icons8-add-to-cart-48.png?v=1759985945">
                            </button>
                        </div>
                    </div>
                </div>

                <div class="variant-info" style="display:none;">
                    ${(value.variants || []).map(v => `
                        <div class="variant-data"
                            data-variant-id="${v.variant_id}"
                            data-colour="${v.colour}"
                            data-size="${v.size}"
                            data-stock="${v.quantity}"
                            data-handle="${v.handel}">
                        </div>
                    `).join('')}
                </div>

                <div class="card-overlay not-needed" style="display:none">
                    <div class="overlay-content">
                        <div class="overlay-scrollable">
                            <div class="overlay-title colour-tag-title" style="margin-top: 15px;">
                                Color: <span class="selected-value"></span>
                            </div>
                            <div class="colour-tags">
                                ${(value.colour || []).map((colour, idx) => `
                                    <button
                                        class="colour-tag ${value.colour.length === 1 ? "active" : ""}"
                                        onclick="colourAdd(this)"
                                        data-id="${colour.id}"
                                        data-name="${colour.name}"
                                        title="${colour.name}">
                                            ${colour.image
                                                ? `<img src="${colour.image}" alt="${colour.name}" class="colour-swatch">`
                                                : colour.name.slice(0, 1)}
                                    </button>
                                `).join('')}
                            </div>

                            <div class="overlay-title size-tag-title" style="margin-top:15px;">
                                Size: <span class="selected-value"></span>
                            </div>
                            <div class="size-pills">
                                ${(value.size || [])
                                    .sort((a, b) => {
                                        const aNum = parseFloat(a.name), bNum = parseFloat(b.name);
                                        const aIsNum = !isNaN(aNum), bIsNum = !isNaN(bNum);
                                        if (aIsNum && bIsNum) return aNum - bNum;
                                        if (aIsNum) return -1;
                                        if (bIsNum) return 1;
                                        return a.name.localeCompare(b.name);
                                    })
                                    .map((size, idx) => `
                                        <button
                                            onclick="sizeAdd(this)"
                                            data-id="${size.id}"
                                            data-name="${size.name}"
                                            title="${size.name}"
                                            class="size-pill ${value.size.length === 1 ? "active" : ""}">
                                            ${size.name}
                                        </button>
                                    `).join('')}
                            </div>
                        </div>

                        <div class="overlay-buttons">
                            <button
                                disabled
                                onclick="addItemToCart(this,'${value.code}')"
                                type="button"
                                class="add-btn-action chataiaddbuttn"
                                data-product-id="${value.code}"
                                data-product-name="${value.name}"
                                data-product-price="${effectivePrice.toFixed(2)}">
                                Add
                            </button>
                            <button onclick="cancelCart(this)" type="button" class="cancel-btn-action">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Start countdown if discount is valid
        if (discountValid && value.discount?.expire_at) {
            const expireTimestamp = Date.parse(value.discount.expire_at);
            const remainingSeconds = Math.max(0, Math.floor((expireTimestamp - window.dateNowTs) / 1000));
            
            setTimeout(() => {
                gdWidgetStartHmsCountdown(countdownId, remainingSeconds, value.shopify_ids);
            }, 100);
        }
    });

    if (isDirect === 1) {
        productHtml += '</div></div></div>';
    }

    return productHtml;
}

function initGDChatWidgetThumbs(container) {
    container.addEventListener("click", function (e) {

        /* -----------------------------
           ✅ Thumbnail click
        ----------------------------- */
        const thumb = e.target.closest(".gd-chat-widget-product-thumb");
        if (thumb) {
            const card = thumb.closest(".gd-chat-widget-product-card");
            if (!card) return;

            const mainImg = card.querySelector(".gd-chat-widget-product-main-img");
            if (!mainImg) return;

            mainImg.src = thumb.dataset.src;

            card.querySelectorAll(".gd-chat-widget-product-thumb")
                .forEach(t => t.classList.remove("active"));

            thumb.classList.add("active");
            return;
        }

        /* -----------------------------
           ✅ Arrow scroll
        ----------------------------- */
        const upArrow = e.target.closest(".gd-chat-widget-thumb-up");
        const downArrow = e.target.closest(".gd-chat-widget-thumb-down");

        if (!upArrow && !downArrow) return;

        const column = (upArrow || downArrow)
            .closest(".gd-chat-widget-product-thumb-column");

        if (!column) return;

        const thumbsWrapper = column.querySelector(".gd-chat-widget-product-thumbs");
        if (!thumbsWrapper) return;

        const scrollAmount = 36; // thumb (30) + gap (6)

        thumbsWrapper.scrollBy({
            top: upArrow ? -scrollAmount : scrollAmount,
            behavior: "smooth"
        });
    });
}

initGDChatWidgetThumbs(document);


function gdChatWidgetOpenOverlay(button, code) {
    const card = button.closest(".gd-chat-widget-product-card");
    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");

    const colours = JSON.parse(card.querySelector("[data-colours]")?.dataset.colours || "[]");
    const sizes = JSON.parse(card.querySelector("[data-sizes]")?.dataset.sizes || "[]");
    const variants = JSON.parse(card.querySelector("[data-variants]")?.dataset.variants || "[]");

    /* -------------------------------------------------
       ✅ OLD BEHAVIOUR RESTORED
       If ONLY 1 colour & 1 size → add directly
    ------------------------------------------------- */
    if (colours.length === 1 && sizes.length === 1) {
        const colourId = colours[0].id;
        const sizeId = sizes[0].id;

        gdChatWidgetGetProductForCart(code, colourId, sizeId);
        
        gdWidgetsendUserFeedback(button, 'add_to_cart', {
          size: sizeId,
          colour: colourId
        });

        return; // ⛔ do NOT open overlay
    }

    /* -------------------------------------------------
       MULTIPLE OPTIONS → OPEN OVERLAY
    ------------------------------------------------- */

    overlay.dataset.code = code;
    overlay.dataset.variants = JSON.stringify(variants);

    /* -------------------------------
       SORT COLOURS A → Z
    ------------------------------- */
    const sortedColours = [...colours].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    /* -------------------------------
       SORT SIZES (number → text)
    ------------------------------- */
    const sortedSizes = [...sizes].sort((a, b) => {
        const aNum = parseFloat(a.name);
        const bNum = parseFloat(b.name);
        const aIsNum = !isNaN(aNum);
        const bIsNum = !isNaN(bNum);

        if (aIsNum && bIsNum) return aNum - bNum;
        if (aIsNum) return -1;
        if (bIsNum) return 1;
        return a.name.localeCompare(b.name);
    });

    /* -------------------------------
       BUILD COLOUR BUTTONS
    ------------------------------- */
    const colourWrap = overlay.querySelector(".colour-tags");
    colourWrap.innerHTML = sortedColours.map(c => `
        <button class="colour-tag"
            data-id="${c.id}"
            data-name="${c.name}"
            onclick="gdChatWidgetSelectColour(this)">
            ${c.image ? `<img src="${c.image}" class="colour-swatch">` : c.name[0]}
        </button>
    `).join("");

    /* -------------------------------
       BUILD SIZE BUTTONS
    ------------------------------- */
    const sizeWrap = overlay.querySelector(".size-pills");
    sizeWrap.innerHTML = sortedSizes.map(s => `
        <button class="size-pill"
            data-id="${s.id}"
            data-name="${s.name}"
            onclick="gdChatWidgetSelectSize(this)">
            ${s.name}
        </button>
    `).join("");

    /* -------------------------------
       AUTO SELECT FIRST COLOUR
    ------------------------------- */
    const firstColour = overlay.querySelector(".colour-tag");
    firstColour.classList.add("active");

    overlay.querySelector(".colour-tag-title .selected-value").textContent =
        firstColour.dataset.name;

    /* -------------------------------
       FILTER SIZES FOR THAT COLOUR
    ------------------------------- */
    gdChatWidgetFilterSizesByColour(firstColour.dataset.name);

    /* -------------------------------
       AUTO SELECT FIRST ENABLED SIZE
    ------------------------------- */
    const firstEnabledSize = overlay.querySelector(".size-pill:not(.disabled)");
    if (firstEnabledSize) {
        firstEnabledSize.classList.add("active");
        overlay.querySelector(".size-tag-title .selected-value").textContent =
            firstEnabledSize.dataset.name;
    }

    gdChatWidgetValidateAddButton();
    overlay.style.display = "flex";
}



function gdChatWidgetFilterSizesByColour(colourName) {
    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");

    const variants = JSON.parse(overlay.dataset.variants || "[]");

    // Which sizes exist for this colour & are in stock?
    const availableSizes = variants
        .filter(v => v.colour === colourName && v.quantity > 0)
        .map(v => v.size);

    const sizeButtons = overlay.querySelectorAll(".size-pill");

    sizeButtons.forEach(btn => {
        const sizeName = btn.dataset.name;

        if (!availableSizes.includes(sizeName)) {
            btn.classList.add("disabled");
            btn.disabled = true;
            btn.classList.remove("active");
        } else {
            btn.classList.remove("disabled");
            btn.disabled = false;
        }
    });
}
function gdChatWidgetSelectColour(btn) {
    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");

    overlay.querySelectorAll(".colour-tag").forEach(el => el.classList.remove("active"));
    btn.classList.add("active");

    const colourName = btn.dataset.name;
    overlay.querySelector(".colour-tag-title .selected-value").textContent = colourName;

    // Re-filter sizes
    gdChatWidgetFilterSizesByColour(colourName);

    // Select first enabled size
    const firstEnabled = overlay.querySelector(".size-pill:not(.disabled)");
    overlay.querySelectorAll(".size-pill").forEach(el => el.classList.remove("active"));

    if (firstEnabled) {
        firstEnabled.classList.add("active");
        overlay.querySelector(".size-tag-title .selected-value").textContent =
            firstEnabled.dataset.name;
    }

    gdChatWidgetValidateAddButton();
}
function gdChatWidgetSelectSize(btn) {
    if (btn.classList.contains("disabled")) return;

    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");

    overlay.querySelectorAll(".size-pill").forEach(el => el.classList.remove("active"));
    btn.classList.add("active");

    overlay.querySelector(".size-tag-title .selected-value").textContent =
        btn.dataset.name;

    gdChatWidgetValidateAddButton();
}
function gdChatWidgetValidateAddButton() {
    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");

    const colourOk = overlay.querySelector(".colour-tag.active");
    const sizeOk = overlay.querySelector(".size-pill.active:not(.disabled)");

    document.getElementById("gdChatWidgetOverlayAddBtn").disabled = !(colourOk && sizeOk);
}
function gdChatWidgetCloseOverlay() {
    document.getElementById("gdChatWidgetUniversalOverlay").style.display = "none";
}

document.getElementById("gdChatWidgetOverlayCancelBtn").onclick = gdChatWidgetCloseOverlay;


/* ---------------------------------------------------------
   ADD ITEM TO CART
--------------------------------------------------------- */
document.getElementById("gdChatWidgetOverlayAddBtn").onclick = function () {
    const overlay = document.getElementById("gdChatWidgetUniversalOverlay");
    const code = overlay.dataset.code;

    const colourId = overlay.querySelector(".colour-tag.active").dataset.id;
    const sizeId = overlay.querySelector(".size-pill.active").dataset.id;

    gdChatWidgetCloseOverlay();

    gdChatWidgetGetProductForCart(code, colourId, sizeId);
};

/* ---------------------------------------------------------
   API → GET PRODUCT FOR CART
--------------------------------------------------------- */

function gdChatWidgetGetProductForCart(code, colour, size) {
    const token = getGDChatWidgetAiToken();
    const sessionId = localStorage.getItem('session_id');

    // Build query parameters
    const params = new URLSearchParams({
        id: sessionId,
        code: code,
        colour: colour,
        size: size
    });

    // Create headers
    const headers = new Headers({
        'Content-Type': 'application/json'
    });
    
    if (token) {
        headers.append('Authorization', `Bearer ${token}`);
    }

    // Make the fetch request
    fetch(`https://ai.mygoddiva.com/get-product-for-cart?${params.toString()}`, {
        method: 'GET',
        headers: headers
    })
    .then(response => response.json())
    .then(response => {
        if (!response?.variant?.shopify_variant_id) {
            console.error("Invalid response", response);
            return;
        }

        const variantId = response.variant.shopify_variant_id;
        const stock = Number(response.variant.inventory_variant__qty || 0);
        const discountCode = response.discount || null;

        Shopify.getCart(cart => {
            const existing = cart.items.find(i => i.variant_id == variantId);
            const currentQty = existing ? existing.quantity : 0;

            if (currentQty + 1 > stock) {
                // Show warning - replace jQuery with vanilla JS
                document.body.classList.add('has-warning');
                
                const warningContent = document.querySelector('.halo-warning-content');
                if (warningContent) {
                    warningContent.textContent = 'The maximum quantity of this item is already in your cart.';
                }
                
                setTimeout(() => {
                    document.body.classList.remove('has-warning');
                    if (warningContent) {
                        warningContent.textContent = '';
                    }
                }, 2000);
                return;
            }

            gdChatWidgetAddToShoppingCart(variantId, discountCode);
        });
    })
    .catch(error => {
        console.error("Error in gdChatWidgetGetProductForCart:", error);
    });
}
/* ---------------------------------------------------------
   ADD TO SHOPIFY CART
--------------------------------------------------------- */

function gdChatWidgetAddToShoppingCart(variantId, discountCode) {
  return fetch('/cart/add.js', {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      attributes: { DudeAi: "true" }
    })
  })
    .then(res => res.json())
    .then(() => {
      if (discountCode) {
        return gdChatWidgetAddDiscount(discountCode)
          .then(cart => {
            gdChatWidgetUpdateSidebar(cart, variantId);
            return cart;
          });
      } else {
        return new Promise(resolve => {
          Shopify.getCart(cart => {
            gdChatWidgetUpdateSidebar(cart, variantId);
            resolve(cart);
          });
        });
      }
    });
}


/* ---------------------------------------------------------
   UPDATE SIDEBAR CART
--------------------------------------------------------- */
function gdChatWidgetUpdateSidebar(cart, variantId) {
    if (window.halo?.updateSidebarCart) {
        window.halo.updateSidebarCart(cart, variantId);
        document.body.classList.add("cart-sidebar-show");
    }
}

async function gdChatWidgetAddDiscount(code) {
  try {
    // 1. Get current cart
    const cart = await fetch('/cart.js').then(r => r.json());

    // 2. Existing discount codes
    const existing = cart.discount_codes?.map(d => d.code) || [];

    // 3. Prevent duplicate apply
    if (existing.includes(code)) {
      console.log('Discount already applied:', code);
      return cart;
    }

    // 4. Apply stacked discounts
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: [...existing, code].join(',')
      })
    });

    if (!res.ok) throw new Error('Failed to apply discount');

    const updatedCart = await res.json();

    // 5. Verify applied
    const applied =
      updatedCart.cart_level_discount_applications?.some(d => d.title === code) ||
      updatedCart.items?.some(item => item.discounts?.some(d => d.title === code)) ||
      updatedCart.discount_codes?.some(d => d.code === code && d.applicable);

    if (!applied) {
      console.warn(`⚠️ Discount "${code}" not applied`);
    }

    return updatedCart;

  } catch (error) {
    console.error('Discount error:', error);
  }
}


// ============================
// LAZY LOAD INITIALIZATION
// ============================

function gdChatWidgetInitLazyLoad(container, messageId, initialProducts = null) {
    let page = initialProducts ? 2 : 1;
    let isLoading = false;

    const isExpanded = document.body.classList.contains("goddiva-assistant-expanded");

    // Number of columns – adjust based on your actual layout
    function getColumnCount() {
        // You can override by setting data-columns on the container
        if (container.dataset.columns) {
            return parseInt(container.dataset.columns, 10) || 2;
        }
        // Fallback: 2 columns when not expanded, 3 when expanded (change if needed)
        return isExpanded ? 3 : 2;
    }
    const columns = getColumnCount();

    const INITIAL_LOAD = 5;          // number shown first
    const TARGET_INCREMENT = 5;      // desired number to add each click (will be adjusted)

    let hasTriggeredAllViewed = false;
    let total = initialProducts ? Number(initialProducts.total) : Number(container.dataset.total) || Infinity;

    // Buffer that holds all products we have fetched so far (including initial)
    let productBuffer = [];
    if (initialProducts && initialProducts.items && initialProducts.items.length > 0) {
        productBuffer = [...initialProducts.items];
    }

    // Number of products already rendered
    let shownCount = Math.min(INITIAL_LOAD, productBuffer.length);

    const swiperEl = container.querySelector('.chat-swiper');
    const wrapper = swiperEl.querySelector('.chat-product-item-wrapper');

    // Render initial products
    if (productBuffer.length > 0) {
        const initialItems = productBuffer.slice(0, INITIAL_LOAD);
        wrapper.innerHTML = gdChatWidgetProductHandel({ items: initialItems }, messageId, 0);
        applyPriceLayoutAroundDiscounts(container);
    }

    container.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');

    setTimeout(() => {
        initChatProductSwiper(container, messageId);
    }, 50);

    // Loader element
    let loader = container.querySelector('.chat-lazy-loader');
    if (!loader) {
        loader = document.createElement('div');
        loader.className = 'chat-lazy-loader';
        loader.innerHTML = '<div class="chat-productspinner"></div>';
        loader.style.display = 'none';
        container.appendChild(loader);
    }

    // Load more button
    let loadMoreBtn = container.querySelector('.chat-load-more');
    if (!loadMoreBtn) {
        loadMoreBtn = document.createElement('button');
        loadMoreBtn.className = 'chat-load-more';
        loadMoreBtn.style.display = 'none';
        loader.parentNode.insertBefore(loadMoreBtn, loader);
    }

    function showLoader() { loader.style.display = 'block'; }
    function hideLoader() { loader.style.display = 'none'; }

    function updateButtonText() {
        const remaining = total - shownCount;

        if (total <= INITIAL_LOAD) {
            loadMoreBtn.style.display = 'none';
            return;
        }

        if (shownCount >= total) {
            loadMoreBtn.textContent = "Show Less Curated Styles";
            return;
        }

        loadMoreBtn.textContent =
            `Show ${remaining} More Curated Style${remaining > 1 ? "s" : ""}`;
    }

    function updateLoadMoreVisibility() {
        if (total <= INITIAL_LOAD) {
            loadMoreBtn.style.display = 'none';
            return;
        }
        loadMoreBtn.style.display = 'block';
        updateButtonText();
    }

    // 🔥 FINAL LOAD DETECTION (unchanged)
    function checkIfAllViewed() {
        const allDragScrolls = document.querySelectorAll('.gd-widget-drag-scroll');
        const lastDragScroll = allDragScrolls[allDragScrolls.length - 1];
        const isCurrentlyLast = container === lastDragScroll;

        if (
            isCurrentlyLast &&
            !hasTriggeredAllViewed &&
            typeof total === "number" &&
            total > 0 &&
            shownCount >= total
        ) {
            hasTriggeredAllViewed = true;
            console.log("🔥 WIDGET LAST DRAG-SCROLL FINISHED → Calling reset API");
            gdWidgetHandleAllProductsViewed();
        }
    }

    // Calculates how many items we should actually add to keep the grid filled
    function calculateItemsToAdd() {
        const remaining = total - shownCount;
        if (remaining <= 0) return 0;

        // Items needed to complete the current row (0 if already full)
        const neededToFillRow = (columns - (shownCount % columns)) % columns;

        // We want to add at least TARGET_INCREMENT items, but we must fill the current row first,
        // then add whole rows until we reach or exceed TARGET_INCREMENT.
        let toAdd = neededToFillRow;
        if (toAdd < TARGET_INCREMENT) {
            // Add full rows until we meet or exceed TARGET_INCREMENT
            const fullRowsNeeded = Math.ceil((TARGET_INCREMENT - toAdd) / columns);
            toAdd += fullRowsNeeded * columns;
        }

        // Never exceed remaining items
        return Math.min(toAdd, remaining);
    }

    // Fetch one page from API and add to buffer
    function fetchNextPage() {
        return new Promise((resolve, reject) => {
            const token = getGDChatWidgetAiToken();
            fetch(`https://ai.mygoddiva.com/get-product?page=${page}&id=${localStorage.getItem('session_id')}&message_id=${messageId}`, {
                headers: token ? { "Authorization": "Bearer " + token } : {}
            })
                .then(response => response.json())
                .then(response => {
                    const items = response.products?.items || [];
                    if (typeof response.products?.total === 'number') {
                        total = response.products.total;
                    }
                    // Add new items to buffer
                    productBuffer.push(...items);
                    page++;
                    resolve(items);
                })
                .catch(error => {
                    console.log('Failed to load products', error);
                    reject(error);
                });
        });
    }

    // Append the next batch of products (determined by calculateItemsToAdd)
    function appendNext() {
        if (isLoading) return;

        // If we've shown all, do nothing
        if (shownCount >= total) {
            hideLoader();
            loadMoreBtn.style.display = 'none';
            return;
        }

        const toAdd = calculateItemsToAdd();
        if (toAdd === 0) {
            hideLoader();
            return;
        }

        isLoading = true;
        showLoader();
        loadMoreBtn.disabled = true;

        // Ensure buffer has enough items
        function ensureBufferAndAppend() {
            const availableInBuffer = productBuffer.length - shownCount;

            if (availableInBuffer >= toAdd) {
                // We have enough in buffer – take the next slice
                const itemsToAppend = productBuffer.slice(shownCount, shownCount + toAdd);
                appendItems(itemsToAppend);
            } else {
                // Need to fetch more from API
                fetchNextPage()
                    .then(() => {
                        // After fetch, try again (recursive call, but safe because we now have more items)
                        ensureBufferAndAppend();
                    })
                    .catch(() => {
                        isLoading = false;
                        hideLoader();
                        loadMoreBtn.disabled = false;
                        updateLoadMoreVisibility();
                    });
            }
        }

        function appendItems(items) {
            if (items.length === 0) {
                isLoading = false;
                hideLoader();
                loadMoreBtn.disabled = false;
                updateLoadMoreVisibility();
                return;
            }

            // Destroy swiper before modifying DOM
            destroyChatProductSwiper(messageId);
            container.classList.remove('swiper');
            wrapper.classList.remove('swiper-wrapper');

            // Append new items
            wrapper.innerHTML += gdChatWidgetProductHandel({ items }, messageId, 0);
            applyPriceLayoutAroundDiscounts(container);

            shownCount += items.length;

            isLoading = false;
            hideLoader();
            loadMoreBtn.disabled = false;
            updateLoadMoreVisibility();

            checkIfAllViewed(); // 🔥 trigger final detection
        }

        ensureBufferAndAppend();
    }

    // Reset to initial state (Show Less)
    function resetToInitial() {
        hasTriggeredAllViewed = false;

        destroyChatProductSwiper(messageId);
        wrapper.innerHTML = '';

        // Reset buffer to initialProducts only (discard fetched items)
        if (initialProducts && initialProducts.items) {
            productBuffer = [...initialProducts.items];
        } else {
            productBuffer = [];
        }
        shownCount = Math.min(INITIAL_LOAD, productBuffer.length);
        page = initialProducts ? 2 : 1;

        if (productBuffer.length > 0) {
            const items = productBuffer.slice(0, INITIAL_LOAD);
            wrapper.innerHTML = gdChatWidgetProductHandel({ items }, messageId, 0);
            applyPriceLayoutAroundDiscounts(container); 
        }

        container.classList.add('swiper');
        wrapper.classList.add('swiper-wrapper');

        setTimeout(() => {
            initChatProductSwiper(container, messageId);
        }, 50);

        updateLoadMoreVisibility();
    }

    // Event listener for load more button
    loadMoreBtn.addEventListener('click', function () {
        if (shownCount >= total) {
            resetToInitial();
        } else {
            appendNext();
        }
    });

    updateLoadMoreVisibility();
}


function gdWidgetHandleAllProductsViewed() {

    const token = getGDChatWidgetAiToken();

    fetch("https://ai.mygoddiva.com/get-reset-prompts", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: "Bearer " + token } : {})
        },
        body: JSON.stringify({
            assistant_id: localStorage.getItem('session_id'),
            collection: window.collectionHandle || null
        })
    })
    .then(res => res.json())
    .then(response => {

        if (!response || !Array.isArray(response.prompts) || response.prompts.length === 0) {
            return;
        }

        const container = document.getElementById("gd-chat-widget-prompt_suggestion");
        if (!container) return;

        container.querySelector(".suggested-make-it-yours-wrapper")?.remove();
        container.querySelector(".refilter-section")?.remove();
        container.classList.add('gd-widget-get-reset-prompts');
        gdWidgetpromptHandel(response.prompts);
    })
    .catch(() => {
        console.log("Failed to fetch widget reset prompts");
    });
}

// Quick View Start
let qvSwiperInstance = null;
let qvRequestToken = 0;

let qvProductData = {
  baseHandle: null,
  variants: [],
  colours: [],
  sizes: []
};

let currentTriggerEl = null;

const qvOverlay = document.getElementById("gd-chat-widget-productQuickView");
const qvPanel = document.querySelector(".gd-chat-widget-product-qv-panel");
const qvCloseBtn = document.getElementById("gd-chat-widget-qvCloseBtn");
const qvLoader = document.querySelector(".gd-chat-widget-qv-loader");

const qvTitleEl = document.getElementById("gd-chat-widget-qvTitle");
const qvPriceEl = document.getElementById("gd-chat-widget-qvPrice");
const qvCompareEl = document.querySelector(".gd-chat-widget-qv-compare-price");
const qvDiscountEl = document.querySelector(".gd-chat-widget-qv-discounted-price");

const qvColorLabel = document.getElementById("gd-chat-widget-qvColor");
const qvColorOptions = document.getElementById("gd-chat-widget-qvColorOptions");

const qvSizeLabel = document.getElementById("gd-chat-widget-qvSelectedSize");
const qvSizeOptions = document.getElementById("gd-chat-widget-qvSizeOptions");

const qvSwiperWrapper = document.getElementById("gd-chat-widget-qvSwiperWrapper");
const qvDescription = document.getElementById("gd-chat-widget-qvDescription");
const qvRating = document.getElementById("gd-chat-widget-qvRating");

const qvWishlistBtn = document.getElementById("gd-chat-widget-qvWishlistBtn");
const qvAddBtn = document.getElementById("gd-chat-widget-qvAddBtn");

const qvDealBadge = document.querySelector(".gd-chat-widget-qv-deal");

/* =========================================================
   HELPERS
========================================================= */
function parseJSON(v) {
  if (!v) return [];
  if (typeof v === "object") return v;
  try { return JSON.parse(v); } catch (e) { return []; }
}

/* Selected color/size from radios (old-sidebar compatible) */
function getSelectedColor() {
  const el = qvOverlay.querySelector("input[name='chat-color']:checked");
  if (!el) return null;
  return {
    name: el.value,
    id: el.dataset.id || null
  };
}

function getSelectedSize() {
  const el = qvOverlay.querySelector("input[name='chat-size']:checked");
  if (!el) return null;
  return {
    name: el.value,
    id: el.dataset.id || el.dataset.sizeId || null,
    variantId: el.dataset.variantId || null
  };
}

/* =========================================================
   WISHLIST (LOCALSTORAGE)
========================================================= */
function gdWidgetToggleWishlistItem(handle) {
  if (!handle) return;
  let list = JSON.parse(localStorage.getItem("wishlistItem")) || [];
  const idx = list.indexOf(handle);
  if (idx === -1) list.push(handle);
  else list.splice(idx, 1);
  localStorage.setItem("wishlistItem", JSON.stringify(list));
}

function gdWidgetUpdateWishlistButtonState(handle) {
  if (!handle) return;
  const list = JSON.parse(localStorage.getItem("wishlistItem")) || [];
  qvWishlistBtn.classList.toggle("in-wishlist", list.includes(handle));
}

/* =========================================================
   COUNTDOWN (DEAL TIMER)
========================================================= */


function gdWidgetStartHmsCountdown(elementId, remainingSeconds, productId) {
  const el = document.getElementById(elementId);
  if (!el) return;

  if (!productEndTimes[productId]) {
    productEndTimes[productId] = Date.now() + remainingSeconds * 1000;
  }

  const endTime = productEndTimes[productId];

  function tick() {
    const diff = Math.floor((endTime - Date.now()) / 1000);
    if (diff <= 0) {
      el.dataset.timer = "expired";
      gdWidgetStopSidebarCountdown();
      return;
    }

    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;

    el.dataset.timer = `${h}h ${m}m ${s}s`;

    if (productId === currentViewedProduct) {
      gdWidgetUpdateSidebarCountdown(diff);
    }

    setTimeout(tick, 1000);
  }

  tick();
}

function gdWidgetStartSidebarCountdown(productId) {
  gdWidgetStopSidebarCountdown();
  const el = document.querySelector(".chat-widget-countdown-inline");
  if (!el) return;

  const endTime = productEndTimes[productId];
  if (!endTime) return;

  sidebarCountdownInterval = setInterval(() => {
    const diff = Math.floor((endTime - Date.now()) / 1000);
    if (diff <= 0) {
      el.dataset.timer = "expired";
      gdWidgetStopSidebarCountdown();
      return;
    }
    const h = Math.floor(diff / 3600);
    const m = Math.floor((diff % 3600) / 60);
    const s = diff % 60;
    el.dataset.timer = `${h}h ${m}m ${s}s`;
  }, 1000);
}

function gdWidgetUpdateSidebarCountdown(seconds) {
  const el = document.querySelector(".chat-widget-countdown-inline");
  if (!el) return;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  el.dataset.timer = `${h}h ${m}m ${s}s`;
}

function gdWidgetStopSidebarCountdown() {
  if (sidebarCountdownInterval) {
    clearInterval(sidebarCountdownInterval);
    sidebarCountdownInterval = null;
  }
}

/* =========================================================
   VARIANT HANDLE RESOLUTION
========================================================= */
function getSelectedVariantHandle() {
  const color = getSelectedColor();
  const size = getSelectedSize();
  const colourName = color ? color.name : null;
  const sizeName = size ? size.name : null;

  // Exact match
  let v = qvProductData.variants.find(
    x => x.colour === colourName && x.size === sizeName
  );
  if (v && v.handel) return v.handel;

  // Fallback: first variant for colour
  v = qvProductData.variants.find(x => x.colour === colourName);
  if (v && v.handel) return v.handel;

  // Final fallback
  return qvProductData.baseHandle;
}

function updateQVPrice(el, colourName) {
  // Get discount info from data attributes
  let discountPercentage = Number(el.dataset.discountPercentage) || 0; // ← const to let
  const discountedPrice = el.dataset.discountedPrice !== undefined && el.dataset.discountedPrice !== "null"
    ? Number(el.dataset.discountedPrice)
    : null;
  
  // Check if discount is valid based on remaining seconds
  const remainingSeconds = Number(el.dataset.remainingSeconds) || 0;
  const discountValid = discountPercentage > 0 && remainingSeconds > 0;

  // Find the selected colour to get its pricing
  let colourPrice = 0;
  let colourSalePrice = null;
  
  if (colourName) {
    const c = qvProductData.colours.find(x =>
      String(x.name).toLowerCase() === String(colourName).toLowerCase()
    );
    if (c) {
      if (typeof c.price === "number") colourPrice = c.price;
      if (typeof c.sale_price !== "undefined") {
        colourSalePrice = c.sale_price === null ? null : Number(c.sale_price);
      }
    }
  } else {
    const firstColour = qvProductData.colours[0];
    if (firstColour) {
      if (typeof firstColour.price === "number") colourPrice = firstColour.price;
      if (typeof firstColour.sale_price !== "undefined") {
        colourSalePrice = firstColour.sale_price === null ? null : Number(firstColour.sale_price);
      }
    }
  }

  let basePrice = colourSalePrice !== null ? colourSalePrice : colourPrice;
  basePrice = Number(basePrice) || 0;
  
  let vipPrice = basePrice;
  let amountSaved = 0;

  if (discountValid) {
    const discountType = Number(el.dataset.discountType) || 2;
    const discountAmountRaw = Number(el.dataset.discountAmount) || 0;

    if (discountType === 1 && discountAmountRaw > 0) {
      vipPrice = basePrice - discountAmountRaw;
      amountSaved = discountAmountRaw;
      discountPercentage = Math.round((amountSaved / basePrice) * 100); 
    } else {
      vipPrice = basePrice * (1 - (discountPercentage / 100));
      amountSaved = basePrice - vipPrice;
    }
    vipPrice = Number(vipPrice.toFixed(2));
    amountSaved = Number(amountSaved.toFixed(2));
  }

  let effective = colourPrice;
  let priceHTML = '';

  if (discountValid) {
    if (colourSalePrice !== null && colourSalePrice > 0) {
      priceHTML = `
        <span class="old-price salestrike">£${colourPrice.toFixed(2)}</span>
        <span class="new-price salestrike">£${colourSalePrice.toFixed(2)}</span>
        <div class="vip-prices">
          <span class="personalized-offs">
            ${Number(el.dataset.discountType) === 1
              ? `£${amountSaved.toFixed(2)} OFF`
              : `${discountPercentage}% OFF`
            }
          </span>
          <span class="personalized-prices"> VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span></span>
        </div>
      `;
      effective = vipPrice;
    } else {
      priceHTML = `
        <span class="old-price salestrike">£${colourPrice.toFixed(2)}</span>
        <div class="vip-prices">
          <span class="personalized-offs">
            ${Number(el.dataset.discountType) === 1
              ? `£${amountSaved.toFixed(2)} OFF`
              : `${discountPercentage}% OFF`
            }
          </span>
          <span class="personalized-prices"> VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span></span>
        </div>
      `;
      effective = vipPrice;
    }
  } else if (colourSalePrice !== null && colourSalePrice > 0) {
    priceHTML = `
      <span class="old-price">£${colourPrice.toFixed(2)}</span>
      <span class="new-price">£${colourSalePrice.toFixed(2)}</span>
    `;
    effective = colourSalePrice;
  } else {
    priceHTML = `<span class="new-price">£${colourPrice.toFixed(2)}</span>`;
    effective = colourPrice;
  }

  qvPriceEl.innerHTML = priceHTML;
  qvAddBtn.dataset.productPrice = effective.toFixed(2);
}

/* =========================================================
   SIZE + COLOR RENDER
========================================================= */

function renderColors() {
  qvColorOptions.innerHTML = "";

  qvProductData.colours.forEach((c, i) => {
    const id = "chat-color-" + i;

    const wrapper = document.createElement("div");
    wrapper.className = "gd-chat-widget-qv-color-options";

    wrapper.innerHTML = `
      <input type="radio"
             name="chat-color"
             id="${id}"
             value="${c.name}"
             data-id="${c.id || ""}"
             ${i === 0 ? "checked" : ""}>
      <label for="${id}" title="${c.name}">
        ${c.image
          ? `<img src="${c.image}" alt="${c.name}" class="color-swatch">`
          : c.name.charAt(0)}
      </label>
    `;

    const input = wrapper.querySelector('input[name="chat-color"]');

    input.addEventListener("change", () => {
      qvColorLabel.textContent = c.name;
      updateQVPrice(currentTriggerEl, c.name);
      renderSizes(c.name); // ✅ load will happen inside
       const productCode = qvPanel?.dataset?.productCode;
      if (productCode) {
        gdChatWidgetLoadProductByCode(productCode);
      }

    });

    qvColorOptions.appendChild(wrapper);
  });

  qvColorLabel.textContent =
    qvProductData.colours[0]?.name || "-";
}
function renderSizes(colorName) {
  qvSizeOptions.innerHTML = "";
  const colorVariants = qvProductData.variants.filter(v => v.colour === colorName);

  let firstAvailableInput = null;

  const sortedSizes = [...qvProductData.sizes].sort((a, b) => {
    const aVal = a.name;
    const bVal = b.name;

    const aNum = parseFloat(aVal);
    const bNum = parseFloat(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return aNum - bNum;
    }

    return aVal.localeCompare(bVal, undefined, {
      numeric: true,
      sensitivity: "base"
    });
  });

  sortedSizes.forEach((s, i) => {
    const variant = colorVariants.find(v => v.size === s.name);
    const available = !!variant;

    const id = "chat-size-" + i;

    const wrapper = document.createElement("div");
    wrapper.className = "gd-chat-widget-qv-size-options";

    wrapper.innerHTML = `
      <input type="radio"
             name="chat-size"
             id="${id}"
             value="${s.name}"
             data-id="${s.id || ""}"
             data-size-id="${s.id || ""}"
             data-variant-id="${variant?.variant_id || ""}"
             ${available ? "" : "disabled"}>
      <label for="${id}" class="${available ? "" : "disabled"}">
        ${s.name}
      </label>
    `;

    const input = wrapper.querySelector('input[name=chat-size]');

    if (available && !firstAvailableInput) {
      firstAvailableInput = input;
    }

    input.addEventListener("change", () => {
      qvSizeLabel.textContent = s.name;
      gdWidgetLoadQVProduct(); // ✅ size change
    });

    qvSizeOptions.appendChild(wrapper);
  });

  if (firstAvailableInput) {
    firstAvailableInput.checked = true;
    qvSizeLabel.textContent = firstAvailableInput.value;

    // ✅ colour change ALSO loads product (size now exists)
    gdWidgetLoadQVProduct();
  } else {
    qvSizeLabel.textContent = "-";
  }
}


/* =========================================================
   VIDEO PLAY / PAUSE ICONS + HANDLER
========================================================= */
const QV_PLAY_ICON = (
  '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">' +
    '<path d="M8 5v14l11-7z"></path>' +
  "</svg>"
);

const QV_PAUSE_ICON = (
  '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">' +
    '<path d="M6 5h4v14H6zm8 0h4v14h-4z"></path>' +
  "</svg>"
);

// Delegated click handler for video toggle button
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".gd-chat-widget-qv-video-toggle");
  if (!btn) return;

  const slide = btn.closest(".video-slide");
  if (!slide) return;

  const video = slide.querySelector("video");
  if (!video) return;

  document
    .querySelectorAll(".gd-chat-widget-qv-swiper video")
    .forEach(v => {
      if (v !== video) {
        v.pause();
        //v.loop = false;
      }
    });

  if (video.paused) {
    //video.loop = true;
    video.play();
    btn.classList.add("playing");
    btn.innerHTML = QV_PAUSE_ICON;
  } else {
    video.pause();
    //video.loop = false;
    //video.currentTime = 0;
    btn.classList.remove("playing");
    btn.innerHTML = QV_PLAY_ICON;
  }
});

/* =========================================================
   LOAD PRODUCT + VIDEO + LIPSCORE
========================================================= */
function gdWidgetLoadQVProduct() {
  const handle = getSelectedVariantHandle();
  if (!handle) return;

  const token = ++qvRequestToken;
  qvLoader.style.display = "flex";

  Promise.all([
    fetch("/products/" + handle + ".js").then(r => r.json()),
    fetch("/products/" + handle + "?view=chat-product-video")
      .then(r => r.text())
      .catch(() => "")
  ])
    .then(([product, videoHTML]) => {

      // ⛔ Ignore stale requests
      if (token !== qvRequestToken) return;

      /* ---------------------------------
         TITLE (FIXED)
      --------------------------------- */
      if (qvTitleEl && product?.title) {
        // qvTitleEl.textContent = product.title;
        qvTitleEl.innerHTML = `<a target="_blank" href="/products/${product.handle}">${product.title}</a>`;
      }

      // Used elsewhere (analytics / add-to-cart)
      qvAddBtn.dataset.productName = product.title;

      /* ---------------------------------
         BASIC PRODUCT DATA
      --------------------------------- */
      qvDescription.innerHTML = product.description || "";
      qvWishlistBtn.dataset.chatWishlistHandle = product.handle;
      qvWishlistBtn.dataset.chatProductId = product.id;
      gdWidgetUpdateWishlistButtonState(product.handle);

      /* ---------------------------------
         RESET & BUILD SWIPER
      --------------------------------- */
      if (qvSwiperInstance) {
        qvSwiperInstance.destroy(true, true);
        qvSwiperInstance = null;
      }

      const slides = [];

      (product.images || []).forEach(src => {
        slides.push(`
          <div class="swiper-slide">
            <img src="${src}" alt="">
          </div>
        `);
      });

      /* ---------------------------------
         VIDEO SLIDE (OPTIONAL)
      --------------------------------- */
      const cleanedVideo = (videoHTML || "").trim();
      if (cleanedVideo) {
        const temp = document.createElement("div");
        temp.innerHTML = cleanedVideo;

        const wrapper =
          temp.querySelector(".video-wrapper") || temp.firstElementChild;

        if (wrapper) {
          wrapper.querySelectorAll("source").forEach(srcEl => {
            const src = srcEl.getAttribute("src");
            if (src && src.startsWith("//")) {
              srcEl.src = "https:" + src;
            }
          });

          const videoEl = wrapper.querySelector("video");
          if (videoEl) {
            const poster = videoEl.getAttribute("poster");
            if (poster && poster.startsWith("//")) {
              videoEl.poster = "https:" + poster;
            }
          }

          const videoSlide = `
            <div class="swiper-slide video-slide">
              <div class="gd-chat-widget-qv-video-wrapper">
                ${wrapper.outerHTML}
                <button type="button"
                        class="gd-chat-widget-qv-video-toggle"
                        aria-label="Play video">
                  ${QV_PLAY_ICON}
                </button>
              </div>
            </div>
          `;

          const VIDEO_SLIDE_INDEX = 1;
          slides.splice(
            Math.min(VIDEO_SLIDE_INDEX, slides.length),
            0,
            videoSlide
          );
        }
      }

      qvSwiperWrapper.innerHTML = slides.join("");

      qvSwiperInstance = new Swiper(".gd-chat-widget-qv-swiper", {
        slidesPerView: 1,
        pagination: { el: ".swiper-pagination", clickable: true },
        navigation: {
          nextEl: ".gd-chat-widget-qv-next",
          prevEl: ".gd-chat-widget-qv-prev"
        },
        on: {
          slideChange() {
            document
              .querySelectorAll(".gd-chat-widget-qv-swiper video")
              .forEach(v => v.pause());

            document
              .querySelectorAll(".gd-chat-widget-qv-video-toggle")
              .forEach(btn => {
                btn.classList.remove("playing");
                btn.innerHTML = QV_PLAY_ICON;
              });
          }
        }
      });

      const videoEl = qvSwiperWrapper.querySelector("video");
      if (videoEl) {
        // Remove any previous ended listener to avoid duplicates
        videoEl.replaceWith(videoEl.cloneNode(true));
        
        const freshVideo = qvSwiperWrapper.querySelector("video");
        freshVideo.addEventListener("ended", function () {
          const toggleBtn = freshVideo
            .closest(".video-slide")
            ?.querySelector(".gd-chat-widget-qv-video-toggle");

          if (toggleBtn) {
            toggleBtn.classList.remove("playing");
            toggleBtn.innerHTML = QV_PLAY_ICON;
          }
        });
      }

      /* ---------------------------------
         SIZE GUIDE ATTRIBUTES (UNCHANGED)
      --------------------------------- */
      const sizeGuideBtn = document.getElementById("gd-chat-widget-qvSizeGuideBtn");
      if (sizeGuideBtn) {
        sizeGuideBtn.setAttribute(
          "data-chat-widget-title",
          product.title || ""
        );
        sizeGuideBtn.setAttribute(
          "data-chat-widget-vendor",
          product.vendor || ""
        );
      }

      /* ---------------------------------
         LIPSCORE RATING
      --------------------------------- */
      fetch("/products/" + handle)
        .then(r => r.text())
        .then(html => {
        
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const rating = doc.querySelector("#lipscore-rating");

          if (!rating) {
            qvRating.style.display = "none";
            qvRating.innerHTML = "";
            return;
          }

          qvRating.style.display = "none";
          qvRating.innerHTML = rating.outerHTML;

          const checkInterval = 200;
          const maxTime = 5000;
          let elapsed = 0;

          const intervalId = setInterval(() => {
            const reviewLink =
              qvRating.querySelector(".lipscore-rating-review-link");

            if (reviewLink) {
              reviewLink.removeAttribute("href");
              reviewLink.removeAttribute("title");

              reviewLink.innerHTML = reviewLink.innerHTML
                .replace(/Reviews\s*/i, "")
                .trim();

              clearInterval(intervalId);
              qvRating.style.display = "block";
            }

            elapsed += checkInterval;
            if (elapsed >= maxTime) {
              clearInterval(intervalId);
              qvRating.style.display = "block";
            }
          }, checkInterval);
        })
        .catch(err => {
          console.warn("QV Lipscore fetch error:", err);
        });

    })
    .catch(err => {
      console.error("QV product load failed:", err);
    })
    .finally(() => {
      if (token === qvRequestToken) {
        qvLoader.style.display = "none";
      }
    });
}


/* =========================================================
   OPEN / CLOSE QUICK VIEW
========================================================= */
function openQuickView(el) {
  currentTriggerEl = el;
  currentViewedProduct = el.dataset.shopifyIds || el.dataset.shopifyIds;

  if (el.dataset.code) {
    qvPanel.setAttribute("data-product-code", el.dataset.code);
  }

  qvProductData = {
    baseHandle: el.dataset.handle || "",
    variants: parseJSON(el.dataset.variants),
    colours: parseJSON(el.dataset.colours),
    sizes: parseJSON(el.dataset.sizes)
  };

  // === SORT COLOURS, SIZES & VARIANTS (ONLY CHANGE ADDED) ===
  if (Array.isArray(qvProductData.colours)) {
    qvProductData.colours.sort((a, b) =>
      (a.name || "").localeCompare(b.name || "")
    );
  }

  if (Array.isArray(qvProductData.sizes)) {
    qvProductData.sizes.sort((a, b) =>
      (a.name || "").localeCompare(b.name || "")
    );
  }

  if (Array.isArray(qvProductData.variants)) {
    qvProductData.variants.sort((a, b) => {
      const c = (a.colour || "").localeCompare(b.colour || "");
      return c !== 0 ? c : (a.size || "").localeCompare(b.size || "");
    });
  }
  // === END OF SORTING ===

  // qvTitleEl.textContent = el.dataset.name || "";
  const title = el.dataset.name || "";
  const handle = el.dataset.handle || "";

  if (qvTitleEl && title && handle) {
    qvTitleEl.innerHTML = `<a target="_blank" href="/products/${handle}">${title}</a>`;
  }

  const firstColourName =
    qvProductData.colours[0] ? qvProductData.colours[0].name : null;

  updateQVPrice(el, firstColourName);

  renderColors();

  if (firstColourName) {
    renderSizes(firstColourName);
  }

  const remaining = Number(el.dataset.remainingSeconds || 0);
  if (remaining > 0) {
    qvDealBadge.style.display = "flex";
    gdWidgetStartHmsCountdown("chat-deal-timer", remaining, currentViewedProduct);
    gdWidgetStartSidebarCountdown(currentViewedProduct);
  } else {
    qvDealBadge.style.display = "none";
  }

  gdChatWidgetLoadProductByCode(el.dataset.code);

  gdWidgetLoadQVProduct();

  qvOverlay.style.display = "flex";
  qvOverlay.setAttribute("aria-hidden", "false");
  requestAnimationFrame(() => qvPanel.classList.add("active"));
}

function closeQuickView() {
  qvPanel.classList.remove("active");
  setTimeout(() => {
    qvOverlay.style.display = "none";
    qvOverlay.setAttribute("aria-hidden", "true");
    if (qvSwiperInstance) {
      qvSwiperInstance.destroy(true, true);
      qvSwiperInstance = null;
    }
  }, 300);
}

/* =========================================================
   EVENTS
========================================================= */
document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".chat-widget-render-in-sidebar");
  if (trigger) {
    openQuickView(trigger);
  }
});

if (qvCloseBtn) {
  qvCloseBtn.addEventListener("click", closeQuickView);
}

if (qvOverlay) {
  qvOverlay.addEventListener("click", function (e) {
    if (e.target === qvOverlay) closeQuickView();
  });
}

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && qvOverlay && qvOverlay.style.display === "flex") {
    closeQuickView();
  }
});

if (qvWishlistBtn) {
  qvWishlistBtn.addEventListener("click", function () {
    const handle = qvWishlistBtn.dataset.chatWishlistHandle;
    gdWidgetToggleWishlistItem(handle);
    gdWidgetUpdateWishlistButtonState(handle);
  });
}

/* =========================================================
   EXTRA API DATA
========================================================= */
async function gdChatWidgetLoadProductByCode(productCode) {
  if (!productCode) return;

  const wrapper = document.getElementById("gd-chat-widget-qvAvailabilityTable");
  const section = document.getElementById("gd-chat-widget-qvAvailability");
  if (!wrapper || !section) return;

  wrapper.innerHTML = `<div class="qv-small-loader">Loading...</div>`;
  section.style.display = "block";

  qvAddBtn.dataset.productId = productCode;

  try {
    const url = `https://ai.mygoddiva.com/get-product-by-code?code=${encodeURIComponent(productCode)}`;
    const response = await fetch(url);
    const data = await response.json();

    let html = "";
    const sections = [
      { key: "available_length", title: "Different Lengths" },
      { key: "available_fit", title: "Different Fit" },
      { key: "available_in", title: "Available In" },
      { key: "available_diffab", title: "Different Fabrics" }
    ];

    sections.forEach(sec => {
      const items = data[sec.key];
      if (items && items.length) {
        html += `
          <div class="qv-availability-row">
            <div class="qv-availability-title">${sec.title}</div>
            <div class="qv-availability-items">
              ${items
                .map(item => `
                  <div class="qv-availability-item" data-value="${item.values?.[0] || ""}">
                    ${item.type}
                  </div>
                `)
                .join("")}
            </div>
          </div>
        `;
      }
    });

    if (html) {
      wrapper.innerHTML = html;
      section.style.display = "block";
    } else {
      section.style.display = "none";
      wrapper.innerHTML = "";
    }

    wrapper.querySelectorAll(".qv-availability-item").forEach(item => {
      item.addEventListener("click", () => {
        const val = item.dataset.value || "";
        const chatInput = document.getElementById("gd-chat-widget-chatInput");
        if (chatInput) {
          chatInput.value = val;
          chatInput.dispatchEvent(new Event("input"));
          chatInput.focus();
        }
      });
    });

  } catch (err) {
    console.error("Availability API failed:", err);
    wrapper.innerHTML = `<div class="qv-error">Unable to load data</div>`;
  }
}


function setQVAddBtnLoading(isLoading) {
  if (!qvAddBtn) return;

  if (isLoading) {
    qvAddBtn.disabled = true;
    qvAddBtn.classList.add("loading");
    qvAddBtn.dataset.originalText = qvAddBtn.innerHTML;
    qvAddBtn.innerHTML = "Adding…";
  } else {
    qvAddBtn.disabled = false;
    qvAddBtn.classList.remove("loading");
    qvAddBtn.innerHTML = qvAddBtn.dataset.originalText || "Add to cart";
  }
}

if (qvAddBtn) {
  qvAddBtn.addEventListener("click", function () {

    const productCode = qvPanel.dataset.productCode;

    const color = getSelectedColor();
    const size = getSelectedSize();

    if (!color || !size || !color.id || !size.id) {
      alert("⚠️ Please select both color and size.");
      return;
    }

    setQVAddBtnLoading(true);

    const token = getGDChatWidgetAiToken();
    const url = new URL("https://ai.mygoddiva.com/get-product-for-cart");

    url.searchParams.set("id", localStorage.getItem("session_id"));
    url.searchParams.set("code", productCode);
    url.searchParams.set("colour", color.id);
    url.searchParams.set("size", size.id);

    fetch(url.toString(), {
      method: "GET",
      headers: token ? { Authorization: "Bearer " + token } : {}
    })
      .then(res => res.json())
      .then(response => {

        if (!response?.variant?.shopify_variant_id) {
          throw new Error("Invalid variant response");
        }

        const variantId = response.variant.shopify_variant_id;
        const stock = Number(response.variant.inventory_variant__qty || 0);
        const discountCode = response.discount || null;

        Shopify.getCart(cart => {
          const existing = cart.items.find(
            i => String(i.variant_id) === String(variantId)
          );

          const currentQty = existing ? existing.quantity : 0;

          if (currentQty + 1 > stock) {
            document.body.classList.add("has-warning");
            const warn = document.querySelector(".halo-warning-content");
            if (warn) {
              warn.textContent =
                "The maximum quantity of this item is already in your cart.";
            }

            setTimeout(() => {
              document.body.classList.remove("has-warning");
              if (warn) warn.textContent = "";
            }, 2000);

            setQVAddBtnLoading(false);
            return;
          }

          // ✅ ADD TO CART (WAIT FOR IT)
          gdChatWidgetAddToShoppingCart(variantId, discountCode)
            .then(() => {
              // ✅ USER FEEDBACK (unchanged payload)
              gdWidgetsendUserFeedback(qvAddBtn, "quick_add_to_cart", {
                size: size.id,
                colour: color.id
              });
            })
            .finally(() => {
              setQVAddBtnLoading(false);
            });
        });
      })
      .catch(err => {
        console.error("Add to cart failed:", err);
        alert("⚠️ Something went wrong while adding the product.");
        setQVAddBtnLoading(false);
      });
  });
}

// Quick View End

  /* =========================================================
    GODDIVA CHAT WIDGET — SIZE GUIDE SIDEBAR 
  ========================================================= */

  function gdChatWidgetSizeGuide() {

    const modal = document.getElementById("gd-chat-widget-sizeGuideModal");
    const modalTitle = document.getElementById("gd-chat-widget-sizeGuideTitle");
    const modalContent = document.getElementById("gd-sizeGuideTableWrapper");
    const closeBtn = document.getElementById("gd-chat-widget-sizeGuideCloseBtn");

    const toggle = document.getElementById("gd-size-unit-toggle");
    const CM_TO_INCH = 0.393701;

    /* ---------------------------------------------
      OPEN HANDLER
    --------------------------------------------- */
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".gd-chat-widget-qv-size-guide");
      if (!btn) return;

      const vendor = btn.getAttribute("data-chat-widget-vendor") || "";
      const title = btn.getAttribute("data-chat-widget-title") || "Size Guide";

      let url = "";

      if (vendor === "Goddiva") {
        url = "https://goddiva.co.uk/pages/size-chart-goddiva";
      } else if (vendor === "Goddiva Plus") {
        url = "https://goddiva.co.uk/pages/size-chart-goddiva-plus";
      } else {
        return;
      }

      fetch(url)
        .then(r => r.text())
        .then(html => {
          const temp = document.createElement("div");
          temp.innerHTML = html;

          const table = temp.querySelector(".size-chart-table");
          if (!table) return;

          modalTitle.textContent = title;

          /* Replace content */
          modalContent.innerHTML = "";
          modalContent.appendChild(table);

          /* Store original values */
          modalContent.querySelectorAll(".size-chart-table-td").forEach(cell => {
            const num = parseFloat(cell.textContent);
            if (!isNaN(num)) {
              cell.dataset.originalValue = num;
            }
          });

          /* Reset toggle (always start in CM mode) */
          toggle.checked = false;

          /* Open sidebar */
          modal.style.display = "flex";
          requestAnimationFrame(() => {
            modal.classList.add("active");
          });
        })
        .catch(err => {
          console.error("Size guide load error:", err);
        });
    });

    /* ---------------------------------------------
      CLOSE HANDLER
    --------------------------------------------- */
    function closeSidebar() {
      modal.classList.remove("active");
      setTimeout(() => {
        modal.style.display = "none";
      }, 300);
    }

    closeBtn.addEventListener("click", closeSidebar);

    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeSidebar();
    });

    /* ---------------------------------------------
      UNIT TOGGLE — CM ↔ INCH
    --------------------------------------------- */
      toggle.addEventListener("change", () => {
        const isInches = toggle.checked;

        // Update unit label (CM ↔ INCH)
        const unitEl = modalContent.querySelector("#unit");
        if (unitEl) {
          unitEl.textContent = isInches ? "INCH" : "CM";
        }

        // Convert table numbers
        modalContent.querySelectorAll(".size-chart-table-td").forEach(cell => {
          const original = parseFloat(cell.dataset.originalValue);
          if (isNaN(original)) return;

          if (isInches) {
            let converted = (original * CM_TO_INCH).toFixed(1);
            if (converted.endsWith(".0")) converted = converted.replace(".0", "");
            cell.textContent = converted;
          } else {
            cell.textContent = original;
          }
        });
    });


  }

  gdChatWidgetSizeGuide();


window.gdChatWidgetOpenOverlay = gdChatWidgetOpenOverlay;
window.gdChatWidgetSelectColour = gdChatWidgetSelectColour;
window.gdChatWidgetSelectSize = gdChatWidgetSelectSize;
window.gdChatWidgetValidateAddButton = gdChatWidgetValidateAddButton;
window.gdChatWidgetCloseOverlay = gdChatWidgetCloseOverlay;
window.gdChatWidgetGetProductForCart = gdChatWidgetGetProductForCart;
window.gdChatWidgetAddToShoppingCart = gdChatWidgetAddToShoppingCart;
window.gdChatWidgetAddDiscount = gdChatWidgetAddDiscount;
window.gdChatWidgetUpdateSidebar = gdChatWidgetUpdateSidebar;


function gdWidgethandleReset() {
  const userId = localStorage.getItem("user_id");
  const refresh_token = localStorage.getItem("ai_refresh_token");
  const token = getGDChatWidgetAiToken();

  if (!userId) {
    console.error("No user_id found in localStorage");
    return;
  }

  // show overlay
  const mainLoader = document.getElementById("gd-chat-widget-loader");
  if (mainLoader) mainLoader.style.display = "inline-flex";

    const refineWrapper = document.querySelector(".gd-chat-widget-refine");
    const resetBar = document.getElementById("gd-chat-widget-resetBar");
    const chatInputWrap = document.getElementById("gd-chat-widget-chatInputWrap");

    resetBar.style.display = "none";
    chatInputWrap.style.display = "block";
    refineWrapper.style.display = "none"; 
    

    const payload = {
      id: userId,
      refresh_token: refresh_token
    };

    if (window.isProductPage && window.productId) {
      payload.product_id = window.productId;
    }

    if (window.isCollectionPage && window.collectionHandle) {
      payload.collection = window.collectionHandle;
    }

  fetch("https://ai.mygoddiva.com/reset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {})
    },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(response => {
      if (!response.session_id) {
        console.error("No session_id returned from reset API");
        return;
      }

      // update session
      localStorage.setItem("session_id", response.session_id);
      sessionStorage.setItem("is_history", "true");

      if (response.token) {
        localStorage.setItem("ai_access_token", response.token.access);
        localStorage.setItem("ai_refresh_token", response.token.refresh);
      }

    

      const conversationArea = document.querySelector(".gd-chat-widget-conversation-area");

      if (conversationArea) {
        if (window.isProductPage) {
          const preserveIds = [
            "gd-chat-widget-prompt_suggestion",
            "onloadproductcontext",
            "gd-chat-widget-prompt_suggestion-for-product",
            "gd-chat-widget-prompt_suggestion-reset"
          ];

          Array.from(conversationArea.children).forEach(child => {

            if (!preserveIds.includes(child.id)) {
              // Remove everything else
              child.remove();
            } else {
              // If it's product context or product prompt suggestion → clear content
              if (
                child.id === "onloadproductcontext" ||
                child.id === "gd-chat-widget-prompt_suggestion-for-product" ||
                child.id === "gd-chat-widget-prompt_suggestion" ||
                child.id === "gd-chat-widget-prompt_suggestion-reset"
              ) {
                child.innerHTML = "";
              }
            }

          });

        } else {
          // Non-product pages → clear everything
          conversationArea.innerHTML = "";
        }
      }


      const clearSelectors = [
        ".chat-widget-tag-container",
        ".gd-chat-widget-chat-suggestions",
        "#chat-widget-change_Filter_suggestion"
      ];

      clearSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => (el.innerHTML = ""));
      });

    document.querySelectorAll(".chat-widget-looking-for, #chat-widget-top-bar").forEach(el => {
      el.style.display = "none";
    });

    document.querySelectorAll(".chat-alternative-section").forEach(el => el.remove());
    document.querySelectorAll(".gd_widget_show_discount-container").forEach(el => el.remove());
    document.querySelectorAll(".gd-message-update-size").forEach(el => el.remove());
    document.querySelectorAll(".message-update-user-name-email").forEach(el => el.remove());
    document.querySelectorAll(".gd-chat-widget-bot-msg.size-reminder").forEach(el => el.remove());
    document.querySelectorAll(".gd-widget-product-context").forEach(el => el.remove());

      const typeLoader = document.getElementById("gd-chat-widget-loader-bubble");
      if (typeLoader) typeLoader.style.display = "none";

      const input = document.getElementById("gd-chat-widget-chatInput");
      if (input) {
        input.value = "";
        input.focus();
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }

      submitCount = 0;
      console.log("submitCount reset to", submitCount);

      // rebuild prompt suggestions
      if (Array.isArray(response.prompts) && response.prompts.length > 0) {

        let promptSuggestion;
        if (window.isProductPage) {
          promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion-reset");
        } else {
          promptSuggestion = document.getElementById("gd-chat-widget-prompt_suggestion");
        }
        

        promptSuggestion.innerHTML = `
          <div class="reset-promt-suggestion-wrapper">
            <strong class="suggested-heading" style="display:none;">Suggested Searches:</strong>
            <div class="prompt-btn-wrapper reset-promt-suggestion"></div>
          </div>
        `;

        const wrapper = promptSuggestion.querySelector(".prompt-btn-wrapper");


        response.prompts.forEach(prompt => {
            const btn = document.createElement("button");
            
            // Base classes: keep existing styling + add get-session-btn and message-specific class
            const messageClass = prompt.message.toLowerCase().replace(/\s+/g, '-');
            btn.className = `prompt-btn whitebg-greenborder get-session-btn ${messageClass}`;
            
            // Set core data attributes
            btn.dataset.id = prompt.id || '';
            btn.dataset.message = prompt.message || '';

            // Parse the type field
            const type = prompt.type || {};
            const isObj = typeof type === "object";
            const typeName = isObj ? (type.name || '') : type;
            const isReset = isObj && 'is_reset' in type ? type.is_reset : null;
            const action = isObj && 'action' in type ? type.action : null;
            const condition = isObj && 'condition' in type ? type.condition : null;

            // Set data-type if typeName exists
            if (typeName) {
                btn.dataset.type = typeName;
            }

            // Set optional attributes
            if (isReset !== null) btn.dataset.isReset = isReset;
            if (action !== null) btn.dataset.action = action;
            if (condition !== null) btn.dataset.condition = condition;

            // If type is a plain string (not an object), set data-filter
            if (!isObj && type) {
                btn.dataset.filter = type;
            }

            // Add button text
            btn.textContent = prompt.message;

            // Add chevron if this is a "filter" type button
            const isFilter = (type === "filter") || (typeName === "filter");
            if (isFilter) {
                const chevronSpan = document.createElement("span");
                chevronSpan.className = "data-filter-chev";
                // Ensure gdWidgetGetChevronSVG is defined in your scope
                chevronSpan.innerHTML = gdWidgetGetChevronSVG();
                btn.appendChild(chevronSpan);
            }

            wrapper.appendChild(btn);
        });

        if (wrapper.querySelector(".prompt-btn")) {
          const heading = promptSuggestion.querySelector(".suggested-heading");
          if (heading) heading.style.display = "block";
        }
        promptSuggestion.style.display = "";

      }

      // hide overlay
      if (mainLoader) mainLoader.style.display = "none";

      console.log("Reset successful, response:", response);
    })
    .catch(err => {
      if (mainLoader) mainLoader.style.display = "none";
      console.error("Reset API error:", err);
    });
}

// attach both buttons to same handler
document.getElementById("gd-chat-widget-btnResetYes")?.addEventListener("click", gdWidgethandleReset);


function gdWidgetShowRetryButtonInMessage(messageText, retryFn, args = []) {
  const conversationArea = document.querySelector('.gd-chat-widget-conversation-area');
  if (!conversationArea) return;

  const userInitials = gdChatWidgetGetUserInitials();

  // Create wrapper
  const msgRow = document.createElement('div');
  msgRow.className = 'gd-chat-widget-msg-row gd-chat-widget-user-msg error';

  msgRow.innerHTML = `
    <div class="gd-chat-widget-user-bubble gd-widget-user-text-retry">
      <span class="retry-message">${messageText}</span>
      <button type="button" class="gd-widget-retry-button" title="Retry">
        <svg width="50px" height="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
          <path d="M25 38c-7.2 0-13-5.8-13-13 0-3.2 1.2-6.2 3.3-8.6l1.5 1.3C15 19.7 14 22.3 14 25c0 6.1 4.9 11 11 11 1.6 0 3.1-.3 4.6-1l.8 1.8c-1.7.8-3.5 1.2-5.4 1.2z"></path>
          <path d="M34.7 33.7l-1.5-1.3c1.8-2 2.8-4.6 2.8-7.3 0-6.1-4.9-11-11-11-1.6 0-3.1.3-4.6 1l-.8-1.8c1.7-.8 3.5-1.2 5.4-1.2 7.2 0 13 5.8 13 13 0 3.1-1.2 6.2-3.3 8.6z"></path>
          <path d="M18 24h-2v-6h-6v-2h8z"></path>
          <path d="M40 34h-8v-8h2v6h6z"></path>
        </svg>
      </button>
    </div>
    <div class="gd-chat-widget-user-avatar">${userInitials}</div>
  `;

  conversationArea.appendChild(msgRow);

  // Retry button logic
  const retryBtn = msgRow.querySelector('.gd-widget-retry-button');

  retryBtn.addEventListener('click', function () {
    retryBtn.disabled = true;
    retryBtn.classList.add('spinning');

    retryFn(...args);

    // Fade out + remove (JS equivalent of jQuery fadeOut)
    retryBtn.style.transition = 'opacity 0.2s';
    retryBtn.style.opacity = '0';

    setTimeout(() => {
      retryBtn.remove();
    }, 200);
  });
}



// pass user events start
function gdWidgetsendUserFeedback(btn, actionType, extraData = {}) {
  const userId = Number(localStorage.getItem('user_id'));
  const assistantId = Number(localStorage.getItem('session_id'));

  if (!userId || !assistantId) {
    console.warn('⚠️ Missing user_id or session_id, skipping feedback.');
    return;
  }

  // 🧠 Build payload and merge in extra data (like size, colour, etc.)
  const payload = {
    user_id: userId,
    assistant_id: assistantId,
    type: actionType,
    data: {
      product_id: btn?.getAttribute('data-product-id') || '',
      product_name: btn?.getAttribute('data-product-name') || '',
      product_price: btn?.getAttribute('data-product-price') || '',
      ...extraData
    }
  };

  console.log(`📤 Sending "${actionType}" feedback:`, payload);

  const token = getGDChatWidgetAiToken();

  fetch('https://ai.mygoddiva.com/feedback/store', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': 'Bearer ' + token } : {})
    },
    body: JSON.stringify(payload)
  })
    .then(res => {
      if (!res.ok) throw res;
      return res.json();
    })
    .then(res => {
      console.log(`✅ Feedback recorded for ${actionType}:`, res);
    })
    .catch(err => {
      console.error(`❌ Error sending ${actionType} feedback:`, err);
    });
}

window.gdWidgetsendUserFeedback = gdWidgetsendUserFeedback;

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.chat-find-similar-item');
  if (!btn) return;

  gdWidgetsendUserFeedback(btn, 'find_similar');
});


// SwipeCards start

const cardData = [
  { category: "neck", name: "Sweet Heart Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_1.png?v=1757436876" },
  { category: "neck", name: "Asymmetric Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_2.png?v=1757494768" },
  { category: "neck", name: "Halter Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_3.png?v=1757494768" },
  { category: "neck", name: "Boat Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_4.png?v=1757494768" },
  { category: "neck", name: "Collar Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_5.png?v=1757494768" },
  { category: "neck", name: "Cowl Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_6.png?v=1757494768" },
  { category: "neck", name: "V Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_7.png?v=1757494768" },
  { category: "neck", name: "Surplice Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_8.png?v=1757494768" },
  { category: "neck", name: "Keyhole Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_9.png?v=1757494768" },
  { category: "neck", name: "High Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_10.png?v=1757494768" },
  { category: "neck", name: "Crew Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_11.png?v=1757494768" },
  { category: "neck", name: "Illusion Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_12.png?v=1757494768" },
  { category: "neck", name: "Knotted Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_13.png?v=1757494768" },
  { category: "neck", name: "Turtle Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_14.png?v=1757494768" },
  { category: "neck", name: "Off The Shoulder Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_15.png?v=1757494768" },
  { category: "neck", name: "One Shoulder Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_16.png?v=1757494768" },
  { category: "neck", name: "Open Back Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_17.png?v=1757494768" },
  { category: "neck", name: "Plunging Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_18.png?v=1757494768" },
  { category: "neck", name: "Queen Ann Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_19.png?v=1757494768" },
  { category: "neck", name: "Round Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_20.png?v=1757494768" },
  { category: "neck", name: "Scoop Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_21.png?v=1757494768" },
  { category: "neck", name: "Split Crew Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_22.png?v=1757494768" },
  { category: "neck", name: "Square Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_23.png?v=1757494768" },
  { category: "neck", name: "Strapless Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_24.png?v=1757494768" },
  { category: "neck", name: "Tie Up Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_25.png?v=1757494768" },
  { category: "neck", name: "Mock Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_26.png?v=1757494768" },
  { category: "neck", name: "Scalloped Neckline", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_27.png?v=1757494768" },
  { category: "neck", name: "Jewel Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/jewel_Neck.png?v=1757499181" },

  { category: "sleeve", name: "Flounce Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flounce_Sleeve.png?v=1757500368" },
  { category: "sleeve", name: "Bell Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bell_Sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Bishop Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bishop_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Cap Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cap_sleeve.png?v=1757499911" },
  { category: "sleeve", name: "Cape Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Cold Shoulder Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cold_shoulder_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Detachable Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Detachable_sleeves.png?v=1757499915" },
  { category: "sleeve", name: "Dolman Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dolman_Sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Draped Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/DRAPED_SLEEVES.png?v=1757499913" },
  { category: "sleeve", name: "Fitted Long Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Fitted_long_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Flutter Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flutter_sleeve.png?v=1757499916" },
  { category: "sleeve", name: "Juliet Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Juliet_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Kimono Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Kimono_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Lantern Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Lantern_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Off Shoulder Bardot Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Off_shoulder_bardot_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Peasant Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Peasant_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Puff Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Puff_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Raglan Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Raglan_Sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Regular Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Regular_sleeve.png?v=1757499913" },
  { category: "sleeve", name: "Sleeveless", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sleeveless.png?v=1757499916" },
  { category: "sleeve", name: "Spaghetti Straps", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Spaghetti_straps.png?v=1757499916" },
  { category: "sleeve", name: "Wings Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Wings_SLEEVES.png?v=1757499914" },

  { category: "hem", name: "Asymmetric Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetric_Hem.png?v=1757501250" },
  { category: "hem", name: "Bubble Ballon Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bubble_Ballon_Hem.png?v=1757501249" },
  { category: "hem", name: "Diagonal Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Diagonal_Hem.png?v=1757501248" },
  { category: "hem", name: "Dipped Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dipped_Hem.png?v=1757501250" },
  { category: "hem", name: "Flared Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flared_Hem.png?v=1757501250" },
  { category: "hem", name: "Fringe Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Fringe_Hem.png?v=1757501249" },
  { category: "hem", name: "High Low Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/High_Low_Hem.png?v=1757501249" },
  { category: "hem", name: "Layered Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Layered_Hem.png?v=1757501249" },
  { category: "hem", name: "Pleated Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Pleated_Hem.png?v=1757501248" },
  { category: "hem", name: "Raw Edge Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Raw_Edge_Hem.png?v=1757501249" },
  { category: "hem", name: "Ruffle Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Ruffle_Hem.png?v=1757501250" },
  { category: "hem", name: "Scalloped Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Scalloped_Hem.png?v=1757501249" },
  { category: "hem", name: "Straight Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Straight_Hem.png?v=1757501247" },
  { category: "hem", name: "Trumpet Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Trumpet_Hem.png?v=1757501250" },
  { category: "hem", name: "Tulip Hemline", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tulip_Hemline.png?v=1757501250" },

  { category: "product_subcategory", name: "Mermaid Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Mermaid_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Corset Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Corset_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Shirt Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Shirt_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Kaftan Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Kaftan_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Straight Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Straight_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Sheath Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sheath_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Peplum Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Peplum_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Smock Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Smock_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Tiered Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tiered_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Shift Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Shift_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Little Black Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Little_Black_Dress.png?v=1757504481" },
  { category: "product_subcategory", name: "A-Line Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/A-Line_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Asymmetrical Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Babydoll Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Babydoll_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Bodycon dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bodycon_dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Cape Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Empire Waist Line Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Empire_Waist_Line_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Skater Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Skater_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Sweater Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sweater_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Wrap Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Wrap_Dress.png?v=1757504482" },
  
  { category: "product_style", name: "Asymmetrical Cutout", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Cutout.png?v=1757766480" },
  { category: "product_style", name: "Asymmetrical Drape", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Drape.png?v=1757766481" },
  { category: "product_style", name: "Asymmetrical Ruffle", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Ruffle.png?v=1757766480" },
  { category: "product_style", name: "Belted", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Belted.png?v=1757766479" },
  { category: "product_style", name: "Boho", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Boho.png?v=1757766479" },
  { category: "product_style", name: "Button Front", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Button_Front.png?v=1757766479" },
  { category: "product_style", name: "Cape Overlay", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_Overlay.png?v=1757766479" },
  { category: "product_style", name: "Corset", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Corset.png?v=1757766480" },
  { category: "product_style", name: "Cutout", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cutout.png?v=1757766480" },
  { category: "product_style", name: "Gathered Waist", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Gathered_Waist.png?v=1757766480" },
  { category: "product_style", name: "Ruched Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Ruched_Style.png?v=1757766479" },
  { category: "product_style", name: "Pleated Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Pleated_Style.png?v=1757766480" },
  { category: "product_style", name: "Layering Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Layering_Style.png?v=1757766480" },
  { category: "product_style", name: "Scallop Edge Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Scallop_Edge_Style.png?v=1757766480" },
  { category: "product_style", name: "Slit Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Slit_Style.png?v=1757766480" },
  { category: "product_style", name: "Structured Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Structured_Style.png?v=1757766479" },
  { category: "product_style", name: "Tiered Panels", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tiered_Panels.png?v=1757766479" },
  { category: "product_style", name: "Draped", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Draped.png?v=1757766481" },
  
  { category: "dress_length", name: "Maxi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Maxi.png?v=1758639249" },
  { category: "dress_length", name: "Midi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Midi.png?v=1758639249" },
  { category: "dress_length", name: "Mini", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Mini.png?v=1758639249" },
  { category: "dress_length", name: "Midaxi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Midaxi.png?v=1758639249" }
];

// Banner images for categories
const categoryBanners = {
  neck: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Neck.jpg?v=1758639701",
  sleeve: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Sleeve.jpg?v=1758639702",
  hem: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Hem.jpg?v=1758639701",
  product_subcategory: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Product_Subcategory.jpg?v=1758639700",
  product_style: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Style.jpg?v=1758639700",
  dress_length: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Dress_Length.jpg?v=1758639702"
};

/* ---------- Build cards ---------- */
function gdWidgetBuildLikeDislikeCards(category = null) {
  const container = document.querySelector('.gd-widget-chat-like-dislike-card-container');
  if (!container) {
    console.error('Container not found');
    return;
  }
  
  container.innerHTML = "";

  const filteredData = category
    ? cardData.filter(item => item.category === category)
    : cardData;

  // Group items by category
  const grouped = {};
  filteredData.forEach(item => {
    if (!grouped[item.category]) grouped[item.category] = [];
    grouped[item.category].push(item);
  });

  // Build array with banners first
  let finalCards = [];
  Object.keys(grouped).forEach(cat => {
    if (categoryBanners[cat]) {
      finalCards.push({
        category: cat,
        name: `${cat}-banner`,
        background: categoryBanners[cat],
        isBanner: true
      });
    }
    finalCards = finalCards.concat(grouped[cat]);
  });

  const total = finalCards.length;

  finalCards.forEach((item, index) => {
    const card = document.createElement("div");
    card.className = "gd-widget-chat-like-dislike-card";
    card.setAttribute("data-category", item.category);
    card.setAttribute("data-name", item.name);

    if (item.isBanner) {
      card.classList.add("gd-widget-category-banner");
    }

    if (item.background.startsWith("#")) {
      card.style.background = item.background;
    } else {
      card.style.backgroundImage = `url('${item.background}')`;
      card.style.backgroundSize = "cover";
      card.style.backgroundPosition = "center";
    }

    card.style.zIndex = total - index;
    card.style.top = "0";

    if (!item.isBanner) {
      const isLike = document.createElement("div");
      isLike.className = "is-like";
      card.appendChild(isLike);
    }

    container.appendChild(card);
  });
}

// Only call if container exists
if (document.querySelector('.gd-widget-chat-like-dislike-card-container')) {
  gdWidgetBuildLikeDislikeCards();
}

/* ---------- Swipe controller ---------- */
function gdWidgetInitSwipeCards(options) {
  const UNDO_THRESHOLD = 3;
  
  let swipeData = sessionStorage.getItem("swipeData")
    ? JSON.parse(sessionStorage.getItem("swipeData"))
    : { likes: {}, dislikes: {} };

  function saveSession() {
    sessionStorage.setItem("swipeData", JSON.stringify(swipeData));
  }

  // undo stack types:
  // { type: 'banner', name, category, html, swipedCount, reversible, originalSwipedCount }
  // { type: 'card',   name, category, html }
  let undoStack = [];

  function getCardName(card) {
    if (!card) return "";
    if (card.dataset && card.dataset.name) return card.dataset.name;
    return card.innerText.trim();
  }

  const frame = document.querySelector(options.container);
  const loveBtn = document.querySelector(options.loveBtn);
  const nopeBtn = document.querySelector(options.nopeBtn);
  const undoBtn = document.querySelector("#undo");
  const buttonsEl = document.querySelector(options.buttons);
  const getStartedEl = document.querySelector('.gd-widget-chat-like-dislike-get-started');

  // Check if required elements exist
  if (!frame) {
    console.error('Swipe cards container not found');
    return null;
  }

  let current = null;
  let likeText = null;
  let startX = 0, startY = 0, moveX = 0, moveY = 0;
  let pointerId = null;

  function refreshCurrent(hideThumb = false) {
    current = frame.querySelector(".gd-widget-chat-like-dislike-card:first-child");
    likeText = current?.querySelector(".is-like");

    frame.querySelectorAll(".gd-widget-chat-like-dislike-card .is-like")
      .forEach(el => el.style.display = "none");

    if (likeText && !hideThumb) likeText.style.display = "flex";

    if (current && current.classList.contains("gd-widget-category-banner")) {
      if (loveBtn) loveBtn.style.display = "none";
      if (nopeBtn) nopeBtn.style.display = "none";
      if (getStartedEl) getStartedEl.style.display = "block";
    } else {
      if (loveBtn) loveBtn.style.display = "flex";
      if (nopeBtn) nopeBtn.style.display = "flex";
      if (getStartedEl) getStartedEl.style.display = "none";
    }
  }

  function initCard(card) {
    if (!card) return;
    card.style.transition = "";
    card.style.transform = "";
    card.style.touchAction = "none";
    card.removeEventListener("pointerdown", onPointerDown);
    card.addEventListener("pointerdown", onPointerDown);
  }

  // helper: find last banner marker index in undoStack (search from end)
  function findLastBannerIndex() {
    for (let i = undoStack.length - 1; i >= 0; i--) {
      if (undoStack[i].type === 'banner') return i;
    }
    return -1;
  }

  // helper: find first banner index (earliest) in undoStack
  function findFirstBannerIndex() {
    for (let i = 0; i < undoStack.length; i++) {
      if (undoStack[i].type === 'banner') return i;
    }
    return -1;
  }

  // helper: count number of banner markers in undoStack
  function countBanners() {
    let c = 0;
    for (let i = 0; i < undoStack.length; i++) if (undoStack[i].type === 'banner') c++;
    return c;
  }

  function addToSwipeData(target, category, name) {
    if (!swipeData[target][category]) swipeData[target][category] = [];
    if (!swipeData[target][category].includes(name)) {
      swipeData[target][category].push(name);
    }
  }

  function removeFromSwipeData(category, name) {
    ["likes", "dislikes"].forEach(type => {
      if (swipeData[type][category]) {
        swipeData[type][category] = swipeData[type][category].filter(n => n !== name);
        if (!swipeData[type][category].length) {
          delete swipeData[type][category];
        }
      }
    });
  }

  // update Undo button visual (lock/unlock) based on top of undoStack
  function updateUndoVisual() {
    if (!undoBtn) return;
    if (!undoStack.length) {
      undoBtn.style.display = "none";
      undoBtn.disabled = true;
      setUndoLockSvg(false, false);
      return;
    }

    const top = undoStack[undoStack.length - 1];
    if (top.type === 'card') {
      // top is card -> undo allowed
      undoBtn.style.display = "flex";
      undoBtn.disabled = false;
      setUndoLockSvg(false, true);
      return;
    }

    if (top.type === 'banner') {
      // top is banner -> check reversible flag
      const bannersCount = countBanners();
      if (top.reversible || bannersCount >= 2) {
        undoBtn.style.display = "flex";
        undoBtn.disabled = false;
        setUndoLockSvg(false, true);
      } else {
        undoBtn.style.display = "flex";
        undoBtn.disabled = true;
        setUndoLockSvg(true, false);
      }
      return;
    }

    undoBtn.style.display = "none";
    undoBtn.disabled = true;
    setUndoLockSvg(false, false);
  }

  // helper to set lock/unlock SVG in undo button
  function setUndoLockSvg(locked, visible) {
    const svg = undoBtn.querySelector('.undo-lock');
    if (!svg) return;
    if (!visible) {
      svg.style.opacity = '0.35';
      svg.innerHTML = '<path d="M3 12v6a2 2 0 0 0 2 2h10"></path><rect x="7" y="7" width="10" height="6" rx="2"></rect>';
      return;
    }
    if (locked) {
      // padlock closed icon
      svg.innerHTML = '<rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V8a5 5 0 0 1 10 0v3"/>';
    } else {
      // unlock icon
      svg.innerHTML = '<path d="M3 12v6a2 2 0 0 0 2 2h10"></path><rect x="7" y="7" width="10" height="6" rx="2"></rect>';
    }
  }

  refreshCurrent();
  initCard(current);
  updateUndoVisual();

  // push banner marker to undoStack (when banner is swiped)
  function pushBannerMarker(cardEl) {
    const marker = {
      type: 'banner',
      name: getCardName(cardEl),
      category: cardEl.dataset.category,
      html: cardEl.outerHTML,
      swipedCount: 0,
      reversible: false,
      originalSwipedCount: 0
    };
    undoStack.push(marker);
    updateUndoVisual();
  }

  // push card entry & increment last banner's swipedCount
  function pushCardEntry(cardEl) {
    const cardName = getCardName(cardEl);
    const category = cardEl.dataset.category;
    const entry = {
      type: 'card',
      name: cardName,
      category,
      html: cardEl.outerHTML
    };
    undoStack.push(entry);

    const bannerIndex = findLastBannerIndex();
    if (bannerIndex !== -1) {
      undoStack[bannerIndex].swipedCount++;
      // mark reversible if threshold reached (persisted once set)
      if (undoStack[bannerIndex].swipedCount >= UNDO_THRESHOLD && !undoStack[bannerIndex].reversible) {
        undoStack[bannerIndex].reversible = true;
        undoStack[bannerIndex].originalSwipedCount = undoStack[bannerIndex].swipedCount;
      }
    }

    updateUndoVisual();
  }

  function setTransform(x, y, deg, duration) {
    if (!current) return;
    current.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${deg}deg)`;

    if (!current.classList.contains("gd-widget-category-banner")) {
      const likeEl = current.querySelector('.is-like');
      if (likeEl) {
        likeEl.style.opacity = Math.min(1, Math.abs(x) / (window.innerWidth * 0.12));
        if (x > 0) {
          likeEl.className = "is-like like";
          likeEl.innerHTML = '<i class="fa fa-thumbs-up"></i>';
        } else {
          likeEl.className = "is-like nope";
          likeEl.innerHTML = '<i class="fa fa-thumbs-down"></i>';
        }
      }
    }

    if (duration) current.style.transition = `transform ${duration}ms`;
  }

  function onPointerDown(e) {
    refreshCurrent();
    if (!current) return;
    e.preventDefault();
    startX = e.clientX;
    startY = e.clientY;
    moveX = 0; moveY = 0;
    try {
      current.setPointerCapture && current.setPointerCapture(e.pointerId);
      pointerId = e.pointerId;
    } catch (err) {}
    current.addEventListener("pointermove", onPointerMove);
    current.addEventListener("pointerup", onPointerUp);
    current.addEventListener("pointercancel", onPointerUp);
    current.addEventListener("pointerleave", onPointerUp);
  }

  function onPointerMove(e) {
    moveX = e.clientX - startX;
    moveY = e.clientY - startY;
    setTransform(moveX, moveY, (moveX / window.innerWidth) * 50);
  }

  function onPointerUp(e) {
    if (!current) return;
    try {
      current.releasePointerCapture && current.releasePointerCapture(pointerId);
      pointerId = null;
    } catch (err) {}
    current.removeEventListener("pointermove", onPointerMove);
    current.removeEventListener("pointerup", onPointerUp);
    current.removeEventListener("pointercancel", onPointerUp);
    current.removeEventListener("pointerleave", onPointerUp);

    if (Math.abs(moveX) > frame.clientWidth / 2) complete();
    else cancel();
  }

  function complete(duration = 350) {
    if (!current) return;

    // Banner swiped -> push marker & remove visually
    if (current.classList.contains("gd-widget-category-banner")) {
      const prev = current;
      pushBannerMarker(prev);
      const next = prev.nextElementSibling;
      setTimeout(() => {
        try { prev.remove(); } catch (e) {}
        checkCardsLeft();
        if (next) {
          initCard(next);
          refreshCurrent();
        }
      }, 10);
      current = next;
      likeText = current?.querySelector(".is-like");
      updateUndoVisual();
      return;
    }

    // Non-banner card
    const cardName = getCardName(current);
    const category = current.dataset.category;

    removeFromSwipeData(category, cardName);
    const sign = moveX === 0 ? 1 : moveX > 0 ? 1 : -1;
    if (sign > 0) addToSwipeData("likes", category, cardName);
    else addToSwipeData("dislikes", category, cardName);

    saveSession();

    pushCardEntry(current);

    const flyX = sign * window.innerWidth * 1.15;
    const flyY = moveX === 0 ? 0 : (moveY / moveX) * flyX;
    setTransform(flyX, flyY, (flyX / window.innerWidth) * 50, duration);

    const prev = current;
    const next = prev.nextElementSibling;
    if (next) setTimeout(() => {
      initCard(next);
      refreshCurrent();
    }, 100);
    current = next;
    likeText = current?.querySelector(".is-like");

    setTimeout(() => {
      try { prev.remove(); } catch (e) {}
      checkCardsLeft();
      updateUndoVisual();
    }, duration + 10);
  }

  function cancel() {
    if (!current) return;
    setTransform(0, 0, 0, 150);
    setTimeout(() => {
      if (current) current.style.transition = "";
    }, 160);
  }

  function checkCardsLeft() {
    const left = frame.querySelectorAll(".gd-widget-chat-like-dislike-card").length;
    if (left === 0) {
      if (undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }
      if (buttonsEl) buttonsEl.style.display = "none";
      if (getStartedEl) getStartedEl.style.display = "none";
      frame.innerHTML = '<div class="thanks">Thanks!</div>';
    } else {
      if (buttonsEl) buttonsEl.style.display = "flex";
    }
  }

  if (loveBtn) loveBtn.addEventListener("click", () => {
    refreshCurrent();
    if (!current || current.classList.contains("gd-widget-category-banner")) return;
    moveX = 1; moveY = 0;
    complete(350);
  });

  if (nopeBtn) nopeBtn.addEventListener("click", () => {
    refreshCurrent();
    if (!current || current.classList.contains("gd-widget-category-banner")) return;
    moveX = -1; moveY = 0;
    complete(350);
  });

  if (undoBtn) undoBtn.addEventListener("click", () => {
    if (!undoStack.length) return;

    // Peek top entry (do not pop until allowed)
    const topEntry = undoStack[undoStack.length - 1];

    // If top is a card -> pop and restore (original behavior)
    if (topEntry.type === 'card') {
      const entry = undoStack.pop();
      removeFromSwipeData(entry.category, entry.name);
      saveSession();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = entry.html.trim();
      const restoredCard = tempDiv.firstChild;

      frame.insertBefore(restoredCard, frame.firstChild);
      initCard(restoredCard);

      // decrement swipedCount on the nearest banner before this card (if exists)
      const bannerIndex = findLastBannerIndex();
      if (bannerIndex !== -1) {
        if (undoStack[bannerIndex].swipedCount > 0) {
          undoStack[bannerIndex].swipedCount--;
        }
        // Do NOT revert reversible flag once set (per requirement)
      }

      if (!undoStack.length && undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }

      refreshCurrent(true);
      updateUndoVisual();
      return;
    }

    // If top is banner -> determine whether we allow restoring it:
    if (topEntry.type === 'banner') {
      const bannersCount = countBanners();

      // allow if reversible OR there exists at least one earlier banner (we're past the first)
      const allowedBecauseMultipleBanners = (bannersCount >= 2);

      if (!topEntry.reversible && !allowedBecauseMultipleBanners) {
        // Not allowed - keep it on stack and disable undo
        if (undoBtn) {
          undoBtn.disabled = true;
        }
        updateUndoVisual();
        return;
      }

      // Allowed -> pop and restore banner DOM
      const entry = undoStack.pop();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = entry.html.trim();
      const restoredCard = tempDiv.firstChild;

      frame.insertBefore(restoredCard, frame.firstChild);
      initCard(restoredCard);

      if (!undoStack.length && undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }

      refreshCurrent(true);
      updateUndoVisual();
      return;
    }

    // fallback
    updateUndoVisual();
  });

  if (getStartedEl) {
    getStartedEl.addEventListener("click", () => {
      refreshCurrent();
      if (!current) return;
      
      moveX = 1;
      moveY = 0;
      complete(350);

      getStartedEl.style.display = "none";
    });
  }

  return {
    refresh: function () {
      refreshCurrent();
      initCard(current);
      checkCardsLeft();
      updateUndoVisual();
    },
    rebuild: function () {
      refreshCurrent();
      initCard(current);
      updateUndoVisual();
    },
    // expose undo stack for debugging if necessary
    _getUndoStack: () => undoStack.slice(),
    _setThreshold: (n) => {
      console.warn('Changing threshold at runtime may need further re-evaluation of undoStack markers.');
    }
  };
}

/* ---------- Init controller ---------- */
let gdWidgetSwipeController = null;
if (document.querySelector('.gd-widget-chat-like-dislike-card-container')) {
  gdWidgetSwipeController = gdWidgetInitSwipeCards({
    container: ".gd-widget-chat-like-dislike-card-container",
    loveBtn: "#love",
    nopeBtn: "#nope",
    buttons: ".gd-widget-chat-like-dislike-buttons",
  });
}

/* ---------- Modal open/close handlers ---------- */
// Event delegation for open button
document.addEventListener('click', function(event) {
  // Handle open button
  if (event.target && event.target.id === 'gd-widgetOpenLikeDislikePopup') {
    const modal = document.getElementById('gdSwipeModal');
    if (modal) {
      modal.classList.add('show');
      if (gdWidgetSwipeController) {
        gdWidgetSwipeController.refresh();
      }
    }
  }
  
  // Handle close button with event delegation
  if (event.target && event.target.classList.contains('gd-widget-chat-like-dislike-close-popup')) {
    const modal = document.getElementById('gdSwipeModal');
    if (modal) {
      modal.classList.remove('show');
    }
  }
  
  // Also handle if the close button has child elements
  if (event.target.closest('.gd-widget-chat-like-dislike-close-popup')) {
    const modal = document.getElementById('gdSwipeModal');
    if (modal) {
      modal.classList.remove('show');
    }
  }
});

// Also attach the original close handlers as backup
document.querySelectorAll('.gd-widget-chat-like-dislike-close-popup').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const modal = document.getElementById("gdSwipeModal");
    if (modal) {
      modal.classList.remove("show");
    }
  });
});

function gdWidgetShowSwipeCardsInChat() {
  const cards = [
    { category: "neck", title: "Neck", desc: "Neck", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Neck.jpg?v=1758639701" },
    { category: "sleeve", title: "Sleeve", desc: "Sleeve", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Sleeve.jpg?v=1758639702" },
    { category: "hem", title: "Hem", desc: "Hem", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Hem.jpg?v=1758639701" },
    { category: "product_subcategory", title: "Product Subcategory", desc: "Product Subcategory", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Product_Subcategory.jpg?v=1758639700" },
    { category: "product_style", title: "Product Style", desc: "Product Style", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Style.jpg?v=1758639700" },
    { category: "dress_length", title: "Dress Length", desc: "Dress Length", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Dress_Length.jpg?v=1758639702" }
  ];

  let currentStep = 0;
  const perPage = 2;
  const totalSteps = Math.ceil(cards.length / perPage);

  function renderStep(step) {
    const start = step * perPage;
    const end = start + perPage;
    const visibleCards = cards.slice(start, end);

    let cardsHTML = visibleCards.map(card => `
      <div class="gd-widget-chat-show-swipecards-card" data-category="${card.category}">
        <img src="${card.img}" alt="${card.title}">
        <div class="gd-widget-chat-show-swipecards-card-title">${card.title}</div>
        <div class="gd-widget-chat-show-swipecards-card-desc">${card.desc}</div>
      </div>
    `).join("");

    const preferencesHTML = `
      <div class="gd-widget-chat-show-swipecards-container">
        <div class="gd-widget-chat-show-swipecards-header">
          <h3>Clothing Preferences</h3>
          <div class="gd-widget-chat-show-swipecards-subtext">
            Choose the clothing types that appeal to you most. You can select multiple options:
          </div>
        </div>

        <div class="gd-widget-chat-show-swipecards-cards">
          ${cardsHTML}
        </div>

        <div style="text-align:center; margin-top:10px;">
          ${step > 0 ? `<div class="gd-widget-chat-show-swipecards-back">← Back</div>` : ""}
          <div class="gd-widget-chat-show-swipecards-button">${step + 1 === totalSteps ? "Finish" : "Continue →"}</div>
        </div>

        <div class="gd-widget-chat-show-swipecards-footer">
          <span>🔆 Select your preferences above or type a message...</span>
          <span>Step ${step + 1} of ${totalSteps}</span>
          <div class="gd-widget-chat-show-swipecards-stepbar">
            <div class="gd-widget-chat-show-swipecards-stepbar-fill" 
                 style="width:${((step + 1) / totalSteps) * 100}%"> </div>
          </div>
        </div>
      </div>
    `;

    // Get the chat area
    const chatArea = document.querySelector('.gd-chat-widget-conversation-area');
    if (!chatArea) {
      console.error('Chat area not found');
      return;
    }

    // Create wrapper if it doesn't exist
    let wrapper = document.getElementById('chat_swipe_wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'chat_swipe_wrapper';
      chatArea.appendChild(wrapper);
    }

    wrapper.innerHTML = preferencesHTML;
  }

  // Event delegation for all interactive elements
  function handleWrapperClick(event) {
    // Handle Continue/Finish button
    if (event.target.closest('.gd-widget-chat-show-swipecards-button')) {
      if (currentStep + 1 < totalSteps) {
        currentStep++;
        renderStep(currentStep);
      } else {
        alert("All steps completed!");
      }
      
      const hidecontinue = totalSteps - 1;
      if (currentStep === hidecontinue) {
        const button = document.querySelector('.gd-widget-chat-show-swipecards-button');
        if (button) button.style.display = 'none';
      }
    }
    
    // Handle Back button
    else if (event.target.closest('.gd-widget-chat-show-swipecards-back')) {
      if (currentStep > 0) {
        currentStep--;
        renderStep(currentStep);
      }
    }
    
    // Handle card click
    else if (event.target.closest('.gd-widget-chat-show-swipecards-card')) {
      const card = event.target.closest('.gd-widget-chat-show-swipecards-card');
      const category = card.getAttribute('data-category');
      gdWidgetBuildLikeDislikeCards(category);
      const modal = document.getElementById("gdSwipeModal");
      if (modal) {
        modal.classList.add("show");
        if (gdWidgetSwipeController) {
          gdWidgetSwipeController.refresh();
        }
      }
    }
  }

  // Initial render
  renderStep(currentStep);
  
  // Set up event delegation on the chat area
  const chatArea = document.querySelector('.gd-chat-widget-conversation-area');
  if (chatArea) {
    // Remove any existing listener to prevent duplicates
    chatArea.removeEventListener('click', handleWrapperClick);
    chatArea.addEventListener('click', handleWrapperClick);
  }
}

// Attach click handler to modal background to close when clicking outside
const modal = document.getElementById('gdSwipeModal');
if (modal) {
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.classList.remove('show');
    }
  });
}

// SwipeCards ends

// Product recommendation Feedback start

function gdWidgetProductRecommendationFeedback(message_id) {
  return `
    <div class="gd-widget-chat_feedback_step" data-id="${message_id}">
      <div class="gd-widget-chat_feedback_helpful">
        <div class="gd-widget-chat_feedback_helpful_wrapper">

          <div class="gd-widget-chat_feedback_title">
            Was this recommendation helpful?
          </div>

          <div class="gd-widget-chat_feedback_choices">
            <button type="button"
              class="gd-widget-chat_feedback_btn gd-widget-chat_feedback_no"
              data-value="no">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28
                  a2 2 0 0 0 2-1.7l1.38-9
                  a2 2 0 0 0-2-2.3zM7 22H4
                  a2 2 0 0 1-2-2v-7
                  a2 2 0 0 1 2-2h3"></path>
              </svg>
              No
            </button>

            <button type="button"
              class="gd-widget-chat_feedback_btn gd-widget-chat_feedback_yes"
              data-value="yes">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28
                  a2 2 0 0 0 2-1.7l1.38-9
                  a2 2 0 0 0-2-2.3zM7 22H4
                  a2 2 0 0 1-2-2v-7
                  a2 2 0 0 1 2-2h3"></path>
              </svg>
              Yes
            </button>
          </div>

          <div class="gd-widget-validation-error" style="display:none;">
            Please indicate if the recommendation was helpful
          </div>

          <button type="button" class="gd-widget-chat_feedback_primary">
            Submit Feedback
          </button>

        </div>
      </div>
    </div>
  `;
}


  document.addEventListener('click', function (e) {

    const feedbackBtn = e.target.closest
      ? e.target.closest('.gd-widget-chat_feedback_btn')
      : null;

    if (feedbackBtn) {
      const wrapper = feedbackBtn.closest('.gd-widget-chat_feedback_choices');
      if (!wrapper) return;

      wrapper
        .querySelectorAll('.gd-widget-chat_feedback_btn')
        .forEach(btn => btn.classList.remove('active'));

      feedbackBtn.classList.add('active');

      const step = feedbackBtn.closest('.gd-widget-chat_feedback_step');
      const error = step.querySelector('.gd-widget-validation-error');
      if (error) error.style.display = 'none';

      return; 
    }

    const submitBtn = e.target.closest
      ? e.target.closest('.gd-widget-chat_feedback_primary')
      : null;

    if (!submitBtn) return;

    const step = submitBtn.closest('.gd-widget-chat_feedback_step');
    if (!step) return;

    const selected = step.querySelector('.gd-widget-chat_feedback_btn.active');
    const error = step.querySelector('.gd-widget-validation-error');

    if (!selected) {
      error.style.display = 'block';
      return;
    }

    const feedback = selected.dataset.value;
    const userId = Number(localStorage.getItem('user_id'));
    const assistantId = Number(localStorage.getItem('session_id'));

    const payload = {
      user_id: userId,
      assistant_id: assistantId,
      type: 'product_recommendation',
      data: { helpful: feedback }
    };

    const token = getGDChatWidgetAiToken();

    fetch('https://ai.mygoddiva.com/feedback/store', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: 'Bearer ' + token } : {})
      },
      body: JSON.stringify(payload)
    })
    .then(r => r.json())
    .then(() => {
      step.innerHTML = `
        <div class="gd-widget-product-recommendation-thanks-msg">
          Thanks for your feedback!
        </div>
      `;
    })
    .catch(err => {
      console.error('Feedback error:', err);
     const loader = document.getElementById('gd-chat-widget-loader-bubble');
     if (loader) loader.style.display = 'none';

    });

  });



// Product recommendation Feedback ends


// Add this helper function right before the auto-scroll functions
function isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           style.opacity !== '0' &&
           el.offsetWidth > 0 && 
           el.offsetHeight > 0;
}

/**
 * ONLY scroll to user's reply - NEVER scroll to anything else
 * This should ONLY be called when user sends a message
 */
window.gdWidgetAutoScrollToUserReply = function() {
    const container = document.querySelector('.gd-chat-widget-conversation-area') || 
                      document.querySelector('.gd-chat-widget-assistant-body');
    const header = document.querySelector('.gd-chat-widget-assistant-header');
    const headerHeight = header ? header.offsetHeight : 0;
    
    if (!container) {
        return;
    }
    
    // Cancel any pending bot auto-scroll
    if (window._botScrollTimeout) {
        clearTimeout(window._botScrollTimeout);
        window._botScrollTimeout = null;
    }
    
    // Cancel any ongoing prompt suggestion polling
    if (window._promptPollingInterval) {
        clearInterval(window._promptPollingInterval);
        window._promptPollingInterval = null;
    }
    
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
        const userReplies = container.querySelectorAll('.gd-chat-widget-user-msg');
        const lastUserReply = userReplies[userReplies.length - 1];
        
        if (lastUserReply) {
            // Calculate position to show the user message at the TOP of the container
            const targetScrollTop = lastUserReply.offsetTop - headerHeight - 10;
            
            // Smooth scroll to position
            container.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth'
            });
            
            console.log('👤 Scrolled to user message');
        }
    });
};


window.gdWidgetAutoScroll = function() {
    const container = document.querySelector('.gd-chat-widget-conversation-area') || 
                      document.querySelector('.gd-chat-widget-assistant-body');
    const header = document.querySelector('.gd-chat-widget-assistant-header');
    const headerHeight = header ? header.offsetHeight : 0;
    
    if (!container) {
        return;
    }
    
    if (window._botScrollTimeout) {
        clearTimeout(window._botScrollTimeout);
        window._botScrollTimeout = null;
    }
    
    if (window._promptPollingInterval) {
        clearInterval(window._promptPollingInterval);
        window._promptPollingInterval = null;
    }
    
    window._botScrollTimeout = setTimeout(() => {
        // PRIORITY 1: Product wrapper
        const productWrapper = container.querySelector('.gd-widget-drag-scroll:last-child');
        
        if (productWrapper) {
            productWrapper.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
            
            setTimeout(() => {
                const targetScrollTop = productWrapper.offsetTop - headerHeight + 30;
                container.scrollTop = targetScrollTop;
                console.log('📦 Scrolled to product wrapper');
            }, 100);
        } 
        else {
            let attempts = 0;
            const maxAttempts = 200;
            const pollInterval = 100;
            
            window._promptPollingInterval = setInterval(() => {
                attempts++;
                
                const promptSuggestion = document.getElementById('gd-chat-widget-prompt_suggestion');
                
                // ✅ PRIORITY 2: RETURN PANELS (MOVED ABOVE)
                // const returnPortalPanels = container.querySelector('.gd-chat-widget-ex-panel:last-child') || 
                //                            container.querySelector('.gd-chat-widget-li-panel:last-child') || 
                //                            container.querySelector('.gd-chat-widget-alt-panel:last-child') ||
                //                            container.querySelector('.gd-chat-widget-li-requested-only:last-child');
                const returnPortalPanelsList = container.querySelectorAll(
                    '.gd-chat-widget-ex-panel, .gd-chat-widget-li-panel, .gd-chat-widget-alt-panel, .gd-chat-widget-li-requested-only'
                );

                const returnPortalPanels = returnPortalPanelsList[returnPortalPanelsList.length - 1];
                
                if (returnPortalPanels) {
                    returnPortalPanels.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    
                    setTimeout(() => {
                        const targetScrollTop = returnPortalPanels.offsetTop - headerHeight + 30;
                        container.scrollTop = targetScrollTop;
                        console.log('📦 Scrolled to return panel (priority 2)');
                    }, 100);
                    
                    clearInterval(window._promptPollingInterval);
                    window._promptPollingInterval = null;
                    return;
                }
                
                // PRIORITY 3: Prompt suggestion
                if (isElementVisible(promptSuggestion)) {
                    void container.offsetHeight;
                    
                    setTimeout(() => {
                        promptSuggestion.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                        
                        setTimeout(() => {
                            const currentScroll = container.scrollTop;
                            const adjustedScroll = currentScroll - headerHeight - 30;
                            
                            container.scrollTo({
                                top: adjustedScroll,
                                behavior: 'smooth'
                            });
                            
                            console.log('💬 Scrolled to prompt suggestion');
                        }, 150);
                    }, 50);
                    
                    clearInterval(window._promptPollingInterval);
                    window._promptPollingInterval = null;
                } 
                else if (attempts >= maxAttempts) {
                    clearInterval(window._promptPollingInterval);
                    window._promptPollingInterval = null;
                    
                    console.log('⏰ Nothing found, fallback to bot reply');
                    
                    const botReplies = container.querySelectorAll('.gd-chat-widget-bot-reply');
                    const lastBotReply = botReplies[botReplies.length - 1];
                    
                    if (lastBotReply) {
                        lastBotReply.scrollIntoView({
                            behavior: 'smooth',
                            block: 'end'
                        });
                        
                        setTimeout(() => {
                            const targetScrollTop = lastBotReply.offsetTop - headerHeight + 10;
                            container.scrollTop = targetScrollTop;
                        }, 100);
                        
                        console.log('🤖 Scrolled to bot reply');
                    }
                    else {
                        container.scrollTo({
                            top: container.scrollHeight,
                            behavior: 'smooth'
                        });
                    }
                }
            }, pollInterval);
        }
        
        window._botScrollTimeout = null;
    }, 300);
};



/**
 * Debug version to check if prompt suggestion is found and visible
 */
window.gdWidgetCheckPromptSuggestion = function() {
    const promptSuggestion = document.getElementById('gd-chat-widget-prompt_suggestion');
    
    if (promptSuggestion) {
        console.log('✅ Prompt suggestion element EXISTS');
        console.log('   - ID:', promptSuggestion.id);
        console.log('   - Display:', window.getComputedStyle(promptSuggestion).display);
        console.log('   - Visibility:', window.getComputedStyle(promptSuggestion).visibility);
        console.log('   - Opacity:', window.getComputedStyle(promptSuggestion).opacity);
        console.log('   - OffsetWidth:', promptSuggestion.offsetWidth);
        console.log('   - OffsetHeight:', promptSuggestion.offsetHeight);
        console.log('   - OffsetTop:', promptSuggestion.offsetTop);
        console.log('   - Parent:', promptSuggestion.parentElement?.className);
    } else {
        console.log('❌ Prompt suggestion element NOT FOUND');
    }
    
    return promptSuggestion;
};

/**
 * Simple scroll to bottom function
 */
window.gdWidgetScrollToBottom = function() {
    const container = document.querySelector('.gd-chat-widget-assistant-body');
    if (container) {
        container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
        });
    }
};

window.gdWidgetScrollToBottom();

  const btn = document.querySelector('.gd-chat-widget-welcome-info-btn');
  const info = document.querySelector('.gd-chat-welcome-info');

  if (btn && info) {
    btn.addEventListener('click', () => {
      info.style.display = info.style.display === 'block' ? 'none' : 'block';
    });
  }


});// domcontent closed here

window.addEventListener('load', () => {
    const btn = document.querySelector('.gd-chat-widget-openAssistantBtnBounce');
    if (!btn) return;

    setTimeout(() => {
      btn.classList.add('stop-animation');
    }, 5000); // 10 seconds
  });




async function gdWidgetSendRegisteredEvent() {
  if (!window.customerLoggedIn) {
    return;
  }

  if (localStorage.getItem("user_id")) {
    return;
  }

  const registerWrapper = document.getElementById('gd-chat-widget-registerWrapper');
  const mainWrapper = document.getElementById('gd-chat-widget-main-wrapper');
  const userNameEl = document.getElementById('gd-chat-widget-user-name');
  const mainLoader = document.getElementById("gd-chat-widget-loader");

  if (mainLoader) {
    mainLoader.style.display = "flex";
  }

  const elPromptSuggestion = document.getElementById("chat-widget-prompt-suggestion");
  if(elPromptSuggestion){
    elPromptSuggestion.innerHTML = '';
  }

  const payload = {
    customer_id: window.customerId
  };

  const storedProduct = sessionStorage.getItem("lastProductId");
  if (storedProduct) {
    payload.product_id = storedProduct;
  }

  try {
    const res = await fetch("https://ai.mygoddiva.com/is_shopify_user_registered", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (res.status === 404) {
      return;
    }
    
    if (!res.ok) {
      return;
    }

    const response = await res.json();

    // Store values exactly as API gives
    localStorage.setItem('session_id', response.session_id);
    localStorage.setItem('user_id', response.user.id);
    localStorage.setItem('user_email', window.customerEmail);
    localStorage.setItem('user_name', window.customerName);
    sessionStorage.setItem("is_history", "true");
    
    if (response.token) {
      localStorage.setItem("ai_access_token", response.token.access);
      localStorage.setItem("ai_refresh_token", response.token.refresh);
    }

    window.gdWidgetSkipInitialChatLoad = true;
    window.gdWidgetSkipInitialChatLoadSize = true;

    if (userNameEl) {
      userNameEl.textContent = window.customerName;
    }
    
    window.gdChatWidgetUpdateUserInitials();

    if (registerWrapper) registerWrapper.style.display = 'none';
    if (mainWrapper) mainWrapper.style.display = 'flex';
    
    if (mainLoader) mainLoader.style.display = "none";

    if (response.prompts) {
      window.gdWidgetpromptHandel(
        window.gdNormalizePrompts(response.prompts)
      );
    }
    
    gdWidgetRenderUserSizesRegisteredEvent(response);

  } catch (err) {
    if (mainLoader) mainLoader.style.display = "none";
  }
}

window.gdWidgetSendRegisteredEvent = gdWidgetSendRegisteredEvent;

function gdWidgetRenderUserSizesRegisteredEvent(response) {
  const sizeLabel = document.getElementById("gd-chat-widget-sizeLabel");
  if (!sizeLabel) {
    return;
  }
  
  sizeLabel.innerHTML = '';

  if (!response?.user?.size) {
    return;
  }

  if (response.user.size && response.user.size.length) {
    // Only UK sizes (exclude ONESIZE and international duplicates)
    const ukIds = [...document.querySelectorAll('.gd-chat-widget-register-sizeCheckbox')]
        .map(cb => Number(cb.dataset.id));

    const uniqueUkSizes = response.user.size.filter(
        item => ukIds.includes(item.id) && item.name.toLowerCase() !== 'onesize'
    );

    if (uniqueUkSizes.length === 1) {
        // Only 1 size selected
        sizeLabel.textContent = `Size: ${uniqueUkSizes[0].name.trim()}`;
    } 
    else if (uniqueUkSizes.length > 1) {
        // Multiple sizes selected
        const firstSize = uniqueUkSizes[0].name.trim();
        const moreCount = uniqueUkSizes.length - 1;
        sizeLabel.textContent = `Size: ${firstSize} +${moreCount} more`;
    }

    // 1️⃣ Remove active class from all size pills
    document.querySelectorAll(".gd-chat-widget-size-pill").forEach(btn => {
        btn.classList.remove("active");
    });

    // 2️⃣ Get selected size IDs DIRECTLY from the response
    const selectedIds = response.user.size.map(s => Number(s.id));

    // 3️⃣ Activate pills that match selected sizes from response
    document.querySelectorAll(".gd-chat-widget-size-pill").forEach(btn => {
        const id = Number(btn.dataset.id);
        if (selectedIds.includes(id)) {
            btn.classList.add("active");
        }
    });

    // 4️⃣ Always activate hidden onesize
    const oneSize = document.querySelector('#size_onesize');
    if (oneSize) {
        oneSize.classList.add("active");
    }
  }
}






/****
 ========================================================================
**Return Portal
 ========================================================================
 ***/

baseEndPointToSubmit = 'https://mp.mygoddiva.com';

 function gdWidgetRenderLineItems(items, lineItemsData) {
  if (!items || !items.length) return '';

  const panelId    = `gd-chat-widget-liPanel_${Date.now()}`;
  const returnFee  = parseFloat(lineItemsData.return_fee) || 0;
  const isVip      = lineItemsData.is_vip_customer        ? '1' : '0';
  const isSelfShip = lineItemsData.is_self_ship_available ? '1' : '0';
  const partnerId  = lineItemsData.partner_id || 1;

  const freePartners = [5, 7, 11, 17,27,29];
  const effectiveFee = (lineItemsData.is_vip_customer || freePartners.includes(partnerId))
    ? '0.00'
    : returnFee.toFixed(2);

//   const cards = items.map((item, index) =>
//     gdWidgetBuildLineItemCard(item, index, lineItemsData)
//   ).join('');

    const cards = items.map((item, index) =>
    gdWidgetBuildLineItemCard(item, index, lineItemsData, panelId)
    ).join('');

    const lastReturnItems = JSON.stringify(lineItemsData.last_return_items || []);


  return `
    <div class="gd-chat-widget-li-panel"
         id="${panelId}"
         data-last-return-items='${gdWidgetEscHtml(lastReturnItems)}'
         data-last-pending-fees-items='${gdWidgetEscHtml(JSON.stringify(lineItemsData.last_pending_fees_items || []))}'
         data-original-query="${gdWidgetEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}"
         data-marketplace-id="${lineItemsData.partner_id || ''}"
         data-shipping-code="${lineItemsData.shipping_country_code || ''}"
         data-search-type="${lineItemsData.search_type || ''}"
         data-search-value="${lineItemsData.search_value || ''}"
         data-return-fee="${effectiveFee}"
         data-is-vip="${isVip}"
         data-is-self-ship="${isSelfShip}"
         data-partner-id="${partnerId}">

      <div class="gd-chat-widget-li-sticky-top">
        <span><strong>Select Items:</strong> Choose the products you'd like to return and specify your reason</span>
      </div>

      <div class="gd-chat-widget-li-select-all-bar">
        <label class="gd-chat-widget-li-select-all-label">
          <input type="checkbox"
                 class="gd-chat-widget-li-checkbox gd-chat-widget-li-select-all-chk"
                 onchange="gdWidgetToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="gd-chat-widget-li-selected-count">0 items selected</span>
      </div>

      <div class="gd-chat-widget-li-grid">
        ${cards}
        ${gdWidgetRenderNonReturnableItems(lineItemsData)}
      </div>

      <!-- Summary — hidden until at least one return option selected -->
      <div class="gd-chat-widget-li-summary" style="display:none;">
        <div class="gd-chat-widget-li-summary-title">Summary</div>
        <table class="gd-chat-widget-li-summary-table">
          <tbody>
            <tr class="gd-chat-widget-li-sum-store-credit" style="display:none;">
              <td>Total Store Credit:</td>
              <td>£<span class="gd-chat-widget-li-sum-sc-val">0.00</span></td>
            </tr>
            <tr class="gd-chat-widget-li-sum-refund" style="display:none;">
              <td>Total Refund:</td>
              <td>£<span class="gd-chat-widget-li-sum-ref-val">0.00</span></td>
            </tr>
            <tr class="gd-chat-widget-li-sum-return-label" style="display:none;">
              <td>Total Return Fee:</td>
              <td>£<span class="gd-chat-widget-li-sum-fee-val">0.00</span></td>
            </tr>
            <tr class="gd-chat-widget-li-sum-self-ship" style="display:none;">
              <td>Total Self Ship Qty:</td>
              <td><span class="gd-chat-widget-li-sum-ss-val">0</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="gd-chat-widget-li-sticky-bottom">
        <!-- Add to previous label — hidden until relevant -->
        <div class="gd-chat-widget-li-addtoprev-wrapper"
            id="gd-chat-widget-addtoprev_${panelId}"
            style="display:none;padding:10px 16px;background:#fff8e1;border-top:1px solid #ffe082;font-size:11px;">
        <p class="gd-chat-widget-li-addtoprev-content" style="margin:0 0 8px;color:#374151;line-height:1.5;"></p>
        <div class="gd-chat-widget-li-addtoprev-radios" style="display:flex;gap:16px;margin-bottom:6px;">
            <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
            <input type="radio"
                    class="gd-chat-widget-li-addtoprev-radio"
                    name="gd-chat-widget-addtoprev_${panelId}"
                    value="yes"
                    onchange="gdWidgetAddToPrevChange(this)" />
            Yes
            </label>
            <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
            <input type="radio"
                    class="gd-chat-widget-li-addtoprev-radio"
                    name="gd-chat-widget-addtoprev_${panelId}"
                    value="no"
                    onchange="gdWidgetAddToPrevChange(this)" />
            No
            </label>
        </div>
        <p class="gd-chat-widget-li-addtoprev-error"
            style="display:none;color:#e74c3c;font-size:11px;margin:4px 0 0;">
            Please choose Yes or No.
        </p>
        </div>
        <!-- Terms & Conditions -->
        <div class="gd-chat-widget-li-terms-wrapper" id="gd-chat-widget-terms_${panelId}" style="display:none;">
            <label class="gd-chat-widget-li-terms-label">
            <input type="checkbox"
                    class="gd-chat-widget-li-terms-chk"
                    id="gd-chat-widget-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
            </label>
            <p class="gd-chat-widget-li-terms-error"
            id="gd-chat-widget-terms-err_${panelId}"
            style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;">
            Please accept the terms and conditions.
            </p>
        </div>

        <button class="gd-chat-widget-li-process-btn" disabled onclick="gdWidgetHandleProcessReturn(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          PROCESS RETURN
        </button>
      </div>

    </div>

    <!-- Image preview popup — one per panel -->
    <div id="gd-chat-widget-img-popup_${panelId}"
         class="gd-chat-widget-img-popup" hidden>
      <div class="gd-chat-widget-img-popup-overlay"
           onclick="gdWidgetFaultyPopupClose('${panelId}')"></div>
      
      <div class="gd-chat-widget-img-popup-box">
        <button class="gd-chat-widget-img-popup-close"
            onclick="gdWidgetFaultyPopupClose('${panelId}')">✕</button>
        <button class="gd-chat-widget-img-popup-nav gd-chat-widget-img-popup-prev"
                onclick="gdWidgetFaultyPopupNav('${panelId}', -1)">&#8249;</button>
        <div class="gd-chat-widget-img-popup-img-wrap">
          <img id="gd-chat-widget-img-popup-img_${panelId}" src="" alt="" />
        </div>
        <button class="gd-chat-widget-img-popup-nav gd-chat-widget-img-popup-next"
                onclick="gdWidgetFaultyPopupNav('${panelId}', 1)">&#8250;</button>
        <div class="gd-chat-widget-img-popup-counter"
             id="gd-chat-widget-img-popup-counter_${panelId}"></div>
      </div>
    </div>

    <!-- Payment popup — one per panel -->
    <div id="gd-chat-widget-pay-popup_${panelId}"
        class="gd-chat-widget-pay-popup" hidden>
    <div class="gd-chat-widget-pay-overlay"></div>
    <div class="gd-chat-widget-pay-box">
        <button class="gd-chat-widget-pay-close"
                onclick="gdWidgetPayPopupClose('${panelId}')">✕</button>
        <div id="gd-chat-widget-pay-content_${panelId}">
        <!-- Injected by gdWidgetShowPaymentPopup() -->
        </div>
    </div>
    </div>

    <!-- Too Big / Too Long popup — one per panel, Goddiva + partner 1 only -->
    <div id="gd-chat-widget-tbtl-popup_${panelId}"
         class="gd-chat-widget-tbtl-popup" hidden>
      <div class="gd-chat-widget-tbtl-overlay"
           onclick="gdWidgetTbtlClose('${panelId}')"></div>
      <div class="gd-chat-widget-tbtl-box">
        <p style="font-size:12px;margin:0 0 12px;line-height:1.5;">
          Did you know you can have your dress altered to the perfect length?
          <a href="https://goddiva.co.uk/pages/alterations" target="_blank" style="color:#ff8080;">
            Learn About Alterations
          </a>
        </p>
        <button class="gd-chat-widget-li-process-btn gd-chat-widget-li-process-active"
                style="width:100%;margin-top:4px;"
                onclick="gdWidgetTbtlClose('${panelId}')">
          Continue with Return
        </button>
      </div>
    </div>

  `;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE CARD
// ─────────────────────────────────────────────────────────────
function gdWidgetBuildLineItemCard(item, index, lineItemsData, panelId) {
  const uid    = `li_${panelId}_${item.id}_${index}`;
  const maxQty = item.availableQty || item.quantity || 1;

  // Price — mirrors portal: price !== gross_price → strikethrough + red
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
    : `<div class="gd-chat-widget-li-img-placeholder">G</div>`;

  const size  = item.size  || '—';
  const color = item.color || '—';

  // Reason options
  const reasons    = lineItemsData.reasons || [];
  const reasonOpts = reasons.map(r =>
    `<option value="${r.id}"
             data-name="${gdWidgetEscHtml(r.name)}"
             data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
             data-is-refund="${r.is_refund ? '1' : '0'}"
             data-faulty="${r.name.toLowerCase() === 'faulty' ? '1' : '0'}"
     >${gdWidgetEscHtml(r.name)}</option>`
  ).join('');

  // ── All condition flags ───────────────────────────────────
  const isActivePeriod     = lineItemsData.is_active_date == 1;
  const isGiftBagName      = item.name === 'Heart Shaped Foil Shopper Bag - Rose Gold';
  const isGiftBag          = isGiftBagName && !!item.is_gift_bag;    // needs other items checked to enable
  const isNonReturnableBag = isGiftBagName && !item.is_gift_bag;     // completely non-returnable
  const isOutlet           = !!item.is_outlet;
  const isMystery          = !!item.is_mystery;
  const isHygieneSeller    = item.seller_id == 60;
  const isDisabled         = !!item.non_returnable;
  const outletNonPartner1  = isOutlet && lineItemsData.partner_id != 1;
  const isCanReturn        = !!item.can_return;

  // Checkbox disabled when any blocking condition is true
  // Outlet partner-1 checkbox starts disabled too — enabled by Yes radio
  const checkboxDisabled =
    isDisabled         ||   // non_returnable flag
    isGiftBag          ||   // gift bag — enabled when other items checked
    isNonReturnableBag ||   // gift bag name but is_gift_bag = false
    isMystery          ||   // mystery box
    isHygieneSeller    ||   // seller 60 hygiene items
    outletNonPartner1  ||   // outlet but not partner 1
    !isActivePeriod    ||   // return period passed
    !isCanReturn;           // can_return = 0

  // Show the interactive form (reason/qty/options)?
  // Only when: period active + not any blocking non-form condition
  const showForm =
    isActivePeriod    &&
    !isDisabled       &&
    !isNonReturnableBag &&
    !isMystery        &&
    !isHygieneSeller  &&
    !outletNonPartner1 &&
    isCanReturn;

  // Badges
  const outletBadge    = isOutlet
    ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-outlet">Outlet</div>` : '';
  const gradeBadge     = item.grade
    ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-grade">Grade ${item.grade}</div>` : '';
  const nonReturnBadge = item.non_returnable
    ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-warn">Non-returnable</div>` : '';
  const giftBagBadge   = isGiftBag
    ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-gift">Promotional Bag</div>` : '';
  const mysteryBadge   = isMystery
    ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-warn">Mystery Box</div>` : '';

  // Card CSS classes
  const cardClasses = [
    'gd-chat-widget-li-card',
    (isDisabled || isNonReturnableBag || isMystery || isHygieneSeller || outletNonPartner1 || !isActivePeriod || !isCanReturn)
      ? 'gd-chat-widget-li-card-disabled' : '',
    isGiftBag          ? 'gd-chat-widget-li-gift-bag-card' : '',
    isOutlet           ? 'gd-chat-widget-li-outlet-card'   : '',
  ].filter(Boolean).join(' ');

  return `
    <div class="${cardClasses}"
         id="gd-chat-widget-card_${uid}"
         data-brand-id="${item.brand_id || ''}"
         data-brand="${gdWidgetEscHtml(item.brand || '')}"
         data-is-gift-bag="${isGiftBag ? '1' : '0'}"
         data-is-outlet="${isOutlet ? '1' : '0'}"
         data-max-qty="${maxQty}"
         data-item-id="${item.id}"
         data-sku="${gdWidgetEscHtml(item.sku || '')}"
         data-name="${gdWidgetEscHtml(item.name || '')}"
         data-grade="${gdWidgetEscHtml(item.grade || '')}"
         data-is-goddiva="${item.is_goddiva ? '1' : '0'}"
         data-store-credit-amount="${item.store_credit_single_amount || 0}"
         data-refund-amount="${item.refund_single_amount || 0}"
         data-store-credit-pct="${item.store_credit_percentage || 0}"
         data-refund-pct="${item.refund_percentage || 0}">

      <input type="checkbox"
             class="gd-chat-widget-li-checkbox"
             id="gd-chat-widget-chk_${uid}"
             data-uid="${uid}"
             ${(checkboxDisabled) ? 'disabled' : ''}
             onchange="gdWidgetOnCheckboxChange(this)" />

      <div class="gd-chat-widget-li-img-wrap">
        <div class="gd-chat-widget-li-img">${imgHtml}</div>
        <div class="gd-chat-widget-li-badges">${outletBadge}${gradeBadge}${mysteryBadge}${giftBagBadge}${nonReturnBadge}</div>
      </div>

      <div class="gd-chat-widget-li-body">

        <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
        <div class="gd-chat-widget-li-price">${priceHtml}</div>



        <!-- ── View Details — always visible ──────────────── -->
        <button class="gd-chat-widget-li-view-details-btn"
                type="button"
                onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-det_${uid}')">
          ${gdWidgetInfoIcon()}
          View Details
          <span class="gd-chat-widget-li-chevron">▾</span>
        </button>

        <div id="gd-chat-widget-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
          <div class="gd-chat-widget-li-detail-grid">
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Size</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(size)}</div>
            </div>
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Colour</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(color)}</div>
            </div>
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">SKU</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku)}</div>
            </div>
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Qty</div>
              <div class="gd-chat-widget-li-dv">${item.quantity}</div>
            </div>
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Brand</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div>
            </div>
            ${item.tracking_name ? `
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Tracking Company</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)}</div>
            </div>` : ''}
            ${item.tracking_id ? `
            <div class="gd-chat-widget-li-dc">
              <div class="gd-chat-widget-li-dl">Tracking ID</div>
              <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_id)}</div>
            </div>` : ''}
          </div>
        </div>

        <!-- ── Status messages — only one will show ───────── -->

        ${!isActivePeriod ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The return period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
            for more information.
          </p>
        ` : ''}

        ${isActivePeriod && !isCanReturn ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for return.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product and as per our return policy, Mystery Box items are non-returnable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && isHygieneSeller ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            For hygiene reasons, we are unable to accept returns on beauty products, ranging from
            pierced jewellery, make-up, skin care, fragrances, hair products and anything that can
            be applied to the skin or body. In addition, we will be unable to accept returns on
            face masks, lingerie &amp; swimwear.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && isNonReturnableBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            Please note: This item is non returnable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && !isNonReturnableBag && isGiftBag ? `
          <p class="gd-chat-widget-li-gift-bag-msg" style="color:#d00;font-size:11px;margin:4px 0;">
            The promotional bag can't be returned on its own. It may only be returned if other items
            from the order are also returned.
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && !isNonReturnableBag && outletNonPartner1 ? `
          <p style="font-size:11px;margin:4px 0;">
            Please note: All outlet items are final sale and cannot be exchanged. These are reduced,
            end-of-line or seasonal products and are not eligible for refunds or exchanges.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        <!-- ── Outlet policy (partner 1 only) ─────────────── -->
       ${isActivePeriod && isCanReturn && isOutlet && !outletNonPartner1 ? `
        <div class="gd-chat-widget-li-outlet-policy">
          <!-- Accordion — collapsed by default -->
          <button class="gd-chat-widget-li-outlet-acc-header" type="button"
                  onclick="this.classList.toggle('open');this.nextElementSibling.hidden=!this.nextElementSibling.hidden;">
            More Information
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div class="gd-chat-widget-li-outlet-acc-body" hidden>
            <p><strong>Please note that outlet items are final sale and not eligible for a full refund,</strong>
              as they are end-of-line or seasonal stock.</p>
            <p>However, as a gesture of goodwill, we can offer a 60% refund in the form of a gift card
              if the item is returned and passes our quality checks. Kindly note:</p>
            <ul style="margin:4px 0 8px 16px;font-size:11px;">
              <li>A small fee applies for the return label.
                <strong>(Returns are free for Goddiva Unlimited subscribers)</strong></li>
              <li>If the item does not meet return conditions, it will be sent back and no refund issued.</li>
            </ul>
            <p>Thank you for your understanding.</p>
          </div>

          <!-- Always visible -->
          <div class="gd-chat-widget-li-outlet-confirm">
            <label>
              <input type="radio"
                    class="gd-chat-widget-li-outlet-radio"
                    name="gd-chat-widget-outlet_${uid}"
                    value="yes"
                    data-uid="${uid}"
                    onchange="gdWidgetOutletRadioChange(this)" />
              <strong>Yes</strong> – I want to return the item
            </label>
            <label>
              <input type="radio"
                    class="gd-chat-widget-li-outlet-radio"
                    name="gd-chat-widget-outlet_${uid}"
                    value="no"
                    data-uid="${uid}"
                    onchange="gdWidgetOutletRadioChange(this)" />
              <strong>No</strong> – I do not want to return it
            </label>
          </div>
        </div>
      ` : ''}


        <!-- ── Interactive form — only when showForm is true ─ -->
        ${showForm ? `

          <!-- Reason + Quantity
               gift bag: hidden until another item checked
               outlet p1: hidden until Yes selected
               normal: always visible -->
          <div class="gd-chat-widget-li-row${isGiftBag ? ' gd-chat-widget-li-gift-bag-row' : ''}${isOutlet ? ' gd-chat-widget-li-outlet-row' : ''}"
               ${isOutlet ? 'style="display:none;"' : ''}>
            <div class="gd-chat-widget-li-reason-wrap">
              <label class="gd-chat-widget-li-label">
                Return Reason <span class="gd-chat-widget-li-req">*</span>
              </label>
              <select class="gd-chat-widget-li-reason"
                      data-uid="${uid}"
                      ${(isGiftBag || isOutlet) ? 'disabled' : ''}
                      onchange="gdWidgetOnReasonChange(this)">
                <option value="">Select a reason…</option>
                ${reasonOpts}
              </select>
              <textarea class="gd-chat-widget-li-specific-reason"
                        id="gd-chat-widget-specificReason_${uid}"
                        data-uid="${uid}"
                        placeholder="Please describe your reason…"
                        maxlength="150"
                        style="display:none;margin-top:6px;width:100%;font-size:11px;
                               padding:6px;border:1px solid #d1d5db;border-radius:6px;resize:vertical;"
                        oninput="gdWidgetAutoCheck('${uid}')"></textarea>
              <span class="gd-chat-widget-li-error-msg"
                    id="gd-chat-widget-specificReasonErr_${uid}"
                    hidden>Please describe your reason</span>
            </div>
            <div>
              <label class="gd-chat-widget-li-label">Quantity</label>
              <div class="gd-chat-widget-li-stepper">
                <button type="button" onclick="gdWidgetChangeQty(this, -1, '${uid}')" ${maxQty <= 1 ? 'disabled' : ''}>−</button>
                <div class="gd-chat-widget-li-qty">1</div>
                <button type="button" onclick="gdWidgetChangeQty(this, +1, '${uid}')" ${maxQty <= 1 ? 'disabled' : ''}>+</button>
              </div>
            </div>
          </div>

          <!-- Faulty upload — shown only when reason = Faulty AND option = return_label -->
          <div id="gd-chat-widget-flt_${uid}" class="gd-chat-widget-li-faulty-upload" hidden>
            <div class="gd-chat-widget-li-faulty-label">
              📷 Upload Photos
              <span class="gd-chat-widget-li-faulty-optional">
                (Optional — min. 3 if uploading, max 3, each up to 5MB)
              </span>
            </div>
            <label class="gd-chat-widget-li-upload-btn" for="gd-chat-widget-fltInput_${uid}">
              Choose Images
              <input type="file"
                     id="gd-chat-widget-fltInput_${uid}"
                     class="gd-chat-widget-li-file-input"
                     accept="image/*"
                     multiple
                     data-uid="${uid}"
                     onchange="gdWidgetFaultyImagesAdded(this)" />
            </label>
            <p class="gd-chat-widget-li-faulty-description">
              If you upload images of the fault, our team will review them. If approved, your return
              postage will be free, otherwise we'll deduct the postage fee from your refund amount.
            </p>
            <span class="gd-chat-widget-li-warn-msg" id="gd-chat-widget-fltWarn_${uid}" hidden></span>
            <div id="gd-chat-widget-fltPreviews_${uid}" class="gd-chat-widget-li-faulty-previews"></div>
            <span class="gd-chat-widget-li-error-msg" id="gd-chat-widget-fltErr_${uid}" hidden>
              Please upload at least 3 images
            </span>
          </div>

          <!-- Return options — hidden until reason chosen, built dynamically -->
          <div id="gd-chat-widget-opts_${uid}" class="gd-chat-widget-li-opts" hidden>
            <div class="gd-chat-widget-li-opts-label">
              Return Options <span class="gd-chat-widget-li-req">*</span>
            </div>
            <div class="gd-chat-widget-li-opts-cards"></div>
            <p class="gd-chat-widget-li-opt-description"
               id="gd-chat-widget-optDesc_${uid}"
               style="font-size:10px;font-weight:600;padding:4px 0 0;margin:0;"></p>
            <span class="gd-chat-widget-li-error-msg" id="gd-chat-widget-optErr_${uid}" hidden>
              Please select a return option
            </span>
          </div>

        ` : ''}

      </div><!-- /.gd-chat-widget-li-body -->
    </div><!-- /.gd-chat-widget-li-card -->
  `;
}

// ─────────────────────────────────────────────────────────────
// REASONS STORE — keyed by panel id
// ─────────────────────────────────────────────────────────────

const _gdWidgetPanelReasons = {};

function gdWidgetSetPanelReasons(panel, reasons) {
  if (panel && panel.id) _gdWidgetPanelReasons[panel.id] = reasons;
}

function gdWidgetGetPanelReasons(panel) {
  return (panel && _gdWidgetPanelReasons[panel.id]) || [];
}


// ─────────────────────────────────────────────────────────────
// GIFT BAG LOGIC — mirrors portal Heart Shaped Foil Shopper Bag logic
// ─────────────────────────────────────────────────────────────

const GD_WIDGET_GIFT_BAG_REASON_IDS = ['9', '10'];

function gdWidgetUpdateGiftBag(panel) {
  if (!panel) return;

  const giftBagCards = panel.querySelectorAll('.gd-chat-widget-li-card[data-is-gift-bag="1"]');
  if (!giftBagCards.length) return;

  // Any non-gift-bag checkbox checked?
  const anyOtherChecked = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk)'
  )].some(chk => {
    const card = chk.closest('.gd-chat-widget-li-card');
    return card && card.dataset.isGiftBag !== '1' && chk.checked;
  });

  const reasons = gdWidgetGetPanelReasons(panel);

  giftBagCards.forEach(card => {
    const chk       = card.querySelector('.gd-chat-widget-li-checkbox');
    const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
    const msgEl     = card.querySelector('.gd-chat-widget-li-gift-bag-msg');
    const rowEl     = card.querySelector('.gd-chat-widget-li-gift-bag-row');
    if (!chk) return;
    if (anyOtherChecked) {
        // Enable the gift bag card
        chk.disabled = false;
        card.classList.add('gd-chat-widget-li-gift-bag-enabled');
        if (msgEl) msgEl.style.display = 'none';
        if (rowEl) rowEl.style.display = 'flex';

        if (reasonSel) {
            reasonSel.disabled = false;
            gdWidgetRebuildGiftBagReason(reasonSel, reasons); // ← keep only this one
        }

    } else {
        if (chk.checked) {
            chk.checked = false;
            gdWidgetResetCard(chk.dataset.uid);
        }
        chk.disabled = true;
        card.classList.remove('gd-chat-widget-li-gift-bag-enabled');
        if (msgEl) msgEl.style.display = '';
        if (rowEl) rowEl.style.display = 'none';

        if (reasonSel) {
            reasonSel.disabled = true;
            gdWidgetRestoreFullReason(reasonSel, reasons);
        }
    }

  });

  // Refresh summary and count after gift bag state changes
  gdWidgetUpdateCount(panel);
  gdWidgetToggleSummary(panel);
}


function gdWidgetRebuildGiftBagReason(selectEl, reasons) {
  if (!selectEl) return;
  const currentValue = selectEl.value;

  let options = '<option value="">Select a reason…</option>';
  reasons.forEach(r => {
    if (GD_WIDGET_GIFT_BAG_REASON_IDS.includes(String(r.id))) {
      options += `<option value="${r.id}"
                           data-name="${gdWidgetEscHtml(r.name)}"
                           data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
                           data-is-refund="${r.is_refund ? '1' : '0'}"
                           data-faulty="0"
                  >${gdWidgetEscHtml(r.name)}</option>`;
    }
  });
  selectEl.innerHTML = options;

  // Keep previous selection if it's still allowed
  if (currentValue && GD_WIDGET_GIFT_BAG_REASON_IDS.includes(currentValue)) {
    selectEl.value = currentValue;
  } else {
    selectEl.value = '';
  }
}

function gdWidgetRestoreFullReason(selectEl, reasons) {
  if (!selectEl) return;
  let options = '<option value="">Select a reason…</option>';
  reasons.forEach(r => {
    options += `<option value="${r.id}"
                         data-name="${gdWidgetEscHtml(r.name)}"
                         data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
                         data-is-refund="${r.is_refund ? '1' : '0'}"
                         data-faulty="${r.name.toLowerCase() === 'faulty' ? '1' : '0'}"
                >${gdWidgetEscHtml(r.name)}</option>`;
  });
  selectEl.innerHTML = options;
  selectEl.value = '';
}




function gdWidgetCheckAddToPrev(panel) {
  const wrapper = panel.querySelector('.gd-chat-widget-li-addtoprev-wrapper');
  if (!wrapper) return;

  // Get both stored arrays from panel data attributes
  let lastReturnItems = [];
  try { lastReturnItems = JSON.parse(panel.dataset.lastReturnItems || '[]'); } catch(e) { lastReturnItems = []; }

  let lastPendingFeesItems = [];
  try { lastPendingFeesItems = JSON.parse(panel.dataset.lastPendingFeesItems || '[]'); } catch(e) { lastPendingFeesItems = []; }

  // Three categories — mirrors portal toggleSummary() exactly
  const addWithPreviousLabelBrands = []; // complete_label brands within 48h
  const pendingFeeBrands           = []; // pending_label brands (fee not yet paid)
  const newLabelFeeBrands          = []; // brands with no prior label at all

  panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
  ).forEach(chk => {
    const card   = document.getElementById(`gd-chat-widget-card_${chk.dataset.uid}`);
    if (!card) return;

    const optVal = card.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected')?.dataset.opt;
    if (optVal !== 'return_label') return;

    const brandId = card.dataset.brandId;
    if (!brandId) return;

    // Check complete_label brands (within 48 hours) — mirrors portal lastReturnItems check
    const matchedComplete = lastReturnItems.find(item => String(item.brand_id) === String(brandId));
    if (matchedComplete) {
      const hoursDiff = Math.abs(new Date() - new Date(matchedComplete.requested_date)) / (1000 * 60 * 60);
      if (hoursDiff < 48) {
        addWithPreviousLabelBrands.push(matchedComplete);
      }
    }

    // Check pending_label brands — mirrors portal lastPendingFeesReturnItems check
    const matchedPending = lastPendingFeesItems.find(item => String(item.brand_id) === String(brandId));
    if (matchedPending) {
      pendingFeeBrands.push(matchedPending);
    }

    // If neither matched → new label fee needed — mirrors portal newLabelFeeBrands
    if (!matchedComplete && !matchedPending) {
      newLabelFeeBrands.push({ brand_id: brandId });
    }
  });

  // Store counts on wrapper so radio handler can read them — mirrors portal data attributes
  wrapper.dataset.newLabelFeeBrands          = newLabelFeeBrands.length;
  wrapper.dataset.addWithPreviousLabelBrands = addWithPreviousLabelBrands.length;
  wrapper.dataset.pendingFeeBrands           = pendingFeeBrands.length;

  // Show add-to-previous wrapper when applicable — mirrors portal show condition
  if (addWithPreviousLabelBrands.length > 0) {
    const brandNames = [...new Set(addWithPreviousLabelBrands.map(i => i.brand_name))];
    const formattedNames = brandNames.length > 1
      ? brandNames.slice(0, -1).join(', ') + ' and ' + brandNames[brandNames.length - 1]
      : brandNames[0];

    const contentEl = wrapper.querySelector('.gd-chat-widget-li-addtoprev-content');
    if (contentEl) {
      contentEl.innerHTML =
        `You recently requested returns for items from <strong>${formattedNames}</strong>.<br/>` +
        `If you haven't shipped them yet, you can use the same label for any new returns.<br/>` +
        `Have you sent the previous items?`;
    }
    wrapper.style.display = '';
  } else {
    wrapper.style.display = 'none';
    wrapper.querySelectorAll('.gd-chat-widget-li-addtoprev-radio').forEach(r => r.checked = false);
  }

  // KEY PORTAL LOGIC (lines 428-434): if all brands have pending fees and no new labels needed → fee is £0
  // Mirrors: if (refund-option checked && newLabelFeeBrands==0 && addWithPrevious==0 && pendingFee>0) → total-returns = 0.00
  const anyReturnLabelChecked = panel.querySelectorAll(
    '.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected[data-opt="return_label"]'
  ).length > 0;

  if (anyReturnLabelChecked &&
      newLabelFeeBrands.length    === 0 &&
      addWithPreviousLabelBrands.length === 0 &&
      pendingFeeBrands.length     > 0) {
    const feeValEl = panel.querySelector('.gd-chat-widget-li-sum-fee-val');
    const feeRow   = panel.querySelector('.gd-chat-widget-li-sum-return-label');
    if (feeValEl) feeValEl.textContent = '0.00';
    if (feeRow)   feeRow.style.display = '';
  }
}

function gdWidgetAddToPrevChange(radio) {
  const panel   = radio.closest('.gd-chat-widget-li-panel');
  const wrapper = radio.closest('.gd-chat-widget-li-addtoprev-wrapper');
  const feeValEl = panel.querySelector('.gd-chat-widget-li-sum-fee-val');
  const feeRow   = panel.querySelector('.gd-chat-widget-li-sum-return-label');
  const errEl    = wrapper?.querySelector('.gd-chat-widget-li-addtoprev-error');

  if (errEl) errEl.style.display = 'none';

  // Read stored counts from wrapper — mirrors portal data attributes
  const newLabelFeeBrands          = parseInt(wrapper?.dataset.newLabelFeeBrands          || '0', 10);
  const addWithPreviousLabelBrands = parseInt(wrapper?.dataset.addWithPreviousLabelBrands || '0', 10);

  if (radio.value === 'no') {
    // "No" = haven't sent yet = can add to previous label = fee is £0
    // Only zero the fee if no truly new label brands — mirrors portal click handler lines 242-250
    if (newLabelFeeBrands === 0 && addWithPreviousLabelBrands > 0) {
      if (feeValEl) feeValEl.textContent = '0.00';
      if (feeRow)   feeRow.style.display = '';
    }
  } else {
    // "Yes" = already sent = need new label = restore normal fee
    // Only restore if no new label brands — mirrors portal
    if (newLabelFeeBrands === 0 && addWithPreviousLabelBrands > 0) {
      gdWidgetUpdateSummary(panel);
    }
  }
}


// function gdWidgetRenderReturnOptions(uid, reasonId) {
//   const card      = document.getElementById(`gd-chat-widget-card_${uid}`);
//   const panel     = card?.closest('.gd-chat-widget-li-panel');
//   const optsEl    = document.getElementById(`gd-chat-widget-opts_${uid}`);
//   const cardsWrap = optsEl?.querySelector('.gd-chat-widget-li-opts-cards');
//   if (!cardsWrap || !panel || !card) return;

//   const returnFee  = parseFloat(panel.dataset.returnFee) || 0;
//   const isVip      = panel.dataset.isVip      === '1';
//   const selfShipOk = panel.dataset.isSelfShip === '1';
//   const partnerId  = parseInt(panel.dataset.partnerId, 10) || 1;

//   const grade          = (card.dataset.grade || '').toUpperCase();
//   const isOutlet       = card.dataset.isOutlet   === '1';
//   const isGoddiva      = card.dataset.isGoddiva  === '1';
//   const storeCreditAmt = parseFloat(card.dataset.storeCreditAmount) || 0;
//   const refundAmt      = parseFloat(card.dataset.refundAmount)      || 0;
//   const scPct          = parseFloat(card.dataset.storeCreditPct)    || 0;
//   const refPct         = parseFloat(card.dataset.refundPct)         || 0;

//   const freePartners = [5, 7, 11, 17,27];
//   const isFree       = isVip || freePartners.includes(partnerId);
//   const effectiveFee = isFree ? '0.00' : returnFee.toFixed(2);

//   const reasons     = gdWidgetGetPanelReasons(panel);
//   const checkReason = reasons.find(r => String(r.id) === String(reasonId));

//   // Grade B or C required for keep-item options — confirmed from API (Grade_C tag = grade "C")
//   const hasGradeTag = ['B', 'C'].includes(grade);

//   let html = '';

//   // Outlet + Goddiva → Return Label only
//   if (checkReason && isGoddiva && isOutlet) {
//     html += gdWidgetOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
//     cardsWrap.innerHTML = html;
//     return;
//   }

//   // Goddiva + Goddiva marketplace → conditional store credit / refund
//   if (checkReason && isGoddiva && partnerId === 1) {
//     if (checkReason.is_store_credit && hasGradeTag && storeCreditAmt > 0) {
//       html += gdWidgetOptCardHtml(uid, 'store_credit',
//         `£${storeCreditAmt.toFixed(2)} Store Credit (Keep the item)`, '');
//     }
//     if (checkReason.is_refund && hasGradeTag && refundAmt > 0) {
//       html += gdWidgetOptCardHtml(uid, 'refund',
//         `£${refundAmt.toFixed(2)} Refund (Keep the item)`, '');
//     }
//   }

//   // Return Label — always shown
//   html += gdWidgetOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);

//   // Self Ship — only if available at order level
//   if (selfShipOk) {
//     html += gdWidgetOptCardHtml(uid, 'self_ship', 'Self Ship', '');
//   }

//   cardsWrap.innerHTML = html;
// }

function gdWidgetRenderReturnOptions(uid, reasonId) {
  const card      = document.getElementById(`gd-chat-widget-card_${uid}`);
  const panel     = card?.closest('.gd-chat-widget-li-panel');
  const optsEl    = document.getElementById(`gd-chat-widget-opts_${uid}`);
  const cardsWrap = optsEl?.querySelector('.gd-chat-widget-li-opts-cards');
  if (!cardsWrap || !panel || !card) return;

  const returnFee  = parseFloat(panel.dataset.returnFee) || 0;
  const isVip      = panel.dataset.isVip      === '1';
  const selfShipOk = panel.dataset.isSelfShip === '1';
  const partnerId  = parseInt(panel.dataset.partnerId, 10) || 1;

  const shippingCode = panel.dataset.shippingCode || '';
  const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);

  const grade          = (card.dataset.grade || '').toUpperCase();
  const isOutlet       = card.dataset.isOutlet  === '1';
  const isGoddiva      = card.dataset.isGoddiva === '1';
  const storeCreditAmt = parseFloat(card.dataset.storeCreditAmount) || 0;
  const refundAmt      = parseFloat(card.dataset.refundAmount)      || 0;

  const freePartners = [5, 7, 11, 17, 27,29];
  const isFree       = isVip || freePartners.includes(partnerId);
  const effectiveFee = isFree ? '0.00' : returnFee.toFixed(2);

  const reasons     = gdWidgetGetPanelReasons(panel);
  const checkReason = reasons.find(r => String(r.id) === String(reasonId));
  const hasGradeTag = ['B', 'C'].includes(grade);

  let html = '';

  // Outlet + Goddiva → Return Label only (hidden for restricted)
  if (checkReason && isGoddiva && isOutlet) {
    if (!isRestricted) {
      html += gdWidgetOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
    }
    cardsWrap.innerHTML = html;
    return;
  }

  // Goddiva marketplace → conditional store credit / refund
  if (checkReason && isGoddiva && partnerId === 1) {
    if (checkReason.is_store_credit && hasGradeTag && storeCreditAmt > 0) {
      html += gdWidgetOptCardHtml(uid, 'store_credit',
        `£${storeCreditAmt.toFixed(2)} Store Credit (Keep the item)`, '');
    }
    if (checkReason.is_refund && hasGradeTag && refundAmt > 0) {
      html += gdWidgetOptCardHtml(uid, 'refund',
        `£${refundAmt.toFixed(2)} Refund (Keep the item)`, '');
    }
  }

  // Return Label — hidden for restricted countries
  if (!isRestricted) {
    html += gdWidgetOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
  }

  // Self Ship — only if available at order level
  if (selfShipOk) {
    html += gdWidgetOptCardHtml(uid, 'self_ship', 'Self Ship', '');
  }

  // Restricted country message
 if (isRestricted) {
  const msgId = `gd-chat-widget-intl-msg_${uid}`;
  html += `
    <button class="gd-chat-widget-li-view-details-btn"
            type="button"
            style="background:#dc2626;color:#fff;border-radius:8px;padding:6px 10px;width:100%;justify-content:space-between;"
            onclick="
              const msg = document.getElementById('${msgId}');
              const isHidden = msg.hasAttribute('hidden');
              msg.toggleAttribute('hidden', !isHidden);
              this.classList.toggle('gd-chat-widget-li-view-details-open', isHidden);
              if (isHidden) msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            ">
      ⚠ Important Note for Customer
      <span class="gd-chat-widget-li-chevron">▾</span>
    </button>
    <div id="${msgId}" class="gd-chat-widget-li-detail-panel" hidden style="font-size:11px;line-height:1.6;color:#374151;overflow-y:auto;max-height:200px;">
      <p style="margin:0 0 6px;">For international locations outside of the EU, USA, Canada, New Zealand, and Australia, customers are responsible for arranging and covering the cost of return postage.</p>
      <p style="margin:0 0 6px;">We recommend using a tracked shipping service with your local courier and ensuring that any applicable duties or taxes are covered.</p>
      <p style="margin:0 0 6px;">Please securely repackage your item(s) in waterproof, non-transparent packaging and include a copy of your order details inside the parcel.</p>
      <p style="margin:0 0 4px;"><strong>Return address:</strong></p>
      <p style="margin:0 0 6px;">Goddiva Returns<br/>CG House, 107B Chadwell Heath Lane<br/>Romford, Essex RM6 4NP<br/>United Kingdom</p>
      <p style="margin:0 0 6px;">Once your return has been received and processed, we will be in touch regarding your refund or exchange.</p>
    </div>`;
}

  cardsWrap.innerHTML = html;
}

function gdWidgetOptCardHtml(uid, optValue, title, desc, fee = null) {
  return `
    <div class="gd-chat-widget-li-opt-card"
         data-uid="${uid}"
         data-opt="${optValue}"
         ${fee !== null ? `data-return-fee="${fee}"` : ''}
         onclick="gdWidgetSelectOpt(this)">
      <div class="gd-chat-widget-li-radio"></div>
      <div class="gd-chat-widget-li-opt-text">
        <div class="gd-chat-widget-li-opt-title">${title}</div>
        ${desc ? `<div class="gd-chat-widget-li-opt-desc">${desc}</div>` : ''}
      </div>
    </div>
  `;
}


// ─────────────────────────────────────────────────────────────
// OPTION DESCRIPTION — mirrors portal updateDescription()
// ─────────────────────────────────────────────────────────────

function gdWidgetUpdateOptDescription(uid) {
  const descEl = document.getElementById(`gd-chat-widget-optDesc_${uid}`);
  if (!descEl) return;

  const card      = document.getElementById(`gd-chat-widget-card_${uid}`);
  const panel     = card?.closest('.gd-chat-widget-li-panel');
  const isVip     = panel?.dataset.isVip === '1';
  const partnerId = parseInt(panel?.dataset.partnerId || '1', 10);
  const freePartners = [5, 7, 11, 17,27,29];
  const isFree    = isVip || freePartners.includes(partnerId);
  const isOutletCard = card?.dataset.isOutlet === '1';

  const optCard  = card?.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected');
  const optValue = optCard?.dataset.opt || '';
  const scAmt    = parseFloat(card?.dataset.storeCreditAmount || 0);
  const refAmt   = parseFloat(card?.dataset.refundAmount      || 0);
  const qty      = parseInt(card?.querySelector('.gd-chat-widget-li-qty')?.textContent || 1, 10);

  const descriptions = {
    store_credit : `Keep the item and receive a gift card worth £${(scAmt * qty).toFixed(2)}. Note: To receive a full refund, please select Return Label or Self Ship instead.`,
    refund       : `Keep the item and get a refund of £${(refAmt * qty).toFixed(2)} to your original payment method. Note: To receive a full refund, please select Return Label or Self Ship instead.`,
    return_label : isOutletCard
      ? ''
      : isFree
        ? 'You can download a return label to send the item back.'
        : 'You will be charged a small fee for all items selected for return. Once paid, you can download the return label.',
    self_ship    : 'Receive a return note and ship the item back at your own expense.',
  };

  descEl.textContent = descriptions[optValue] || '';
}


function gdWidgetToggleSummary(panel) {
  const summary = panel.querySelector('.gd-chat-widget-li-summary');
  if (!summary) return;

  const checkedWithOption = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
  )].some(chk => {
    const card = document.getElementById(`gd-chat-widget-card_${chk.dataset.uid}`);
    return card?.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected');
  });

  // Also show summary if any checked item has a reason selected (even without option yet)
  const checkedWithReason = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
  )].some(chk => {
    const card = document.getElementById(`gd-chat-widget-card_${chk.dataset.uid}`);
    const reasonSel = card?.querySelector('.gd-chat-widget-li-reason');
    return reasonSel && reasonSel.value !== '';
  });

  const hasAnyOption = checkedWithOption;

  summary.style.display = hasAnyOption ? 'block' : 'none';
  if (hasAnyOption) {
    gdWidgetUpdateSummary(panel);
    gdWidgetCheckAddToPrev(panel);
  }
}

function gdWidgetUpdateSummary(panel) {
  const checkedChks = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
  )];

  const partnerId    = parseInt(panel.dataset.partnerId || '1', 10);
  const isVip        = panel.dataset.isVip === '1';
  const freePartners = [5, 7, 11, 17,27,29];
  const isFree       = isVip || freePartners.includes(partnerId);
  const returnFee    = isFree ? 0 : parseFloat(panel.dataset.returnFee || 0);

  let totalSC        = 0;
  let totalRefund    = 0;
  let totalFee       = 0;
  let totalSelfShip  = 0;
  let returnFeeAdded = false; // fee added only once per order — mirrors portal

  checkedChks.forEach(chk => {
    const uid    = chk.dataset.uid;
    const card   = document.getElementById(`gd-chat-widget-card_${uid}`);
    if (!card) return;
    const qty    = parseInt(card.querySelector('.gd-chat-widget-li-qty')?.textContent || 1, 10);
    const optVal = card.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected')?.dataset.opt || '';
    const scAmt  = parseFloat(card.dataset.storeCreditAmount || 0);
    const refAmt = parseFloat(card.dataset.refundAmount      || 0);

    if (optVal === 'store_credit') totalSC       += scAmt * qty;
    if (optVal === 'refund')       totalRefund   += refAmt * qty;
    if (optVal === 'self_ship')    totalSelfShip += qty;
    if (optVal === 'return_label' && !returnFeeAdded && returnFee > 0) {
      totalFee += returnFee;
      returnFeeAdded = true;
    }
  });

  const showRow = (sel, condition) => {
    const row = panel.querySelector(sel);
    if (row) row.style.display = condition ? '' : 'none';
  };
  showRow('.gd-chat-widget-li-sum-store-credit', totalSC       > 0);
  showRow('.gd-chat-widget-li-sum-refund',        totalRefund   > 0);
  showRow('.gd-chat-widget-li-sum-return-label',  totalFee      > 0);
  showRow('.gd-chat-widget-li-sum-self-ship',     totalSelfShip > 0);

  const q = s => panel.querySelector(s);
  if (q('.gd-chat-widget-li-sum-sc-val'))  q('.gd-chat-widget-li-sum-sc-val').textContent  = totalSC.toFixed(2);
  if (q('.gd-chat-widget-li-sum-ref-val')) q('.gd-chat-widget-li-sum-ref-val').textContent = totalRefund.toFixed(2);
  if (q('.gd-chat-widget-li-sum-fee-val')) q('.gd-chat-widget-li-sum-fee-val').textContent = totalFee.toFixed(2);
  if (q('.gd-chat-widget-li-sum-ss-val'))  q('.gd-chat-widget-li-sum-ss-val').textContent  = totalSelfShip;
}


// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function gdWidgetOnCheckboxChange(chk) {
  const uid  = chk.dataset.uid;
  const card = chk.closest('.gd-chat-widget-li-card');
  const panel = chk.closest('.gd-chat-widget-li-panel');

  if (!chk.checked) {
    gdWidgetResetCard(uid);
  } else {
    // Gift bag checked → rebuild reason dropdown to allowed reasons only
    if (card && card.dataset.isGiftBag === '1') {
      const reasons   = gdWidgetGetPanelReasons(panel);
      const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
      if (reasonSel) gdWidgetRebuildGiftBagReason(reasonSel, reasons);
    }

    // Outlet checked → auto-select "Yes" radio and show form
    if (card && card.dataset.isOutlet === '1') {
      const yesRadio = card.querySelector('.gd-chat-widget-li-outlet-radio[value="yes"]');
      if (yesRadio && !yesRadio.checked) {
        yesRadio.checked = true;
        gdWidgetOutletRadioChange(yesRadio);
      }
    }
  }

  gdWidgetUpdateCount(panel);
  gdWidgetToggleSummary(panel);

  // FIX: always update gift bag state on any checkbox change
  gdWidgetUpdateGiftBag(panel);
}

function gdWidgetResetCard(uid) {
  const card = document.getElementById(`gd-chat-widget-card_${uid}`);
  if (!card) return;

  const qtyEl  = card.querySelector('.gd-chat-widget-li-qty');
  if (qtyEl) qtyEl.textContent = 1;

    const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
    if (reasonSel) {
        // Restore full reasons if it's a gift bag
        if (card.dataset.isGiftBag === '1') {
        const panel   = card.closest('.gd-chat-widget-li-panel');
        const reasons = gdWidgetGetPanelReasons(panel);
        gdWidgetRestoreFullReason(reasonSel, reasons);
        } else {
        reasonSel.value = '';
        }
    }

    const specificEl = document.getElementById(`gd-chat-widget-specificReason_${uid}`);
    if (specificEl) {
    specificEl.style.display = 'none';
    specificEl.value = '';
    }
    const specificErrEl = document.getElementById(`gd-chat-widget-specificReasonErr_${uid}`);
    if (specificErrEl) specificErrEl.hidden = true;


    const optsPanel = document.getElementById(`gd-chat-widget-opts_${uid}`);
    if (optsPanel) {
        optsPanel.setAttribute('hidden', '');
        const cardsWrap = optsPanel.querySelector('.gd-chat-widget-li-opts-cards');
        if (cardsWrap) cardsWrap.innerHTML = '';
        optsPanel.classList.remove('gd-chat-widget-li-opts-error');
        const optErr = document.getElementById(`gd-chat-widget-optErr_${uid}`);
        if (optErr) optErr.hidden = true;
    }

    const descEl = document.getElementById(`gd-chat-widget-optDesc_${uid}`);
    if (descEl) descEl.textContent = '';

    const detPanel = document.getElementById(`gd-chat-widget-det_${uid}`);
    if (detPanel) detPanel.setAttribute('hidden', '');
    const detBtn = card.querySelector('.gd-chat-widget-li-view-details-btn');
    if (detBtn) detBtn.classList.remove('gd-chat-widget-li-view-details-open');

    gdWidgetFaultyReset(uid);

    const fltEl = document.getElementById(`gd-chat-widget-flt_${uid}`);
    if (fltEl) fltEl.setAttribute('hidden', '');

    const card4 = document.getElementById(`gd-chat-widget-card_${uid}`);
    if (card4) card4.dataset.isFaultyReason = '0';

    
    const panel5    = document.getElementById(`gd-chat-widget-card_${uid}`)?.closest('.gd-chat-widget-li-panel');
    const termsChk  = panel5?.querySelector('.gd-chat-widget-li-terms-chk');
    const termsErr  = panel5?.querySelector('.gd-chat-widget-li-terms-error');
    // Only uncheck T&C if no items remain checked after this reset
    const stillChecked = panel5?.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
    ).length;
    if (!stillChecked) {
    if (termsChk) termsChk.checked = false;
    if (termsErr) termsErr.style.display = 'none';
    }

    const outletRadios = card?.querySelectorAll('.gd-chat-widget-li-outlet-radio');
    if (outletRadios?.length) {
    outletRadios.forEach(r => r.checked = false);
    const rowEl = card.querySelector('.gd-chat-widget-li-outlet-row');
    const noMsg = card.querySelector('.gd-chat-widget-li-outlet-no-msg');
    if (rowEl) rowEl.style.display = 'none';
    if (noMsg) noMsg.style.display = 'none';
    // Re-disable the reason select for outlet items (form hidden until Yes)
    const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
    if (reasonSel && card.dataset.isOutlet === '1') reasonSel.disabled = true;
    // NOTE: checkbox stays enabled so user can re-click it
    }

    gdWidgetClearCardErrors(card);
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// FIX: calls gdWidgetUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function gdWidgetChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`gd-chat-widget-card_${uid}`);
  const qtyEl  = btn.closest('.gd-chat-widget-li-stepper').querySelector('.gd-chat-widget-li-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);
  val          = Math.min(maxQty, Math.max(1, val + delta));
  qtyEl.textContent = val;

  gdWidgetAutoCheck(uid);
  gdWidgetUpdateOptDescription(uid);

  const panel = card?.closest('.gd-chat-widget-li-panel');
  if (panel) {
    gdWidgetToggleSummary(panel);
    gdWidgetUpdateGiftBag(panel); // FIX: update gift bag on qty change
  }
}


// ─────────────────────────────────────────────────────────────
// REASON DROPDOWN
// FIX: calls gdWidgetUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function gdWidgetOnReasonChange(sel) {
  const uid    = sel.dataset.uid;
  const optsEl = document.getElementById(`gd-chat-widget-opts_${uid}`);
  const fltEl  = document.getElementById(`gd-chat-widget-flt_${uid}`);
  const descEl = document.getElementById(`gd-chat-widget-optDesc_${uid}`);
  const hasVal = sel.value !== '';

  const selectedOpt = sel.options[sel.selectedIndex];
  const isFaulty    = selectedOpt && selectedOpt.dataset.faulty === '1';
  const isOther      = selectedOpt && selectedOpt.text === 'Other';


  const specificEl   = document.getElementById(`gd-chat-widget-specificReason_${uid}`);
  const specificErrEl = document.getElementById(`gd-chat-widget-specificReasonErr_${uid}`);
  if (specificEl) {                                                                           
    specificEl.style.display = isOther ? '' : 'none';                                          
    if (!isOther) specificEl.value = '';                                                       
  }                                                                                           
  if (specificErrEl) specificErrEl.hidden = true;  


  sel.classList.remove('gd-chat-widget-li-field-error');
  sel.closest('.gd-chat-widget-li-reason-wrap')
     .querySelector('.gd-chat-widget-li-error-msg:not([id])')?.remove();

  if (descEl) descEl.textContent = '';

  if (optsEl) {
    if (!hasVal) {
      optsEl.setAttribute('hidden', '');
      const cardsWrap = optsEl.querySelector('.gd-chat-widget-li-opts-cards');
      if (cardsWrap) cardsWrap.innerHTML = '';
      optsEl.classList.remove('gd-chat-widget-li-opts-error');
      const optErr = document.getElementById(`gd-chat-widget-optErr_${uid}`);
      if (optErr) optErr.hidden = true;
    } else {
      gdWidgetRenderReturnOptions(uid, sel.value);
      optsEl.removeAttribute('hidden');
    }
  }
  
    if (fltEl) {
        fltEl.setAttribute('hidden', '');
        gdWidgetFaultyReset(uid);
    }

    const card3 = document.getElementById(`gd-chat-widget-card_${uid}`);
    if (card3) card3.dataset.isFaultyReason = isFaulty ? '1' : '0';

  gdWidgetAutoCheck(uid);

  const panel = sel.closest('.gd-chat-widget-li-panel');
  if (panel) {
    gdWidgetToggleSummary(panel);
    gdWidgetUpdateGiftBag(panel);

    // Too Big / Too Long popup — Goddiva items + partner 1 only (reason 4 = Too Big, 6 = Too Long)
    const card2     = document.getElementById(`gd-chat-widget-card_${uid}`);
    const isGoddiva = card2?.dataset.isGoddiva === '1';
    const partnerId = parseInt(panel.dataset.partnerId || '1', 10);
    if (isGoddiva && partnerId === 1 && (sel.value === '4' || sel.value === '6')) {
     // gdWidgetTbtlOpen(panel.id, uid);
    } else {
     // gdWidgetTbtlClose(panel.id);
    }
  }
}


// ─────────────────────────────────────────────────────────────
// AUTO-CHECK HELPER
// ─────────────────────────────────────────────────────────────

function gdWidgetAutoCheck(uid) {
  const chk = document.getElementById(`gd-chat-widget-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.gd-chat-widget-li-panel');
  if (panel) gdWidgetUpdateCount(panel);
}


// ─────────────────────────────────────────────────────────────
// OPTION SELECTION
// FIX: calls gdWidgetUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function gdWidgetSelectOpt(card) {
  const uid  = card.dataset.uid;
  const opts = card.closest('.gd-chat-widget-li-opts');

  opts.querySelectorAll('.gd-chat-widget-li-opt-card')
      .forEach(s => s.classList.remove('gd-chat-widget-li-opt-selected'));
  card.classList.add('gd-chat-widget-li-opt-selected');

  opts.classList.remove('gd-chat-widget-li-opts-error');
  const optErr = document.getElementById(`gd-chat-widget-optErr_${uid}`);
  if (optErr) optErr.hidden = true;

  const fltEl       = document.getElementById(`gd-chat-widget-flt_${uid}`);
  const optValue    = card.dataset.opt;
  const isFaulty    = document.getElementById(`gd-chat-widget-card_${uid}`)?.dataset.isFaultyReason === '1';

  if (fltEl) {
    if (isFaulty && optValue === 'return_label') {
      fltEl.removeAttribute('hidden');
    } else {
      fltEl.setAttribute('hidden', '');
      gdWidgetFaultyReset(uid);
    }
  }


  gdWidgetUpdateOptDescription(uid);

  const panel = card.closest('.gd-chat-widget-li-panel');
  if (panel) {
    gdWidgetUpdateCount(panel);
    gdWidgetToggleSummary(panel);
    gdWidgetUpdateGiftBag(panel);
    gdWidgetCheckAddToPrev(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// VIEW DETAILS
// ─────────────────────────────────────────────────────────────

function gdWidgetToggleDetails(btn, panelId) {
  const panel  = document.getElementById(panelId);
  if (!panel) return;
  const isOpen = panel.hasAttribute('hidden');
  panel.toggleAttribute('hidden', !isOpen);
  btn.classList.toggle('gd-chat-widget-li-view-details-open', isOpen);
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function gdWidgetToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.gd-chat-widget-li-panel');
  const itemChks = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) gdWidgetResetCard(c.dataset.uid);
  });
  gdWidgetUpdateCount(panel);
  gdWidgetToggleSummary(panel);
  gdWidgetUpdateGiftBag(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function gdWidgetUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.gd-chat-widget-li-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.gd-chat-widget-li-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  // Show/hide T&C wrapper — mirrors portal toggleSubmitBtn()
  const termsWrapper = panel.querySelector('.gd-chat-widget-li-terms-wrapper');
  if (termsWrapper) {
    termsWrapper.style.display = count > 0 ? '' : 'none';
    // Clear terms error when items unchecked
    if (count === 0) {
      const termsErr = panel.querySelector('.gd-chat-widget-li-terms-error');
      if (termsErr) termsErr.style.display = 'none';
    }
  }

  if (count === 0) {
    const addToPrevWrapper = panel.querySelector('.gd-chat-widget-li-addtoprev-wrapper');
    if (addToPrevWrapper) {
        addToPrevWrapper.style.display = 'none';
        addToPrevWrapper.querySelectorAll('.gd-chat-widget-li-addtoprev-radio')
                        .forEach(r => r.checked = false);
        const err = addToPrevWrapper.querySelector('.gd-chat-widget-li-addtoprev-error');
        if (err) err.style.display = 'none';
    }
    }

  const allValid = count > 0 && gdWidgetValidateSelected(checkedChks, false);
  const btn      = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('gd-chat-widget-li-process-active', allValid);
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION
// ─────────────────────────────────────────────────────────────

function gdWidgetValidateSelected(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid  = chk.dataset.uid;
    const card = document.getElementById(`gd-chat-widget-card_${uid}`);
    if (!card) return;

    const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
    if (!reasonSel || reasonSel.value === '') {
      allValid = false;
      if (showErrors) gdWidgetShowFieldError(reasonSel, 'Please select a return reason');
    }

   
    const selectedReasonText = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    if (selectedReasonText === 'Other') {
    const specificEl = document.getElementById(`gd-chat-widget-specificReason_${uid}`);
    if (!specificEl || !specificEl.value.trim()) {
        allValid = false;
        if (showErrors) {
        const specificErrEl = document.getElementById(`gd-chat-widget-specificReasonErr_${uid}`);
        if (specificErrEl) specificErrEl.hidden = false;
        }
    }
    }

    const optsPanel = document.getElementById(`gd-chat-widget-opts_${uid}`);
    if (optsPanel && !optsPanel.hasAttribute('hidden')) {
      if (!optsPanel.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected')) {
        allValid = false;
        if (showErrors) {
          optsPanel.classList.add('gd-chat-widget-li-opts-error');
          const optErr = document.getElementById(`gd-chat-widget-optErr_${uid}`);
          if (optErr) optErr.hidden = false;
        }
      }
    }

    const fltPanel = document.getElementById(`gd-chat-widget-flt_${uid}`);
    if (fltPanel && !fltPanel.hasAttribute('hidden')) {
      const files = gdWidgetFaultyGetFiles(uid);
      if (files.length > 0 && files.length < GD_WIDGET_FAULTY_MIN) {
        allValid = false;
        if (showErrors) {
          const fltErr = document.getElementById(`gd-chat-widget-fltErr_${uid}`);
          if (fltErr) fltErr.hidden = false;
        }
      }
    }


  });

  return allValid;
}

function gdWidgetShowFieldError(field, message) {
  if (!field) return;
  field.classList.add('gd-chat-widget-li-field-error');
  const wrap = field.closest('.gd-chat-widget-li-reason-wrap');
  if (wrap && !wrap.querySelector('.gd-chat-widget-li-error-msg:not([id])')) {
    const msg       = document.createElement('span');
    msg.className   = 'gd-chat-widget-li-error-msg';
    msg.textContent = message;
    wrap.appendChild(msg);
  }
}

function gdWidgetClearCardErrors(card) {
  if (!card) return;
  card.querySelectorAll('.gd-chat-widget-li-field-error').forEach(el => el.classList.remove('gd-chat-widget-li-field-error'));
  card.querySelectorAll('.gd-chat-widget-li-error-msg:not([id])').forEach(el => el.remove());
  card.querySelectorAll('.gd-chat-widget-li-opts-error').forEach(el => el.classList.remove('gd-chat-widget-li-opts-error'));
  const uid    = card.id.replace('gd-chat-widget-card_', '');
  const optErr = document.getElementById(`gd-chat-widget-optErr_${uid}`);
  if (optErr) optErr.hidden = true;
  const fltErr = document.getElementById(`gd-chat-widget-fltErr_${uid}`);
  if (fltErr) fltErr.hidden = true;
  const uid2 = card.id.replace('gd-chat-widget-card_', '');
  const specificErrEl = document.getElementById(`gd-chat-widget-specificReasonErr_${uid2}`);
  if (specificErrEl) specificErrEl.hidden = true;
}


// ─────────────────────────────────────────────────────────────
// FAULTY IMAGE UPLOAD
// ─────────────────────────────────────────────────────────────

const GD_WIDGET_FAULTY_MIN  = 3;
const GD_WIDGET_FAULTY_MAX  = 3;
const GD_WIDGET_FAULTY_SIZE = 5 * 1024 * 1024;

function gdWidgetFaultyImagesAdded(input) {
  const uid         = input.dataset.uid;
  const existing    = gdWidgetFaultyGetFiles(uid);
  const incoming    = [...input.files];
  const errorMsgs   = [];
  const limitErrors = [];

  // Allowed types — mirrors portal exactly
  const allowedTypes = { 'image/jpeg': true, 'image/png': true, 'image/jpg': true };

  incoming.forEach(f => {
    if (!allowedTypes[f.type]) {
      errorMsgs.push(`${f.name} — not a valid image (JPG/PNG only).`);
      return;
    }
    if (f.size > GD_WIDGET_FAULTY_SIZE) {
      errorMsgs.push(`${f.name} exceeds 5MB.`);
      return;
    }
    if (existing.find(e => e.name === f.name && e.size === f.size)) { return; }
    if (existing.length >= GD_WIDGET_FAULTY_MAX) { limitErrors.push(f.name); return; }
    // Rename with timestamp — mirrors portal new File([file], `${Date.now()}-${file.name}`)
    const renamed = new File([f], `${Date.now()}-${f.name}`, { type: f.type, lastModified: f.lastModified });
    existing.push(renamed);
  });

  gdWidgetFaultySetFiles(uid, existing);
  gdWidgetFaultyRenderPreviews(uid);
  gdWidgetFaultyClearError(uid);

  const warnEl = document.getElementById(`gd-chat-widget-fltWarn_${uid}`);
  if (warnEl) {
    const msgs = [...errorMsgs];
    if (limitErrors.length) msgs.push(`Max ${GD_WIDGET_FAULTY_MAX} images allowed. ${limitErrors.length} file(s) were skipped.`);
    warnEl.textContent = msgs.join(' ');
    warnEl.hidden      = msgs.length === 0;
  }

  input.value = '';
  const panel = input.closest('.gd-chat-widget-li-panel');
  if (panel) gdWidgetUpdateCount(panel);
}

function gdWidgetFaultyRemove(uid, index) {
  const files = gdWidgetFaultyGetFiles(uid);
  files.splice(index, 1);
  gdWidgetFaultySetFiles(uid, files);
  gdWidgetFaultyRenderPreviews(uid);
  gdWidgetFaultyClearError(uid);
  const card  = document.getElementById(`gd-chat-widget-card_${uid}`);
  const panel = card?.closest('.gd-chat-widget-li-panel');
  if (panel) gdWidgetUpdateCount(panel);
}

function gdWidgetFaultyPreview(uid, index) {
  const card    = document.getElementById(`gd-chat-widget-card_${uid}`);
  const panel   = card?.closest('.gd-chat-widget-li-panel');
  const panelId = panel?.id;
  if (!panelId) return;
  gdWidgetFaultyPopupOpen(panelId, uid, index);
}

function gdWidgetFaultyRenderPreviews(uid) {
  const container = document.getElementById(`gd-chat-widget-fltPreviews_${uid}`);
  if (!container) return;
  container.querySelectorAll('img').forEach(img => URL.revokeObjectURL(img.src));
  const files = gdWidgetFaultyGetFiles(uid);
  if (!files.length) { container.innerHTML = ''; return; }
  container.innerHTML = files.map((f, i) => {
    const url = URL.createObjectURL(f);
    return `
      <div class="gd-chat-widget-li-faulty-thumb">
        <img src="${url}" alt="${gdWidgetEscHtml(f.name)}"
             onclick="gdWidgetFaultyPreview('${uid}', ${i})" title="Click to preview" />
        <button type="button" class="gd-chat-widget-li-faulty-remove"
                onclick="gdWidgetFaultyRemove('${uid}', ${i})" title="Remove">✕</button>
        <div class="gd-chat-widget-li-faulty-thumb-name">${gdWidgetEscHtml(f.name)}</div>
      </div>`;
  }).join('');
}

function gdWidgetFaultyReset(uid) {
  gdWidgetFaultySetFiles(uid, []);
  const container = document.getElementById(`gd-chat-widget-fltPreviews_${uid}`);
  if (container) {
    container.querySelectorAll('img').forEach(img => URL.revokeObjectURL(img.src));
    container.innerHTML = '';
  }
  gdWidgetFaultyClearError(uid);
  const input = document.getElementById(`gd-chat-widget-fltInput_${uid}`);
  if (input) input.value = '';
}

function gdWidgetFaultyClearError(uid) {
  const err  = document.getElementById(`gd-chat-widget-fltErr_${uid}`);
  if (err) err.hidden = true;
  const warn = document.getElementById(`gd-chat-widget-fltWarn_${uid}`);
  if (warn) { warn.hidden = true; warn.textContent = ''; }
}

const _gdWidgetFaultyFiles = {};
function gdWidgetFaultyGetFiles(uid)      { return _gdWidgetFaultyFiles[uid] || []; }
function gdWidgetFaultySetFiles(uid, arr) { _gdWidgetFaultyFiles[uid] = arr; }


// ─────────────────────────────────────────────────────────────
// IMAGE PREVIEW POPUP
// ─────────────────────────────────────────────────────────────

const _gdWidgetPopupState = {};

function gdWidgetFaultyPopupOpen(panelId, uid, index) {
  _gdWidgetPopupState[panelId] = { uid, index };
  _gdWidgetPopupRender(panelId);
  const popup = document.getElementById(`gd-chat-widget-img-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}

function gdWidgetFaultyPopupClose(panelId) {
  const popup = document.getElementById(`gd-chat-widget-img-popup_${panelId}`);
  if (popup) {
    const img = popup.querySelector('img');
    if (img && img.src.startsWith('blob:')) URL.revokeObjectURL(img.src);
    popup.setAttribute('hidden', '');
  }
  delete _gdWidgetPopupState[panelId];
}

function gdWidgetFaultyPopupNav(panelId, direction) {
  const state = _gdWidgetPopupState[panelId];
  if (!state) return;
  const files = gdWidgetFaultyGetFiles(state.uid);
  if (!files.length) return;
  state.index = (state.index + direction + files.length) % files.length;
  _gdWidgetPopupRender(panelId);
}

function _gdWidgetPopupRender(panelId) {
  const state   = _gdWidgetPopupState[panelId];
  if (!state) return;
  const files   = gdWidgetFaultyGetFiles(state.uid);
  const file    = files[state.index];
  if (!file) return;

  const imgEl   = document.getElementById(`gd-chat-widget-img-popup-img_${panelId}`);
  const counter = document.getElementById(`gd-chat-widget-img-popup-counter_${panelId}`);
  const popup   = document.getElementById(`gd-chat-widget-img-popup_${panelId}`);

  if (imgEl && imgEl.src.startsWith('blob:')) URL.revokeObjectURL(imgEl.src);
  if (imgEl)   imgEl.src = URL.createObjectURL(file);
  if (counter) counter.textContent = `${state.index + 1} / ${files.length}`;

  if (popup) {
    const showNav = files.length > 1;
    const prev = popup.querySelector('.gd-chat-widget-img-popup-prev');
    const next = popup.querySelector('.gd-chat-widget-img-popup-next');
    if (prev) prev.style.visibility = showNav ? '' : 'hidden';
    if (next) next.style.visibility = showNav ? '' : 'hidden';
  }
}

document.addEventListener('keydown', function (e) {
  const openPopup = document.querySelector('.gd-chat-widget-img-popup:not([hidden])');
  if (!openPopup) return;
  const panelId = openPopup.id.replace('gd-chat-widget-img-popup_', '');
  if (e.key === 'ArrowRight') gdWidgetFaultyPopupNav(panelId, 1);
  if (e.key === 'ArrowLeft')  gdWidgetFaultyPopupNav(panelId, -1);
  if (e.key === 'Escape')     gdWidgetFaultyPopupClose(panelId);
});


function gdWidgetOutletRadioChange(radio) {
  const uid   = radio.dataset.uid;
  const card  = document.getElementById(`gd-chat-widget-card_${uid}`);
  const panel = card?.closest('.gd-chat-widget-li-panel');
  const chk   = document.getElementById(`gd-chat-widget-chk_${uid}`);
  const rowEl = card?.querySelector('.gd-chat-widget-li-outlet-row');
  const noMsg = card?.querySelector('.gd-chat-widget-li-outlet-no-msg');

  if (radio.value === 'yes') {
    if (rowEl) rowEl.style.display = 'flex';
    if (noMsg) noMsg.style.display = 'none';
    // Enable reason select and check the card checkbox
    const reasonSel = card?.querySelector('.gd-chat-widget-li-reason');
    if (reasonSel) reasonSel.disabled = false;
    if (chk) {
      chk.disabled = false;
      chk.checked  = true;
    }
  } else {
    if (rowEl) rowEl.style.display = 'none';
    if (noMsg) noMsg.style.display = '';
    // Uncheck but keep checkbox enabled so user can re-click
    if (chk) {
      chk.checked = false;
      // chk.disabled = true;  ← REMOVED: keep enabled so user can re-click
    }
    gdWidgetResetCard(uid);
    if (noMsg) noMsg.style.display = '';
    radio.checked = true;
  }

  if (panel) {
    gdWidgetUpdateCount(panel);
    gdWidgetToggleSummary(panel);
    gdWidgetUpdateGiftBag(panel);
  }
}


// Freeze a panel — disable all interaction, show status message
function gdWidgetFreezePanel(panel, message) {
  // Disable all checkboxes, selects, buttons
  panel.querySelectorAll('input, select, button, textarea').forEach(el => {
    el.disabled = true;
  });
  panel.classList.add('gd-chat-widget-li-panel-frozen');

  // Replace the process button with a status message
  const btn = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.textContent = message || 'Submitted';
    btn.classList.add('gd-chat-widget-li-process-done');
  }
}

// Unfreeze on error — allow retry
function gdWidgetUnfreezePanel(panel) {
  panel.querySelectorAll('input, select, button, textarea').forEach(el => {
    el.disabled = false;
  });
  panel.classList.remove('gd-chat-widget-li-panel-frozen');

  const btn = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.textContent = 'PROCESS RETURN';
    btn.classList.remove('gd-chat-widget-li-process-done');
  }

  // Re-run gift bag and count to restore correct disabled states
  gdWidgetUpdateGiftBag(panel);
  gdWidgetUpdateCount(panel);
}

// ─────────────────────────────────────────────────────────────
// TOO BIG / TOO LONG POPUP
// Triggered by reason 4 (Too Big) or 6 (Too Long) for Goddiva + partner 1
// ─────────────────────────────────────────────────────────────

function gdWidgetTbtlOpen(panelId) {
  const popup = document.getElementById(`gd-chat-widget-tbtl-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}

function gdWidgetTbtlClose(panelId) {
  const popup = document.getElementById(`gd-chat-widget-tbtl-popup_${panelId}`);
  if (popup) popup.setAttribute('hidden', '');
}


// ─────────────────────────────────────────────────────────────
// NON-RETURNABLE ITEMS — rendered inside the return grid
// Mirrors portal getNonReturnableItemHtml(data)
// data.nonReturnableItems is a separate API array (earrings/skincare hygiene items)
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderNonReturnableItems(lineItemsData) {
  const sellers = lineItemsData.nonReturnableItems || [];
  if (!sellers.length) return '';
  const isActive = lineItemsData.is_active_date == 1;

  return sellers.flatMap(seller => (seller.items || []).map((item, i) => {
    const uid = `nonret_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = price !== gross
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    return `
      <div class="gd-chat-widget-li-card gd-chat-widget-li-card-disabled">
        <div class="gd-chat-widget-li-img-wrap">
          <div class="gd-chat-widget-li-img">
            ${item.image
              ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
              : `<div class="gd-chat-widget-li-img-placeholder">G</div>`}
          </div>
          <div class="gd-chat-widget-li-badges">
            <div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-warn">Non-Returnable</div>
          </div>
        </div>
        <div class="gd-chat-widget-li-body">
          <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
          <div class="gd-chat-widget-li-price">${priceHtml}</div>

          <button class="gd-chat-widget-li-view-details-btn" type="button"
                  onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-det_${uid}')">
            ${gdWidgetInfoIcon()} View Details
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div id="gd-chat-widget-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
            <div class="gd-chat-widget-li-detail-grid">
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Size</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Colour</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">SKU</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Qty</div>
                <div class="gd-chat-widget-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Brand</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || seller.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Tracking</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)} — ${gdWidgetEscHtml(item.tracking_id || '')}</div>
              </div>` : ''}
            </div>
          </div>

          ${isActive
            ? `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
                 Please note: All earrings / skin care / hair care, etc. items cannot be
                 returned/exchanged for hygiene reasons.
               </p>
               <p style="font-size:11px;">If you have any questions, please contact
                 <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
               </p>`
            : `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
                 The return period has passed. Please contact customer service at
                 <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
               </p>`}
        </div>
      </div>`;
  })).join('');
}

// ─────────────────────────────────────────────────────────────
// PROCESS RETURN
// ─────────────────────────────────────────────────────────────
function gdWidgetHandleProcessReturn(btn) {
  const panel       = btn.closest('.gd-chat-widget-li-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.gd-chat-widget-li-checkbox:not(.gd-chat-widget-li-select-all-chk):checked'
  )];
 
  if (!gdWidgetValidateSelected(checkedChks, true)) {
    gdWidgetScrollToFirstError(panel);
    gdWidgetToast('Please fill all required fields', 'warning');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.gd-chat-widget-li-terms-chk');
  const termsErr = panel.querySelector('.gd-chat-widget-li-terms-error');
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    gdWidgetToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  // Add to previous label validation
  const addToPrevWrapper = panel.querySelector('.gd-chat-widget-li-addtoprev-wrapper');
  const addToPrevErr     = panel.querySelector('.gd-chat-widget-li-addtoprev-error');
  if (addToPrevWrapper && addToPrevWrapper.style.display !== 'none') {
    const selectedRadio = addToPrevWrapper.querySelector('.gd-chat-widget-li-addtoprev-radio:checked');
    if (!selectedRadio) {
      if (addToPrevErr) addToPrevErr.style.display = '';
      gdWidgetToast('Please choose Yes or No for previous label', 'warning');
      return;
    }
    if (addToPrevErr) addToPrevErr.style.display = 'none';
  }
 
  // Build items array
  const addToPrevRadio       = addToPrevWrapper?.querySelector('.gd-chat-widget-li-addtoprev-radio:checked');
  const addWithPreviousLabel = addToPrevRadio?.value === 'no';
  const termsAccepted        = termsChk ? termsChk.checked : false;
  const panelId              = panel.id;
 
  const items = checkedChks.map(chk => {
    const uid       = chk.dataset.uid;
    const card      = document.getElementById(`gd-chat-widget-card_${uid}`);
    const reasonSel = card.querySelector('.gd-chat-widget-li-reason');
    const reason_id = reasonSel?.value || '';
    const reason    = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    const optCard   = card.querySelector('.gd-chat-widget-li-opt-card.gd-chat-widget-li-opt-selected');
    const option    = optCard?.dataset.opt       || '';
    const returnFee = optCard?.dataset.returnFee || null;
    const qty       = parseInt(card.querySelector('.gd-chat-widget-li-qty')?.textContent, 10) || 1;
    const item_id   = card.dataset.itemId || '';
    const item_sku  = card.dataset.sku  || '';
    const item_name = card.dataset.name || '';
    const specificReasonEl = card.querySelector('.gd-chat-widget-li-specific-reason');
    const specificReason   = specificReasonEl ? specificReasonEl.value.trim() : '';
    const images    = gdWidgetFaultyGetFiles(uid);
 
    return { uid, item_id, item_sku, item_name, reason_id, reason, specificReason, option, return_fee: returnFee, qty, images };
  });
 
  // Show confirmation dialog
  gdWidgetConfirm({
    title: 'Return Items',
    message: 'Are you sure you want to proceed with this return?',
    confirmText: 'Yes, Process Return',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: i.item_name, reason: i.reason, qty: i.qty })),
    onConfirm: function () {
      _gdWidgetSubmitReturn(btn, panel, panelId, items, termsAccepted, addWithPreviousLabel);
    },
  });
}
 
function _gdWidgetSubmitReturn(btn, panel, panelId, items, termsAccepted, addWithPreviousLabel) {

  const originalQuery = panel.dataset.originalQuery || '';
  // Build FormData — matches old portal exactly
  const formData = new FormData();
  formData.append('order',    panel.dataset.orderId    || '');
  formData.append('customer', panel.dataset.customerId || '');
  formData.append('type', 'return');
  formData.append('terms_conditions_checkbox', termsAccepted);
  formData.append('add_with_previous_label', addWithPreviousLabel);
 
  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`,             item.item_id);
    formData.append(`items[${index}][sku]`,            item.item_sku);
    formData.append(`items[${index}][product]`,        item.item_name);
    formData.append(`items[${index}][reason]`,         item.reason_id);
    formData.append(`items[${index}][reasonText]`,     item.reason);
    formData.append(`items[${index}][specificReason]`, item.specificReason || '');
    formData.append(`items[${index}][return_option]`,  item.option);
    formData.append(`items[${index}][quantity]`,       item.qty);
    if (item.images && item.images.length > 0) {
      item.images.forEach((file, fileIndex) => {
        formData.append(`items[${index}][images][${fileIndex}]`, file, file.name);
      });
    }
  });
 
  gdWidgetBtnStartLoading(btn, 'Processing return…');
  gdWidgetFreezePanel(panel, 'Processing your return…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmit}/v1/api/return/request-add`, {
    method: 'POST',
    body: formData,
  })
  .then(res => res.json())
  .then(response => {
    if (response.errors) {
      gdWidgetBtnStopLoading(btn, 'PROCESS RETURN');
      gdWidgetUnfreezePanel(panel);
      gdWidgetToast(response.errors || 'Failed to process return', 'error');
      return;
    }
 
    if (response.invoice_url) {
      // Payment required — show payment popup
      //gdWidgetBtnSuccess(btn, 'Return Submitted');
      gdWidgetToast('Return submitted! Please complete payment.', 'success');
      gdWidgetShowPaymentPopup(panelId, response, {
        return_fee            : parseFloat(panel.dataset.returnFee) || 0,
        shipping_country_code : panel.dataset.shippingCode || '',
        is_vip_customer       : panel.dataset.isVip === '1',
      });

      document.querySelectorAll('.gd-chat-widget-pay-close').forEach(el => {
        el.setAttribute('data-refresh', 'yes');
      });

      panel.dataset.refreshQuery = originalQuery;
    } else {
      // No payment needed — success
    //  gdWidgetBtnSuccess(btn, 'Return Processed');
      gdWidgetToast(response.message || 'Return processed successfully!', 'success', 6000);

      if (originalQuery) {
        gdWidgetShowPanelLoader(panel, 'Please wait...');
        setTimeout(() => gdWidgetChatQuery(originalQuery), 1000);
      }
      
     // gdWidgetRefreshPanel(panel, 'return');

    }
  })
  .catch(err => {
    gdWidgetBtnStopLoading(btn, 'PROCESS RETURN');
    gdWidgetUnfreezePanel(panel);
    gdWidgetToast('An unexpected error occurred. Please try again.', 'error');
    console.error('gdWidgetHandleProcessReturn fetch error:', err);
  });
}
 

// restrictedCountries 


var pusher = new Pusher('33b7f1cf4c7cf49972bc', {
cluster: 'eu'
});

const GD_WIDGET_RESTRICTED_COUNTRIES = [
  'US','CA','AT','BE','BG','CY','CZ','DE','DK','EE',
  'EL','ES','FI','FR','GR','HR','HU','IE','IT','LT',
  'LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','AU','NZ'
];

// Keyed by panelId — stores grouped brand data for label download after payment
const _gdWidgetGroupedData = {};
// Keyed by panelId — stores allIntervals for cleanup
const _gdWidgetPayIntervals = {};

function gdWidgetShowPaymentPopup(panelId, response, allData) {
  const content = document.getElementById(`gd-chat-widget-pay-content_${panelId}`);
  if (!content) return;

  _gdWidgetGroupedData[panelId] = null;

  const shippingCode  = allData.shipping_country_code || '';
  const isRestricted  = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const pad  = n => String(n).padStart(2, '0');
    const h    = date.getHours();
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${pad(date.getDate())}-${pad(date.getMonth()+1)}-${date.getFullYear()} ` +
           `${pad(h % 12 || 12)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
  }

  let html = '<h3 style="margin:0 0 12px;font-size:14px;font-weight:700;">Summary</h3>';

  // ── Return Label Summary ──
  if (response.return_label_response?.items?.length > 0) {
    const rlr       = response.return_label_response;
    const hasError  = rlr.error !== false;

    html += `<div class="gd-chat-widget-pay-accordion">
      <div class="gd-chat-widget-pay-acc-header" onclick="gdWidgetPayAccToggle(this)">
        <span class="gd-chat-widget-pay-acc-arrow open">▾</span>
        Return Items Summary
      </div>
      <div class="gd-chat-widget-pay-acc-body" style="display:block;">`;

    if (!hasError) {
      html += `<p>A return fee of £${allData.return_fee} is required before you can download the return label.</p>
               <p>Once you make this one-time payment, a return label will be provided for each brand.</p>
               <p>Requested Date: ${formatDate(rlr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that your return request could not be processed. Please reach out to our support team at
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for return:</p>`;

    // Group by brand — mirrors portal groupedData reduce
    const groupedData = rlr.items.reduce((acc, item) => {
      let group = acc.find(g => g.brand_id === item.brand_id);
      if (!group) {
        group = { brand_id: item.brand_id, brand_name: item.brand_name, items: [] };
        acc.push(group);
      }
      group.items.push(item);
      return acc;
    }, []);

    _gdWidgetGroupedData[panelId] = groupedData;

    groupedData.forEach(brand => {
      html += `<h4 data-brand-id="${brand.brand_id}"
                   style="font-size:12px;font-weight:700;margin:8px 0 4px;">
                 ${gdWidgetEscHtml(brand.brand_name)}
               </h4>
               <ul class="gd-chat-widget-pay-sku-list">`;
      brand.items.forEach(item => {
        html += `<li data-lineitem-id="${item.line_item_id}">
                   ${gdWidgetEscHtml(item.sku)} (Qty: ${item.quantity})
                 </li>`;
      });
      html += `</ul>`;
    });

    html += `<p>Please click the button below to complete the payment and proceed with your return.</p>
             <p style="margin-top:12px;text-align:center;">
               <a class="gd-chat-widget-pay-now-btn"
                  href="${gdWidgetEscHtml(rlr.invoice_url)}"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-return-request-id="${rlr.returnRequestId}"
                  data-panel-id="${panelId}"
                  onclick="gdWidgetPayNowClick(this)">
                 Pay Now
               </a>
             </p>`;

    html += `</div></div>`; // close acc-body + accordion
  }

  // ── Self Ship Summary ──
  if (response.self_ship_response?.items?.length > 0) {
    const ssr      = response.self_ship_response;
    const hasError = ssr.error !== false;

    html += `<div class="gd-chat-widget-pay-accordion">
      <div class="gd-chat-widget-pay-acc-header" onclick="gdWidgetPayAccToggle(this)">
        <span class="gd-chat-widget-pay-acc-arrow">▾</span>
        Self Ship Summary
      </div>
      <div class="gd-chat-widget-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>Requested Date: ${formatDate(ssr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that the items selected for Self Ship could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for self ship:</p><ul class="gd-chat-widget-pay-sku-list">`;
    ssr.items.forEach(item => {
      html += `<li>${gdWidgetEscHtml(item.sku)} (Qty: ${item.quantity})
               | <a href="${gdWidgetEscHtml(item.return_note_url)}" target="_blank"
                    style="color:#ff8080;">Download Return Note</a></li>`;
    });
    html += `</ul></div></div>`;
  }

  // ── Store Credit Summary ──
  if (response.store_credit_response?.items?.length > 0) {
    const scr      = response.store_credit_response;
    const hasError = scr.error !== false;

    html += `<div class="gd-chat-widget-pay-accordion">
      <div class="gd-chat-widget-pay-acc-header" onclick="gdWidgetPayAccToggle(this)">
        <span class="gd-chat-widget-pay-acc-arrow">▾</span>
        Store Credit Summary
      </div>
      <div class="gd-chat-widget-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>Thank you for choosing to keep the items. We have sent you an email with the Gift Voucher worth £${scr.total_amount}</p>
               <p>Requested Date: ${formatDate(scr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that the Gift Card worth £${scr.total_amount} could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for store credit:</p><ul class="gd-chat-widget-pay-sku-list">`;
    scr.items.forEach(item => {
      html += `<li>${gdWidgetEscHtml(item.sku)} (Qty: ${item.quantity})</li>`;
    });
    html += `</ul></div></div>`;
  }

  // ── Refund Summary ──
  if (response.refund_response?.items?.length > 0) {
    const rr       = response.refund_response;
    const hasError = rr.error !== false;

    html += `<div class="gd-chat-widget-pay-accordion">
      <div class="gd-chat-widget-pay-acc-header" onclick="gdWidgetPayAccToggle(this)">
        <span class="gd-chat-widget-pay-acc-arrow">▾</span>
        Refund Summary
      </div>
      <div class="gd-chat-widget-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>We are pleased to inform you that a refund of £${rr.total_amount} has been successfully processed to your original payment method.</p>
               <p>Requested Date: ${formatDate(rr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that a refund of £${rr.total_amount} could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for refund while keeping the item:</p>
             <ul class="gd-chat-widget-pay-sku-list">`;
    rr.items.forEach(item => {
      html += `<li>${gdWidgetEscHtml(item.sku)} (Qty: ${item.quantity})</li>`;
    });
    html += `</ul></div></div>`;
  }

  content.innerHTML = html;

  // Show the popup
  const popup = document.getElementById(`gd-chat-widget-pay-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}


function gdWidgetPayNowClick(btn) {
  const panelId        = btn.dataset.panelId;
  const returnRequestId = btn.dataset.returnRequestId;
  const url            = btn.getAttribute('href');

  // Delay button state change — mirrors portal setTimeout 1000
  setTimeout(() => {
    btn.classList.add('gd-chat-widget-pay-now-waiting');
    btn.removeAttribute('href');
    btn.removeAttribute('target');
    btn.textContent = '⏳ Waiting for payment…';
    btn.onclick = null; // prevent double click
  }, 1000);

  gdWidgetCheckForPayment(btn, url, panelId, returnRequestId);
}

function gdWidgetCheckForPayment(btn, url, panelId, returnRequestId) {
  if (!returnRequestId || typeof pusher === 'undefined') return;

  const channelId = 'retrun-request.' + returnRequestId;
  const channel   = pusher.subscribe(channelId);

  channel.bind('return-label-payment-event', function(data) {
    if (!data || data.status !== 'paid') return;

    pusher.unsubscribe(channelId);

    if (btn.dataset.paymentStatus === 'paid') return;
    btn.dataset.paymentStatus = 'paid';

    // Update button state immediately
    btn.textContent = '✓ Payment Completed';
    btn.classList.remove('gd-chat-widget-pay-now-waiting');
    btn.classList.add('gd-chat-widget-pay-now-done');

    // Get the panel
    // const panel = document.getElementById(panelId)
    //            || document.querySelector('.gd-chat-widget-li-requested-only');
    

   const panel = document.getElementById(panelId)
               || document.querySelector(`#gd-chat-widget-req-wrapper_${panelId}`);
    if (!panel) return;

    const shippingCode = panel.dataset?.shippingCode || '';
    const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);
    const content      = document.getElementById(`gd-chat-widget-pay-content_${panelId}`);
    const grouped      = _gdWidgetGroupedData[panelId];

    // Show download links or omniparcel message in the popup
    if (grouped && Array.isArray(grouped) && content) {
      // Close payment popup after a short delay
      setTimeout(() => {
        gdWidgetPayPopupClose(panelId);
        gdWidgetToast('Payment completed successfully!', 'success');

        const panel = document.getElementById(panelId);
        const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
        if (query) {
          gdWidgetShowPanelLoader(panel, 'Please wait...');
          gdWidgetChatQuery(query);
        }

        // Refresh the panel with fresh data
        //gdWidgetRefreshPanel(panel, 'return');
      }, 2000);
    } else {
      // No grouped data — just close and refresh
      setTimeout(() => {
        gdWidgetPayPopupClose(panelId);
        gdWidgetToast('Payment completed successfully!', 'success');

        const panel = document.getElementById(panelId);
          const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
          if (query) {
            gdWidgetShowPanelLoader(panel, 'Please wait...');
            gdWidgetChatQuery(query);
          }
       // gdWidgetRefreshPanel(panel, 'return');
      }, 1500);
    }
  });
}

function gdWidgetGetLabelUrl(brandId, lineItemId, completedRequest) {
  const brandData = completedRequest.items?.find(b => b.brand_id == brandId);
  if (!brandData) return null;
  const itemData = brandData.items?.find(i => i.id == lineItemId);
  return itemData?.return_tracking?.label_url || null;
}

function gdWidgetGetQrCodeUrl(brandId, lineItemId, completedRequest) {
  const brandData = completedRequest.items?.find(b => b.brand_id == brandId);
  if (!brandData) return null;
  const itemData = brandData.items?.find(i => i.id == lineItemId);
  return itemData?.return_tracking?.qrcode_url || null;
}


function gdWidgetPayPopupClose(panelId) {
  const popup = document.getElementById(`gd-chat-widget-pay-popup_${panelId}`);
  if (popup) popup.setAttribute('hidden', '');

  // const panel = document.getElementById(panelId) || document.querySelector('.gd-chat-widget-li-requested-only');

  const panel = document.getElementById(panelId) || document.querySelector(`#gd-chat-widget-req-wrapper_${panelId}`);
  
  
  // Check if any .gd-chat-widget-pay-close element has data-refresh="yes"
  const payCloseElements = document.querySelectorAll('.gd-chat-widget-pay-close');
  let shouldRefresh = false;
  
  payCloseElements.forEach(el => {
    if (el.getAttribute('data-refresh') === 'yes') {
      shouldRefresh = true;
      // Remove the attribute after checking to prevent repeated refreshes
      el.removeAttribute('data-refresh');
    }
  });
  
  // If refresh is needed, call gdWidgetChatQuery
  if (shouldRefresh) {
    const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
    if (query) {
      gdWidgetShowPanelLoader(panel, 'Please wait...');
      gdWidgetChatQuery(query);
    }
  }
}

function gdWidgetPayAccToggle(header) {
  const body  = header.nextElementSibling;
  const arrow = header.querySelector('.gd-chat-widget-pay-acc-arrow');
  const isOpen = body.style.display !== 'none';
  body.style.display  = isOpen ? 'none' : 'block';
  arrow.classList.toggle('open', !isOpen);
}









// already requested item
// ─────────────────────────────────────────────────────────────
// REQUESTED ITEMS — rendered after not_requested cards
// All 5 sections use the same two-column layout:
//   Left  → Next Steps (instructions + download buttons)
//   Right → Items (product cards with meta grid)
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderRequestedItems(lineItemsData, panelId) {
  const requested    = lineItemsData.requested || {};
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);
  let html = '';

  const pendingLabels  = requested?.return?.return_label?.pending_label  || [];
  const completeLabels = requested?.return?.return_label?.complete_label || [];

  if (pendingLabels.length  > 0) html += gdWidgetRenderPendingLabels(pendingLabels, isRestricted, panelId);
  if (completeLabels.length > 0) html += gdWidgetRenderCompleteLabels(completeLabels, isRestricted, panelId);

  if (requested?.return?.self_ship)    html += gdWidgetRenderProcessedReturn(requested.return.self_ship,    'self_ship');
  if (requested?.return?.store_credit) html += gdWidgetRenderProcessedReturn(requested.return.store_credit, 'store_credit');
  if (requested?.return?.refund)       html += gdWidgetRenderProcessedReturn(requested.return.refund,       'refund');

  if (requested?.exchange?.length  > 0) html += gdWidgetRenderAlreadyRequestedExchange(requested.exchange, isRestricted);
  if (requested?.alteration?.length > 0) html += gdWidgetRenderAlreadyRequestedAlteration(requested.alteration, isRestricted);

  return html;
}


// ─────────────────────────────────────────────────────────────
// SHARED HELPERS
// ─────────────────────────────────────────────────────────────

/** Success / info / warning banner at the top of each accordion body */
function gdWidgetReqBanner(type, title, sub, badgeLabel, badgeColor) {
  if (type === 'cancelled') {
    return `
      <div class="gd-chat-widget-req-cancelled-banner">
        <span>⚠</span>
        <div>${title}. Please contact
          <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
        </div>
      </div>`;
  }
  const color = badgeColor || '#16a34a';
  return `
    <div class="gd-chat-widget-req-success-banner">
      <span class="gd-chat-widget-req-success-icon">✓</span>
      <div>
        <div class="gd-chat-widget-req-success-title">${title}</div>
        <div class="gd-chat-widget-req-success-sub">${sub}</div>
      </div>
      <span class="gd-chat-widget-req-fee-badge" style="background:${color};">${badgeLabel}</span>
    </div>`;
}

/** How-to steps box — left column */
function gdWidgetReqStepsBox(title, steps) {
  const lis = steps.map(s => `<li>${s}</li>`).join('');
  return `
    <div class="gd-chat-widget-req-steps-box">
      <div class="gd-chat-widget-req-steps-title">ℹ ${title}</div>
      <ol class="gd-chat-widget-req-steps-list">${lis}</ol>
    </div>`;
}

/** Download buttons — left column */
function gdWidgetReqDownloadBtns(labelUrl, qrUrl, isRestricted) {
  if (isRestricted) {
    return `<p class="gd-chat-widget-li-req-note" style="margin-top:6px;">
              Please visit
              <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307"
                 target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a>
              to generate your return label.
            </p>`;
  }
  let html = '';
  if (labelUrl) {
    html += `<a href="${gdWidgetEscHtml(labelUrl)}" target="_blank"
                class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label">
               ⬇ Download Return Label
             </a>`;
  }
  if (qrUrl) {
    html += `<a href="${gdWidgetEscHtml(qrUrl)}" target="_blank"
                class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-qr">
               ⇄ Download QR Code
             </a>`;
  }
  return html;
}

/** Single product card — right column */
function gdWidgetReqProductCard(item, qtyLabel, statusHtml, badgeHtml) {
  const returning = item.return_qty || item.quantity || 1;

  // Faulty images
  let imagesHtml = '';
  if (Array.isArray(item.images) && item.images.length > 0) {
    const imageUrls = item.images.filter(Boolean);
    if (imageUrls.length > 0) {
      imagesHtml = `
        <div class="gd-chat-widget-req-faulty-images">
          <div class="gd-chat-widget-req-faulty-label">Uploaded Images:</div>
          <div class="gd-chat-widget-req-faulty-thumbs">
            ${imageUrls.map((imgUrl, i) => `
              <div class="gd-chat-widget-req-faulty-thumb"
                   onclick="gdWidgetReqImagePopupOpen(this, ${i})">
                <img src="${gdWidgetEscHtml(imgUrl)}" alt="Faulty image ${i + 1}" />
              </div>
            `).join('')}
          </div>
        </div>`;
    }
  }

  return `
    <div class="gd-chat-widget-req-product-card">
      <div class="gd-chat-widget-req-product-img">
        ${item.image
          ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
          : `<div class="gd-chat-widget-li-img-placeholder">G</div>`}
      </div>
      <div class="gd-chat-widget-req-product-info">
        <div class="gd-chat-widget-req-product-name">${gdWidgetEscHtml(item.name)}</div>
        <div class="gd-chat-widget-req-product-meta-grid">
          <div>
            <div class="gd-chat-widget-req-meta-label">SKU:</div>
            <div class="gd-chat-widget-req-meta-value">${gdWidgetEscHtml(item.sku)}</div>
          </div>
          <div>
            <div class="gd-chat-widget-req-meta-label">Price:</div>
            <div class="gd-chat-widget-req-meta-value gd-chat-widget-req-price">£${parseFloat(item.price || 0).toFixed(2)}</div>
          </div>
          <div>
            <div class="gd-chat-widget-req-meta-label">Ordered:</div>
            <div class="gd-chat-widget-req-meta-value">${item.quantity}</div>
          </div>
          <div>
            <div class="gd-chat-widget-req-meta-label">${qtyLabel}:</div>
            <div class="gd-chat-widget-req-meta-value">${returning}</div>
          </div>
        </div>
        ${imagesHtml}
        ${statusHtml
          ? `<div class="gd-chat-widget-req-product-status">${statusHtml}</div>`
          : badgeHtml}
      </div>
    </div>`;
}

/** Outer two-column wrapper */
function gdWidgetReqTwoCol(leftHtml, rightHtml) {
  return `<div class="gd-chat-widget-req-two-col">${leftHtml}${rightHtml}</div>`;
}




// ─────────────────────────────────────────────────────────────
// REQUESTED ITEMS — IMAGE PREVIEW POPUP (for server-hosted URLs)
// Reuses the same popup style as the faulty upload preview
// ─────────────────────────────────────────────────────────────

const _gdWidgetReqImagePopupState = { images: [], index: 0 };

function gdWidgetReqImagePopupOpen(thumb, index) {
  const container = thumb.closest('.gd-chat-widget-req-faulty-thumbs');
  const allThumbs = container.querySelectorAll('.gd-chat-widget-req-faulty-thumb img');
  _gdWidgetReqImagePopupState.images = [...allThumbs].map(img => img.src);
  _gdWidgetReqImagePopupState.index = index;

  let popup = document.getElementById('gd-chat-widget-req-img-popup');
  if (!popup) {
    const popupHtml = `
      <div id="gd-chat-widget-req-img-popup" class="gd-chat-widget-img-popup" hidden>
        <div class="gd-chat-widget-img-popup-overlay"
             onclick="gdWidgetReqImagePopupClose()"></div>
        <div class="gd-chat-widget-img-popup-box">
          <button class="gd-chat-widget-img-popup-close"
                  onclick="gdWidgetReqImagePopupClose()">✕</button>
          <button class="gd-chat-widget-img-popup-nav gd-chat-widget-img-popup-prev"
                  onclick="gdWidgetReqImagePopupNav(-1)">&#8249;</button>
          <div class="gd-chat-widget-img-popup-img-wrap">
            <img id="gd-chat-widget-req-img-popup-img" src="" alt="" />
          </div>
          <button class="gd-chat-widget-img-popup-nav gd-chat-widget-img-popup-next"
                  onclick="gdWidgetReqImagePopupNav(1)">&#8250;</button>
          <div class="gd-chat-widget-img-popup-counter"
               id="gd-chat-widget-req-img-popup-counter"></div>
        </div>
      </div>`;
    const panel = document.getElementById('gd-chat-widget-assistantPanel') || document.body;
    panel.insertAdjacentHTML('beforeend', popupHtml);
    popup = document.getElementById('gd-chat-widget-req-img-popup');
  }

  _gdWidgetReqImagePopupRender();
  popup.removeAttribute('hidden');
}


function gdWidgetReqImagePopupClose() {
  const popup = document.getElementById('gd-chat-widget-req-img-popup');
  if (popup) popup.setAttribute('hidden', '');
}

function gdWidgetReqImagePopupNav(direction) {
  const state = _gdWidgetReqImagePopupState;
  if (!state.images.length) return;
  state.index = (state.index + direction + state.images.length) % state.images.length;
  _gdWidgetReqImagePopupRender();
}

function _gdWidgetReqImagePopupRender() {
  const state   = _gdWidgetReqImagePopupState;
  const imgEl   = document.getElementById('gd-chat-widget-req-img-popup-img');
  const counter = document.getElementById('gd-chat-widget-req-img-popup-counter');
  const popup   = document.getElementById('gd-chat-widget-req-img-popup');

  if (imgEl) imgEl.src = state.images[state.index] || '';
  if (counter) counter.textContent = `${state.index + 1} / ${state.images.length}`;

  if (popup) {
    const showNav = state.images.length > 1;
    const prev = popup.querySelector('.gd-chat-widget-img-popup-prev');
    const next = popup.querySelector('.gd-chat-widget-img-popup-next');
    if (prev) prev.style.visibility = showNav ? '' : 'hidden';
    if (next) next.style.visibility = showNav ? '' : 'hidden';
  }
}

// Keyboard navigation — extend existing listener
document.addEventListener('keydown', function(e) {
  const popup = document.getElementById('gd-chat-widget-req-img-popup');
  if (!popup || popup.hasAttribute('hidden')) return;
  if (e.key === 'ArrowRight') gdWidgetReqImagePopupNav(1);
  if (e.key === 'ArrowLeft')  gdWidgetReqImagePopupNav(-1);
  if (e.key === 'Escape')     gdWidgetReqImagePopupClose();
});

// ─────────────────────────────────────────────────────────────
// 1. RETURN FEE PENDING
// ─────────────────────────────────────────────────────────────


function gdWidgetRenderPendingLabels(pendingLabels, isRestricted, panelId) {
  let html = `
    <div class="gd-chat-widget-li-requested-separator">
      <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-danger">Return Fee Pending</div>`;

  pendingLabels.forEach((label, labelIdx) => {
    label.items?.forEach((seller, sellerIdx) => {
      const totalItems = seller.items?.length || 0;
      const listId     = `gd-chat-widget-req-pending_${panelId}_${labelIdx}_${sellerIdx}`;

      html += `<div class="gd-chat-widget-li-req-accordion">
        <div class="gd-chat-widget-li-req-acc-header" onclick="gdWidgetReqAccToggle(this)">
          <span class="gd-chat-widget-li-req-acc-arrow open">▾</span>
          Return Fee Pending — ${gdWidgetEscHtml(label.requested_date || '')}
        </div>
        <div class="gd-chat-widget-li-req-acc-body">`;

      html += gdWidgetReqBanner('warning',
        'Payment Required',
        'Please complete the return fee payment to download your return label.',
        'Fee Pending', '#f59e0b');

      html += `<div class="gd-chat-widget-req-brand-title">${gdWidgetEscHtml(seller.brand || '')}</div>`;

      const leftCol = `
        <div class="gd-chat-widget-req-col-steps">
          <div class="gd-chat-widget-req-col-heading"><span>💳</span> Payment Required</div>
          <div class="gd-chat-widget-req-col-sub">Complete payment to proceed with your return</div>
          ${gdWidgetReqStepsBox('How to Complete Your Return:', [
            'Click the "Pay for Return Label" button below',
            'Complete the one-time payment for the return label',
            'Return to this page after payment',
            'Download your return label and QR code',
            'Pack your item and drop off at any authorised location',
          ])}
          ${gdWidgetPendingLabelPayBtn(seller.items?.[0], label)}
          <p class="gd-chat-widget-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const statusHtml = gdWidgetPendingItemStatus(item);
        const hiddenClass = itemIdx >= 1 ? ' gd-chat-widget-req-product-hidden' : '';
        rightItems += `<div class="gd-chat-widget-req-product-item${hiddenClass}">
          ${gdWidgetReqProductCard(
            item,
            'Returning',
            statusHtml,
            `<span class="gd-chat-widget-req-ready-badge" style="background:#fef3c7;color:#d97706;">Awaiting Payment</span>`
          )}
        </div>`;
      });

      const showMoreBtn = totalItems > 1
        ? `<button class="gd-chat-widget-req-show-more-btn" type="button"
                   onclick="gdWidgetReqToggleProducts(this, '${listId}')">
             Show ${totalItems - 1} More Item${totalItems - 1 !== 1 ? 's' : ''} ▾
           </button>`
        : '';

      const rightCol = `
        <div class="gd-chat-widget-req-col-products">
          <div class="gd-chat-widget-req-col-heading-row">
            <div class="gd-chat-widget-req-col-heading"><span>📋</span> Return Items</div>
            <span class="gd-chat-widget-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="gd-chat-widget-req-col-sub">Items pending return fee payment</div>
          <div class="gd-chat-widget-req-products-list" id="${listId}">
            ${rightItems}
          </div>
          ${showMoreBtn}
        </div>`;

      html += gdWidgetReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

/** Pay button or cancelled/declined message — shown in left column */
function gdWidgetPendingLabelPayBtn(item, label) {
  if (!item) return '';

  if (item.return_request_item_status_id == 4) {
    const type = item.return_request_item_cancelled_type;
    if (type === 'admin' || type === 'system') {
      return `<p class="gd-chat-widget-li-req-text-danger">Return request was declined by Admin because return fee was not paid.</p>`;
    }
    return `<p class="gd-chat-widget-li-req-text-danger">Return request cancelled by you.</p>`;
  }
  if (item.return_request_item_status_id == 3) {
    return `<p class="gd-chat-widget-li-req-text-danger">Return request was declined by Admin.</p>`;
  }
  if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
    let html = `
      <a href="javascript:;"
         class="gd-chat-widget-req-dl-btn"
         style="background:#f59e0b;color:#fff !important;margin-bottom:5px;"
         data-invoice-url="${gdWidgetEscHtml(item.lable_invoice_url || '')}"
         onclick="gdWidgetOpenPaymentFromPending(this)">
        💳 Pay for Return Label
      </a>
      <p class="gd-chat-widget-li-req-note">A one-time payment is required. After payment, your label will be available to download.</p>`;

    // Faulty images — shown in left column below pay button
    if (Array.isArray(item.images) && item.images.length > 0) {
      html += `<div class="gd-chat-widget-li-req-faulty-imgs">`;
      item.images.forEach((imgUrl, i) => {
        if (imgUrl) {
          html += `<a href="${gdWidgetEscHtml(imgUrl)}" target="_blank" class="gd-chat-widget-li-req-faulty-thumb">
                     <img src="${gdWidgetEscHtml(imgUrl)}" alt="Faulty image ${i + 1}" />
                   </a>`;
        }
      });
      html += `</div>`;
    }
    return html;
  }
  return '';
}

/** Per-item status for pending — only error/declined states */
function gdWidgetPendingItemStatus(item) {
  if (item.return_request_item_status_id == 4) {
    const type = item.return_request_item_cancelled_type;
    if (type === 'admin' || type === 'system') {
      return `<p class="gd-chat-widget-li-req-text-danger">Declined by Admin.</p>`;
    }
    return `<p class="gd-chat-widget-li-req-text-danger">Cancelled by you.</p>`;
  }
  if (item.return_request_item_status_id == 3) {
    return `<p class="gd-chat-widget-li-req-text-danger">Declined by Admin.</p>`;
  }
  return ''; // badge shows instead
}


// ─────────────────────────────────────────────────────────────
// 2. RETURN FEE PAID / DOWNLOAD LABEL
// ─────────────────────────────────────────────────────────────


function gdWidgetRenderCompleteLabels(completeLabels, isRestricted, panelId) {
  let html = `
    <div class="gd-chat-widget-li-requested-separator">
      <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-info">Return Fee Paid</div>`;

  completeLabels.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="gd-chat-widget-li-req-accordion">
        <div class="gd-chat-widget-li-req-acc-header" onclick="gdWidgetReqAccToggle(this)">
          <span class="gd-chat-widget-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Return on ${gdWidgetEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="gd-chat-widget-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach((seller, sellerIdx) => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;
      const listId      = `gd-chat-widget-req-products_${panelId}_${index}_${sellerIdx}`;

      // Banner
      html += isCancelled
        ? gdWidgetReqBanner('cancelled', 'Return request was cancelled or declined', '', '', '')
        : gdWidgetReqBanner('success',
            'Return Request Successful!',
            'Your return has been processed and labels are ready for download.',
            'Fee Paid', '#16a34a');

      // Brand title
      html += `<div class="gd-chat-widget-req-brand-title">${gdWidgetEscHtml(seller.brand || '')}</div>`;

      // Left column
      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? gdWidgetReqStepsBox('How to Return:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
          ])
        : '';

      const leftCol = `
        <div class="gd-chat-widget-req-col-steps">
          <div class="gd-chat-widget-req-col-heading"><span>📦</span> Next Steps</div>
          <div class="gd-chat-widget-req-col-sub">Follow these steps to complete your return</div>
          ${stepsHtml}
          ${!isCancelled ? gdWidgetReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="gd-chat-widget-li-req-note" style="margin-top:8px;">
            If you have any questions, please reach out to
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      // Right column — build cards with show more/less
      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const statusHtml = gdWidgetCompleteLabelItemStatus(item, isRestricted);
        const hiddenClass = itemIdx >= 1 ? ' gd-chat-widget-req-product-hidden' : '';
        rightItems += `<div class="gd-chat-widget-req-product-item${hiddenClass}">
          ${gdWidgetReqProductCard(
            item, 'Returning', statusHtml,
            `<span class="gd-chat-widget-req-ready-badge">Ready to Return</span>`
          )}
        </div>`;
      });

      const showMoreBtn = totalItems > 1
        ? `<button class="gd-chat-widget-req-show-more-btn" type="button"
                   onclick="gdWidgetReqToggleProducts(this, '${listId}')">
             Show ${totalItems - 1} More Item${totalItems - 1 !== 1 ? 's' : ''} ▾
           </button>`
        : '';

      const rightCol = `
        <div class="gd-chat-widget-req-col-products">
          <div class="gd-chat-widget-req-col-heading-row">
            <div class="gd-chat-widget-req-col-heading"><span>📋</span> Returned Products</div>
            <span class="gd-chat-widget-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="gd-chat-widget-req-col-sub">Items included in this return</div>
          <div class="gd-chat-widget-req-products-list" id="${listId}">
            ${rightItems}
          </div>
          ${showMoreBtn}
        </div>`;

      html += gdWidgetReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

function gdWidgetReqToggleProducts(btn, listId) {
  const list = document.getElementById(listId);
  if (!list) return;

  const isExpanded = list.dataset.expanded === '1';
  const hiddenItems = list.querySelectorAll('.gd-chat-widget-req-product-hidden');
  const totalHidden = hiddenItems.length;

  if (isExpanded) {
    list.dataset.expanded = '0';
    hiddenItems.forEach(el => el.classList.remove('gd-chat-widget-req-product-visible'));
    btn.textContent = `Show ${totalHidden} More Item${totalHidden !== 1 ? 's' : ''} ▾`;
  } else {
    list.dataset.expanded = '1';
    hiddenItems.forEach(el => el.classList.add('gd-chat-widget-req-product-visible'));
    btn.textContent = 'Show Less ▴';
  }
}

function gdWidgetCompleteLabelItemStatus(item, isRestricted) {
  if (isRestricted) return ''; // Omniparcel shown in left column
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if ((item.lable_type == 1 || item.lable_type == 2) && item.lable_type_url === 'error') {
        return `<p class="gd-chat-widget-li-req-text-danger">Label generation failed. Please contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
      }
      if (item.lable_type == 3) {
        return `<a href="${gdWidgetEscHtml(item.lable_type_url || '')}" target="_blank" class="gd-chat-widget-li-req-btn">Download Return Note</a>
                <p class="gd-chat-widget-li-req-note">Self-ship — send back at your own expense.</p>`;
      }
      if (item.lable_type == 6) {
        return `<p class="gd-chat-widget-li-req-text-success">Refund of £${parseFloat(item.refund_total_amount || 0).toFixed(2)} processed to your original payment method.</p>`;
      }
      return ''; // label shown at brand level
    }
    if (item.refund_status_id == 3) {
      return `<p class="gd-chat-widget-li-req-text-danger">Return request <strong>Declined</strong>. Please contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }
    if (item.refund_status_id == 6) {
      return `<p class="gd-chat-widget-li-req-text-success">Refund of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> successfully processed for <strong>${item.return_qty} qty</strong>.</p>`;
    }
    return `<p class="gd-chat-widget-li-req-note">Return completed — Qty: ${item.return_qty}.</p>`;
  }
  if (item.is_return == 2 && item.lable_type == 5) {
    return `<p class="gd-chat-widget-li-req-text-success">Gift Voucher of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> sent to your email.</p>`;
  }
  if (item.is_return == 3) {
    return `<p class="gd-chat-widget-li-req-text-danger">Already requested for exchange — cannot place a return request.</p>`;
  }
  if (item.alteration_request_status != null) {
    return `<p class="gd-chat-widget-li-req-text-danger">Already requested for alteration — cannot place a return request.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 3. SELF SHIP / STORE CREDIT / REFUND
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderProcessedReturn(sellerwiseItems, key) {
  const config = {
    self_ship    : { badge: 'Self-Ship Return Requested', badgeClass: 'gd-chat-widget-li-req-badge-info',    bannerTitle: 'Self-Ship Return Confirmed!',   bannerSub: 'Pack your item and send it back using your own courier.',    badgeLabel: 'Self-Ship', badgeColor: '#2563eb', icon: '📦', heading: 'Return Items', qtyLabel: 'Returning',   readyLabel: 'Ready to Ship',      readyBg: '#dbeafe', readyColor: '#2563eb' },
    store_credit : { badge: 'Store Credit Issued',        badgeClass: 'gd-chat-widget-li-req-badge-success', bannerTitle: 'Store Credit Issued!',          bannerSub: 'A gift voucher has been sent to your email address.',        badgeLabel: 'Gift Card', badgeColor: '#16a34a', icon: '🎁', heading: 'Items Kept',  qtyLabel: 'Kept',        readyLabel: 'Gift Card Issued',   readyBg: '#dcfce7', readyColor: '#16a34a' },
    refund       : { badge: 'Refund Issued',              badgeClass: 'gd-chat-widget-li-req-badge-success', bannerTitle: 'Refund Processed!',             bannerSub: 'Your refund has been issued to your original payment method.', badgeLabel: 'Refunded',  badgeColor: '#16a34a', icon: '💰', heading: 'Refunded Items', qtyLabel: 'Refunded',  readyLabel: 'Refund Issued',      readyBg: '#dcfce7', readyColor: '#16a34a' },
  };
  const c = config[key];

  let html = `
    <div class="gd-chat-widget-li-requested-separator">
      <div class="gd-chat-widget-li-req-badge ${c.badgeClass}">${c.badge}</div>`;

  sellerwiseItems.forEach((sellerwiseItem, groupIndex) => {
    const totalItems = sellerwiseItem.items?.length || 0;

    html += `<div class="gd-chat-widget-li-req-accordion">
      <div class="gd-chat-widget-li-req-acc-header" onclick="gdWidgetReqAccToggle(this)">
        <span class="gd-chat-widget-li-req-acc-arrow ${groupIndex === 0 ? 'open' : ''}">▾</span>
        ${c.badge} — ${gdWidgetEscHtml(sellerwiseItem.requested_date || sellerwiseItem.items?.[0]?.requested_date || '')}
      </div>
      <div class="gd-chat-widget-li-req-acc-body" ${groupIndex === 0 ? '' : 'style="display:none;"'}>`;

    // Banner
    html += gdWidgetReqBanner('success', c.bannerTitle, c.bannerSub, c.badgeLabel, c.badgeColor);

    // Brand title
    const brand = sellerwiseItem.brand || sellerwiseItem.items?.[0]?.brand || '';
    html += `<div class="gd-chat-widget-req-brand-title">${gdWidgetEscHtml(brand)}</div>`;

    // Left column — instructions specific to each type
    let stepsContent = '';
    if (key === 'self_ship') {
      stepsContent = gdWidgetReqStepsBox('How to Self-Ship:', [
        'Download your return note below',
        'Pack your item(s) securely in the original packaging',
        'Include the return note inside the package',
        'Send using your preferred courier at your own expense',
      ]);
      // Self-ship return note button — per item
      sellerwiseItem.items?.forEach(item => {
        if (item.lable_type == 3 && item.lable_type_url) {
          stepsContent += `<a href="${gdWidgetEscHtml(item.lable_type_url)}" target="_blank"
                              class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label">
                             ⬇ Download Return Note
                           </a>`;
        }
        if (item.lable_type == 1 && item.lable_type_url) {
          stepsContent += `<a href="${gdWidgetEscHtml(item.lable_type_url)}" target="_blank"
                              class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label">
                             ⬇ Download Return Label
                           </a>`;
        }
        if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
          stepsContent += `<a href="javascript:;"
                              class="gd-chat-widget-req-dl-btn"
                              style="background:#f59e0b;color:#fff !important;"
                              data-invoice-url="${gdWidgetEscHtml(item.lable_invoice_url || '')}"
                              onclick="gdWidgetOpenPaymentFromPending(this)">
                             💳 Pay for Return Label
                           </a>`;
        }
      });
    } else if (key === 'store_credit') {
      stepsContent = `
        <div class="gd-chat-widget-req-steps-box">
          <div class="gd-chat-widget-req-steps-title">ℹ Store Credit Details:</div>
          <ol class="gd-chat-widget-req-steps-list">
            <li>A gift voucher has been emailed to you</li>
            <li>Check your inbox (and spam/junk folder)</li>
            <li>Use the voucher code on your next Goddiva order</li>
            <li>The item can remain with you — no need to return it</li>
          </ol>
        </div>`;
    } else if (key === 'refund') {
      stepsContent = `
        <div class="gd-chat-widget-req-steps-box">
          <div class="gd-chat-widget-req-steps-title">ℹ Refund Details:</div>
          <ol class="gd-chat-widget-req-steps-list">
            <li>Your refund has been issued to your original payment method</li>
            <li>Please allow 3–5 business days for it to appear</li>
            <li>The item can remain with you — no need to return it</li>
          </ol>
        </div>`;
    }

    const leftCol = `
      <div class="gd-chat-widget-req-col-steps">
        <div class="gd-chat-widget-req-col-heading"><span>${c.icon}</span> ${key === 'self_ship' ? 'Next Steps' : 'Summary'}</div>
        <div class="gd-chat-widget-req-col-sub">${c.bannerSub}</div>
        ${stepsContent}
        <p class="gd-chat-widget-li-req-note" style="margin-top:8px;">
          If you have any questions, please contact
          <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
        </p>
      </div>`;

    // Right column — items
    let rightItems = '';
    sellerwiseItem.items?.forEach(item => {
      const statusHtml = gdWidgetProcessedReturnStatus(item, key);
      rightItems += gdWidgetReqProductCard(
        item, c.qtyLabel, statusHtml,
        `<span class="gd-chat-widget-req-ready-badge" style="background:${c.readyBg};color:${c.readyColor};">${c.readyLabel}</span>`
      );
    });

    const rightCol = `
      <div class="gd-chat-widget-req-col-products">
        <div class="gd-chat-widget-req-col-heading-row">
          <div class="gd-chat-widget-req-col-heading"><span>📋</span> ${c.heading}</div>
          <span class="gd-chat-widget-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
        </div>
        <div class="gd-chat-widget-req-col-sub">Items included in this ${key.replace('_', ' ')}</div>
        ${rightItems}
      </div>`;

    html += gdWidgetReqTwoCol(leftCol, rightCol);
    html += `</div></div>`;
  });

  html += `</div>`;
  return html;
}

function gdWidgetProcessedReturnStatus(item, key) {
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
        return `<p class="gd-chat-widget-li-req-text-danger">Return fee payment pending.</p>`;
      }
      if (item.lable_type == 6) {
        return `<p class="gd-chat-widget-li-req-text-success">Refund of £${parseFloat(item.refund_total_amount || 0).toFixed(2)} processed.</p>`;
      }
      return ''; // badge shows
    }
    if (item.refund_status_id == 3) {
      return `<p class="gd-chat-widget-li-req-text-danger">Request <strong>Declined</strong>. Contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }
    if (item.refund_status_id == 6) {
      return `<p class="gd-chat-widget-li-req-text-success">Refund of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> processed for <strong>${item.return_qty} qty</strong>.</p>`;
    }
    return `<p class="gd-chat-widget-li-req-note">Completed — Qty: ${item.return_qty}.</p>`;
  }
  if (item.is_return == 2 && item.lable_type == 5) {
    return `<p class="gd-chat-widget-li-req-text-success">Gift Voucher of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> sent.</p>`;
  }
  if (item.is_return == 3) {
    return `<p class="gd-chat-widget-li-req-text-danger">Already requested for exchange.</p>`;
  }
  if (item.alteration_request_status != null) {
    return `<p class="gd-chat-widget-li-req-text-danger">Already requested for alteration.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 4. ALREADY REQUESTED FOR EXCHANGE
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderAlreadyRequestedExchange(exchangeRequests, isRestricted) {
  let html = `
    <div class="gd-chat-widget-li-requested-separator">
      <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-info">Already Requested for Exchange</div>`;

  exchangeRequests.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="gd-chat-widget-li-req-accordion">
        <div class="gd-chat-widget-li-req-acc-header" onclick="gdWidgetReqAccToggle(this)">
          <span class="gd-chat-widget-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Exchange on ${gdWidgetEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="gd-chat-widget-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach(seller => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;

      html += isCancelled
        ? gdWidgetReqBanner('cancelled', 'Exchange request was cancelled or declined', '', '', '')
        : gdWidgetReqBanner('success',
            'Exchange Request Successful!',
            'Please send back the item using the return label below.',
            'Exchange', '#2563eb');

      html += `<div class="gd-chat-widget-req-brand-title">${gdWidgetEscHtml(seller.brand || '')}</div>`;

      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? gdWidgetReqStepsBox('How to Return for Exchange:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
          ])
        : '';

      const leftCol = `
        <div class="gd-chat-widget-req-col-steps">
          <div class="gd-chat-widget-req-col-heading"><span>🔄</span> Next Steps</div>
          <div class="gd-chat-widget-req-col-sub">Follow these steps to complete your exchange</div>
          ${stepsHtml}
          ${!isCancelled ? gdWidgetReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="gd-chat-widget-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach(item => {
        const statusHtml = gdWidgetExchangeItemStatus(item, isRestricted);
        rightItems += gdWidgetReqProductCard(
          item, 'Exchanging', statusHtml,
          `<span class="gd-chat-widget-req-ready-badge" style="background:#dbeafe;color:#2563eb;">Ready to Exchange</span>`
        );
      });

      const rightCol = `
        <div class="gd-chat-widget-req-col-products">
          <div class="gd-chat-widget-req-col-heading-row">
            <div class="gd-chat-widget-req-col-heading"><span>📋</span> Exchanged Items</div>
            <span class="gd-chat-widget-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="gd-chat-widget-req-col-sub">Items included in this exchange</div>
          ${rightItems}
        </div>`;

      html += gdWidgetReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

function gdWidgetExchangeItemStatus(item, isRestricted) {
  if (isRestricted) return '';
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if ((item.lable_type == 1 || item.lable_type == 2) && item.lable_type_url === 'error') {
        return `<p class="gd-chat-widget-li-req-text-danger">Label generation failed. Contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
      }
      return ''; // label at brand level
    }
    if (item.refund_status_id == 3) {
      return `<p class="gd-chat-widget-li-req-text-danger">Exchange request <strong>Declined</strong>.</p>`;
    }
    return `<p class="gd-chat-widget-li-req-text-success">Exchange completed from order ${gdWidgetEscHtml(item.exchange_order || '')} — Qty: ${item.return_qty}.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 5. ALREADY REQUESTED FOR ALTERATION
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderAlreadyRequestedAlteration(alterationRequests, isRestricted) {
  let html = `
    <div class="gd-chat-widget-li-requested-separator">
      <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-info">Already Requested for Alteration</div>`;

  alterationRequests.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="gd-chat-widget-li-req-accordion">
        <div class="gd-chat-widget-li-req-acc-header" onclick="gdWidgetReqAccToggle(this)">
          <span class="gd-chat-widget-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Alteration on ${gdWidgetEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="gd-chat-widget-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach(seller => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;

      html += isCancelled
        ? gdWidgetReqBanner('cancelled', 'Alteration request was cancelled or declined', '', '', '')
        : gdWidgetReqBanner('success',
            'Alteration Request Successful!',
            'Please send back the item so we can complete the alterations for you.',
            'Alteration', '#7c3aed');

      html += `<div class="gd-chat-widget-req-brand-title">${gdWidgetEscHtml(seller.brand || '')}</div>`;

      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? gdWidgetReqStepsBox('How to Send for Alteration:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
            'Your item will be tailored and returned within 7–14 days',
          ])
        : '';

      const leftCol = `
        <div class="gd-chat-widget-req-col-steps">
          <div class="gd-chat-widget-req-col-heading"><span>✂️</span> Next Steps</div>
          <div class="gd-chat-widget-req-col-sub">Follow these steps to complete your alteration</div>
          ${stepsHtml}
          ${!isCancelled ? gdWidgetReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="gd-chat-widget-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const uid = `alt_req_${item.id}_${index}_${itemIdx}`;
        const returning = item.return_qty || item.quantity || 1;
        const statusHtml = gdWidgetAlterationItemStatus(item, isRestricted);

        rightItems += `
          <div class="gd-chat-widget-req-product-card">
            <div class="gd-chat-widget-req-product-img">
              ${item.image
                ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
                : `<div class="gd-chat-widget-li-img-placeholder">G</div>`}
            </div>
            <div class="gd-chat-widget-req-product-info">
              <div class="gd-chat-widget-req-product-name">${gdWidgetEscHtml(item.name)}</div>
              <div class="gd-chat-widget-li-price">£${parseFloat(item.price || 0).toFixed(2)}</div>

              <button class="gd-chat-widget-li-view-details-btn" type="button"
                      onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-det_${uid}')">
                ${gdWidgetInfoIcon()} View Details
                <span class="gd-chat-widget-li-chevron">▾</span>
              </button>
              <div id="gd-chat-widget-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
                <div class="gd-chat-widget-li-detail-grid">
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">SKU</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku || '—')}</div>
                  </div>
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Size</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div>
                  </div>
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Colour</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div>
                  </div>
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Ordered</div>
                    <div class="gd-chat-widget-li-dv">${item.quantity || 1}</div>
                  </div>
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Altering</div>
                    <div class="gd-chat-widget-li-dv">${returning}</div>
                  </div>
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Brand</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div>
                  </div>
                  ${item.alteration_request_status ? `
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Status</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.alteration_request_status)}</div>
                  </div>` : ''}
                  ${item.alteration_request_length ? `
                  <div class="gd-chat-widget-li-dc">
                    <div class="gd-chat-widget-li-dl">Requested Length (cm)</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.alteration_request_length)}</div>
                  </div>` : ''}
                  ${item.alteration_request_note?.trim() ? `
                  <div class="gd-chat-widget-li-dc" style="grid-column: 1 / -1;">
                    <div class="gd-chat-widget-li-dl">Note</div>
                    <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.alteration_request_note)}</div>
                  </div>` : ''}
                </div>

                ${item.alteration_request_trackings?.length > 0 ? `
                <div style="margin-top:6px;display:none">
                  ${item.alteration_request_trackings.map(t => `
                    <a href="${gdWidgetEscHtml(t.tracking_url)}" target="_blank"
                       class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label"
                       style="margin-bottom:4px;font-size:10px;">
                      ${gdWidgetEscHtml(t.tracking_name)} — ${gdWidgetEscHtml(t.tracking_id)}
                    </a>
                  `).join('')}
                </div>` : ''}

                ${item.alteration_request_status === 'Pending' && item.return_tracking?.label_url && item.return_tracking.label_url !== 'error' ? `
                <div style="margin-top:6px;display:flex;gap:6px;flex-wrap:wrap;display:none">
                  <a href="${gdWidgetEscHtml(item.return_tracking.label_url)}" target="_blank"
                     class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label">
                    ⬇ Download Return Label
                  </a>
                  ${item.return_tracking.qrcode_url && item.return_tracking.qrcode_url !== 'error' ? `
                  <a href="${gdWidgetEscHtml(item.return_tracking.qrcode_url)}" target="_blank"
                     class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-qr">
                    ⇄ Download QR Code
                  </a>` : ''}
                </div>` : ''}
              </div>

              ${statusHtml
                ? `<div class="gd-chat-widget-req-product-status">${statusHtml}</div>`
                : `<span class="gd-chat-widget-req-ready-badge" style="background:#ede9fe;color:#7c3aed;">Ready to Alter</span>`}
            </div>
          </div>`;
      });

      const rightCol = `
        <div class="gd-chat-widget-req-col-products">
          <div class="gd-chat-widget-req-col-heading-row">
            <div class="gd-chat-widget-req-col-heading"><span>📋</span> Alteration Items</div>
            <span class="gd-chat-widget-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="gd-chat-widget-req-col-sub">Items included in this alteration</div>
          ${rightItems}
        </div>`;

      html += gdWidgetReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

function gdWidgetAlterationItemStatus(item, isRestricted) {
  if (isRestricted) return '';
  if (item.alteration_request_status == null) return '';

  let html = `
    <div class="gd-chat-widget-req-meta-label" style="margin-top:4px;display:none">Status:</div>
    <div class="gd-chat-widget-req-meta-value" style="margin-bottom:3px;display:none">${gdWidgetEscHtml(item.alteration_request_status)}</div>`;

  if (item.alteration_request_length) {
    html += `<div class="gd-chat-widget-req-meta-label" style="display:none">Requested Length (cm):</div>
             <div class="gd-chat-widget-req-meta-value" style="margin-bottom:3px;display:none">${gdWidgetEscHtml(item.alteration_request_length)}</div>`;
  }

  if (item.alteration_request_note?.trim()) {
    html += `<div class="gd-chat-widget-req-meta-label" style="display:none">Note:</div>
             <div class="gd-chat-widget-req-meta-value" style="margin-bottom:3px;display:none">${gdWidgetEscHtml(item.alteration_request_note)}</div>`;
  }

  if (item.alteration_request_trackings?.length > 0) {
    html += `<div class="gd-chat-widget-req-meta-label" style="margin-bottom:2px;display:none">Tracking:</div>`;
    item.alteration_request_trackings.forEach(t => {
      html += `<a href="${gdWidgetEscHtml(t.tracking_url)}" target="_blank" class="gd-chat-widget-li-req-btn" style="margin-bottom:2px;">
                 ${gdWidgetEscHtml(t.tracking_name)} — ${gdWidgetEscHtml(t.tracking_id)}
               </a>`;
    });
  }

  // Per-item label (alteration pending state)
  if (item.alteration_request_status === 'Pending' && item.return_tracking?.label_url) {
    if (item.return_tracking.label_url !== 'error') {
      html += `<a href="${gdWidgetEscHtml(item.return_tracking.label_url)}" target="_blank"
                  class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-label" style="margin-top:4px;display:none">
                 ⬇ Download Return Label
               </a>`;
    }
    if (item.return_tracking.qrcode_url && item.return_tracking.qrcode_url !== 'error') {
      html += `<a href="${gdWidgetEscHtml(item.return_tracking.qrcode_url)}" target="_blank"
                  class="gd-chat-widget-req-dl-btn gd-chat-widget-req-dl-btn-qr" style="display:none">
                 ⇄ Download QR Code
               </a>`;
    }
  }

  return html;
}


// ─────────────────────────────────────────────────────────────
// SHARED UTILITIES
// ─────────────────────────────────────────────────────────────

function gdWidgetReqAccToggle(header) {
  const body  = header.nextElementSibling;
  const arrow = header.querySelector('.gd-chat-widget-li-req-acc-arrow');
  const isOpen = body.style.display !== 'none';
  body.style.display = isOpen ? 'none' : 'block';
  if (arrow) arrow.classList.toggle('open', !isOpen);
}

function gdWidgetOpenPaymentFromPending(btn) {
  const invoiceUrl = btn.dataset.invoiceUrl;
  if (!invoiceUrl) return;

  // Walk up to panel or standalone wrapper — mirrors both render paths
  const container = btn.closest('.gd-chat-widget-li-panel')
                 || btn.closest('.gd-chat-widget-li-requested-only');
  const panelId = container?.id;
  if (!panelId) return;

  const content = document.getElementById(`gd-chat-widget-pay-content_${panelId}`);
  if (!content) return;

  const shippingCode = container?.dataset?.shippingCode || '';
  const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);
  const returnFee    = parseFloat(container?.dataset?.returnFee || 0) || 1.99;

  // Read pending labels stored on container
  let pendingLabels = [];
  try {
    pendingLabels = JSON.parse(container.dataset.pendingLabels || '[]');
  } catch(e) { pendingLabels = []; }

  let html = `
    <h3 style="margin:0 0 12px;font-size:14px;font-weight:700;">Return Fee Pending</h3>
    <p style="font-size:12px;margin:0 0 10px;color:#374151;">
      You previously selected the Return Label option for some items but have not yet paid
      the associated fees. Below are the pending return label charges. Once the payment is
      completed, you will be able to download the return label.
    </p>`;

  // Build groupedData for Pusher label download after payment
  const grouped = [];

  pendingLabels.forEach((label, index) => {
    // Same skip condition as old portal
    const skip =
      label.return_request_status_id      == 5 &&
      label.return_request_item_status_id == 4 &&
      label.return_request_financial_status == null &&
      label.is_return_fee                 == 1;
    if (skip) return;

    const invoiceNumber   = index + 1;
    const returnRequestId = label.return_request_id || '';

    html += `
      <div class="gd-chat-widget-pay-accordion">
        <div class="gd-chat-widget-pay-acc-header" onclick="gdWidgetPayAccToggle(this)"
             style="display:flex;align-items:center;justify-content:space-between;">
          <span>
            <span class="gd-chat-widget-pay-acc-arrow open">▾</span>
            Return Fee #${invoiceNumber}
          </span>
          <a class="gd-chat-widget-pay-now-btn"
             href="${gdWidgetEscHtml(label.invoice_url || '')}"
             target="_blank"
             rel="noopener noreferrer"
             data-return-request-id="${returnRequestId}"
             data-panel-id="${panelId}"
             onclick="gdWidgetPayNowClick(this)"
             style="font-size:11px;margin-left:8px;">
            Pay Now
          </a>
        </div>
        <div class="gd-chat-widget-pay-acc-body" style="display:block;">`;

    if (isRestricted) {
      html += `
        <p style="font-size:12px;color:#374151;display:none;">
          You have selected the following items for return. A return fee of
          £${returnFee.toFixed(2)} is required before you can download the return label.
        </p>
        <p style="font-size:12px;color:#374151;">
          Now please go to this URL
          <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307"
             target="_blank" rel="noopener noreferrer" style="color:#1d4ed8;">
            https://www.omniparcelreturns.com/bookreturn/booking_return/307
          </a>
          and generate your return label. Thanks.
        </p>`;
    } else {
      html += `
        <p style="font-size:12px;color:#374151;">
          You have selected the following items for return. A return fee of
          £${returnFee.toFixed(2)} is required before you can download the return label.
        </p>`;

      // Error code — mirrors old portal: if (label.error_code !== 0)
      if (label.error_code !== 0) {
        html += `<div style="font-size:11px;color:#e74c3c;margin-bottom:8px;display:none">
                   Some error occurred. Error Code: ${gdWidgetEscHtml(String(label.error_code || ''))}
                 </div>`;
      }
    }

    html += `
      <p style="font-size:12px;color:#374151;${isRestricted ? 'display:none;' : ''}">
        Once this return fee is paid, you can download the return label for the following items:
      </p>`;

    // Loop sellers — mirrors old: label.items.forEach(sellerwiseItem)
    (label.items || []).forEach(seller => {
      html += `<h4 data-brand-id="${gdWidgetEscHtml(String(seller.brand_id || ''))}"
                   style="font-size:12px;font-weight:700;margin:8px 0 4px;"
                   class="gd-chat-widget-brand-fee-header">
                 ${gdWidgetEscHtml(seller.brand || '')}
               </h4>
               <ul class="gd-chat-widget-pay-sku-list">`;

      (seller.items || []).forEach(item => {
        html += `<li>${gdWidgetEscHtml(item.sku || '')}</li>`;

        // Build grouped for Pusher label injection after payment
        let group = grouped.find(g => g.brand_id === seller.brand_id);
        if (!group) {
          group = { brand_id: seller.brand_id, brand_name: seller.brand, items: [] };
          grouped.push(group);
        }
        group.items.push({ line_item_id: item.id, brand_id: seller.brand_id });
      });

      html += `</ul>`;
    });

    html += `</div></div>`;
  });

  // Store grouped for Pusher payment confirmation — same as gdWidgetShowPaymentPopup
  _gdWidgetGroupedData[panelId] = grouped;

  content.innerHTML = html;

  const popup = document.getElementById(`gd-chat-widget-pay-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}




function gdWidgetRenderRequestedPopups(panelId) {
    return `
        <div id="gd-chat-widget-pay-popup_${panelId}"
             class="gd-chat-widget-pay-popup" hidden>
            <div class="gd-chat-widget-pay-overlay"> </div>
            <div class="gd-chat-widget-pay-box">
                <button class="gd-chat-widget-pay-close"
                        onclick="gdWidgetPayPopupClose('${panelId}')">✕</button>
                <div id="gd-chat-widget-pay-content_${panelId}"></div>
            </div>
        </div>`;
}

//return implementation ends




//exchange implementation start

// ─────────────────────────────────────────────────────────────
// ENTRY POINT
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderExchangePanel(items, lineItemsData) {
  const panelId      = `gd-chat-widget-exPanel_${Date.now()}`;
  const isActive     = lineItemsData.is_active_date == 1;
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);

  // Only build item cards if there are not_requested items
  const cards = (items && items.length)
    ? items.map((item, index) =>
        gdWidgetBuildExchangeCard(item, index, lineItemsData, panelId)
      ).join('')
    : '';

  // Already requested sections — mirrors portal exchange tab:
  // processAlreadyExchangeItems + alreadyRequested(Return) + alreadyRequested(Alteration)
  // + getOutletItemHtml + getNonReturnableItemHtml
  const requested = lineItemsData.requested || {};

  let alreadyRequestedHtml = '';

  // 1. Already exchanged — mirrors processAlreadyExchangeItems(data)
  if (requested?.exchange?.length > 0) {
    alreadyRequestedHtml += gdWidgetRenderAlreadyRequestedExchange(requested.exchange, isRestricted);
  }

  // 2. Already returned (complete_label) — mirrors alreadyRequested(..., 'Return')
  const completeItems = (requested?.return?.return_label?.complete_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  if (completeItems.length > 0) {
    alreadyRequestedHtml += gdWidgetRenderExAlreadyReturnedCards(completeItems, 'Return');
  }

  // 3. Already returned (pending_label) — mirrors alreadyRequested(..., 'Return')
  const pendingItems = (requested?.return?.return_label?.pending_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  if (pendingItems.length > 0) {
    alreadyRequestedHtml += gdWidgetRenderExAlreadyReturnedCards(pendingItems, 'Return');
  }

  // 4. Already altered — mirrors alreadyRequested(..., 'Alteration')
  if (requested?.alteration?.length > 0) {
    alreadyRequestedHtml += gdWidgetRenderAlreadyRequestedAlteration(requested.alteration, isRestricted);
  }

  // 5. Outlet items — mirrors getOutletItemHtml(data, 'exchange') — partner 1 only
  if (lineItemsData.partner_id == 1) {
    const outletItems = (lineItemsData.outlet || []).flatMap(s => s.items || []);
    if (outletItems.length > 0) {
      alreadyRequestedHtml += gdWidgetRenderExOutletCards(outletItems);
    }
  }

  // 6. Non-returnable items — mirrors getNonReturnableItemHtml(data)
  if ((lineItemsData.nonReturnableItems || []).length > 0) {
    alreadyRequestedHtml += gdWidgetRenderNonReturnableItems(lineItemsData);
  }

  // If there are no new items AND no already-requested sections — nothing to render
  if (!cards && !alreadyRequestedHtml) return '';

  return `
    <div class="gd-chat-widget-ex-panel"
         id="${panelId}"
         data-original-query="${gdWidgetEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}">

      <div class="gd-chat-widget-li-sticky-top">
        <span><strong>Exchange Items:</strong> Select a product and choose the size or colour you'd like instead</span>
      </div>

      <div class="gd-chat-widget-li-select-all-bar">
        <label class="gd-chat-widget-li-select-all-label">
          <input type="checkbox"
                 class="gd-chat-widget-li-checkbox gd-chat-widget-ex-select-all-chk"
                 onchange="gdWidgetExToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="gd-chat-widget-ex-selected-count">0 items selected</span>
      </div>

      <div class="gd-chat-widget-li-grid">
        ${cards}
        ${alreadyRequestedHtml}
      </div>

      <div class="gd-chat-widget-li-sticky-bottom">
        <!-- T&C -->
        <div class="gd-chat-widget-li-terms-wrapper" id="gd-chat-widget-ex-terms_${panelId}" style="display:none;">
          <label class="gd-chat-widget-li-terms-label">
            <input type="checkbox"
                   class="gd-chat-widget-ex-terms-chk"
                   id="gd-chat-widget-ex-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
          </label>
          <p class="gd-chat-widget-li-terms-error"
             id="gd-chat-widget-ex-terms-err_${panelId}"
             style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;">
            Please accept the terms and conditions.
          </p>
        </div>

        <button class="gd-chat-widget-li-process-btn" disabled onclick="gdWidgetHandleExchange(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          EXCHANGE ITEMS
        </button>
      </div>

    </div>`;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE EXCHANGE CARD
// ─────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────
// EXCHANGE HELPERS — already-returned + outlet disabled cards
// Mirrors portal alreadyRequested(..., 'Return') and
// getOutletItemHtml(data, 'exchange') in exchange tab
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderExAlreadyReturnedCards(items, type, action = 'exchanged') {
  if (!items.length) return '';
  let html = `
    <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-info gd-chat-widget-li-grid-full">
      Already Requested for ${type}
    </div>`;
  items.forEach((item, i) => {
    const uid = `already_${type}_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = (price !== gross)
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    html += `
      <div class="gd-chat-widget-li-card">
        <div class="gd-chat-widget-li-img-wrap">
          <div class="gd-chat-widget-li-img">
            ${item.image
              ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
              : `<div class="gd-chat-widget-li-img-placeholder">G</div>`}
          </div>
        </div>
        <div class="gd-chat-widget-li-body">
          <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
          <div class="gd-chat-widget-li-price">${priceHtml}</div>

          <button class="gd-chat-widget-li-view-details-btn" type="button"
                  onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-det_${uid}')">
            ${gdWidgetInfoIcon()} View Details
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div id="gd-chat-widget-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
            <div class="gd-chat-widget-li-detail-grid">
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Size</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Colour</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">SKU</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Qty</div>
                <div class="gd-chat-widget-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Brand</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Tracking</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)} — ${gdWidgetEscHtml(item.tracking_id || '')}</div>
              </div>` : ''}
            </div>
          </div>

          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item has already been requested for ${type.toLowerCase()} and cannot be ${action}.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>
      </div>`;
  });
  return html;
}


function gdWidgetRenderExOutletCards(items) {
  if (!items.length) return '';
  let html = `
    <div class="gd-chat-widget-li-req-badge gd-chat-widget-li-req-badge-warn gd-chat-widget-li-grid-full">
      Outlet Item
    </div>`;
  items.forEach((item, i) => {
    const uid = `ex_outlet_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = (price !== gross)
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    const outletBadge = `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-outlet">Outlet</div>`;
    const gradeBadge = item.grade
      ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-grade">Grade ${item.grade}</div>` : '';

    html += `
      <div class="gd-chat-widget-li-card">
        <div class="gd-chat-widget-li-img-wrap">
          <div class="gd-chat-widget-li-img">
            ${item.image
              ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
              : `<div class="gd-chat-widget-li-img-placeholder">G</div>`}
          </div>
          <div class="gd-chat-widget-li-badges">${outletBadge}${gradeBadge}</div>
        </div>
        <div class="gd-chat-widget-li-body">
          <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
          <div class="gd-chat-widget-li-price">${priceHtml}</div>



          <button class="gd-chat-widget-li-view-details-btn" type="button"
                  onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-det_${uid}')">
            ${gdWidgetInfoIcon()} View Details
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div id="gd-chat-widget-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
            <div class="gd-chat-widget-li-detail-grid">
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Size</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Colour</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">SKU</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku || '—')}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Qty</div>
                <div class="gd-chat-widget-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Brand</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Tracking Company</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)}</div>
              </div>` : ''}
              ${item.tracking_id ? `
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Tracking ID</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_id)}</div>
              </div>` : ''}
            </div>
          </div>

          <p style="font-size:11px;margin:4px 0;">
            Please note: All outlet items are final sale and cannot be exchanged. These are reduced,
            end-of-line or seasonal products and are not eligible for refunds or exchanges.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>
      </div>`;
  });
  return html;
}

function gdWidgetBuildExchangeCard(item, index, lineItemsData, panelId) {
  const uid    = `ex_${panelId}_${item.id}_${index}`;
  const isActive = lineItemsData.is_active_date == 1;

  // Same conditions as return portal
  const isGiftBag      = !!item.is_gift_bag;
  // const isOutlet       = !!item.is_outlet;
  const isOutlet = item.product_tags?.includes('outlet') || false;
  const isMystery      = !!item.is_mystery;
  const isHygiene      = item.seller_id == 60;
  const isCanExchange  = !!item.can_exchange;
  const hasVariants    = item.variants && item.variants.length > 0;

  // Checkbox disabled when any blocking condition
  const checkboxDisabled =
    isGiftBag     ||
    isOutlet      ||
    isMystery     ||
    isHygiene     ||
    !isActive     ||
    !isCanExchange||
    !hasVariants;

  // Price display
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
    : `<div class="gd-chat-widget-li-img-placeholder">G</div>`;

  // Exchange reasons — uses exchange_reasons not reasons
  const exchangeReasons = lineItemsData.exchange_reasons || [];
  const reasonOpts = exchangeReasons.map(r =>
    `<option value="${r.id}">${gdWidgetEscHtml(r.name)}</option>`
  ).join('');

  // Variant options
  const variantOpts = hasVariants
    ? item.variants.map(v =>
        `<option value="${gdWidgetEscHtml(v.value)}" data-variant-id="${v.id}">
           ${gdWidgetEscHtml(v.value)}
         </option>`
      ).join('')
    : '';

  // Badges
  const outletBadge  = isOutlet  ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-outlet">Outlet</div>` : '';
  const gradeBadge   = item.grade ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-grade">Grade ${item.grade}</div>` : '';
  const mysteryBadge = isMystery  ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-warn">Mystery Box</div>` : '';
  const giftBagBadge = isGiftBag  ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-gift">Promotional Bag</div>` : '';

  // What to show in the body
  // const showForm = isActive && isCanExchange && !isGiftBag && !isOutlet && !isMystery && !isHygiene;

  const showForm = isActive && isCanExchange && !isGiftBag && !isMystery && !isHygiene;


  return `
    <div class="gd-chat-widget-li-card${checkboxDisabled ? ' gd-chat-widget-li-card-disabled' : ''}"
         id="gd-chat-widget-ex-card_${uid}"
         data-item-id="${item.id}"
         data-sku="${gdWidgetEscHtml(item.sku || '')}"
         data-name="${gdWidgetEscHtml(item.name || '')}"
         data-original-size="${gdWidgetEscHtml(item.color + ' / ' + item.size)}"
         data-max-qty="${item.availableQty || item.quantity || 1}">

      <input type="checkbox"
             class="gd-chat-widget-li-checkbox gd-chat-widget-ex-chk"
             id="gd-chat-widget-ex-chk_${uid}"
             data-uid="${uid}"
             ${checkboxDisabled ? 'disabled' : ''}
             onchange="gdWidgetExOnCheckboxChange(this)" />

      <div class="gd-chat-widget-li-img-wrap">
        <div class="gd-chat-widget-li-img">${imgHtml}</div>
        <div class="gd-chat-widget-li-badges">${outletBadge}${gradeBadge}${mysteryBadge}${giftBagBadge}</div>
      </div>

      <div class="gd-chat-widget-li-body">

        <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
        <div class="gd-chat-widget-li-price">${priceHtml}</div>
        <div style="font-size:10px;color:#6b7280;margin-bottom:4px;display:none;">
          ${gdWidgetEscHtml(item.color)} / ${gdWidgetEscHtml(item.size)} &nbsp;·&nbsp; SKU: ${gdWidgetEscHtml(item.sku)}
        </div>

        <!-- Status messages -->
        ${!isActive ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The exchange period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && !isCanExchange ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for exchange.
          </p>
        ` : ''}

        ${isActive && isCanExchange && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product and as per our policy, Mystery Box items are non-exchangeable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && isCanExchange && !isMystery && isHygiene ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            For hygiene reasons, we are unable to accept exchanges on beauty products, pierced jewellery,
            make-up, skin care, fragrances, hair products, face masks, lingerie &amp; swimwear.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && isCanExchange && !isMystery && !isHygiene && isGiftBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The promotional bag cannot be exchanged.
          </p>
        ` : ''}

        ${showForm ? `

          <!-- View Details -->
          <button class="gd-chat-widget-li-view-details-btn" type="button"
                  onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-ex-det_${uid}')">
            ${gdWidgetInfoIcon()} View Details
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div id="gd-chat-widget-ex-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
            <div class="gd-chat-widget-li-detail-grid">
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Size</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Colour</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">SKU</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku)}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Qty</div><div class="gd-chat-widget-li-dv">${item.quantity}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Brand</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div></div>
              ${item.tracking_name ? `<div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Tracking</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)} — ${gdWidgetEscHtml(item.tracking_id)}</div></div>` : ''}
            </div>
          </div>

          ${hasVariants ? `

            <!-- Exchange form: Available Option + Qty + Reason -->
            <div class="gd-chat-widget-ex-form-row">

              <!-- Available Option -->
              <div class="gd-chat-widget-ex-field-wrap">
                <label class="gd-chat-widget-li-label">
                  Exchange For <span class="gd-chat-widget-li-req">*</span>
                </label>
                <select class="gd-chat-widget-ex-available-option"
                        data-uid="${uid}"
                        data-size="${gdWidgetEscHtml(item.color + ' / ' + item.size)}"
                        onchange="gdWidgetExOnVariantChange(this)">
                  <option value="">Select option…</option>
                  ${variantOpts}
                </select>
              </div>

              <!-- Quantity -->
              <div class="gd-chat-widget-ex-field-wrap gd-chat-widget-ex-field-qty">
                <label class="gd-chat-widget-li-label">Quantity</label>
                <div class="gd-chat-widget-li-stepper">
                  <button type="button" onclick="gdWidgetExChangeQty(this, -1, '${uid}')" ${(item.availableQty || item.quantity || 1) <= 1 ? 'disabled' : ''}>−</button>
                  <div class="gd-chat-widget-ex-qty">1</div>
                  <button type="button" onclick="gdWidgetExChangeQty(this, +1, '${uid}')" ${(item.availableQty || item.quantity || 1) <= 1 ? 'disabled' : ''}>+</button>
                </div>
                <span class="gd-chat-widget-li-error-msg"
                      id="gd-chat-widget-ex-qty-err_${uid}"
                      hidden>
                  Quantity cannot exceed available quantity [${item.availableQty || item.quantity}]
                </span>
              </div>

            </div>

            <!-- Same size warning -->
            <p class="gd-chat-widget-ex-same-size-msg" id="gd-chat-widget-ex-same-msg_${uid}"
               style="display:none;color:#e74c3c;font-size:10px;margin:4px 0;">
              As you've selected the same size as the original item. Please let us know your reason for requesting an exchange using the text box below.
            </p>

            <!-- Circular exchange warning -->
            <p class="gd-chat-widget-ex-circular-msg" id="gd-chat-widget-ex-circular-msg_${uid}"
               style="display:none;color:#e74c3c;font-size:10px;margin:4px 0;">
              This selection creates a circular exchange. Please select a different option.
            </p>

            <!-- Reason -->
            <div class="gd-chat-widget-li-reason-wrap" style="margin-top:6px;">
              <label class="gd-chat-widget-li-label">
                Reason <span class="gd-chat-widget-li-req">*</span>
              </label>
              <select class="gd-chat-widget-ex-reason"
                      id="gd-chat-widget-ex-reason_${uid}"
                      data-uid="${uid}"
                      onchange="gdWidgetExOnReasonChange(this)">
                <option value="">Select a reason…</option>
                ${reasonOpts}
              </select>

              <!-- Specific reason — shown when reason = Other OR same size -->
              <textarea class="gd-chat-widget-ex-specific-reason"
                        id="gd-chat-widget-ex-specific_${uid}"
                        data-uid="${uid}"
                        placeholder="Please describe your reason…"
                        maxlength="150"
                        style="display:none;margin-top:6px;width:100%;font-size:11px;padding:6px;
                               border:1px solid #d1d5db;border-radius:6px;resize:vertical;"
                        oninput="gdWidgetExAutoCheck('${uid}')"></textarea>

              <span class="gd-chat-widget-li-error-msg" id="gd-chat-widget-ex-err_${uid}" hidden>
                Please fill all required fields
              </span>
            </div>

          ` : `
            <!-- No variants available -->
            <p style="font-size:11px;font-weight:600;color:#6b7280;padding:10px 0;">
              Another product option is not available for this item.
            </p>
          `}

        ` : ''}

      </div><!-- /.gd-chat-widget-li-body -->
    </div><!-- /.gd-chat-widget-li-card -->
  `;
}


// ─────────────────────────────────────────────────────────────
// VARIANT / AVAILABLE OPTION CHANGE
// Mirrors portal .available_option change handler exactly
// ─────────────────────────────────────────────────────────────

function gdWidgetExOnVariantChange(sel) {
  const uid          = sel.dataset.uid;
  const selectedVal  = sel.value;
  const originalSize = sel.dataset.size; // "Color / Size"
  const isSameSize   = selectedVal.trim().toLowerCase() === originalSize.trim().toLowerCase();

  const reasonSel   = document.getElementById(`gd-chat-widget-ex-reason_${uid}`);
  const specificEl  = document.getElementById(`gd-chat-widget-ex-specific_${uid}`);
  const sameMsgEl   = document.getElementById(`gd-chat-widget-ex-same-msg_${uid}`);

  // Reset specific reason
  if (specificEl) { specificEl.value = ''; specificEl.style.display = 'none'; }

  if (isSameSize) {
    // Same size — auto-set reason to "Other", disable dropdown, show textarea + warning
    if (reasonSel) {
      const otherOpt = [...reasonSel.options].find(o => o.text === 'Other');
      if (otherOpt) {
        reasonSel.value    = otherOpt.value;
        reasonSel.disabled = true;
      }
    }
    if (sameMsgEl) sameMsgEl.style.display = '';
    if (specificEl) specificEl.style.display = '';
  } else {
    // Different size — restore reason dropdown
    if (reasonSel) {
      reasonSel.value    = '';
      reasonSel.disabled = false;
    }
    if (sameMsgEl) sameMsgEl.style.display = 'none';
  }

  // Auto-check card
  gdWidgetExAutoCheck(uid);

  // Circular exchange detection
  const panel = sel.closest('.gd-chat-widget-ex-panel');
  if (panel && gdWidgetExDetectCircular(panel)) {
    const circularMsg = document.getElementById(`gd-chat-widget-ex-circular-msg_${uid}`);
    if (circularMsg) circularMsg.style.display = '';
    sel.value = '';
    if (reasonSel) { reasonSel.value = ''; reasonSel.disabled = false; }
    if (sameMsgEl) sameMsgEl.style.display = 'none';
  } else {
    const circularMsg = document.getElementById(`gd-chat-widget-ex-circular-msg_${uid}`);
    if (circularMsg) circularMsg.style.display = 'none';
  }

  if (panel) {
    gdWidgetExUpdateCount(panel);
    gdWidgetExUpdateTerms(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// REASON CHANGE
// ─────────────────────────────────────────────────────────────

function gdWidgetExOnReasonChange(sel) {
  const uid        = sel.dataset.uid;
  const isOther    = sel.options[sel.selectedIndex]?.text === 'Other';
  const specificEl = document.getElementById(`gd-chat-widget-ex-specific_${uid}`);

  if (specificEl) {
    specificEl.style.display = isOther ? '' : 'none';
    if (!isOther) specificEl.value = '';
  }

  gdWidgetExAutoCheck(uid);

  const panel = sel.closest('.gd-chat-widget-ex-panel');
  if (panel) {
    gdWidgetExUpdateCount(panel);
    gdWidgetExUpdateTerms(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// CIRCULAR EXCHANGE DETECTION
// Mirrors portal detectCircularExchange() — DFS graph traversal
// ─────────────────────────────────────────────────────────────

function gdWidgetExDetectCircular(panel) {
  const graph = {};

  panel.querySelectorAll('.gd-chat-widget-ex-available-option').forEach(sel => {
    const oldSku = String(sel.dataset.size).trim().toLowerCase();
    const newSku = String(sel.value).trim().toLowerCase();
    if (newSku && newSku !== '' && oldSku !== newSku) {
      graph[oldSku] = newSku;
    }
  });

  const visited = new Set();
  const stack   = new Set();

  function dfs(node) {
    if (stack.has(node))   return true;
    if (visited.has(node)) return false;
    visited.add(node);
    stack.add(node);
    const next = graph[node];
    if (next && dfs(next)) return true;
    stack.delete(node);
    return false;
  }

  return Object.keys(graph).some(key => dfs(key));
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// ─────────────────────────────────────────────────────────────

function gdWidgetExChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`gd-chat-widget-ex-card_${uid}`);
  const qtyEl  = btn.closest('.gd-chat-widget-li-stepper').querySelector('.gd-chat-widget-ex-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);

  // ADD: show/hide exceeded warning
  const exceedErr = document.getElementById(`gd-chat-widget-ex-qty-err_${uid}`);

  val = Math.max(1, val + delta);

  if (val > maxQty) {
    val = maxQty;
    if (exceedErr) exceedErr.hidden = false;
  } else {
    if (exceedErr) exceedErr.hidden = true;
  }

  qtyEl.textContent = val;
  gdWidgetExAutoCheck(uid);
}

// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function gdWidgetExOnCheckboxChange(chk) {
  const uid   = chk.dataset.uid;
  const panel = chk.closest('.gd-chat-widget-ex-panel');
  if (!chk.checked) gdWidgetExResetCard(uid);
  gdWidgetExUpdateCount(panel);
  gdWidgetExUpdateTerms(panel);
}

function gdWidgetExAutoCheck(uid) {
  const chk = document.getElementById(`gd-chat-widget-ex-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.gd-chat-widget-ex-panel');
  if (panel) {
    gdWidgetExUpdateCount(panel);
    gdWidgetExUpdateTerms(panel); 
  }
}

function gdWidgetExResetCard(uid) {
  const card = document.getElementById(`gd-chat-widget-ex-card_${uid}`);
  if (!card) return;

  const variantSel = card.querySelector('.gd-chat-widget-ex-available-option');
  if (variantSel) variantSel.value = '';

  const reasonSel = card.querySelector('.gd-chat-widget-ex-reason');
  if (reasonSel) { reasonSel.value = ''; reasonSel.disabled = false; }

  const specificEl = document.getElementById(`gd-chat-widget-ex-specific_${uid}`);
  if (specificEl) { specificEl.value = ''; specificEl.style.display = 'none'; }

  const sameMsgEl = document.getElementById(`gd-chat-widget-ex-same-msg_${uid}`);
  if (sameMsgEl) sameMsgEl.style.display = 'none';

  const circularMsg = document.getElementById(`gd-chat-widget-ex-circular-msg_${uid}`);
  if (circularMsg) circularMsg.style.display = 'none';

  const errEl = document.getElementById(`gd-chat-widget-ex-err_${uid}`);
  if (errEl) errEl.hidden = true;

  const qtyEl = card.querySelector('.gd-chat-widget-ex-qty');
  if (qtyEl) qtyEl.textContent = 1;
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function gdWidgetExToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.gd-chat-widget-ex-panel');
  const itemChks = [...panel.querySelectorAll(
    '.gd-chat-widget-ex-chk:not(.gd-chat-widget-ex-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) gdWidgetExResetCard(c.dataset.uid);
  });
  gdWidgetExUpdateCount(panel);
  gdWidgetExUpdateTerms(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function gdWidgetExUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.gd-chat-widget-ex-chk:not(.gd-chat-widget-ex-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.gd-chat-widget-ex-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.gd-chat-widget-ex-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  // Circular check across panel
  const hasCircular = gdWidgetExDetectCircular(panel);

  const allValid = count > 0 && !hasCircular && gdWidgetExValidate(checkedChks, false);
  const btn      = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('gd-chat-widget-li-process-active', allValid);
  }
}

function gdWidgetExUpdateTerms(panel) {
  const termsWrapper = panel.querySelector('.gd-chat-widget-li-terms-wrapper');
  const checkedCount = panel.querySelectorAll(
    '.gd-chat-widget-ex-chk:not(.gd-chat-widget-ex-select-all-chk):checked'
  ).length;
  if (termsWrapper) {
    termsWrapper.style.display = checkedCount > 0 ? '' : 'none';
    if (checkedCount === 0) {
      const termsChk = panel.querySelector('.gd-chat-widget-ex-terms-chk');
      if (termsChk) termsChk.checked = false;
    }
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION
// ─────────────────────────────────────────────────────────────

function gdWidgetExValidate(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid  = chk.dataset.uid;
    const card = document.getElementById(`gd-chat-widget-ex-card_${uid}`);
    if (!card) return;

    const variantSel  = card.querySelector('.gd-chat-widget-ex-available-option');
    const reasonSel   = card.querySelector('.gd-chat-widget-ex-reason');
    const specificEl  = document.getElementById(`gd-chat-widget-ex-specific_${uid}`);
    const errEl       = document.getElementById(`gd-chat-widget-ex-err_${uid}`);
    const qtyEl       = card.querySelector('.gd-chat-widget-ex-qty');

    let cardValid = true;

    // Variant required (if variants exist)
    if (variantSel && (!variantSel.value || variantSel.value === '')) cardValid = false;

    // Reason required
    if (reasonSel && (!reasonSel.value || reasonSel.value === '')) cardValid = false;

    // Specific reason required if "Other" or same size
    if (reasonSel && reasonSel.options[reasonSel.selectedIndex]?.text === 'Other') {
      if (!specificEl || !specificEl.value.trim()) cardValid = false;
    }
    if (specificEl && specificEl.style.display !== 'none' && !specificEl.value.trim()) {
      cardValid = false;
    }

    // Quantity required
    if (qtyEl && (!qtyEl.textContent || parseInt(qtyEl.textContent) < 1)) cardValid = false;

    if (!cardValid) {
      allValid = false;
      if (showErrors && errEl) errEl.hidden = false;
    } else {
      if (errEl) errEl.hidden = true;
    }
  });

  return allValid;
}


// ─────────────────────────────────────────────────────────────
// SUBMIT — mirrors portal exchange formData build
// ─────────────────────────────────────────────────────────────
function gdWidgetHandleExchange(btn) {
  const panel       = btn.closest('.gd-chat-widget-ex-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.gd-chat-widget-ex-chk:not(.gd-chat-widget-ex-select-all-chk):checked'
  )];
 
  if (!gdWidgetExValidate(checkedChks, true)) {
    gdWidgetScrollToFirstError(panel);
    gdWidgetToast('Please fill all required fields', 'warning');
    return;
  }
 
  // Circular check
  if (gdWidgetExDetectCircular(panel)) {
    gdWidgetToast('One or more exchange selections create a circular exchange. Please review.', 'error');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.gd-chat-widget-ex-terms-chk');
  const termsErr = panel.querySelector(`[id^="gd-chat-widget-ex-terms-err_"]`);
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    gdWidgetToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  const panelId       = panel.id;
  const termsAccepted = termsChk ? termsChk.checked : false;
 
  const items = checkedChks.map(chk => {
    const uid        = chk.dataset.uid;
    const card       = document.getElementById(`gd-chat-widget-ex-card_${uid}`);
    const variantSel = card.querySelector('.gd-chat-widget-ex-available-option');
    const reasonSel  = card.querySelector('.gd-chat-widget-ex-reason');
    const specificEl = document.getElementById(`gd-chat-widget-ex-specific_${uid}`);
    const qtyEl      = card.querySelector('.gd-chat-widget-ex-qty');
 
    const selectedOpt   = variantSel?.options[variantSel.selectedIndex];
    const to_exchange   = variantSel?.value     || '';
    const variant_id    = selectedOpt?.dataset.variantId || '';
    const reason_id     = reasonSel?.value      || '';
    const reason        = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    const specificReason = specificEl ? specificEl.value.trim() : '';
    const qty           = parseInt(qtyEl?.textContent || 1, 10) || 1;
    const item_id       = card.dataset.itemId || '';
    const item_name     = card.dataset.name   || '';
    const item_sku      = card.dataset.sku    || '';
 
    return { uid, item_id, item_sku, item_name, to_exchange, variant_id, reason_id, reason, specificReason, qty };
  });
 
  gdWidgetConfirm({
    title: 'Exchange Items',
    message: 'Please confirm before proceeding with your exchange request.',
    confirmText: 'Exchange',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: i.item_name, reason: i.reason, qty: i.qty })),
    onConfirm: function () {
      _gdWidgetSubmitExchange(btn, panel, panelId, items, termsAccepted);
    },
  });
}
 
function _gdWidgetSubmitExchange(btn, panel, panelId, items, termsAccepted) {
  const originalQuery = panel.dataset.originalQuery || '';
  const formData = new FormData();
  formData.append('order',    panel.dataset.orderId    || '');
  formData.append('customer', panel.dataset.customerId || '');
  formData.append('type', 'exchange');
  //formData.append('terms_conditions_checkbox', termsAccepted);
 
  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`,             item.item_id);
    formData.append(`items[${index}][sku]`,            item.item_sku);
    formData.append(`items[${index}][product]`,        item.item_name);
    formData.append(`items[${index}][reasonText]`,     item.reason);
    formData.append(`items[${index}][reason]`,         item.reason_id);
    formData.append(`items[${index}][specificReason]`, item.specificReason || '');
    formData.append(`items[${index}][quantity]`,       item.qty);
    formData.append(`items[${index}][to_exchange]`,    item.to_exchange);
    formData.append(`items[${index}][variant]`,        item.variant_id);
  });
 
  gdWidgetBtnStartLoading(btn, 'Processing exchange…');
  gdWidgetFreezePanel(panel, 'Processing your exchange…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmit}/v1/api/return/request-add`, {
    method: 'POST',
    body: formData,
  })
  .then(res => res.json())
  .then(response => {
    if (response.errors) {
      gdWidgetBtnStopLoading(btn, 'EXCHANGE ITEMS');
      gdWidgetUnfreezePanel(panel);
      gdWidgetToast(response.errors || 'Failed to process exchange', 'error');
      return;
    }
 
    gdWidgetBtnSuccess(btn, 'Exchange Submitted');
    gdWidgetToast(response.message || 'Exchange processed successfully!', 'success', 6000);

    if (originalQuery) {
      gdWidgetShowPanelLoader(panel, 'Please wait...');
      setTimeout(() => gdWidgetChatQuery(originalQuery), 1000);
    }

    // const originalQuery = panel.dataset.originalQuery || '';
    // gdWidgetRefreshPanel(panel, 'exchange');
  })
  .catch(err => {
    gdWidgetBtnStopLoading(btn, 'EXCHANGE ITEMS');
    gdWidgetUnfreezePanel(panel);
    gdWidgetToast('An unexpected error occurred. Please try again.', 'error');
    console.error('Exchange fetch error:', err);
  });
}
 


//exchange implementation ends



//alteration implementation start

// ─────────────────────────────────────────────────────────────
// ENTRY POINT
// ─────────────────────────────────────────────────────────────

function gdWidgetRenderAlterationPanel(notRequestedItems, lineItemsData) {
  const outletItems = (lineItemsData.outlet || []).flatMap(s => s.items || []);
  const allItems    = [...(notRequestedItems || []), ...outletItems];

  const goddivaItems = allItems.filter(item => item.is_goddiva);
  const alterations  = lineItemsData.requested?.alteration || [];
  const requested    = lineItemsData.requested || {};
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = GD_WIDGET_RESTRICTED_COUNTRIES.includes(shippingCode);

  // Already returned/exchanged items
  const completeReturnItems = (requested?.return?.return_label?.complete_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  const pendingReturnItems = (requested?.return?.return_label?.pending_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  const exchangeItems = (requested?.exchange || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);

  const hasAnything = goddivaItems.length > 0
    || alterations.length > 0
    || completeReturnItems.length > 0
    || pendingReturnItems.length > 0
    || exchangeItems.length > 0;

  if (!hasAnything) return '';

  const panelId = `gd-chat-widget-altPanel_${Date.now()}`;

  // Cards for not_requested + outlet
  const cards = goddivaItems.length > 0
    ? allItems.map((item, index) =>
        gdWidgetBuildAlterationCard(item, index, lineItemsData, panelId)
      ).join('')
    : '';

  // Already-requested sections
  let alreadyHtml = '';

  if (alterations.length > 0) {
    alreadyHtml += gdWidgetRenderAlreadyRequestedAlteration(alterations, isRestricted);
  }
  if (completeReturnItems.length > 0) {
    alreadyHtml += gdWidgetRenderExAlreadyReturnedCards(completeReturnItems, 'Return', 'altered');
  }
  if (pendingReturnItems.length > 0) {
    alreadyHtml += gdWidgetRenderExAlreadyReturnedCards(pendingReturnItems, 'Return', 'altered');
  }
  if (exchangeItems.length > 0) {
    alreadyHtml += gdWidgetRenderExAlreadyReturnedCards(exchangeItems, 'Exchange', 'altered');
  }

  return `
    <div class="gd-chat-widget-alt-panel"
         id="${panelId}"
         data-original-query="${gdWidgetEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}">

      <div class="gd-chat-widget-li-sticky-top">
        <span><strong>Made to Measure:</strong> Select items and specify the alterations you need</span>
      </div>

      ${goddivaItems.length > 0 ? `
      <div class="gd-chat-widget-li-select-all-bar">
        <label class="gd-chat-widget-li-select-all-label">
          <input type="checkbox"
                 class="gd-chat-widget-li-checkbox gd-chat-widget-alt-select-all-chk"
                 onchange="gdWidgetAltToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="gd-chat-widget-alt-selected-count">0 items selected</span>
      </div>
      ` : ''}

      <div class="gd-chat-widget-li-grid">
        ${cards}
        ${alreadyHtml}
      </div>

      ${goddivaItems.length > 0 ? `
      <div class="gd-chat-widget-li-sticky-bottom">
        <div class="gd-chat-widget-li-terms-wrapper"
             id="gd-chat-widget-alt-terms_${panelId}"
             style="display:none;">
          <label class="gd-chat-widget-li-terms-label">
            <input type="checkbox"
                   class="gd-chat-widget-alt-terms-chk"
                   id="gd-chat-widget-alt-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
          </label>
          <p style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;"
             class="gd-chat-widget-alt-terms-err"
             id="gd-chat-widget-alt-terms-err_${panelId}">
            Please accept the terms and conditions.
          </p>
        </div>

        <button class="gd-chat-widget-li-process-btn"
                disabled
                onclick="gdWidgetHandleAlteration(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          SUBMIT FOR ALTERATION
        </button>
      </div>
      ` : ''}

    </div>`;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE CARD
// ─────────────────────────────────────────────────────────────

function gdWidgetBuildAlterationCard(item, index, lineItemsData, panelId) {
  const uid      = `alt_${panelId}_${item.id}_${index}`;
  const isActive = lineItemsData.is_active_date == 1;

  // Portal: only Goddiva items shown in alteration tab
  const isGoddiva  = !!item.is_goddiva;
  const isGiftBag  = !!item.is_gift_bag;
  const isMystery  = !!item.is_mystery;
  const canAlter   = !!item.can_alteration_request;
  const maxQty     = item.availableQty || item.quantity || 1;

  // Checkbox disabled when: not Goddiva, not eligible, gift bag, mystery, period passed
  const checkboxDisabled = !isGoddiva || !canAlter || isGiftBag || isMystery || !isActive;

  // Price display
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${gdWidgetEscHtml(item.image)}" alt="${gdWidgetEscHtml(item.name)}" />`
    : `<div class="gd-chat-widget-li-img-placeholder">G</div>`;

  // Badges
  const gradeBadge   = item.grade  ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-grade">Grade ${item.grade}</div>` : '';
  const mysteryBadge = isMystery   ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-warn">Mystery Box</div>` : '';
  const giftBagBadge = isGiftBag   ? `<div class="gd-chat-widget-li-badge gd-chat-widget-li-badge-gift">Promotional Bag</div>` : '';

  // Show form only when fully eligible
  const showForm = isGoddiva && isActive && canAlter && !isGiftBag && !isMystery;

  // Card disabled styling
  const cardClass = `gd-chat-widget-li-card${checkboxDisabled ? ' gd-chat-widget-li-card-disabled' : ''}`;

  return `
    <div class="${cardClass}"
         id="gd-chat-widget-alt-card_${uid}"
         data-item-id="${item.id}"
         data-max-qty="${maxQty}">

      <input type="checkbox"
             class="gd-chat-widget-li-checkbox gd-chat-widget-alt-chk"
             id="gd-chat-widget-alt-chk_${uid}"
             data-uid="${uid}"
             ${checkboxDisabled ? 'disabled' : ''}
             onchange="gdWidgetAltOnCheckboxChange(this)" />

      <div class="gd-chat-widget-li-img-wrap">
        <div class="gd-chat-widget-li-img">${imgHtml}</div>
        <div class="gd-chat-widget-li-badges">${gradeBadge}${mysteryBadge}${giftBagBadge}</div>
      </div>

      <div class="gd-chat-widget-li-body">

        <div class="gd-chat-widget-li-name">${gdWidgetEscHtml(item.name)}</div>
        <div class="gd-chat-widget-li-price">${priceHtml}</div>
        <div style="font-size:10px;color:#6b7280;margin-bottom:4px;display:none;">
          ${gdWidgetEscHtml(item.color)} / ${gdWidgetEscHtml(item.size)}
          &nbsp;·&nbsp; SKU: ${gdWidgetEscHtml(item.sku)}
        </div>

        <!-- Status messages — mirrors portal conditions exactly -->
        ${!isGoddiva ? `
          <p style="font-size:11px;color:#6b7280;margin:4px 0;">
            Alteration is only available for Goddiva items.
          </p>
        ` : ''}

        ${isGoddiva && !isActive ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The alteration period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isGoddiva && isActive && !canAlter ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for alteration.
          </p>
        ` : ''}

        ${isGoddiva && isActive && canAlter && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product — it cannot be altered.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isGoddiva && isActive && canAlter && !isMystery && isGiftBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The promotional bag cannot be altered.
          </p>
        ` : ''}

        ${showForm ? `

          <!-- View Details -->
          <button class="gd-chat-widget-li-view-details-btn" type="button"
                  onclick="gdWidgetToggleDetails(this, 'gd-chat-widget-alt-det_${uid}')">
            ${gdWidgetInfoIcon()} View Details
            <span class="gd-chat-widget-li-chevron">▾</span>
          </button>
          <div id="gd-chat-widget-alt-det_${uid}" class="gd-chat-widget-li-detail-panel" hidden>
            <div class="gd-chat-widget-li-detail-grid">
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Size</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.size || '—')}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Colour</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.color || '—')}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">SKU</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.sku)}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Qty</div><div class="gd-chat-widget-li-dv">${item.quantity}</div></div>
              <div class="gd-chat-widget-li-dc"><div class="gd-chat-widget-li-dl">Brand</div><div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.brand || '—')}</div></div>
              ${item.tracking_name ? `
              <div class="gd-chat-widget-li-dc">
                <div class="gd-chat-widget-li-dl">Tracking</div>
                <div class="gd-chat-widget-li-dv">${gdWidgetEscHtml(item.tracking_name)} — ${gdWidgetEscHtml(item.tracking_id)}</div>
              </div>` : ''}
            </div>
          </div>

          <!-- Alteration form: Qty + Length + Note -->
          <div class="gd-chat-widget-alt-form-row">

            <!-- Quantity stepper -->
            <div class="gd-chat-widget-ex-field-wrap gd-chat-widget-ex-field-qty">
              <label class="gd-chat-widget-li-label">Quantity</label>
              <div class="gd-chat-widget-li-stepper">
                <button type="button" ${maxQty <= 1 ? 'disabled' : ''} onclick="gdWidgetAltChangeQty(this, -1, '${uid}')">−</button>
                <div class="gd-chat-widget-alt-qty">1</div>
                <button type="button" ${maxQty <= 1 ? 'disabled' : ''} onclick="gdWidgetAltChangeQty(this, +1, '${uid}')">+</button>
              </div>
            </div>

            <!-- Length input -->
            <div class="gd-chat-widget-ex-field-wrap">
              <label class="gd-chat-widget-li-label">
                Hem removal (cm) <span class="gd-chat-widget-li-req">*</span>
              </label>
              <input type="number"
                class="gd-chat-widget-alt-length"
                id="gd-chat-widget-alt-length_${uid}"
                data-uid="${uid}"
                placeholder="1–30 cm"
                min="1"
                max="30"
                oninput="gdWidgetAltLengthInput(this, '${uid}')"
                onblur="gdWidgetAltLengthBlur(this, '${uid}')" />
              <span style="font-size:9px;color:#9ca3af;line-height:normal">Enter a value between 1 and 30 cm.</span>
              <span id="gd-chat-widget-alt-length-error_${uid}" style="font-size:9px;color:red;line-height:normal"></span>
            </div>

          </div>

          <!-- Note textarea -->
          <div style="margin-top:8px;">
            <label class="gd-chat-widget-li-label">Note <span style="font-weight:400;color:#9ca3af;">(optional)</span></label>
            <textarea class="gd-chat-widget-alt-note"
                      id="gd-chat-widget-alt-note_${uid}"
                      data-uid="${uid}"
                      placeholder="Enter any additional notes for the tailor…"
                      maxlength="1000"
                      oninput="gdWidgetAltNoteInput(this, '${uid}')"></textarea>
            <span class="gd-chat-widget-alt-char-count"
                  id="gd-chat-widget-alt-chars_${uid}">1000 characters remaining</span>
          </div>

          <!-- Error message -->
          <span class="gd-chat-widget-li-error-msg"
                id="gd-chat-widget-alt-err_${uid}"
                hidden>
            Please fill all required fields (quantity and hem length)
          </span>

        ` : ''}

      </div><!-- /.gd-chat-widget-li-body -->
    </div><!-- /.gd-chat-widget-li-card -->
  `;
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// ─────────────────────────────────────────────────────────────

function gdWidgetAltChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`gd-chat-widget-alt-card_${uid}`);
  const qtyEl  = btn.closest('.gd-chat-widget-li-stepper').querySelector('.gd-chat-widget-alt-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);
  val          = Math.min(maxQty, Math.max(1, val + delta));
  qtyEl.textContent = val;
  gdWidgetAltAutoCheck(uid);
}


// ─────────────────────────────────────────────────────────────
// NOTE CHARACTER COUNTER — mirrors portal alterationremaining
// ─────────────────────────────────────────────────────────────

function gdWidgetAltNoteInput(textarea, uid) {
  const max       = 1000;
  const remaining = max - textarea.value.length;
  const counterEl = document.getElementById(`gd-chat-widget-alt-chars_${uid}`);
  if (counterEl) counterEl.textContent = `${remaining} character${remaining !== 1 ? 's' : ''} remaining`;
  gdWidgetAltAutoCheck(uid);
}


// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function gdWidgetAltOnCheckboxChange(chk) {
  const uid   = chk.dataset.uid;
  const panel = chk.closest('.gd-chat-widget-alt-panel');
  if (!chk.checked) gdWidgetAltResetCard(uid);
  gdWidgetAltUpdateCount(panel);
  gdWidgetAltUpdateTerms(panel);
}

function gdWidgetAltLengthInput(input, uid) {
  const raw = input.value;
  const val = parseFloat(raw);
  const errorEl = document.getElementById(`gd-chat-widget-alt-length-error_${uid}`);

  if (errorEl) {
    errorEl.textContent = '';
  }

  if (raw === '' || isNaN(val)) {
    gdWidgetAltAutoCheck(uid);
    return;
  }

  let messages = [];

  if (/^\d+\.\d{3,}$/.test(raw)) {
    messages.push('Only 2 decimal places allowed.');
  }

  if (val < 1 || val > 30) {
    // messages.push('Value must be between 1 and 30.');
  }

  if (errorEl) {
    errorEl.textContent = messages.join(' ');
  }

  gdWidgetAltAutoCheck(uid);
}

function gdWidgetAltLengthBlur(input, uid) {
  let raw = input.value;
  let val = parseFloat(raw);
  const errorEl = document.getElementById(`gd-chat-widget-alt-length-error_${uid}`);

  if (errorEl) errorEl.textContent = '';

  if (raw === '' || isNaN(val)) {
    input.value = '';
    gdWidgetAltAutoCheck(uid);
    return;
  }

  let messages = [];

  // 👉 Check decimal issue
  if (/^\d+\.\d{3,}$/.test(raw)) {
    messages.push('Only 2 decimal places allowed.');
  }

  // 👉 Clamp range
  if (val < 1) {
    val = 1;
  } else if (val > 30) {
    val = 30;
  }

  // 👉 Always trim to 2 decimals (no rounding surprise)
  val = Math.floor(val * 100) / 100;

  // 👉 Set value
  input.value = val.toFixed(2);

  // 👉 Show error if needed
  if (errorEl) {
    errorEl.textContent = messages.join(' ');
  }

  gdWidgetAltAutoCheck(uid);
}

function gdWidgetAltAutoCheck(uid) {
  const chk = document.getElementById(`gd-chat-widget-alt-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.gd-chat-widget-alt-panel');
  if (panel) {
    gdWidgetAltUpdateCount(panel);
    gdWidgetAltUpdateTerms(panel);
  }
}

function gdWidgetAltResetCard(uid) {
  const card = document.getElementById(`gd-chat-widget-alt-card_${uid}`);
  if (!card) return;

  const qtyEl = card.querySelector('.gd-chat-widget-alt-qty');
  if (qtyEl) qtyEl.textContent = 1;

  const lengthEl = document.getElementById(`gd-chat-widget-alt-length_${uid}`);
  if (lengthEl) lengthEl.value = '';

  const noteEl = document.getElementById(`gd-chat-widget-alt-note_${uid}`);
  if (noteEl) noteEl.value = '';

  const counterEl = document.getElementById(`gd-chat-widget-alt-chars_${uid}`);
  if (counterEl) counterEl.textContent = '1000 characters remaining';

  const errEl = document.getElementById(`gd-chat-widget-alt-err_${uid}`);
  if (errEl) errEl.hidden = true;

  const decimalErr = document.getElementById(`gd-chat-widget-alt-length-error_${uid}`);
  if(decimalErr) decimalErr.textContent = ''

  // Collapse details
  const detPanel = document.getElementById(`gd-chat-widget-alt-det_${uid}`);
  if (detPanel) detPanel.setAttribute('hidden', '');
  const detBtn = card.querySelector('.gd-chat-widget-li-view-details-btn');
  if (detBtn) detBtn.classList.remove('gd-chat-widget-li-view-details-open');
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function gdWidgetAltToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.gd-chat-widget-alt-panel');
  const itemChks = [...panel.querySelectorAll(
    '.gd-chat-widget-alt-chk:not(.gd-chat-widget-alt-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) gdWidgetAltResetCard(c.dataset.uid);
  });
  gdWidgetAltUpdateCount(panel);
  gdWidgetAltUpdateTerms(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function gdWidgetAltUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.gd-chat-widget-alt-chk:not(.gd-chat-widget-alt-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.gd-chat-widget-alt-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.gd-chat-widget-alt-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  const allValid = count > 0 && gdWidgetAltValidate(checkedChks, false);
  const btn      = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('gd-chat-widget-li-process-active', allValid);
  }
}

function gdWidgetAltUpdateTerms(panel) {
  const termsWrapper = panel.querySelector('.gd-chat-widget-li-terms-wrapper');
  const checkedCount = panel.querySelectorAll(
    '.gd-chat-widget-alt-chk:not(.gd-chat-widget-alt-select-all-chk):checked'
  ).length;
  if (termsWrapper) {
    termsWrapper.style.display = checkedCount > 0 ? '' : 'none';
    if (checkedCount === 0) {
      const termsChk = panel.querySelector('.gd-chat-widget-alt-terms-chk');
      if (termsChk) termsChk.checked = false;
    }
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION — mirrors portal: length + quantity required
// ─────────────────────────────────────────────────────────────

function gdWidgetAltValidate(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid    = chk.dataset.uid;
    const card   = document.getElementById(`gd-chat-widget-alt-card_${uid}`);
    const errEl  = document.getElementById(`gd-chat-widget-alt-err_${uid}`);
    if (!card) return;

    const qtyEl    = card.querySelector('.gd-chat-widget-alt-qty');
    const lengthEl = document.getElementById(`gd-chat-widget-alt-length_${uid}`);

    const qty    = parseInt(qtyEl?.textContent || 0, 10);
    
    const rawLength = parseFloat(lengthEl?.value || 0);
    const valid = qty >= 1 && !isNaN(rawLength) && rawLength >= 1 && rawLength <= 30;

    if (!valid) {
      allValid = false;
      if (showErrors && errEl) errEl.hidden = false;
    } else {
      if (errEl) errEl.hidden = true;
    }
  });

  return allValid;
}


// ─────────────────────────────────────────────────────────────
// SUBMIT — mirrors portal submitDataAlteration()
// Payload is JSON (not FormData) — matches /v1/api/web/made-to-measure
// ─────────────────────────────────────────────────────────────
function gdWidgetHandleAlteration(btn) {
  const panel       = btn.closest('.gd-chat-widget-alt-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.gd-chat-widget-alt-chk:not(.gd-chat-widget-alt-select-all-chk):checked'
  )];
 
  if (checkedChks.length === 0) {
    gdWidgetToast('Please select an item to proceed', 'warning');
    return;
  }
 
  if (!gdWidgetAltValidate(checkedChks, true)) {
    gdWidgetScrollToFirstError(panel);
    gdWidgetToast('Please fill all required fields', 'warning');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.gd-chat-widget-alt-terms-chk');
  const termsErr = panel.querySelector('.gd-chat-widget-alt-terms-err');
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    gdWidgetToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  const items = checkedChks.map(chk => {
    const uid      = chk.dataset.uid;
    const card     = document.getElementById(`gd-chat-widget-alt-card_${uid}`);
    const qtyEl    = card.querySelector('.gd-chat-widget-alt-qty');
    const lengthEl = document.getElementById(`gd-chat-widget-alt-length_${uid}`);
    const noteEl   = document.getElementById(`gd-chat-widget-alt-note_${uid}`);
 
    return {
      id       : card.dataset.itemId || '',
      length   : parseFloat(lengthEl?.value || 0),
      quantity : parseInt(qtyEl?.textContent || 1, 10),
      note     : noteEl?.value.trim() || null,
    };
  });
 
  const payload = {
    order    : panel.dataset.orderId    || '',
    customer : panel.dataset.customerId || '',
    type     : 'alteration',
    items    : items,
  };
 
  gdWidgetConfirm({
    title: 'Made to Measure',
    message: 'Please confirm before proceeding with your alteration request.',
    confirmText: 'Submit Alteration',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: `Item ${i.id}`, reason: `${i.length}cm`, qty: i.quantity })),
    onConfirm: function () {
      _gdWidgetSubmitAlteration(btn, panel, payload);
    },
  });
}
 
function _gdWidgetSubmitAlteration(btn, panel, payload) {
  const originalQuery = panel.dataset.originalQuery || '';

  gdWidgetBtnStartLoading(btn, 'Submitting alteration…');
  gdWidgetFreezePanel(panel, 'Submitting alteration…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmit}/v1/api/web/made-to-measure`, {
    method  : 'POST',
    headers : { 'Content-Type': 'application/json' },
    body    : JSON.stringify(payload),
  })
  .then(res => res.json())
  .then(response => {
    if (response.error) {
      gdWidgetBtnStopLoading(btn, 'SUBMIT FOR ALTERATION');
      gdWidgetUnfreezePanel(panel);
      gdWidgetToast(response.message || 'Failed to submit alteration', 'error');
      return;
    }
 
    gdWidgetBtnSuccess(btn, 'Alteration Submitted');
    gdWidgetToast('Alteration submitted successfully!', 'success', 6000);

    if (originalQuery) {
      gdWidgetShowPanelLoader(panel, 'Please wait...');
      setTimeout(() => gdWidgetChatQuery(originalQuery), 1000);
    }

    //gdWidgetRefreshPanel(panel, 'alteration');

  })
  .catch(err => {
    gdWidgetBtnStopLoading(btn, 'SUBMIT FOR ALTERATION');
    gdWidgetUnfreezePanel(panel);
    gdWidgetToast('An unexpected error occurred. Please try again.', 'error');
    console.error('Alteration fetch error:', err);
  });
}
 

//alteration implementation ends

// ─────────────────────────────────────────────────────────────
// UTILITIES
// ─────────────────────────────────────────────────────────────

function gdWidgetResetPanel(panel) {
  if (!panel) return;

  panel.querySelectorAll('input[type="checkbox"]').forEach(chk => {
    chk.checked = false;
    chk.indeterminate = false;
  });

  panel.querySelectorAll('input[type="radio"]').forEach(r => {
    r.checked = false;
  });

  panel.querySelectorAll('select').forEach(sel => {
    sel.value = '';
  });

  panel.querySelectorAll('textarea').forEach(ta => {
    ta.value = '';
    ta.style.display = 'none';
  });

  panel.querySelectorAll('.gd-chat-widget-li-opts').forEach(el => {
    el.setAttribute('hidden', '');
    const cardsWrap = el.querySelector('.gd-chat-widget-li-opts-cards');
    if (cardsWrap) cardsWrap.innerHTML = '';
  });

  panel.querySelectorAll('.gd-chat-widget-li-faulty-upload').forEach(el => {
    el.setAttribute('hidden', '');
  });

  panel.querySelectorAll('.gd-chat-widget-li-detail-panel').forEach(el => {
    el.setAttribute('hidden', '');
  });

  panel.querySelectorAll('.gd-chat-widget-li-view-details-btn').forEach(btn => {
    btn.classList.remove('gd-chat-widget-li-view-details-open');
  });

  panel.querySelectorAll('.gd-chat-widget-li-qty, .gd-chat-widget-ex-qty, .gd-chat-widget-alt-qty').forEach(el => {
    el.textContent = '1';
  });

  panel.querySelectorAll('.gd-chat-widget-li-error-msg').forEach(el => {
    el.hidden = true;
  });
  panel.querySelectorAll('.gd-chat-widget-li-opts-error').forEach(el => {
    el.classList.remove('gd-chat-widget-li-opts-error');
  });
  panel.querySelectorAll('.gd-chat-widget-li-field-error').forEach(el => {
    el.classList.remove('gd-chat-widget-li-field-error');
  });

  panel.querySelectorAll('[id^="gd-chat-widget-optDesc_"]').forEach(el => {
    el.textContent = '';
  });

  const summary = panel.querySelector('.gd-chat-widget-li-summary');
  if (summary) summary.style.display = 'none';

  const termsWrapper = panel.querySelector('.gd-chat-widget-li-terms-wrapper');
  if (termsWrapper) termsWrapper.style.display = 'none';

  const termsErr = panel.querySelector('.gd-chat-widget-li-terms-error');
  if (termsErr) termsErr.style.display = 'none';

  const addToPrev = panel.querySelector('.gd-chat-widget-li-addtoprev-wrapper');
  if (addToPrev) {
    addToPrev.style.display = 'none';
    const addToPrevErr = addToPrev.querySelector('.gd-chat-widget-li-addtoprev-error');
    if (addToPrevErr) addToPrevErr.style.display = 'none';
  }

  const countEl = panel.querySelector('.gd-chat-widget-li-selected-count, .gd-chat-widget-ex-selected-count, .gd-chat-widget-alt-selected-count');
  if (countEl) countEl.textContent = '0 items selected';

  const btn = panel.querySelector('.gd-chat-widget-li-process-btn');
  if (btn) {
    btn.disabled = true;
    btn.classList.remove('gd-chat-widget-li-process-active', 'gd-chat-widget-btn-loading', 'gd-chat-widget-btn-success', 'gd-chat-widget-li-process-done');
    btn.removeAttribute('data-original-text');
  }

  panel.querySelectorAll('.gd-chat-widget-li-faulty-previews').forEach(el => {
    el.querySelectorAll('img').forEach(img => {
      if (img.src.startsWith('blob:')) URL.revokeObjectURL(img.src);
    });
    el.innerHTML = '';
  });
}


function gdWidgetSilentRefresh(message, onSuccess) {
  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;

  const payload = {
    query        : message,
    assistant_id : localStorage.getItem('session_id'),
    is_history   : isHistory
  };

  if (window.isProductPage && window.productId) {
    payload.product_id = window.productId;
  }

  const token = getGDChatWidgetAiToken();

  fetch('https://ai.mygoddiva.com/user-query', {
    method  : 'POST',
    headers : Object.assign(
      { 'Content-Type': 'application/json' },
      token ? { 'Authorization': 'Bearer ' + token } : {}
    ),
    body: JSON.stringify(payload)
  })
  .then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  })
  .then(response => {
    if (typeof onSuccess === 'function' && response.line_items) {
      onSuccess(response.line_items);
    }
  })
  .catch(err => {
    console.error('gdWidgetSilentRefresh error:', err);
  });
}


function gdWidgetRefreshPanel(panel, type) {
  // Try to get order/customer from panel or parent
  const orderId    = panel.dataset.orderId || panel.closest('[data-order-id]')?.dataset.orderId;
  const customerId = panel.dataset.customerId || panel.closest('[data-customer-id]')?.dataset.customerId;

  if (!orderId && !customerId) {
    // Fallback — find any panel on the page with order data
    const anyPanel = document.querySelector('[data-order-id][data-customer-id]');
    if (anyPanel) {
      return gdWidgetRefreshPanel(anyPanel, type);
    }
    console.warn('Cannot refresh: missing order/customer ID');
    return;
  }

  const query = panel.dataset.originalQuery || `return request order ${orderId}`;

  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;
  const payload = {
    query        : query,
    assistant_id : localStorage.getItem('session_id'),
    is_history   : isHistory
  };

  if (window.isProductPage && window.productId) {
    payload.product_id = window.productId;
  }

  const token = getGDChatWidgetAiToken();

  fetch('https://ai.mygoddiva.com/user-query', {
    method  : 'POST',
    headers : Object.assign(
      { 'Content-Type': 'application/json' },
      token ? { 'Authorization': 'Bearer ' + token } : {}
    ),
    body: JSON.stringify(payload)
  })
  .then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  })
  .then(response => {
    if (!response.line_items) return;

    response._originalQuery = query;
    response.type = type === 'return' ? 'return_request'
                  : type === 'exchange' ? 'exchange_request'
                  : 'alteration_request';

    if (typeof gdChatWidgetChatResponse === 'function') {
      gdChatWidgetChatResponse(response, null, null, null);
    }
  })
  .catch(err => {
    console.error('gdWidgetRefreshPanel error:', err);
  });
}


function gdWidgetShowPanelLoader(panel, message) {
  
  if (!panel) return;

  // Remove existing loader if any
  panel.classList.add('gd-chat-widget-panel-stale');

  //gdWidgetHidePanelLoader(panel);
  
  const loader = document.createElement('div');
  loader.className = 'gd-chat-widget-panel-loader';
  loader.innerHTML = `
    <div class="gd-chat-widget-panel-loader-inner">
      <div class="gd-chat-widget-panel-loader-spinner"></div>
      <p class="gd-chat-widget-panel-loader-text">${gdWidgetEscHtml(message || 'Refreshing...')}</p>
    </div>
  `;
  panel.style.position = 'relative';
  panel.appendChild(loader);
}

function gdWidgetHidePanelLoader(panel) {
  if (!panel) return;
  const loader = panel.querySelector('.gd-chat-widget-panel-loader');
  if (loader) loader.remove();
}


function gdWidgetToast(message, type = 'info', duration = 4000) {
  // type: 'success' | 'error' | 'warning' | 'info'
 
  // Create container if it doesn't exist
  let container = document.getElementById('gd-chat-widget-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'gd-chat-widget-toast-container';
    const panel = document.getElementById('gd-chat-widget-assistantPanel') || document.body;
    panel.appendChild(container);
  }
 
  const toast = document.createElement('div');
  toast.className = `gd-chat-widget-toast gd-chat-widget-toast-${type}`;
 
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };
 
  toast.innerHTML = `
    <span class="gd-chat-widget-toast-icon">${icons[type] || icons.info}</span>
    <span class="gd-chat-widget-toast-msg">${gdWidgetEscHtml(message)}</span>
    <button class="gd-chat-widget-toast-close" onclick="this.parentElement.remove()">✕</button>
  `;
 
  container.appendChild(toast);
 
  // Trigger enter animation
  requestAnimationFrame(() => toast.classList.add('gd-chat-widget-toast-show'));
 
  // Auto dismiss
  const timer = setTimeout(() => {
    toast.classList.remove('gd-chat-widget-toast-show');
    toast.classList.add('gd-chat-widget-toast-hide');
    toast.addEventListener('animationend', () => toast.remove(), { once: true });
    // Fallback removal
    setTimeout(() => { if (toast.parentElement) toast.remove(); }, 400);
  }, duration);
 
  // Cancel auto-dismiss on hover
  toast.addEventListener('mouseenter', () => clearTimeout(timer));
  toast.addEventListener('mouseleave', () => {
    setTimeout(() => {
      toast.classList.remove('gd-chat-widget-toast-show');
      toast.classList.add('gd-chat-widget-toast-hide');
      toast.addEventListener('animationend', () => toast.remove(), { once: true });
      setTimeout(() => { if (toast.parentElement) toast.remove(); }, 400);
    }, 1500);
  });
}
 
// ═══════════════════════════════════════════════════════════════
// 2. CONFIRMATION DIALOG — custom, no jQuery
// ═══════════════════════════════════════════════════════════════
 function gdWidgetConfirm(options) {
  const {
    title = 'Confirm',
    message = 'Are you sure?',
    confirmText = 'Yes',
    cancelText = 'No',
    onConfirm,
    onCancel,
    items = [],
  } = options;

  let itemsHtml = '';
  if (items.length > 0) {
    itemsHtml = `
      <table class="gd-chat-widget-confirm-table" style="display:none">
        <thead><tr><th>Product</th><th>Reason</th><th>Qty</th></tr></thead>
        <tbody>
          ${items.map(item => `
            <tr>
              <td>${gdWidgetEscHtml(item.product || item.item_name || '')}</td>
              <td>${gdWidgetEscHtml(item.reason || item.reasonText || '')}</td>
              <td>${item.qty || item.quantity || 1}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>`;
  }

  const overlay = document.createElement('div');
  overlay.className = 'gd-chat-widget-confirm-overlay';
  overlay.innerHTML = `
    <div class="gd-chat-widget-confirm-box">
      <div class="gd-chat-widget-confirm-header">
        <span class="gd-chat-widget-confirm-title">${gdWidgetEscHtml(title)}</span>
        <button class="gd-chat-widget-confirm-close" data-action="cancel">✕</button>
      </div>
      <div class="gd-chat-widget-confirm-body">
        <p>${gdWidgetEscHtml(message)}</p>
        ${itemsHtml}
      </div>
      <div class="gd-chat-widget-confirm-footer">
        <button class="gd-chat-widget-confirm-btn gd-chat-widget-confirm-btn-cancel" data-action="cancel">
          ${gdWidgetEscHtml(cancelText)}
        </button>
        <button class="gd-chat-widget-confirm-btn gd-chat-widget-confirm-btn-confirm" data-action="confirm">
          ${gdWidgetEscHtml(confirmText)}
        </button>
      </div>
    </div>
  `;

  function close(action) {
    overlay.classList.add('gd-chat-widget-confirm-closing');
    overlay.addEventListener('animationend', () => overlay.remove(), { once: true });
    setTimeout(() => { if (overlay.parentElement) overlay.remove(); }, 300);
    if (action === 'confirm' && typeof onConfirm === 'function') onConfirm();
    if (action === 'cancel' && typeof onCancel === 'function') onCancel();
  }

  overlay.addEventListener('click', (e) => {
    const action = e.target.dataset.action;
    if (action) close(action);
    if (e.target === overlay) close('cancel');
  });

  const escHandler = (e) => {
    if (e.key === 'Escape') { close('cancel'); document.removeEventListener('keydown', escHandler); }
  };
  document.addEventListener('keydown', escHandler);

  // Append inside chat panel, not body
  const container = document.getElementById('gd-chat-widget-assistantPanel') || document.body;
  container.appendChild(overlay);
  requestAnimationFrame(() => overlay.classList.add('gd-chat-widget-confirm-open'));
}
 
 
// ═══════════════════════════════════════════════════════════════
// 3. LOADING SPINNER HELPERS
// ═══════════════════════════════════════════════════════════════
 
function gdWidgetBtnStartLoading(btn, text) {
  if (!btn) return;
  btn.disabled = true;
  btn.dataset.originalText = btn.innerHTML;
  btn.innerHTML = `
    <span class="gd-chat-widget-btn-spinner"></span>
    ${gdWidgetEscHtml(text || 'Processing…')}
  `;
  btn.classList.add('gd-chat-widget-btn-loading');
}
 
function gdWidgetBtnStopLoading(btn, text) {
  if (!btn) return;
  btn.disabled = false;
  btn.innerHTML = btn.dataset.originalText || text || 'Submit';
  btn.classList.remove('gd-chat-widget-btn-loading');
}
 
function gdWidgetBtnSuccess(btn, text) {
  if (!btn) return;
  btn.innerHTML = `<span style="margin-right:4px;">✓</span> ${gdWidgetEscHtml(text || 'Done')}`;
  btn.classList.remove('gd-chat-widget-btn-loading');
  btn.classList.add('gd-chat-widget-btn-success');
  btn.disabled = true;
}
 
 
// ═══════════════════════════════════════════════════════════════
// 4. SMOOTH SCROLL TO FIRST ERROR
// ═══════════════════════════════════════════════════════════════
 
function gdWidgetScrollToFirstError(panel) {
  if (!panel) return;
  const firstError = panel.querySelector(
    '.gd-chat-widget-li-field-error, .gd-chat-widget-li-error-msg:not([hidden]), .gd-chat-widget-li-opts-error'
  );
  if (firstError) {
    const card = firstError.closest('.gd-chat-widget-li-card');
    const target = card || firstError;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Brief highlight
    target.classList.add('gd-chat-widget-card-highlight');
    setTimeout(() => target.classList.remove('gd-chat-widget-card-highlight'), 2000);
  }
}
 

function gdWidgetEscHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}


function gdWidgetInfoIcon() {
  return `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13">
    <circle cx="8" cy="8" r="6"/><path d="M8 7v4M8 5.5v.5"/>
  </svg>`;
}